/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  StringOrInt: { input: any; output: any; }
  _Any: { input: any; output: any; }
  federation__FieldSet: { input: any; output: any; }
  federation__Policy: { input: any; output: any; }
  federation__Scope: { input: any; output: any; }
  FileUpload: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  additionalListing?: Maybe<AdditionalListingResult>;
  agency?: Maybe<Agency>;
  agencySearchBySuburbs?: Maybe<AgencySearch>;
  agencySuburbSubscription?: Maybe<AgencySuburbSubscriptionResult>;
  /**
   * WARNING: Will be deprecated in favour of "contact"
   * This type is actually a "Contact", which uses a Relay ID rather than a contactId.
   * It is an agent within a certain agency (e.g. rawilson@raywhite.com.au).
   * @deprecated Old agent is actually a contact which uses relay ids
   */
  agent?: Maybe<Agent>;
  /** https://agency-api.domain.com.au/v2/agents/{agentId} */
  agentByAgentIdV2?: Maybe<AgentV2>;
  agentShowcase?: Maybe<AgentShowcase>;
  /** @deprecated Unused, and node-client response type does not match GQL Type, nor are there any resolvers */
  alerts?: Maybe<Array<Maybe<Alert>>>;
  area?: Maybe<Area>;
  buildingByPropertyId?: Maybe<Building>;
  buildingBySlug?: Maybe<Building>;
  bybPropertyReportProductPreferred?: Maybe<BybPropertyReportProduct>;
  childcareSpacesNearby: Array<ChildcareSpace>;
  /** https://agency-api.domain.com.au/v2/agentsearch/agents/{agencyId}/{agentId} */
  contactByAgencyIdAndAgentId?: Maybe<Contact>;
  /**
   * A Contact is the Join between a relationship between a single agent and a single agency.
   * E.g.:
   * Snake Plissken = Agent
   * Ray White = Agency
   *
   * Snake Plissken working at Ray White = Contact
   *
   * https://agency-api.domain.com.au/v2/agentsearch/agents/{contactId}
   */
  contactByContactId?: Maybe<Contact>;
  contactSearchBySuburbs?: Maybe<ContactSearch>;
  contentHomeScreen: ContentHomeScreen;
  /**
   * Will eventually replace 'propertySupplyDemand'.
   * See: https://domain.atlassian.net/browse/ME-1046
   */
  demandSale?: Maybe<DemandSaleData>;
  /**
   * GET /v1/calculators/refinance
   * GET /v1/calculators/refinance/savings
   * Calculate refinance savings
   * @deprecated Domain Home Loans joint venture exited
   */
  dhlCalculateRefinanceSavings?: Maybe<DhlRefinanceSavingsCalculationResult>;
  /**
   * GET /v1/calculators/stamp-duty
   * Calculate stamp duty and upfront costs
   * @deprecated Domain Home Loans joint venture exited
   */
  dhlCalculateUpfrontCosts?: Maybe<DhlUpfrontCostsCalculationResult>;
  /**
   * GET v1/users/loan-tools/ufc
   * Saved form values for the stamp duty calculator, as previously entered by the current user
   * @deprecated Domain Home Loans joint venture exited
   */
  dhlStampDutyCalculatorDataByUser?: Maybe<DhlStampDutyCalculatorData>;
  discoveryContent?: Maybe<DiscoveryContent>;
  featureFlag: Array<Maybe<FeatureFlag>>;
  /** Get advice articles based on user's goals */
  getAdviceArticlesByUserGoals?: Maybe<ContentAdviceArticlesResult>;
  getAllShortlistedListings?: Maybe<GetShortlistingV2Result>;
  getArticleById?: Maybe<ContentArticleResult>;
  getArticleList?: Maybe<ContentArticleListResult>;
  getLastSearchForArticle?: Maybe<LastSearchForArticleResult>;
  getNearbySchoolsById?: Maybe<SchoolWithDistanceConnection>;
  getSchoolByIdOrSeoName?: Maybe<School>;
  getShortlistedListings?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  getShortlistedListingsV2?: Maybe<GetShortlistedListingsV2Result>;
  /**
   * GET v1/rates
   * return current home loan interest/comparison & rba rates
   * cached at edge for 60 minutes
   * @deprecated Domain Home Loans joint venture exited
   */
  homeLoanRates?: Maybe<HomeLoanRates>;
  listing?: Maybe<Listing>;
  /** @deprecated Use listingByIdV2 */
  listingById?: Maybe<ListingDetails>;
  /** Return the listing details for a given listing id. */
  listingByIdV2?: Maybe<ListingDetailsV2>;
  locationProfile?: Maybe<LocationProfile>;
  locationProfiles?: Maybe<Array<Maybe<LocationProfile>>>;
  /**
   * Return the market insights given a bounding box
   * @deprecated Use marketInsightsV2 instead
   */
  marketInsights?: Maybe<MarketInsights>;
  marketInsightsV2?: Maybe<MarketInsightsResult>;
  /** Get matching saved search based on search request */
  matchingSavedSearch?: Maybe<MatchingSavedSearchResult>;
  matterportExhibition?: Maybe<MatterportExhibitionResult>;
  /** Get the current user's details - will return null if no user available */
  me?: Maybe<User>;
  /** Get all saved and recent searches without map search deduplication */
  mySearches?: Maybe<SavedSearchResultsV2>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Fetches objects given their IDs */
  nodes: Array<Maybe<Node>>;
  /**
   * Get personalised sold listings based on saved or recent searches
   * @deprecated Use recentlySoldListings instead
   */
  personalisedSoldListings?: Maybe<SoldListingsResults>;
  /** Get personalised suburb insights based on saved or recent searches */
  personalisedSuburbInsights?: Maybe<SuburbInsightResults>;
  /** Return a boolean for Post Inspection Mode if user is high intent for a given listing. */
  postInspectionMode?: Maybe<PostInspectionMode>;
  /** Return the premarket listing details for a given id. */
  premarketListingById?: Maybe<PremarketListing>;
  /** @deprecated Use projectByProjectIdV2 */
  projectByProjectId?: Maybe<Project>;
  /** Return the project details for a given projectId. */
  projectByProjectIdV2?: Maybe<ProjectV2>;
  /** @deprecated This resolver adds unnecessary complexity to the Property API migration and is not used. */
  properties?: Maybe<Array<Maybe<Property>>>;
  /** @deprecated Moving to query specific to the input */
  property?: Maybe<Property>;
  propertyByGlobalId?: Maybe<Property>;
  propertyByPropertyId?: Maybe<Property>;
  propertyByPropertySlug?: Maybe<Property>;
  /**
   * Will be deprecated for 'demandSale'.
   * See: https://domain.atlassian.net/browse/ME-1046
   */
  propertySupplyDemand?: Maybe<PropertySupplyDemand>;
  /** Get personalised sold listings based on saved or recent searches */
  recentlySoldListings?: Maybe<RecentlySoldListingsResults>;
  /**
   * Get saved and recent searches
   * @deprecated use savedSearchesV2
   */
  savedSearches?: Maybe<SavedSearchResults>;
  /** Get saved searches count (WEB) - GET /v1/users/savedsearches/count */
  savedSearchesCount?: Maybe<Scalars['Int']['output']>;
  /** Get saved and recent searches */
  savedSearchesV2?: Maybe<SavedSearchResultsV2>;
  /** @deprecated Use searchListingsV2 */
  searchListings?: Maybe<SearchListingsResults>;
  searchListingsByMultipleSavedSearchesV2?: Maybe<SearchListingsResultsByMultipleSavedSearchesWithErrorV2>;
  /**
   * Search listings by saved or recent search ID
   * @deprecated use searchListingsBySavedSearchV3
   */
  searchListingsBySavedSearch?: Maybe<SearchListingsResults>;
  /**
   * Search listings by saved or recent search ID
   * @deprecated use searchListingsBySavedSearchV3
   */
  searchListingsBySavedSearchV2?: Maybe<SearchListingsResultsV2>;
  /** Search listings by saved or recent search ID */
  searchListingsBySavedSearchV3?: Maybe<SearchListingsBySavedSearchResult>;
  /** @deprecated Use searchListingsByUrlV2 */
  searchListingsByUrl?: Maybe<SearchListingsResults>;
  searchListingsByUrlV2?: Maybe<SearchListingsResultsV2>;
  /**
   * Get listings for all the surrounding suburbs of the
   * input location (excludes the suburb in the input)
   */
  searchListingsFromSurroundingSuburbs?: Maybe<SearchListingsResultsV2>;
  searchListingsV2?: Maybe<SearchListingsResultsV2>;
  /** @deprecated Use searchSoldListingsV2 */
  searchSoldListings?: Maybe<SearchListingsResults>;
  /**
   * Search recently sold listings, utilising a limited subset of the potential filters while disregarding the others.
   * Please use searchListingsV2 for typical sold listings.
   */
  searchSoldListingsV2?: Maybe<SearchListingsResultsV2>;
  searchTopspotListingsV2?: Maybe<SearchListingsResultsV2>;
  sharedShortlists?: Maybe<UserShortlistsResult>;
  suburb?: Maybe<Suburb>;
  /** Get suburb market insights for a specific suburb by URL slug */
  suburbInsights?: Maybe<SuburbInsightsResult>;
  /** Get suburb performance data given the combination of suburb, state and postcode inputs. */
  suburbPerformanceWithPostcode?: Maybe<SuburbPerformance>;
  suburbs?: Maybe<Array<Maybe<Suburb>>>;
  suggestedAgencies?: Maybe<Array<Maybe<SuggestedAgency>>>;
  /**
   * GET v1/locations/buildings/_suggest
   * Searches for buildings that best match the address terms. Can be used to power search type ahead.
   */
  suggestedBuildings: Array<SuggestedBuilding>;
  suggestedContacts?: Maybe<Array<Maybe<SuggestedContact>>>;
  /**
   * GET v1/locations/properties/_suggest/components
   * Searches for properties that best match the address terms. Can be used to power search type ahead.
   */
  suggestedProperties: Array<SuggestedProperty>;
  /**
   * GET v1/locations/streets/_suggest
   * Searches for streets that best match the address terms. Can be used to power search type ahead.
   */
  suggestedStreets: Array<SuggestedStreet>;
  /** Return a list of suggested suburbs for a given suburb (experimental). */
  suggestedSuburbs?: Maybe<Suggestions>;
  suggestLocations?: Maybe<Array<LocationSuggestion>>;
  /** Get the current user's details - will throw authentication error if no user available */
  user?: Maybe<User>;
  /** Get recommended listings for a given user */
  userRecommendations?: Maybe<UserRecommendations>;
  userShortlists?: Maybe<UserShortlistsResult>;
  vendorEnquiries?: Maybe<Array<Maybe<VendorEnquiry>>>;
  vendorEnquiry?: Maybe<VendorEnquiry>;
  /** Version of the server. Should not be visible on Prod. */
  version?: Maybe<Scalars['String']['output']>;
};


export type QueryAdditionalListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgencyArgs = {
  agencyId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAgencySearchBySuburbsArgs = {
  agencyNameKeyword?: InputMaybe<Scalars['String']['input']>;
  includeAgents?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<AgencySearchSortBy>;
  suburbSlugs: Array<Scalars['String']['input']>;
};


export type QueryAgencySuburbSubscriptionArgs = {
  suburbSlug: Scalars['String']['input'];
};


export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentByAgentIdV2Args = {
  agentIdV2: Scalars['String']['input'];
};


export type QueryAgentShowcaseArgs = {
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  postcode: Scalars['String']['input'];
  propertyType?: InputMaybe<AgencyApiPropertyType>;
  state: States;
  suburbName: Scalars['String']['input'];
};


export type QueryAlertsArgs = {
  subjectId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAreaArgs = {
  area: Scalars['String']['input'];
};


export type QueryBuildingByPropertyIdArgs = {
  propertyId: Scalars['String']['input'];
};


export type QueryBuildingBySlugArgs = {
  buildingSlug: Scalars['String']['input'];
};


export type QueryBybPropertyReportProductPreferredArgs = {
  address: BybAddressInput;
  auctionDate?: InputMaybe<Scalars['String']['input']>;
  enableInstigate?: InputMaybe<Scalars['Boolean']['input']>;
  propertyType?: InputMaybe<BybPropertyType>;
};


export type QueryChildcareSpacesNearbyArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryContactByAgencyIdAndAgentIdArgs = {
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
};


export type QueryContactByContactIdArgs = {
  contactId: Scalars['Int']['input'];
};


export type QueryContactSearchBySuburbsArgs = {
  agentNameKeyword?: InputMaybe<Scalars['String']['input']>;
  agentType?: InputMaybe<AgentSearchContactTypes>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ContactSearchSortBy>;
  suburbSlugs: Array<Scalars['String']['input']>;
};


export type QueryDemandSaleArgs = {
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms: Scalars['Int']['input'];
  carspaces?: InputMaybe<Scalars['Int']['input']>;
  postcode: Scalars['String']['input'];
  propertyType: Scalars['String']['input'];
  state: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};


export type QueryDhlCalculateRefinanceSavingsArgs = {
  input: DhlRefinanceSavingsCalculationOptions;
};


export type QueryDhlCalculateUpfrontCostsArgs = {
  input: DhlUpfrontCostsCalculationOptions;
};


export type QueryDiscoveryContentArgs = {
  type: Scalars['String']['input'];
};


export type QueryFeatureFlagArgs = {
  flags: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetAdviceArticlesByUserGoalsArgs = {
  userGoals: Array<OnboardingValue>;
};


export type QueryGetArticleByIdArgs = {
  articleId: Scalars['Int']['input'];
};


export type QueryGetArticleListArgs = {
  articleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  brand: Scalars['String']['input'];
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  invisibleTags?: InputMaybe<Scalars['Boolean']['input']>;
  metadataFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetLastSearchForArticleArgs = {
  articleId: Scalars['Int']['input'];
};


export type QueryGetNearbySchoolsByIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeClosedSchool?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
};


export type QueryGetSchoolByIdOrSeoNameArgs = {
  idOrSlug: Scalars['ID']['input'];
};


export type QueryGetShortlistedListingsArgs = {
  idsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingIds: Array<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shortlistId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetShortlistedListingsV2Args = {
  idsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingIds: Array<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shortlistId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListingArgs = {
  adId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListingByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingByIdV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryLocationProfileArgs = {
  apmLocationId?: InputMaybe<Scalars['Int']['input']>;
  domainLocationId?: InputMaybe<Scalars['Int']['input']>;
  pfLocationId?: InputMaybe<Scalars['String']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationProfilesArgs = {
  urlSlugs: Array<Scalars['String']['input']>;
};


export type QueryMarketInsightsArgs = {
  geoWindow: SearchListingsGeoWindowBoxInput;
};


export type QueryMarketInsightsV2Args = {
  geoWindow: SearchListingsGeoWindowBoxInput;
};


export type QueryMatchingSavedSearchArgs = {
  matchingSavedSearchInput: MatchingSavedSearchInput;
};


export type QueryMatterportExhibitionArgs = {
  itemCount: Scalars['Int']['input'];
  locations?: InputMaybe<Array<MatterportSearchLocation>>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPersonalisedSoldListingsArgs = {
  params?: InputMaybe<SoldListingsInput>;
};


export type QueryPersonalisedSuburbInsightsArgs = {
  params?: InputMaybe<SuburbInsightInput>;
};


export type QueryPostInspectionModeArgs = {
  listingId: Scalars['String']['input'];
};


export type QueryPremarketListingByIdArgs = {
  premarketListingId: Scalars['String']['input'];
};


export type QueryProjectByProjectIdArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectByProjectIdV2Args = {
  projectId: Scalars['Int']['input'];
};


export type QueryPropertiesArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPropertyArgs = {
  hpgSlug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPropertyByGlobalIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyByPropertyIdArgs = {
  propertyId: Scalars['String']['input'];
};


export type QueryPropertyByPropertySlugArgs = {
  propertySlug: Scalars['String']['input'];
};


export type QueryPropertySupplyDemandArgs = {
  bathrooms: Scalars['Int']['input'];
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  carspaces: Scalars['Int']['input'];
  postcode: Scalars['String']['input'];
  propertyType: Scalars['String']['input'];
  state: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};


export type QueryRecentlySoldListingsArgs = {
  params?: InputMaybe<RecentlySoldListingsInput>;
};


export type QuerySavedSearchesCountArgs = {
  isAlert?: InputMaybe<Scalars['Boolean']['input']>;
  lastRunCutOff?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['Int']['input']>;
  searchQueryBody?: InputMaybe<Scalars['String']['input']>;
  searchQueryHash?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchListingsArgs = {
  searchParams: SearchListingsParametersInput;
};


export type QuerySearchListingsByMultipleSavedSearchesV2Args = {
  searchListingsBySavedSearchParamsArray: Array<SearchListingsBySavedSearchParametersInput>;
};


export type QuerySearchListingsBySavedSearchArgs = {
  searchListingsBySavedSearchParams: SearchListingsBySavedSearchParametersInput;
};


export type QuerySearchListingsBySavedSearchV2Args = {
  searchListingsBySavedSearchParams: SearchListingsBySavedSearchParametersInput;
};


export type QuerySearchListingsBySavedSearchV3Args = {
  searchListingsBySavedSearchParams: SearchListingsBySavedSearchParametersInput;
};


export type QuerySearchListingsByUrlArgs = {
  url: Scalars['String']['input'];
};


export type QuerySearchListingsByUrlV2Args = {
  input: SearchListingsByUrlInput;
};


export type QuerySearchListingsFromSurroundingSuburbsArgs = {
  searchParams: SearchListingsParametersInput;
};


export type QuerySearchListingsV2Args = {
  searchParams: SearchListingsParametersInput;
};


export type QuerySearchSoldListingsArgs = {
  searchParams: SearchListingsParametersInput;
};


export type QuerySearchSoldListingsV2Args = {
  searchParams: SearchListingsParametersInput;
};


export type QuerySearchTopspotListingsV2Args = {
  searchParams: TopSpotSearchParametersInput;
};


export type QuerySharedShortlistsArgs = {
  sharedShortlistId: Scalars['String']['input'];
};


export type QuerySuburbArgs = {
  suburbId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuburbInsightsArgs = {
  urlSlug: Scalars['String']['input'];
};


export type QuerySuburbPerformanceWithPostcodeArgs = {
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  periodSize?: InputMaybe<SuburbPerformancePeriodSizeInput>;
  postcode: Scalars['String']['input'];
  propertyCategory?: InputMaybe<SuburbPerformancePropertyCategoryInput>;
  state: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  totalPeriods?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuburbsArgs = {
  area?: InputMaybe<Scalars['String']['input']>;
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySuggestedAgenciesArgs = {
  name: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuggestedBuildingsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  terms: Scalars['String']['input'];
};


export type QuerySuggestedContactsArgs = {
  name: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuggestedPropertiesArgs = {
  channel?: InputMaybe<LocationTypeaheadChannel>;
  minScore?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  terms: Scalars['String']['input'];
};


export type QuerySuggestedStreetsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  terms: Scalars['String']['input'];
};


export type QuerySuggestedSuburbsArgs = {
  mode: SuggestedSuburbMode;
  suburbId: Scalars['String']['input'];
};


export type QuerySuggestLocationsArgs = {
  exactMatchesToTop?: InputMaybe<Scalars['Boolean']['input']>;
  locationTypes?: InputMaybe<Array<InputMaybe<LocationSuggestionType>>>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  prefixText: Scalars['String']['input'];
  stateBoost?: InputMaybe<States>;
};


export type QueryUserRecommendationsArgs = {
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorEnquiriesArgs = {
  enquiryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryVendorEnquiryArgs = {
  enquiryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type AdditionalListingResult = AdditionalListing | ErrorWithUserMessage;

export type AdditionalListing = {
  __typename?: 'AdditionalListing';
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  dwellingType?: Maybe<Scalars['String']['output']>;
  generalPhoneNumber?: Maybe<Scalars['String']['output']>;
  homepassEnabled: Scalars['Boolean']['output'];
  /**
   * Listing ID.
   * * Other Listing / Project id is Int
   */
  id: Scalars['ID']['output'];
  /** Indicates if bookings are enabled for this listing via Homepass Booking API */
  isBookingsEnabled: Scalars['Boolean']['output'];
  lifecycleStatus?: Maybe<Scalars['String']['output']>;
  listingType: Scalars['String']['output'];
  metadata?: Maybe<AdditionalListingPropertyMetadata>;
  phoneEnquiryPreference: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['String']['output']>;
  project?: Maybe<AdditionalListingProject>;
  promoLevel?: Maybe<Scalars['String']['output']>;
  saleMetadata?: Maybe<AdditionalListingSaleMetadata>;
  schools?: Maybe<AdditionalNearbySchools>;
  searchMode?: Maybe<Scalars['String']['output']>;
  timeOnMarketFormats: TimeOnMarketFormats;
  trackingMetadata: TrackingMetadata;
  type: AdvertiserType;
};

export type AdditionalListingPropertyMetadata = {
  __typename?: 'AdditionalListingPropertyMetadata';
  addressComponents?: Maybe<AdditionalListingAddressComponents>;
};

export type AdditionalListingAddressComponents = {
  __typename?: 'AdditionalListingAddressComponents';
  area?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  stateShort?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  suburbId?: Maybe<Scalars['Int']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type AdditionalListingProject = {
  __typename?: 'AdditionalListingProject';
  dwellingType?: Maybe<Scalars['String']['output']>;
  inspectionSchedule?: Maybe<InspectionSchedule>;
  listingType?: Maybe<Scalars['String']['output']>;
  phoneEnquiryPreference?: Maybe<Scalars['Boolean']['output']>;
  priceRange?: Maybe<ProjectDisplayPriceRange>;
  projectDataFoundation?: Maybe<Scalars['String']['output']>;
};

export type InspectionSchedule = {
  __typename?: 'InspectionSchedule';
  isBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isByAppointmentOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type ProjectDisplayPriceRange = {
  __typename?: 'ProjectDisplayPriceRange';
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type AdditionalListingSaleMetadata = {
  __typename?: 'AdditionalListingSaleMetadata';
  dateSold?: Maybe<Scalars['String']['output']>;
  saleType?: Maybe<Scalars['String']['output']>;
};

export type AdditionalNearbySchools = {
  __typename?: 'AdditionalNearbySchools';
  governmentSchools?: Maybe<Array<AdditionalSchoolWithDistance>>;
  independentSchools?: Maybe<Array<AdditionalSchoolWithDistance>>;
};

export type AdditionalSchoolWithDistance = {
  __typename?: 'AdditionalSchoolWithDistance';
  school?: Maybe<AdditionalSchool>;
};

export type AdditionalSchool = {
  __typename?: 'AdditionalSchool';
  acaraId?: Maybe<Scalars['Int']['output']>;
  centroid?: Maybe<Scalars['String']['output']>;
  geoLocation?: Maybe<Geolocation>;
  id?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<AdditionalSchoolMetadata>;
  postcode?: Maybe<Scalars['String']['output']>;
  schoolSector?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
};

export type Geolocation = {
  __typename?: 'Geolocation';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type AdditionalSchoolMetadata = {
  __typename?: 'AdditionalSchoolMetadata';
  addressComponents: AdditionalSchoolMetadataAddressComponents;
};

export type AdditionalSchoolMetadataAddressComponents = {
  __typename?: 'AdditionalSchoolMetadataAddressComponents';
  postcode?: Maybe<Scalars['String']['output']>;
  stateShort?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type TimeOnMarketFormats = {
  __typename?: 'TimeOnMarketFormats';
  detailsSection?: Maybe<Scalars['String']['output']>;
};

export type TrackingMetadata = {
  __typename?: 'TrackingMetadata';
  adType?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer resolved here; always returns null. Use ListingDetails.metadata.trackingMetadata instead. */
  bookingSystem?: Maybe<Scalars['String']['output']>;
  corePropertyID?: Maybe<Scalars['String']['output']>;
  daysListed?: Maybe<Scalars['Int']['output']>;
  expHouseAndLandFilterExperiment?: Maybe<Scalars['String']['output']>;
  hasInteractiveFloorplan?: Maybe<Scalars['Boolean']['output']>;
  primaryCategory?: Maybe<Scalars['String']['output']>;
  saleMethod?: Maybe<Scalars['String']['output']>;
};

export enum AdvertiserType {
  Agent = 'AGENT',
  Private = 'PRIVATE'
}

export type ErrorWithUserMessage = Error & {
  __typename?: 'ErrorWithUserMessage';
  /** Error status for clients */
  errorStatus: ErrorStatus;
  /** Technical error message */
  message: Scalars['String']['output'];
  /** User friendly error message */
  userMessage: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export enum ErrorStatus {
  BadRequest = 'BAD_REQUEST',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  NoContent = 'NO_CONTENT',
  NotFound = 'NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED'
}

export type Agency = Node & {
  __typename?: 'Agency';
  activeSuburbs?: Maybe<Array<Maybe<ActiveSuburbDetails>>>;
  address?: Maybe<Address>;
  agencyId: Scalars['Int']['output'];
  agencyVideoUrl?: Maybe<Scalars['String']['output']>;
  agentsearchListingsByAgencyId?: Maybe<AgentsearchListingCategories>;
  agentsearchListingsFiltersByAgencyId?: Maybe<ListingFilters>;
  branding?: Maybe<AgencyBranding>;
  contactDetails?: Maybe<AgencyContactDetails>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  /** The agency's tier depth, e.g. 'platinum', 'gold', etc." */
  depthTier?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domainRentalFormOptIn?: Maybe<Scalars['Boolean']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  fullProfileUrl?: Maybe<Scalars['String']['output']>;
  hasReinswBadge?: Maybe<Scalars['Boolean']['output']>;
  hideOfficeLocation?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oneFormOptIn?: Maybe<Scalars['Boolean']['output']>;
  /**
   * To detect the detailed tier depth, use the combination with depthTier instead.
   * The like of gold, and silver tiers will be identified only as 'branded' by profileTier."
   */
  profileTier?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<AgencyRecommendations>;
  showFacebookFeed?: Maybe<Scalars['Boolean']['output']>;
  showGooglePlusFeed?: Maybe<Scalars['Boolean']['output']>;
  showInstagramFeed?: Maybe<Scalars['Boolean']['output']>;
  showLinkedInFeed?: Maybe<Scalars['Boolean']['output']>;
  showPastSalesPrices?: Maybe<Scalars['Boolean']['output']>;
  showRecentlySold?: Maybe<Scalars['Boolean']['output']>;
  showRMAReviewsAgency?: Maybe<Scalars['Boolean']['output']>;
  showRMAReviewsAgentProfiles?: Maybe<Scalars['Boolean']['output']>;
  showTabSoldLastYear?: Maybe<Scalars['Boolean']['output']>;
  showTwitterFeed?: Maybe<Scalars['Boolean']['output']>;
  showYoutubeChannelFeed?: Maybe<Scalars['Boolean']['output']>;
  statistics?: Maybe<AgencyStatistics>;
  /** Get an suburb statistics for a Contact, not adding a param returns the statistics for all suburbs combined */
  suburbStatistics?: Maybe<SuburbSoldStatistics>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtubeChannelUrl?: Maybe<Scalars['String']['output']>;
};


export type AgencyAgentsearchListingsByAgencyIdArgs = {
  bedrooms?: InputMaybe<AgentsearchListingBedrooms>;
  listingStatuses: Array<AgencyApiListingStatus>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  propertyType?: InputMaybe<AgencyApiPropertyType>;
  sortBy?: InputMaybe<AgentsearchListingsSortBy>;
  suburbId?: InputMaybe<Scalars['String']['input']>;
};


export type AgencyContactsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ContactSortBy>;
};


export type AgencyRecommendationsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type AgencySuburbStatisticsArgs = {
  suburbSlug?: InputMaybe<Scalars['String']['input']>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

export type ActiveSuburbDetails = {
  __typename?: 'ActiveSuburbDetails';
  listingCount?: Maybe<Scalars['Int']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  salesType?: Maybe<Scalars['String']['output']>;
  suburbName?: Maybe<Scalars['String']['output']>;
  suburbSlug?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  addressSlug?: Maybe<Scalars['String']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  displayAddress?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<AddressDisplayType>;
  geolocation?: Maybe<Geolocation>;
  mapCertainty?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<States>;
  street?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  streetType?: Maybe<Scalars['String']['output']>;
  streetTypeLong?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Suburb>;
  /** SuburbID returned from Search API V2. */
  suburbId?: Maybe<Scalars['Int']['output']>;
  suburbName?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export enum AddressDisplayType {
  AreaOnly = 'AREA_ONLY',
  FullAddress = 'FULL_ADDRESS',
  RegionOnly = 'REGION_ONLY',
  StateOnly = 'STATE_ONLY',
  StreetAndSuburb = 'STREET_AND_SUBURB',
  SuburbOnly = 'SUBURB_ONLY'
}

export enum States {
  Act = 'ACT',
  Nsw = 'NSW',
  Nt = 'NT',
  Qld = 'QLD',
  Sa = 'SA',
  Tas = 'TAS',
  Vic = 'VIC',
  Wa = 'WA'
}

export type Suburb = Node & {
  __typename?: 'Suburb';
  area?: Maybe<Scalars['String']['output']>;
  content?: Maybe<ContentLocationProfile>;
  /** The encoded database id and graphql type */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  schools?: Maybe<Array<Maybe<School>>>;
  /** The slug to use this suburb in a URL on Domain. */
  slug?: Maybe<Scalars['String']['output']>;
  state: States;
  statistics?: Maybe<SuburbStatistics>;
  suburbId: Scalars['String']['output'];
  suburbShape?: Maybe<SuburbShape>;
  surroundingSuburbs: Array<Suburb>;
};


export type SuburbSuburbShapeArgs = {
  geometryPrecision?: InputMaybe<SuburbShapeGeometryPrecision>;
};

export type ContentLocationProfile = {
  __typename?: 'ContentLocationProfile';
  additionalImages?: Maybe<Array<Maybe<ContentLocationProfileImage>>>;
  content?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<ContentLocationProfileImage>;
  id: Scalars['ID']['output'];
  location?: Maybe<ContentLocation>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentLocationProfileImage = {
  __typename?: 'ContentLocationProfileImage';
  altText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<ContentLocationProfileCaption>;
  credit?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
};

export type ContentLocationProfileCaption = {
  __typename?: 'ContentLocationProfileCaption';
  content?: Maybe<Scalars['String']['output']>;
  photographer?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  date?: Maybe<Scalars['String']['output']>;
  mediaCategory: MediaCategory;
  rawUrl: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  /** trim can remove surrounding space in an image. */
  url: Scalars['String']['output'];
};


export type ImageUrlArgs = {
  allowUpscale?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  fitIn?: InputMaybe<Scalars['Boolean']['input']>;
  imageFormat?: InputMaybe<ImageFormat>;
  imageSize?: InputMaybe<ImageSize>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  resolution?: InputMaybe<Resolution>;
  retina?: InputMaybe<ImageRetina>;
  trim?: InputMaybe<ImageTrim>;
};

export enum MediaCategory {
  Image = 'IMAGE',
  OtherMedia = 'OTHER_MEDIA',
  Video = 'VIDEO'
}

export enum ImageFormat {
  Jpeg = 'JPEG',
  Png = 'PNG',
  Webp = 'WEBP'
}

/** List of predefined image sizes */
export enum ImageSize {
  /**
   * Listing detail: desktop
   * 1920px x 1080px
   */
  Large = 'LARGE',
  /**
   * Listing agent avatar
   * 2x for retina display
   * 180px x 180px
   */
  ListingAgentAvatar = 'LISTING_AGENT_AVATAR',
  /**
   * Listing hero: laptop/desktop 21:9
   * 1680px x 720px
   */
  ListingHeroLarge = 'LISTING_HERO_LARGE',
  /**
   * Listing hero: tablet 21:9
   * 1050px x 450px
   */
  ListingHeroMedium = 'LISTING_HERO_MEDIUM',
  /**
   * Listing hero: mobile 16:9
   * 640px x 360px
   */
  ListingHeroSmall = 'LISTING_HERO_SMALL',
  /**
   * Listing hero: extra large desktop 16:9
   * 1680px x 945px
   */
  ListingHeroXlarge = 'LISTING_HERO_XLARGE',
  /** 1280px x 720px */
  Medium = 'MEDIUM',
  /**
   * Project listing: depth glowup branding logo image
   * 360px x 121px
   */
  ProjectListingBrandingLogo = 'PROJECT_LISTING_BRANDING_LOGO',
  /**
   * Project: child listings thumbnails
   * 660px x 660px
   */
  ProjectListingChildListingsThumbnails = 'PROJECT_LISTING_CHILD_LISTINGS_THUMBNAILS',
  /**
   * Project: other projects thumbnails
   * 464px x 402px
   */
  ProjectListingOtherProjectsThumbnails = 'PROJECT_LISTING_OTHER_PROJECTS_THUMBNAILS',
  /**
   * Search listing: skeleton images tablet
   * Listing detail: tablet
   * 1020px x 1020px
   */
  SearchListings_1To_1RatioMedium = 'SEARCH_LISTINGS_1_TO_1_RATIO_MEDIUM',
  /**
   * Search listing: agency contacts profile photos
   * 90px x 90px
   */
  SearchListings_1To_1RatioSmall = 'SEARCH_LISTINGS_1_TO_1_RATIO_SMALL',
  /**
   * Search listing: high quality image size for project
   * 1160px x 662px
   */
  SearchListings_16To_9RatioMedium = 'SEARCH_LISTINGS_16_TO_9_RATIO_MEDIUM',
  /**
   * Search listing: high quality image size
   * 1160px x 774px
   */
  SearchListings_3To_2RatioMedium = 'SEARCH_LISTINGS_3_TO_2_RATIO_MEDIUM',
  /**
   * Search listing: original image size from old api
   * 660px x 440px
   */
  SearchListings_3To_2RatioSmall = 'SEARCH_LISTINGS_3_TO_2_RATIO_SMALL',
  /**
   * Search listing: skeleton images mobile
   * Listing detail: mobile
   * 600px x 800px
   */
  SearchListings_3To_4RatioSmall = 'SEARCH_LISTINGS_3_TO_4_RATIO_SMALL',
  /**
   * Search listing: depth glowup listing card image
   * 720 x 540px
   */
  SearchListings_4To_3RatioSmall = 'SEARCH_LISTINGS_4_TO_3_RATIO_SMALL',
  /**
   * Search listing: agency branding banner
   * 800px x 55px
   */
  SearchListingsAgencyBrandingBanner = 'SEARCH_LISTINGS_AGENCY_BRANDING_BANNER',
  /**
   * Search listing: agency branding logo
   * 170px x 60px
   */
  SearchListingsAgencyBrandingLogo = 'SEARCH_LISTINGS_AGENCY_BRANDING_LOGO',
  /**
   * Search listing: platinum agency skeleton branding logo for web and apps
   * 200px x 70px
   */
  SearchListingsAgencySkeletonBrandingLogo = 'SEARCH_LISTINGS_AGENCY_SKELETON_BRANDING_LOGO',
  /**
   * Search listing: standard agency skeleton branding logo for web
   * 120px x 42px
   */
  SearchListingsAgencySkeletonBrandingLogoStandard = 'SEARCH_LISTINGS_AGENCY_SKELETON_BRANDING_LOGO_STANDARD',
  /**
   * Search listing: child listings thumbnails
   * Listing detail: thumbnail
   * 144px x 106px
   */
  SearchListingsChildListingsThumbnails = 'SEARCH_LISTINGS_CHILD_LISTINGS_THUMBNAILS',
  /** 640px x 480px */
  Small = 'SMALL'
}

export type Resolution = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

/**
 * ImageRetina defines the pixel density multiplier for high-resolution displays.
 * - X1 for standard displays (1x)
 * - X2 for retina displays (2x)
 * - X3 for ultra high-resolution displays (3x)
 */
export enum ImageRetina {
  X1 = 'X1',
  X2 = 'X2',
  X3 = 'X3'
}

/**
 * ImageTrim can remove surrounding space in an image.
 * - OFF does not trim
 * - DEFAULT trims from the top left pixel with a color tolerance 200.
 * - a CUSTOM option can be introduced together with an Input type and argument
 *   when we want to let clients customise their trim orientation and color tolerance.
 */
export enum ImageTrim {
  Default = 'DEFAULT',
  Off = 'OFF'
}

export type ContentLocation = {
  __typename?: 'ContentLocation';
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type School = {
  __typename?: 'School';
  acaraId?: Maybe<Scalars['ID']['output']>;
  ageId?: Maybe<Scalars['ID']['output']>;
  asAtDate?: Maybe<Scalars['String']['output']>;
  campusType?: Maybe<SchoolCampusType>;
  catchments?: Maybe<Array<Maybe<SchoolCatchment>>>;
  centroid?: Maybe<Geolocation>;
  disclaimer: Scalars['String']['output'];
  displayAddress?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['ID']['output']>;
  domainSeoUrlSlug?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<SchoolGender>;
  labels?: Maybe<Array<SchoolLabel>>;
  links?: Maybe<Array<SchoolLinks>>;
  name?: Maybe<Scalars['String']['output']>;
  nearbySchools?: Maybe<Array<School>>;
  parentAcaraId?: Maybe<Scalars['ID']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<SchoolProfile>;
  schoolSector?: Maybe<SchoolSector>;
  schoolType?: Maybe<SchoolType>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SchoolStatus>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export enum SchoolCampusType {
  HeadCampus = 'HeadCampus',
  SingleEntity = 'SingleEntity',
  SubCampus = 'SubCampus'
}

export type SchoolCatchment = {
  __typename?: 'SchoolCatchment';
  boundary?: Maybe<SingleOrMultiGeolocationPolygon>;
  boundaryGeoJson?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SchoolCatchmentType>;
};

export type SingleOrMultiGeolocationPolygon = GeolocationMultiPolygon | GeolocationPolygon;

export type GeolocationMultiPolygon = {
  __typename?: 'GeolocationMultiPolygon';
  coordinates: Array<Array<Array<Geolocation>>>;
};

export type GeolocationPolygon = {
  __typename?: 'GeolocationPolygon';
  coordinates: Array<Array<Geolocation>>;
};

export enum SchoolCatchmentType {
  Primary = 'Primary',
  Secondary = 'Secondary'
}

export enum SchoolGender {
  Boys = 'Boys',
  CoEd = 'CoEd',
  Girls = 'Girls'
}

export type SchoolLabel = {
  __typename?: 'SchoolLabel';
  name: Scalars['String']['output'];
};

export type SchoolLinks = {
  __typename?: 'SchoolLinks';
  name: Scalars['String']['output'];
  slug: SchoolSlugs;
  value: Scalars['String']['output'];
};

export enum SchoolSlugs {
  Icsea = 'ICSEA',
  Naplan = 'NAPLAN'
}

export type SchoolProfile = {
  __typename?: 'SchoolProfile';
  bottomSeaQuarter?: Maybe<Scalars['Int']['output']>;
  boysEnrolments?: Maybe<Scalars['Int']['output']>;
  fullTimeEquivalentEnrolments?: Maybe<Scalars['Float']['output']>;
  fullTimeEquivalentNonTeachingStaff?: Maybe<Scalars['Float']['output']>;
  fullTimeEquivalentTeachingStaff?: Maybe<Scalars['Float']['output']>;
  geolocation?: Maybe<SchoolGeolocationType>;
  girlsEnrolments?: Maybe<Scalars['Int']['output']>;
  governingBody?: Maybe<Scalars['String']['output']>;
  governingBodyUrl?: Maybe<Scalars['String']['output']>;
  icsea?: Maybe<Scalars['Int']['output']>;
  indigenousEnrolments?: Maybe<Scalars['Int']['output']>;
  languageBackgroundOtherThanEnglishPercentage?: Maybe<Scalars['Int']['output']>;
  lowerMiddleSeaQuarter?: Maybe<Scalars['Int']['output']>;
  nonTeachingStaff?: Maybe<Scalars['Int']['output']>;
  teachingStaff?: Maybe<Scalars['Int']['output']>;
  topSeaQuarter?: Maybe<Scalars['Int']['output']>;
  totalEnrolments?: Maybe<Scalars['Int']['output']>;
  upperMiddleSeaQuarter?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  yearRange?: Maybe<Scalars['String']['output']>;
};

export enum SchoolGeolocationType {
  InnerRegional = 'InnerRegional',
  MajorCities = 'MajorCities',
  OuterRegional = 'OuterRegional',
  Remote = 'Remote',
  VeryRemote = 'VeryRemote'
}

export enum SchoolSector {
  Catholic = 'Catholic',
  Government = 'Government',
  Independent = 'Independent'
}

export enum SchoolType {
  Combined = 'Combined',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Special = 'Special'
}

export enum SchoolStatus {
  Closed = 'Closed',
  Open = 'Open',
  Pending = 'Pending',
  Proposed = 'Proposed'
}

export type SuburbStatistics = {
  __typename?: 'SuburbStatistics';
  /** The percentage of the population that are married. */
  marriedPercentage?: Maybe<Scalars['Float']['output']>;
  /** The most common age bracket for this suburb */
  mostCommonAgeBracket?: Maybe<Scalars['String']['output']>;
  /** The percentage of owners that are living in their properties in this suburb. */
  ownerOccupierPercentage?: Maybe<Scalars['Float']['output']>;
  /** Number of people living in this suburb */
  population?: Maybe<Scalars['Int']['output']>;
  /** Percentage of people who are renting and live in this suburb */
  renterPercentage?: Maybe<Scalars['Float']['output']>;
  /** The percentage of the population that are single. */
  singlePercentage?: Maybe<Scalars['Float']['output']>;
};

export enum SuburbShapeGeometryPrecision {
  High = 'high',
  Low = 'low'
}

export type SuburbShape = {
  __typename?: 'SuburbShape';
  boundaryGeoJson?: Maybe<Scalars['String']['output']>;
  center?: Maybe<Geolocation>;
};

export enum AgentsearchListingBedrooms {
  Fiveplus = 'FIVEPLUS',
  Four = 'FOUR',
  One = 'ONE',
  Studio = 'STUDIO',
  Three = 'THREE',
  Two = 'TWO'
}

export enum AgencyApiListingStatus {
  Lease = 'LEASE',
  Leased = 'LEASED',
  Sale = 'SALE',
  Sold = 'SOLD'
}

export enum AgencyApiPropertyType {
  Apartment = 'APARTMENT',
  Commercial = 'COMMERCIAL',
  House = 'HOUSE',
  Land = 'LAND',
  Rural = 'RURAL'
}

export enum AgentsearchListingsSortBy {
  Priceascending = 'PRICEASCENDING',
  Pricedescending = 'PRICEDESCENDING'
}

export type AgentsearchListingCategories = {
  __typename?: 'AgentsearchListingCategories';
  leasedListings?: Maybe<AgentsearchListingResults>;
  leaseListings?: Maybe<AgentsearchListingResults>;
  saleListings?: Maybe<AgentsearchListingResults>;
  soldListings?: Maybe<AgentsearchListingResults>;
};

export type AgentsearchListingResults = {
  __typename?: 'AgentsearchListingResults';
  results?: Maybe<Array<Maybe<AgentsearchListingResult>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type AgentsearchListingResult = {
  __typename?: 'AgentsearchListingResult';
  leadContact?: Maybe<Contact>;
  listing?: Maybe<AgentsearchListing>;
  saleType?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  activeSuburbs?: Maybe<Array<Maybe<ActiveSuburbDetails>>>;
  address?: Maybe<Address>;
  /** Get an agency from agency api */
  agencyByAgencyId?: Maybe<Agency>;
  agencyId: Scalars['Int']['output'];
  agencyLogo?: Maybe<Scalars['String']['output']>;
  agencyName?: Maybe<Scalars['String']['output']>;
  agencyUrlPath?: Maybe<Scalars['String']['output']>;
  agentIdV2: Scalars['String']['output'];
  agentsearchListingsByAgentIdV2AndAgencyId?: Maybe<AgentsearchListingCategories>;
  agentsearchListingsFiltersByAgentIdV2AndAgencyId?: Maybe<ListingFilters>;
  /** Get an AgentV2 from a Contact */
  agentV2ByContactId?: Maybe<AgentV2>;
  agentVideoUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Contact ID is not returned by newer contactByAgencyIdAndAgentId resolution. Use agentIdV2 instead if possible. */
  contactId?: Maybe<Scalars['Int']['output']>;
  /** The agent's tier depth, e.g. 'platinum', 'gold', 'silver', etc." */
  depthTier?: Maybe<Scalars['String']['output']>;
  /** @deprecated The agent email address is obscured. Use hasEmail instead. */
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  /** First name of the agent */
  firstName?: Maybe<Scalars['String']['output']>;
  hasEmail?: Maybe<Scalars['Boolean']['output']>;
  hasReinsw?: Maybe<Scalars['Boolean']['output']>;
  hideOfficeLocation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Join of agencyId + agentIdV2 in the form:
   *
   * {agencyId}-{agentIdV2}
   */
  id: Scalars['ID']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isActiveProfilePage?: Maybe<Scalars['Boolean']['output']>;
  isHideSoldLeasedListings?: Maybe<Scalars['Boolean']['output']>;
  jobCategory?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Last name of the agent */
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** Full name of the agent. i.e. <firstName> <lastName> */
  name?: Maybe<Scalars['String']['output']>;
  /** Get a Next Inspection from a Contact */
  nextInspectionByContact?: Maybe<NextInspection>;
  personalWebsiteUrl?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Image>;
  profileText?: Maybe<Scalars['String']['output']>;
  /**
   * To detect the detailed tier depth, use the combination with depthTier instead.
   * The like of gold, and silver tiers will be identified only as 'branded' by profileTier."
   */
  profileTier?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<ContactRecommendations>;
  showSocialFeeds?: Maybe<Scalars['Boolean']['output']>;
  /** Get an contact statistics from a Contact */
  statistics?: Maybe<ContactStatistics>;
  suburbSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Get an suburb statistics for a Contact, not adding a param returns the statistics for all suburbs combined */
  suburbStatistics?: Maybe<SuburbSoldStatistics>;
  telephone?: Maybe<Scalars['String']['output']>;
  testimonials?: Maybe<Array<Maybe<ContactTestimonial>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  youTubeChannelUrl?: Maybe<Scalars['String']['output']>;
};


export type ContactAgentsearchListingsByAgentIdV2AndAgencyIdArgs = {
  bedrooms?: InputMaybe<AgentsearchListingBedrooms>;
  isHideSoldLeasedListings?: InputMaybe<Scalars['Boolean']['input']>;
  listingStatuses: Array<AgencyApiListingStatus>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  propertyType?: InputMaybe<AgencyApiPropertyType>;
  sortBy?: InputMaybe<AgentsearchListingsSortBy>;
  suburbId?: InputMaybe<Scalars['String']['input']>;
};


export type ContactRecommendationsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactSuburbStatisticsArgs = {
  suburbSlug?: InputMaybe<Scalars['String']['input']>;
};

export type ListingFilters = {
  __typename?: 'ListingFilters';
  listingSummary?: Maybe<Array<Maybe<ListingFilterListingType>>>;
};

export type ListingFilterListingType = {
  __typename?: 'ListingFilterListingType';
  bedrooms?: Maybe<Array<Scalars['String']['output']>>;
  listingType?: Maybe<ListingFilterStatus>;
  propertyTypes?: Maybe<Array<Maybe<AgencyApiPropertyType>>>;
  suburbSummaries?: Maybe<Array<Maybe<ListingFilterSuburbSummary>>>;
};

export enum ListingFilterStatus {
  Lease = 'LEASE',
  Leased = 'LEASED',
  Sale = 'SALE',
  Sold = 'SOLD'
}

export type ListingFilterSuburbSummary = {
  __typename?: 'ListingFilterSuburbSummary';
  listingCount: Scalars['Int']['output'];
  suburbName: Scalars['String']['output'];
  suburbSlug?: Maybe<Scalars['String']['output']>;
};

export type AgentV2 = {
  __typename?: 'AgentV2';
  agentAgencies?: Maybe<Array<Maybe<AgentAgency>>>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  dateDeleted?: Maybe<Scalars['String']['output']>;
  dateUpdated?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mergedTo?: Maybe<Scalars['String']['output']>;
  mergedToDate?: Maybe<Scalars['String']['output']>;
};

export type AgentAgency = {
  __typename?: 'AgentAgency';
  agencyByAgencyId?: Maybe<Agency>;
  agencyId: Scalars['Int']['output'];
  agentIdV2: Scalars['String']['output'];
  contactByAgencyId?: Maybe<Contact>;
  isWorkingForAgency?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  startedWorkingFor?: Maybe<Scalars['String']['output']>;
};

export type NextInspection = {
  __typename?: 'NextInspection';
  fromTime?: Maybe<Scalars['String']['output']>;
  listingByAdId?: Maybe<Listing>;
  toTime?: Maybe<Scalars['String']['output']>;
  where?: Maybe<Scalars['String']['output']>;
};

export type Listing = {
  __typename?: 'Listing';
  address?: Maybe<Address>;
  advertiser?: Maybe<Agency>;
  /** The AdvertiserId (for example agency) database id */
  advertiserId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated old agent deprecated prefer contact */
  agents?: Maybe<Array<Maybe<Agent>>>;
  availableDate?: Maybe<Scalars['String']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The encoded database id and graphql type */
  id: Scalars['ID']['output'];
  inspectionDetails?: Maybe<ListingInspectionDetails>;
  /** The area that the property occupies. */
  internalArea?: Maybe<Scalars['Float']['output']>;
  isChildListing?: Maybe<Scalars['Boolean']['output']>;
  isRural?: Maybe<Scalars['Boolean']['output']>;
  /** The area that the property occupies. */
  landArea?: Maybe<Scalars['Float']['output']>;
  /** The Listing database id */
  listingId: Scalars['Int']['output'];
  media?: Maybe<Array<Media>>;
  parkingSpaces?: Maybe<Scalars['Int']['output']>;
  priceDetails?: Maybe<ListingPriceDetails>;
  promoLevel?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']['output']>;
  propertyTypes: Array<Scalars['String']['output']>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  statementOfInformation?: Maybe<StatementOfInformation>;
  status?: Maybe<ListingStatus>;
  type?: Maybe<ListingMode>;
  updated?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  virtualTourUrl?: Maybe<Scalars['String']['output']>;
};


export type ListingInternalAreaArgs = {
  unit?: InputMaybe<AreaUnits>;
};


export type ListingLandAreaArgs = {
  unit?: InputMaybe<AreaUnits>;
};


export type ListingMediaArgs = {
  categories?: InputMaybe<Array<MediaCategory>>;
};

export type Agent = Node & Person & {
  __typename?: 'Agent';
  agency?: Maybe<Agency>;
  agencyId: Scalars['Int']['output'];
  agentId: Scalars['String']['output'];
  agentIdV2: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  isActiveProfilePage?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  landlineNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  personalWebsiteUrl?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Image>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  /**
   * localAgentConnection arguments are get statistics based on
   *  - bedrooms
   *  - listing type
   *  - suburb
   *   By disabling these you are getting an agent's total statistics.
   *
   *  E.g.
   *  - Agent has sold 4 houses with 2 bedrooms in Beaconsfield VS
   *  - Agent has sold 8 properties with any number of bedrooms anywhere.
   */
  statistics?: Maybe<AgentStatistics>;
  unfilteredStatistics?: Maybe<UnfilteredAgentStatistics>;
};


export type AgentStatisticsArgs = {
  useLocalAgentConnectionArguments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Person = {
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AgentStatistics = {
  __typename?: 'AgentStatistics';
  averageDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  averageSalePrice?: Maybe<Scalars['Float']['output']>;
  maxSoldPrice?: Maybe<Scalars['Int']['output']>;
  minSoldPrice?: Maybe<Scalars['Int']['output']>;
  mostRecentNewListingDate?: Maybe<Scalars['String']['output']>;
  mostRecentSaleDate?: Maybe<Scalars['String']['output']>;
  totalAuctioned?: Maybe<Scalars['Int']['output']>;
  totalDaysOnMarket?: Maybe<Scalars['Int']['output']>;
  totalForRent?: Maybe<Scalars['Int']['output']>;
  totalForSale?: Maybe<Scalars['Int']['output']>;
  totalJointLeased?: Maybe<Scalars['Int']['output']>;
  totalJointSold?: Maybe<Scalars['Int']['output']>;
  totalJointSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalLeased?: Maybe<Scalars['Int']['output']>;
  totalNotWithheldSoldCount?: Maybe<Scalars['Int']['output']>;
  totalSold?: Maybe<Scalars['Int']['output']>;
  totalSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalSoldPrice?: Maybe<Scalars['Int']['output']>;
  totalSoldWithValidDaysOnMarket?: Maybe<Scalars['Int']['output']>;
};

export type UnfilteredAgentStatistics = {
  __typename?: 'UnfilteredAgentStatistics';
  averageDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  averageSalePrice?: Maybe<Scalars['Float']['output']>;
  maxSoldPrice?: Maybe<Scalars['Float']['output']>;
  totalAuctioned?: Maybe<Scalars['Int']['output']>;
  totalSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalSoldPrice?: Maybe<Scalars['Float']['output']>;
};

export type ListingInspectionDetails = {
  __typename?: 'ListingInspectionDetails';
  inspections?: Maybe<Array<Maybe<ListingInspections>>>;
};

export type ListingInspections = {
  __typename?: 'ListingInspections';
  closingDateTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  openingDateTime?: Maybe<Scalars['String']['output']>;
};

export enum AreaUnits {
  /** Return area size in acres. */
  Acres = 'ACRES',
  /** Return area size in hectares. */
  Hectares = 'HECTARES',
  /** Return area size in squared meters. */
  SquareMeters = 'SQUARE_METERS'
}

export type Media = Image | OtherMedia | Video;

export type OtherMedia = {
  __typename?: 'OtherMedia';
  mediaCategory: MediaCategory;
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Video = {
  __typename?: 'Video';
  mediaCategory: MediaCategory;
  previewImage?: Maybe<PreviewImage>;
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  videoId?: Maybe<Scalars['String']['output']>;
};


export type VideoPreviewImageArgs = {
  quality?: InputMaybe<YouTubeThumbnailQuality>;
};

export enum YouTubeThumbnailQuality {
  Hqdefault = 'hqdefault',
  Maxresdefault = 'maxresdefault'
}

export type PreviewImage = {
  __typename?: 'PreviewImage';
  url: Scalars['String']['output'];
};

export type ListingPriceDetails = {
  __typename?: 'ListingPriceDetails';
  bond?: Maybe<Scalars['Float']['output']>;
  canDisplayPrice?: Maybe<Scalars['Boolean']['output']>;
  displayPrice?: Maybe<Scalars['String']['output']>;
  hiddenPriceReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
};

export type Property = Node & {
  __typename?: 'Property';
  address?: Maybe<Address>;
  /** AI-generated summary text for the property. */
  aiPropertySummary?: Maybe<AiPropertySummary>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  /** Gets the building this property is within. */
  building?: Maybe<Building>;
  /** Gets the cadastres for this property. */
  cadastres?: Maybe<Array<Maybe<Cadastre>>>;
  category?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field adds unnecessary complexity to the Property API migration and is not used. */
  claimant?: Maybe<Claimant>;
  /** Gets the comparable sales for this property. */
  comparableSales?: Maybe<Array<Maybe<ComparableSale>>>;
  /** List of feature labels returned from the Property API. */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of features converted from boolean object returned from the Property Feature API. */
  featuresList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The url slug generated by home price guide. */
  hpgSlug?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** The internal area of the property. */
  internalArea?: Maybe<Scalars['Float']['output']>;
  /** The area that the property occupies. */
  landArea?: Maybe<Scalars['Float']['output']>;
  /** The listing attached to this property. */
  listings?: Maybe<Array<Maybe<Listing>>>;
  /** Gets location profile for this property/bedroom combination. */
  locationProfile?: Maybe<LocationProfile>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** If the property is listed for sale on Domain or not. */
  marketStatus?: Maybe<MarketStatus>;
  media?: Maybe<Array<Media>>;
  /** Gets listings that are within the same building and on the same street as this property. */
  neighboringListings?: Maybe<NeighboringListings>;
  parkingSpaces?: Maybe<Scalars['Int']['output']>;
  /** Gets list of perils for this property */
  perils?: Maybe<PropertyPerils>;
  planNumber?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['String']['output']>;
  rentalEstimate?: Maybe<RentalEstimate>;
  sales?: Maybe<Array<Maybe<SalesGrowthList>>>;
  /** Gets nearby schools to this property */
  schools?: Maybe<Array<Maybe<SchoolWithDistance>>>;
  sectionNumber?: Maybe<Scalars['String']['output']>;
  /** Similar properties that are for sale, for rent or sold. */
  similarProperties: Array<Maybe<Property>>;
  /**
   * Provides a textual statement about a property and its neighbourhood.
   * By default, will only be generated for properties which have no sale history, features and photos.
   */
  statement?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the suburb performance for this property.
   * Outputs data from the past 4 years: periodSize=QUARTERS and totalPeriods=16.
   */
  suburbPerformance?: Maybe<SuburbPerformance>;
  supplyDemand?: Maybe<SupplyDemand>;
  timeline?: Maybe<Array<Maybe<PropertyTimelineEvent>>>;
  type?: Maybe<Scalars['String']['output']>;
  valuation?: Maybe<PropertyValuation>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
};


export type PropertyInternalAreaArgs = {
  unit?: InputMaybe<AreaUnits>;
};


export type PropertyLandAreaArgs = {
  unit?: InputMaybe<AreaUnits>;
};


export type PropertyMediaArgs = {
  categories?: InputMaybe<Array<MediaCategory>>;
};


export type PropertySimilarPropertiesArgs = {
  includeForRentProperties: Scalars['Boolean']['input'];
  includeForSaleProperties: Scalars['Boolean']['input'];
  includeSoldProperties: Scalars['Boolean']['input'];
  maxResultsForEachType?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyStatementArgs = {
  alwaysGenerate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyTimelineArgs = {
  category?: InputMaybe<PropertyTimelineEventCategories>;
  hideWarnings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiPropertySummary = {
  __typename?: 'AiPropertySummary';
  activitySection?: Maybe<Scalars['String']['output']>;
  assetSection?: Maybe<Scalars['String']['output']>;
  introSection?: Maybe<Scalars['String']['output']>;
  marketSection?: Maybe<Scalars['String']['output']>;
};

export type Building = {
  __typename?: 'Building';
  /** Building address */
  address?: Maybe<Address>;
  buildingSlug?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  photos?: Maybe<Array<Maybe<BuildingPhoto>>>;
  statistics?: Maybe<BuildingStatistics>;
  /** The URL slug for the street of this building */
  suburbSlug?: Maybe<Scalars['String']['output']>;
  /** Number of units for this building */
  totalNumberOfProperties?: Maybe<Scalars['Int']['output']>;
};

export type BuildingPhoto = {
  __typename?: 'BuildingPhoto';
  advertId?: Maybe<Scalars['String']['output']>;
  fullUrl?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
};

export type BuildingStatistics = {
  __typename?: 'BuildingStatistics';
  averageOwnerOccupierTenureMonths?: Maybe<Scalars['Int']['output']>;
  owners?: Maybe<Scalars['Int']['output']>;
  propertyTypes?: Maybe<Array<Maybe<BuildingPropertyType>>>;
  tenants?: Maybe<Scalars['Int']['output']>;
  tenures?: Maybe<Array<Maybe<BuildingTenure>>>;
};

export type BuildingPropertyType = {
  __typename?: 'BuildingPropertyType';
  forRent?: Maybe<Scalars['Int']['output']>;
  forSale?: Maybe<Scalars['Int']['output']>;
  rentedLast12Months?: Maybe<Scalars['Int']['output']>;
  soldLast12Months?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BuildingTenure = {
  __typename?: 'BuildingTenure';
  count?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type Cadastre = {
  __typename?: 'Cadastre';
  cadastreReference?: Maybe<Scalars['String']['output']>;
  cadastreSubType?: Maybe<Scalars['String']['output']>;
  cadastreType?: Maybe<Scalars['String']['output']>;
  geometries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum Claimant {
  Investor = 'Investor',
  Owner = 'Owner',
  Tenant = 'Tenant',
  Unspecified = 'Unspecified'
}

export type ComparableSale = {
  __typename?: 'ComparableSale';
  address?: Maybe<Scalars['String']['output']>;
  addressCoordinate?: Maybe<ComparableSaleAddressCoordinate>;
  adverts?: Maybe<Array<Maybe<ComparableSaleAdvert>>>;
  areaSize?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  buildingArea?: Maybe<Scalars['Float']['output']>;
  carSpaces?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSaleActivity?: Maybe<ComparableSaleLastSaleActivity>;
  photos?: Maybe<Array<Maybe<ComparableSalePhoto>>>;
  priceHeading?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type ComparableSaleAddressCoordinate = {
  __typename?: 'ComparableSaleAddressCoordinate';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
};

export type ComparableSaleAdvert = {
  __typename?: 'ComparableSaleAdvert';
  displayPrice?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ComparableSaleLastSaleActivity = {
  __typename?: 'ComparableSaleLastSaleActivity';
  date?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ComparableSalePhoto = {
  __typename?: 'ComparableSalePhoto';
  fullUrl?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  rank?: Maybe<Scalars['Int']['output']>;
};

export type LocationProfile = {
  __typename?: 'LocationProfile';
  /** APM location ID for this location */
  apmLocationId?: Maybe<Scalars['Int']['output']>;
  /** Area name of this location */
  areaName?: Maybe<Scalars['String']['output']>;
  /** Detail information for this location */
  data: LocationDetails;
  /** Domain location ID for this location */
  domainLocationId?: Maybe<Scalars['Int']['output']>;
  /** The ID of a location */
  id?: Maybe<Scalars['ID']['output']>;
  /** Legacy location ID for this location */
  locationId?: Maybe<Scalars['Int']['output']>;
  /** Pricefinder location ID for this location */
  pfLocationId?: Maybe<Scalars['String']['output']>;
  /** Postcode for this location */
  postcode?: Maybe<Scalars['String']['output']>;
  /** Region of this location */
  regionName?: Maybe<Scalars['String']['output']>;
  /** State in which this location is located in */
  state?: Maybe<Scalars['String']['output']>;
  /** Name of the suburb that is represented by this location */
  suburbName?: Maybe<Scalars['String']['output']>;
  /** List of all surrounding suburbs for this location */
  surroundingSuburbs?: Maybe<Array<Maybe<SurroundingSuburb>>>;
  /** URL slug for this location */
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export type LocationDetails = {
  __typename?: 'LocationDetails';
  /** Number of apartments and unit for rent in this location */
  apartmentsAndUnitsForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of apartments and unit for sale in this location */
  apartmentsAndUnitsForSale?: Maybe<Scalars['Int']['output']>;
  /** Number of block of units for sale in this location */
  blockOfUnitsForSale?: Maybe<Scalars['Int']['output']>;
  /** Number of duplexes for rent in this location */
  duplexesForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of duplexes for sale in this location */
  duplexesForSale?: Maybe<Scalars['Int']['output']>;
  /** Number of houses for rent in this location */
  housesForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of houses for sale in this location */
  housesForSale?: Maybe<Scalars['Int']['output']>;
  /** Percentage of people who are married and live in this location */
  marriedPercentage?: Maybe<Scalars['Float']['output']>;
  /** The most common age bracket for this location */
  mostCommonAgeBracket?: Maybe<Scalars['String']['output']>;
  /** Percentage of people who own property and live in this location */
  ownerOccupierPercentage?: Maybe<Scalars['Float']['output']>;
  /** Number of penthouses for rent in this location */
  penthousesForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of penthouses for sale in this location */
  penthousesForSale?: Maybe<Scalars['Int']['output']>;
  /** Number of people living in this location */
  population?: Maybe<Scalars['Int']['output']>;
  /** List of categories for this location */
  propertyCategories?: Maybe<Array<Maybe<PropertyCategory>>>;
  /** Percentage of people who are renting and live in this location */
  renterPercentage?: Maybe<Scalars['Float']['output']>;
  /** Number of semi-detached houses for rent in this location */
  semiDetachedHousesForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of semi-detached houses for sale in this location */
  semiDetachedHousesForSale?: Maybe<Scalars['Int']['output']>;
  /** Percentage of people who are single and live in this location */
  singlePercentage?: Maybe<Scalars['Float']['output']>;
  /** Number of studios for rent in this location */
  studiosForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of studios for sale in this location */
  studiosForSale?: Maybe<Scalars['Int']['output']>;
  /** Number of terraced houses for rent in this location */
  terracedHousesForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of terraced houses for sale in this location */
  terracedHousesForSale?: Maybe<Scalars['Int']['output']>;
  /** Number of townhouses for rent in this location */
  townhousesForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of townhouses for sale in this location */
  townhousesForSale?: Maybe<Scalars['Int']['output']>;
  /** Number of villas for rent in this location */
  villasForRent?: Maybe<Scalars['Int']['output']>;
  /** Number of villas for sale in this location */
  villasForSale?: Maybe<Scalars['Int']['output']>;
};

export type PropertyCategory = {
  __typename?: 'PropertyCategory';
  /** The percentage clearance rate of auctions in this category */
  auctionClearanceRate?: Maybe<Scalars['Float']['output']>;
  /** Amount of bedrooms for this category */
  bedrooms?: Maybe<Scalars['Int']['output']>;
  /** Number of days a property has been on the market */
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  /** Number of properties for rent in this category */
  entryLevelPrice?: Maybe<Scalars['Int']['output']>;
  /** Estimated repayments for this category */
  estimatedRepayments?: Maybe<Scalars['Float']['output']>;
  /** Amount of bedrooms for this category */
  forRent?: Maybe<Scalars['Int']['output']>;
  /** Number of properties for sale in this category */
  forSale?: Maybe<Scalars['Int']['output']>;
  /** Price for properties of luxury level */
  luxuryLevelPrice?: Maybe<Scalars['Int']['output']>;
  /** Median weekly rent for this category */
  medianRentPrice?: Maybe<Scalars['Int']['output']>;
  /** Median sold price for this category */
  medianSoldPrice?: Maybe<Scalars['Int']['output']>;
  mostRecentSaleDate?: Maybe<Scalars['String']['output']>;
  /** Number of properties sold */
  numberSold?: Maybe<Scalars['Int']['output']>;
  /** Name of this category */
  propertyCategory?: Maybe<Scalars['String']['output']>;
  /** List of sales in this category */
  salesGrowthList?: Maybe<Array<Maybe<SalesGrowthList>>>;
};

export type SalesGrowthList = {
  __typename?: 'SalesGrowthList';
  /** Amount of annual growth for this year */
  annualGrowth?: Maybe<Scalars['Float']['output']>;
  /** Number of days a property has been on the market for this year */
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  /** Median price the property has been sold for */
  medianSoldPrice?: Maybe<Scalars['Int']['output']>;
  /** Number of properties sold for this year */
  numberSold?: Maybe<Scalars['Int']['output']>;
  /** Year of this entry */
  year?: Maybe<Scalars['Int']['output']>;
};

export type SurroundingSuburb = {
  __typename?: 'SurroundingSuburb';
  /** Name of the suburb */
  name?: Maybe<Scalars['String']['output']>;
  /** URL slug for the suburb */
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export enum MarketStatus {
  OffMarket = 'OFF_MARKET',
  OnMarket = 'ON_MARKET'
}

export type NeighboringListings = {
  __typename?: 'NeighboringListings';
  building?: Maybe<SearchListingsResultListing>;
  street?: Maybe<SearchListingsResultListing>;
};

export type SearchListingsResultListing = BaseListing & {
  __typename?: 'SearchListingsResultListing';
  /** Agency details */
  agency?: Maybe<SearchListingsAgency>;
  /** Auction details */
  auctionDetails?: Maybe<SearchListingsAuctionDetails>;
  /** Total number of bathrooms in the property */
  bathrooms?: Maybe<Scalars['Float']['output']>;
  /** Total number of bedrooms in the property; Studio apartments have a value of "0" */
  bedrooms?: Maybe<Scalars['Float']['output']>;
  /** Branding appearance: dark or light */
  brandingAppearance?: Maybe<Scalars['String']['output']>;
  /** Building Area in square meters */
  buildingArea?: Maybe<BuildingArea>;
  /** Total number of car spaces in the property. */
  carspaces?: Maybe<Scalars['Float']['output']>;
  /**
   * The date that the property becomes available. Will be null if not specified.
   * @deprecated Use `dateAvailableV2`
   */
  dateAvailable?: Maybe<Scalars['String']['output']>;
  /** The date that the property becomes available. Will be null if not specified. */
  dateAvailableV2?: Maybe<DateTime>;
  /**
   * The date that the property was last listed. Will be null if not specified.
   * @deprecated Use `dateListedV2`
   */
  dateListed?: Maybe<Scalars['String']['output']>;
  /** The date that the property was last listed. Will be null if not specified. */
  dateListedV2?: Maybe<DateTime>;
  /** Encapsulates the parts that make up an Address */
  displayableAddress?: Maybe<Address>;
  /**
   * Listing displayPrice
   * @deprecated Use priceDetails instead
   */
  displayPrice?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  hasFloorPlan: Scalars['Boolean']['output'];
  /** Indicates if a listing has matterport interior or exterior virtual tour */
  hasMatterport: Scalars['Boolean']['output'];
  /** Indicates if a listing has an associated video */
  hasVideo: Scalars['Boolean']['output'];
  /** Brief one line text */
  headline?: Maybe<Scalars['String']['output']>;
  /** Hero image of the property */
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  /** Inspection details */
  inspectionDetails?: Maybe<InspectionDetails>;
  isNew: Scalars['Boolean']['output'];
  /** Indicates if a listing is a retirement living */
  isRetirement: Scalars['Boolean']['output'];
  /**
   * Flag to indicate whether the listing is Rural or not.
   *             Rural listing can have various different property types (one of them is "Rural" Property Type)
   *             So we can't use Property Type(s) alone to identify Rural Listings
   *             This flag is being set based on property type and area (should be more than 4 hac) of listing
   */
  isRural: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Scalars['String']['output']>>;
  /** Land size and unit in square meter or hectre */
  landArea?: Maybe<LandArea>;
  listingId: Scalars['Int']['output'];
  /** SEO URL slug to link to the listing on Domain */
  listingSlug?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<SearchListingsType>;
  /** For virtual tours, Matterport URLs */
  matterport?: Maybe<Matterport>;
  /** The media associated with the property provided by the advertiser */
  media?: Maybe<Array<Media>>;
  onlyShowProperties?: Maybe<Array<Scalars['String']['output']>>;
  priceDetails?: Maybe<PriceDetails>;
  priceFromApm?: Maybe<Scalars['Boolean']['output']>;
  project?: Maybe<Project>;
  promoLevel?: Maybe<PromoLevel>;
  propertyLabels?: Maybe<Array<SearchListingsResultsPropertyLabel>>;
  propertyType?: Maybe<SearchListingsPropertyType>;
  propertyTypes?: Maybe<Array<SearchListingsPropertyType>>;
  soldData?: Maybe<SoldDetails>;
  summaryDescription?: Maybe<Scalars['String']['output']>;
  /** A set of semi-arbitrary strings describing the listing */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  topSpotKeywords?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents a Base Property Listing */
export type BaseListing = {
  agency?: Maybe<AgencyDetails>;
  /** Total number of bathrooms in the property */
  bathrooms?: Maybe<Scalars['Float']['output']>;
  /** Total number of bedrooms in the property; Studio apartments have a value of "0" */
  bedrooms?: Maybe<Scalars['Float']['output']>;
  /** Total number of car spaces in the property. */
  carspaces?: Maybe<Scalars['Float']['output']>;
  /**
   * The date that the property becomes available. Will be null if not specified.
   * @deprecated Use `dateAvailableV2`
   */
  dateAvailable?: Maybe<Scalars['String']['output']>;
  /** The date that the property becomes available. Will be null if not specified. */
  dateAvailableV2?: Maybe<DateTime>;
  /**
   * The date that the property was last listed. Will be null if not specified.
   * @deprecated Use `dateListedV2`
   */
  dateListed?: Maybe<Scalars['String']['output']>;
  /** The date that the property was last listed. Will be null if not specified. */
  dateListedV2?: Maybe<DateTime>;
  /**
   * Address to display on the Domain website
   * Encapsulates the parts that make up an Address
   * AddressParts from Listings API
   */
  displayableAddress?: Maybe<Address>;
  /** Brief one line text */
  headline?: Maybe<Scalars['String']['output']>;
  /** Hero image of the property */
  heroImage?: Maybe<Image>;
  /**
   * Listing ID.
   * * Premarket Listing id is an UUID String
   * * Other Listing / Project id is Int
   */
  id: Scalars['ID']['output'];
  /** Inspection details */
  inspectionDetails?: Maybe<InspectionDetails>;
  /** The media associated with the property provided by the advertiser */
  media?: Maybe<Array<Media>>;
  priceDetails?: Maybe<PriceDetails>;
  /**
   * Available Listing promotional levels.
   * Please note that the Listings API is not the source of truth for promo levels.
   * They are being supplied here for backwards compatibility. As such, and to avoid breaking changes, promo levels will be exposed using the legacy, pre-2017, names(e.g.Standard, Elite, Elite PP, etc.).
   * Mapping the new promo levels to the old ones can involve some loss of information, e.g.the new Platinum Extend is mapped to the old Premium Plus. To retrieve fully accurate promo levels, enumerated with the full set of promo level names, please use the Booking API.
   */
  promoLevel?: Maybe<PromoLevel>;
};

export type AgencyDetails = Agency | SearchListingsAgency;

export type SearchListingsAgency = {
  __typename?: 'SearchListingsAgency';
  accountType?: Maybe<Scalars['String']['output']>;
  agencyId: Scalars['Int']['output'];
  branding?: Maybe<SearchListingsAgencyBranding>;
  contacts?: Maybe<Array<SearchListingsAgencyContact>>;
  name?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SearchListingsAgencyType>;
};

export type SearchListingsAgencyBranding = {
  __typename?: 'SearchListingsAgencyBranding';
  banner?: Maybe<Image>;
  logo?: Maybe<Image>;
  logoColour?: Maybe<Scalars['String']['output']>;
};

export type SearchListingsAgencyContact = {
  __typename?: 'SearchListingsAgencyContact';
  name?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Image>;
};

export enum SearchListingsAgencyType {
  Agency = 'Agency',
  Private = 'Private'
}

export type DateTime = {
  __typename?: 'DateTime';
  day: Scalars['Int']['output'];
  dayOfWeek: Scalars['String']['output'];
  isoDate: Scalars['String']['output'];
  isoDateWithTimeZone: Scalars['String']['output'];
  month: Scalars['String']['output'];
  time: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type InspectionDetails = {
  __typename?: 'InspectionDetails';
  /** True or False indicating whether the inspection is by appointment only */
  byAppointmentOnly: Scalars['Boolean']['output'];
  /** This inspection is based on the searchParams 'inspectionFrom' */
  currentInspection?: Maybe<Inspection>;
  inspections?: Maybe<Array<Inspection>>;
  nextInspection?: Maybe<Inspection>;
  /** Timezone of the location of the property */
  timezone: Scalars['String']['output'];
};

export type Inspection = {
  __typename?: 'Inspection';
  closingDateTime: DateTime;
  /**
   * Description of the inspection provided by the Advertiser.
   * When listings are bulk uploaded, inspection times are provided as a string. Other inspection details will not be provided
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * opening time - closing time
   * eg: 10.00am - 11.30am
   */
  displayableTimeFrame: Scalars['String']['output'];
  openingDateTime: DateTime;
  /** To denote if the inspection repeats every week */
  repeat: Scalars['Boolean']['output'];
};

export type PriceDetails = {
  __typename?: 'PriceDetails';
  bond?: Maybe<Scalars['Float']['output']>;
  /** Flag indicating whether the advertiser has chosen to display the property price */
  canDisplayPrice?: Maybe<Scalars['Boolean']['output']>;
  /** A string provided by the Advertiser representing the ByIdListingPriceQueryResult of the Listing e.g. Over $1,000,000 This should be the default price field for client to use */
  displayPrice?: Maybe<Scalars['String']['output']>;
  /**
   * Search price range.
   * This field is populated only if the display price doesn’t contain the price.
   */
  displayPriceRange?: Maybe<DisplayPriceRange>;
  rawValues?: Maybe<PriceValues>;
};

export type DisplayPriceRange = {
  __typename?: 'DisplayPriceRange';
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
};

export type PriceValues = {
  __typename?: 'PriceValues';
  /** exact price in integer */
  exactPrice?: Maybe<Scalars['Int']['output']>;
  /** exact price in float from listing api */
  exactPriceV2?: Maybe<Scalars['Float']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export enum PromoLevel {
  /** Branded, formerly known as Elite */
  Elite = 'ELITE',
  /** Gold, formerly known as Elite PP */
  ElitePp = 'ELITE_PP',
  Premium = 'PREMIUM',
  /** Formerly known as Premium Plus, this value now encapsulates both Platinum and Platinum Extend. For explicit values, please use the Booking API. */
  PremiumPlus = 'PREMIUM_PLUS',
  /** Basic, formerly known as Standard */
  Standard = 'STANDARD',
  /** Silver, formerly known as Standard PP */
  StandardPp = 'STANDARD_PP'
}

export type SearchListingsAuctionDetails = {
  __typename?: 'SearchListingsAuctionDetails';
  auctionedDate?: Maybe<DateTime>;
  auctionedPrice?: Maybe<PriceDetails>;
  auctionSchedule?: Maybe<SearchListingsAuctionSchedule>;
};

export type SearchListingsAuctionSchedule = {
  __typename?: 'SearchListingsAuctionSchedule';
  locationDescription?: Maybe<Scalars['String']['output']>;
  openingDateTime: DateTime;
};

export type BuildingArea = {
  __typename?: 'BuildingArea';
  size: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type LandArea = {
  __typename?: 'LandArea';
  size: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export enum SearchListingsType {
  NewHomes = 'NewHomes',
  Rent = 'Rent',
  Sale = 'Sale',
  Share = 'Share',
  Sold = 'Sold'
}

export type Matterport = {
  __typename?: 'Matterport';
  exterior?: Maybe<MatterportTour>;
  interior?: Maybe<MatterportTour>;
  source?: Maybe<Scalars['String']['output']>;
};

export type MatterportTour = {
  __typename?: 'MatterportTour';
  preview?: Maybe<PreviewImage>;
  url: Scalars['String']['output'];
};

export type Project = {
  __typename?: 'Project';
  /** Agency details */
  agency?: Maybe<Agency>;
  agents?: Maybe<Array<Agent>>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<ProjectBanner>;
  /** Brochure url */
  brochureUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<ProjectCategory>;
  /** Child listings under the project */
  childListings?: Maybe<Array<ListingDetails>>;
  createdDate?: Maybe<DateTime>;
  description?: Maybe<Scalars['String']['output']>;
  developmentDetails?: Maybe<DevelopmentDetails>;
  /**
   * address that can be displayed based on agent decision to disclose
   * by FullAddress, StreetAndSuburb, SuburbOnly, or StateOnly.
   */
  displayableAddress?: Maybe<Address>;
  displayAd?: Maybe<DisplayAd>;
  endDate?: Maybe<DateTime>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  headline?: Maybe<Scalars['String']['output']>;
  /** Hero image of the project */
  heroImage?: Maybe<Image>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Inspection details */
  inspectionDetails?: Maybe<InspectionDetails>;
  logo?: Maybe<Scalars['String']['output']>;
  /** Masterplan of the project */
  masterplan?: Maybe<Masterplan>;
  /** List of all the images and video of the project */
  media?: Maybe<Array<Media>>;
  /** Name of the project */
  name?: Maybe<Scalars['String']['output']>;
  /** Other projects associated with the agency */
  otherProjects?: Maybe<Array<Project>>;
  projectUrl?: Maybe<Scalars['String']['output']>;
  promoLevel?: Maybe<ProjectPromoLevel>;
  propertyTypes?: Maybe<Array<ListingPropertyType>>;
  schools?: Maybe<NearbySchools>;
  startDate?: Maybe<DateTime>;
  staticMapUrl?: Maybe<Scalars['String']['output']>;
  suburbProfile?: Maybe<LocationProfile>;
  /** Project tagline */
  tagline?: Maybe<Scalars['String']['output']>;
  trackingMetadata?: Maybe<Scalars['String']['output']>;
  /** display suite */
  viewingAddress?: Maybe<Address>;
};

export type ProjectBanner = {
  __typename?: 'ProjectBanner';
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

export enum ProjectCategory {
  Apartment = 'APARTMENT',
  HouseAndLand = 'HOUSE_AND_LAND',
  Retirement = 'RETIREMENT'
}

export type ListingDetails = BaseListing & {
  __typename?: 'ListingDetails';
  agency?: Maybe<Agency>;
  agents?: Maybe<Array<Agent>>;
  auctionDetails?: Maybe<ListingDetailsAuctionDetails>;
  /** The auction result for this listing */
  auctionResult?: Maybe<ListingAuctionResult>;
  /** Total number of bathrooms in the property */
  bathrooms?: Maybe<Scalars['Float']['output']>;
  /** Total number of bedrooms in the property; Studio apartments have a value of "0" */
  bedrooms?: Maybe<Scalars['Float']['output']>;
  broadbandDetails?: Maybe<BroadbandDetails>;
  buildingArea?: Maybe<BuildingArea>;
  /**
   * Building and pest report product.
   * If agencyId is in excludeBeforeYouBidAgencies feature flag, it will return null.
   */
  bybPropertyReportProductPreferred?: Maybe<BybPropertyReportProduct>;
  /** Total number of car spaces in the property. */
  carspaces?: Maybe<Scalars['Float']['output']>;
  channel?: Maybe<ListingDetailsChannel>;
  /**
   * The date that the property becomes available. Will be null if not specified.
   * @deprecated Use `dateAvailableV2`
   */
  dateAvailable?: Maybe<Scalars['String']['output']>;
  /** The date that the property becomes available. Will be null if not specified. */
  dateAvailableV2?: Maybe<DateTime>;
  /** The date that the property was created. Will be null if not specified. */
  dateCreated?: Maybe<DateTime>;
  /**
   * The date that the property was last listed. Will be null if not specified.
   * @deprecated Use `dateListedV2`
   */
  dateListed?: Maybe<Scalars['String']['output']>;
  /** The date that the property was last listed. Will be null if not specified. */
  dateListedV2?: Maybe<DateTime>;
  /** The date that the property was updated. Will be null if not specified. */
  dateUpdated?: Maybe<DateTime>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Address to display on the Domain website
   * Encapsulates the parts that make up an Address
   * AddressParts from Listings API
   */
  displayableAddress?: Maybe<Address>;
  energyEfficiencyRating?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  floorPlan?: Maybe<Image>;
  floorPlans?: Maybe<Array<Image>>;
  /** Indicates if a listing has matterport interior or exterior virtual tour */
  hasMatterport: Scalars['Boolean']['output'];
  /** ThirdPartyRentalForm */
  hasThirdPartyRentalForm?: Maybe<Scalars['Boolean']['output']>;
  /** Brief one line text */
  headline?: Maybe<Scalars['String']['output']>;
  /** Hero image of the listing */
  heroImage?: Maybe<Image>;
  /**
   * Listing ID.
   * * Other Listing / Project id is Int
   */
  id: Scalars['ID']['output'];
  /** Inspection details */
  inspectionDetails?: Maybe<InspectionDetails>;
  isRural?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates whether the current user has shortlisted this listing.
   * Returns false if the user is not authenticated.
   */
  isShortlisted: Scalars['Boolean']['output'];
  isWithdrawn?: Maybe<Scalars['Boolean']['output']>;
  landArea?: Maybe<LandArea>;
  landAreaSqm?: Maybe<Scalars['Float']['output']>;
  /** The highlights for this listing */
  listingHighlights: Array<ListingHighlight>;
  listingId: Scalars['Int']['output'];
  listingMode?: Maybe<ListingMode>;
  /** The user note for this listing */
  listingNote?: Maybe<ListingNote>;
  listingType: ListingType;
  /** For virtual tours, Matterport URLs */
  matterport?: Maybe<Matterport>;
  /** The media associated with the property provided by the advertiser */
  media?: Maybe<Array<Media>>;
  metadata?: Maybe<ListingDetailsMetadata>;
  nbnDetails?: Maybe<NbnDetails>;
  numberOfDwellings?: Maybe<Scalars['Int']['output']>;
  objective?: Maybe<ListingDetailsObjective>;
  priceDetails?: Maybe<PriceDetails>;
  /** The price update for this listing */
  priceUpdate?: Maybe<ListingPriceUpdate>;
  /**
   * Parent project if the listing is a child listing.
   * returns null for resi listings.
   */
  project?: Maybe<Project>;
  promoLevel: PromoLevel;
  property?: Maybe<Property>;
  propertyTypes?: Maybe<Array<ListingPropertyType>>;
  /** Information for the listing provider. e.g. bulkuploader information */
  providerDetails?: Maybe<ProviderDetails>;
  /** The rental detail's of the listing in case of it being for rent or leased */
  rentalDetails?: Maybe<RentalDetails>;
  /** The method of sale for an advertised listing */
  saleMethod?: Maybe<SaleMethod>;
  schools?: Maybe<NearbySchools>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  shortlistTags?: Maybe<Array<ListingDetailsShortlistTag>>;
  soldDetails?: Maybe<SoldDetails>;
  statementOfInformation?: Maybe<StatementOfInformation>;
  staticMapUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ListingStatus>;
  structuredFeatures?: Maybe<Array<ListingDetailsStructuredFeature>>;
  suburbProfile?: Maybe<LocationProfile>;
  thirdPartyRentalForm?: Maybe<ThirdPartyRentalForm>;
  virtualTourTier?: Maybe<VirtualTourTier>;
  virtualTourUrl?: Maybe<Scalars['String']['output']>;
};


export type ListingDetailsBybPropertyReportProductPreferredArgs = {
  enableInstigate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ListingDetailsListingHighlightsArgs = {
  maxHighlights?: Scalars['Int']['input'];
};

export type ListingDetailsAuctionDetails = {
  __typename?: 'ListingDetailsAuctionDetails';
  /** Only visible if allowed by advertiser and listing has been auctioned */
  auctionedDate?: Maybe<DateTime>;
  /** Only visible if allowed by advertiser and listing has been auctioned */
  auctionedPrice?: Maybe<PriceDetails>;
  auctionSchedule?: Maybe<ListingDetailsAuctionSchedule>;
};

export type ListingDetailsAuctionSchedule = {
  __typename?: 'ListingDetailsAuctionSchedule';
  locationDescription?: Maybe<Scalars['String']['output']>;
  openingDateTime?: Maybe<DateTime>;
  terms?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Auction result for a listing */
export type ListingAuctionResult = {
  __typename?: 'ListingAuctionResult';
  /** The date of the auction */
  auctionDate?: Maybe<Scalars['String']['output']>;
  /** The sale price of the auction */
  price?: Maybe<Scalars['Int']['output']>;
  /** The sale type of the auction */
  saleType?: Maybe<Scalars['String']['output']>;
};

export type BroadbandDetails = {
  __typename?: 'BroadbandDetails';
  adConfig?: Maybe<BroadbandAdConfig>;
  locId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  serviceClass?: Maybe<Scalars['Int']['output']>;
  technology?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BroadbandAdConfig = {
  __typename?: 'BroadbandAdConfig';
  body?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BybPropertyReportProduct = {
  __typename?: 'BybPropertyReportProduct';
  addressSlug?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  eta?: Maybe<Scalars['String']['output']>;
  etaReportUploadDatetime?: Maybe<Scalars['String']['output']>;
  fullCost?: Maybe<Scalars['Float']['output']>;
  inspectionDatetime?: Maybe<Scalars['String']['output']>;
  isDynamicPricing?: Maybe<Scalars['Boolean']['output']>;
  isInstigated?: Maybe<Scalars['Boolean']['output']>;
  isReportLive?: Maybe<Scalars['Boolean']['output']>;
  isSecondChargeOptional?: Maybe<Scalars['Boolean']['output']>;
  longDisclaimer?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productModel?: Maybe<Scalars['String']['output']>;
  purchaseEndpoint?: Maybe<Scalars['String']['output']>;
  purchaseLink?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<BybReportType>;
  reportUploadedAt?: Maybe<Scalars['String']['output']>;
  secondCharge?: Maybe<Scalars['Float']['output']>;
  shortDisclaimer?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum BybReportType {
  BuildingPest = 'BUILDING_PEST',
  Strata = 'STRATA'
}

export enum ListingDetailsChannel {
  Business = 'BUSINESS',
  Commercial = 'COMMERCIAL',
  Residential = 'RESIDENTIAL'
}

/** Most relevant and time-sensitive information about a property at a glance */
export type ListingHighlight = {
  __typename?: 'ListingHighlight';
  /** The category of the highlight */
  category: ListingHighlightCategory;
  /** Label text */
  text: Scalars['String']['output'];
  /** The tone of status */
  tone: ListingHighlightTone;
};

/** The category of the listing highlight, which indicates the type of information being highlighted. */
export enum ListingHighlightCategory {
  /** If the property is live - auction */
  Auction = 'AUCTION',
  /** Auction result event such as postponed, withdrawn, passed in */
  AuctionResultEvent = 'AUCTION_RESULT_EVENT',
  /** Available from a date in the future */
  Availability = 'AVAILABILITY',
  /** New or listed X days ago */
  Freshness = 'FRESHNESS',
  /** If the property is live - inspection */
  Inspection = 'INSPECTION',
  /** Sold, Leased, Archived, Under Offer, Deposit Taken */
  Status = 'STATUS'
}

/** The tone of the listing highlight, which indicates the sentiment or urgency of the information being highlighted. */
export type ListingHighlightTone = {
  __typename?: 'ListingHighlightTone';
  /** The hex code of the badge color */
  hexBadge: Scalars['String']['output'];
  /** The hex code of the text color */
  hexText: Scalars['String']['output'];
  /** The name of the tone */
  name: ListingHighlightToneName;
};

/** The tone of the listing highlight, which indicates the sentiment or urgency of the information being highlighted. */
export enum ListingHighlightToneName {
  /**
   * Orange/Yellow - Availability transition
   * Examples: Under offer / deposit taken
   */
  AvailabilityTransition = 'AVAILABILITY_TRANSITION',
  /**
   * Aqua/Teal - Exciting opportunity, attention
   * Examples: Updated, passed-in at auction
   */
  ExcitingOpportunity = 'EXCITING_OPPORTUNITY',
  /** Green - New! */
  New = 'NEW',
  /**
   * Red/Pink - No longer available
   * Examples: Leased / sold / sold at auction
   */
  NoLongerAvailable = 'NO_LONGER_AVAILABLE',
  /**
   * Purple - Upcoming, mark the date
   * Examples: Inspections / auctions upcoming
   */
  Upcoming = 'UPCOMING',
  /**
   * Grey - User status
   * Examples: Viewed
   */
  UserStatus = 'USER_STATUS'
}

export enum ListingMode {
  Archived = 'ARCHIVED',
  Buy = 'BUY',
  Leased = 'LEASED',
  Rent = 'RENT',
  Share = 'SHARE',
  Sold = 'SOLD'
}

/** A note added by the user to a listing */
export type ListingNote = {
  __typename?: 'ListingNote';
  /** The date the note was last updated */
  lastUpdatedDate?: Maybe<DateTime>;
  /** The note text */
  text: Scalars['String']['output'];
};

export enum ListingType {
  Child = 'CHILD',
  Premarket = 'PREMARKET',
  Project = 'PROJECT',
  Residential = 'RESIDENTIAL'
}

export type ListingDetailsMetadata = {
  __typename?: 'ListingDetailsMetadata';
  trackingMetadata?: Maybe<Scalars['String']['output']>;
};

export type NbnDetails = {
  __typename?: 'NbnDetails';
  downloadSpeedInMbps?: Maybe<Scalars['String']['output']>;
  serviceStatus?: Maybe<Scalars['String']['output']>;
  speedTier?: Maybe<Scalars['String']['output']>;
  techType?: Maybe<NbnTechType>;
  uploadSpeedInMbps?: Maybe<Scalars['String']['output']>;
};

export enum NbnTechType {
  Fttb = 'FTTB',
  Fttc = 'FTTC',
  Fttn = 'FTTN',
  Fttp = 'FTTP',
  Hfc = 'HFC',
  Satellite = 'SATELLITE',
  Wireless = 'WIRELESS'
}

export enum ListingDetailsObjective {
  Rent = 'RENT',
  Sale = 'SALE'
}

/** Price update for a listing */
export type ListingPriceUpdate = {
  __typename?: 'ListingPriceUpdate';
  /** The current price */
  currentPrice?: Maybe<Scalars['String']['output']>;
  /** The date the current price was updated */
  currentPriceUpdated?: Maybe<Scalars['String']['output']>;
  /** The previous price */
  lastPrice?: Maybe<Scalars['String']['output']>;
  /** The date the previous price was updated */
  lastUpdated?: Maybe<Scalars['String']['output']>;
};

export enum ListingPropertyType {
  AcreageSemiRural = 'ACREAGE_SEMI_RURAL',
  ApartmentUnitFlat = 'APARTMENT_UNIT_FLAT',
  Aquaculture = 'AQUACULTURE',
  BlockOfUnits = 'BLOCK_OF_UNITS',
  Carspace = 'CARSPACE',
  ChickenShop = 'CHICKEN_SHOP',
  Cropping = 'CROPPING',
  DairyFarming = 'DAIRY_FARMING',
  DeliCafe = 'DELI_CAFE',
  DevelopmentLand = 'DEVELOPMENT_LAND',
  DevelopmentSite = 'DEVELOPMENT_SITE',
  Duplex = 'DUPLEX',
  Equine = 'EQUINE',
  Farm = 'FARM',
  Farmlet = 'FARMLET',
  FishingForestry = 'FISHING_FORESTRY',
  Grazing = 'GRAZING',
  HomeBased = 'HOME_BASED',
  Horticulture = 'HORTICULTURE',
  HotelLeisure = 'HOTEL_LEISURE',
  House = 'HOUSE',
  IndustrialWarehouse = 'INDUSTRIAL_WAREHOUSE',
  International = 'INTERNATIONAL',
  IrrigationServices = 'IRRIGATION_SERVICES',
  Livestock = 'LIVESTOCK',
  MedicalConsulting = 'MEDICAL_CONSULTING',
  MixedFarming = 'MIXED_FARMING',
  NewApartments = 'NEW_APARTMENTS',
  NewHomeDesigns = 'NEW_HOME_DESIGNS',
  NewHouseLand = 'NEW_HOUSE_LAND',
  NewLand = 'NEW_LAND',
  Offices = 'OFFICES',
  OnlineBusiness = 'ONLINE_BUSINESS',
  Orchard = 'ORCHARD',
  Other = 'OTHER',
  ParkingCarSpace = 'PARKING_CAR_SPACE',
  Penthouse = 'PENTHOUSE',
  Retail = 'RETAIL',
  Retirement = 'RETIREMENT',
  Rural = 'RURAL',
  RuralCommercialFarming = 'RURAL_COMMERCIAL_FARMING',
  RuralLifestyle = 'RURAL_LIFESTYLE',
  SeafoodShop = 'SEAFOOD_SHOP',
  SemiDetached = 'SEMI_DETACHED',
  ServicedOffices = 'SERVICED_OFFICES',
  ShowroomsBulkyGoods = 'SHOWROOMS_BULKY_GOODS',
  SpecialistFarm = 'SPECIALIST_FARM',
  Studio = 'STUDIO',
  Terrace = 'TERRACE',
  Townhouse = 'TOWNHOUSE',
  Unknown = 'UNKNOWN',
  VacantLand = 'VACANT_LAND',
  Villa = 'VILLA',
  Viticulture = 'VITICULTURE'
}

export type ProviderDetails = {
  __typename?: 'ProviderDetails';
  providerAdID?: Maybe<Scalars['String']['output']>;
  providerSystem?: Maybe<Scalars['String']['output']>;
};

export type RentalDetails = {
  __typename?: 'RentalDetails';
  /** The Date the listing was leased. DateTime is in a local timezone. */
  leasedDate?: Maybe<DateTime>;
  /** The rental method of the advertised listing */
  rentalMethod?: Maybe<RentalMethod>;
};

export enum RentalMethod {
  Holiday = 'HOLIDAY',
  Lease = 'LEASE',
  NotStated = 'NOT_STATED',
  Rent = 'RENT',
  Share = 'SHARE'
}

export enum SaleMethod {
  Auction = 'AUCTION',
  ExpressionOfInterest = 'EXPRESSION_OF_INTEREST',
  NotStated = 'NOT_STATED',
  PrivateTreaty = 'PRIVATE_TREATY',
  Tender = 'TENDER'
}

export type NearbySchools = {
  __typename?: 'NearbySchools';
  /** @deprecated Use governmentSchoolsV2 to include more details */
  governmentSchools?: Maybe<Array<SchoolWithDistance>>;
  governmentSchoolsV2?: Maybe<Array<GovernmentSchoolWithDistance>>;
  independentSchools?: Maybe<Array<SchoolWithDistance>>;
};

export type SchoolWithDistance = {
  __typename?: 'SchoolWithDistance';
  distance?: Maybe<Scalars['Float']['output']>;
  school?: Maybe<School>;
};

export type GovernmentSchoolWithDistance = {
  __typename?: 'GovernmentSchoolWithDistance';
  bucket?: Maybe<GovernmentSchoolBucket>;
  distance?: Maybe<Scalars['Float']['output']>;
  school?: Maybe<School>;
};

export enum GovernmentSchoolBucket {
  InCatchment = 'InCatchment',
  Nearby = 'Nearby'
}

export type ListingDetailsShortlistTag = {
  __typename?: 'ListingDetailsShortlistTag';
  label?: Maybe<Scalars['String']['output']>;
  type: ListingDetailsShortlistTagType;
};

export enum ListingDetailsShortlistTagType {
  Archived = 'ARCHIVED',
  Buy = 'BUY',
  DepositTaken = 'DEPOSIT_TAKEN',
  Leased = 'LEASED',
  NewDevelopment = 'NEW_DEVELOPMENT',
  NewHome = 'NEW_HOME',
  PassedInAtAuction = 'PASSED_IN_AT_AUCTION',
  Rent = 'RENT',
  Sold = 'SOLD',
  SoldLastSixMonths = 'SOLD_LAST_SIX_MONTHS',
  SoldLastYear = 'SOLD_LAST_YEAR',
  UnderOffer = 'UNDER_OFFER',
  Updated = 'UPDATED',
  WithdrawnFromAuction = 'WITHDRAWN_FROM_AUCTION'
}

export type SoldDetails = {
  __typename?: 'SoldDetails';
  canDisplayPrice?: Maybe<Scalars['Boolean']['output']>;
  governmentRecordedSoldPrice?: Maybe<PriceDetails>;
  priceSource?: Maybe<SoldDetailsPriceSource>;
  publishSource?: Maybe<SoldDetailsPublishSource>;
  saleMethod?: Maybe<SoldDetailsSaleMethod>;
  soldDate?: Maybe<DateTime>;
  soldPrice?: Maybe<PriceDetails>;
  /** @deprecated Use `priceSource` */
  source?: Maybe<SoldDetailsPriceSource>;
};

export enum SoldDetailsPriceSource {
  Agency = 'Agency',
  Apm = 'Apm'
}

export enum SoldDetailsPublishSource {
  External = 'External',
  Internal = 'Internal'
}

export enum SoldDetailsSaleMethod {
  ExpressionOfInterest = 'ExpressionOfInterest',
  NotStated = 'NotStated',
  SoldByAuction = 'SoldByAuction',
  SoldByPrivateTreaty = 'SoldByPrivateTreaty',
  SoldByTender = 'SoldByTender',
  SoldPriorToAuction = 'SoldPriorToAuction',
  Withdrawn = 'Withdrawn'
}

export type StatementOfInformation = {
  __typename?: 'StatementOfInformation';
  comparableData?: Maybe<ComparableData>;
  documentationUrl?: Maybe<Scalars['String']['output']>;
  estimatedPrice?: Maybe<EstimatedPrice>;
  suburbMedianPrice?: Maybe<SuburbMedianPrice>;
};

export type ComparableData = {
  __typename?: 'ComparableData';
  comparableProperty?: Maybe<Array<Maybe<ComparableProperty>>>;
  declarationText?: Maybe<Scalars['String']['output']>;
};

export type ComparableProperty = {
  __typename?: 'ComparableProperty';
  dateOfSale?: Maybe<Scalars['String']['output']>;
  displayAddress?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  soldPrice?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type EstimatedPrice = {
  __typename?: 'EstimatedPrice';
  from?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
};

export type SuburbMedianPrice = {
  __typename?: 'SuburbMedianPrice';
  medianPrice?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceCollectionDate?: Maybe<Scalars['String']['output']>;
  sourceDateFrom?: Maybe<Scalars['String']['output']>;
  sourceDateTo?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export enum ListingStatus {
  Archived = 'ARCHIVED',
  DepositTaken = 'DEPOSIT_TAKEN',
  Leased = 'LEASED',
  Live = 'LIVE',
  New = 'NEW',
  NewDevelopment = 'NEW_DEVELOPMENT',
  Pending = 'PENDING',
  RecentlyUpdated = 'RECENTLY_UPDATED',
  Sold = 'SOLD',
  UnderOffer = 'UNDER_OFFER',
  Unknown = 'UNKNOWN'
}

/** Structured feature */
export type ListingDetailsStructuredFeature = {
  __typename?: 'ListingDetailsStructuredFeature';
  /** Category name */
  category?: Maybe<Scalars['String']['output']>;
  /** Name of the feature */
  name?: Maybe<Scalars['String']['output']>;
  /** Source of the feature */
  source?: Maybe<ListingDetailsStructuredFeatureSource>;
};

export enum ListingDetailsStructuredFeatureSource {
  Advertiser = 'ADVERTISER',
  Suggested = 'SUGGESTED'
}

export type ThirdPartyRentalForm = {
  __typename?: 'ThirdPartyRentalForm';
  apply?: Maybe<ThirdPartyRentalFormProvider>;
  booking?: Maybe<ThirdPartyRentalFormProvider>;
};

export type ThirdPartyRentalFormProvider = {
  __typename?: 'ThirdPartyRentalFormProvider';
  provider: Scalars['String']['output'];
  system: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum VirtualTourTier {
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type DevelopmentDetails = {
  __typename?: 'DevelopmentDetails';
  buildingHeight?: Maybe<DevelopmentDetailValueRange>;
  estimatedCompletionDate?: Maybe<EstimatedCompletionDate>;
  floorCount?: Maybe<DevelopmentDetailValueRange>;
  numberOfBuildings?: Maybe<DevelopmentDetailValue>;
  numberOfResidences?: Maybe<DevelopmentDetailValue>;
  priceFrom?: Maybe<DevelopmentDetailValue>;
};

export type DevelopmentDetailValueRange = {
  __typename?: 'DevelopmentDetailValueRange';
  displayText?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
};

export type EstimatedCompletionDate = {
  __typename?: 'EstimatedCompletionDate';
  displayText?: Maybe<Scalars['String']['output']>;
  estimatedCompletionDate?: Maybe<Scalars['String']['output']>;
  estimatedCompletionTertile?: Maybe<EstimateCompletionTertile>;
};

export enum EstimateCompletionTertile {
  Early = 'EARLY',
  Late = 'LATE',
  Mid = 'MID'
}

export type DevelopmentDetailValue = {
  __typename?: 'DevelopmentDetailValue';
  displayText?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type DisplayAd = {
  __typename?: 'DisplayAd';
  imageUrl?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type Masterplan = {
  __typename?: 'Masterplan';
  allowEnquiry: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum ProjectPromoLevel {
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type SearchListingsResultsPropertyLabel = {
  __typename?: 'SearchListingsResultsPropertyLabel';
  label: Scalars['String']['output'];
  propertyStatus: SearchListingsPropertyLabelStatus;
};

export enum SearchListingsPropertyLabelStatus {
  Auction = 'Auction',
  DepositTaken = 'DepositTaken',
  Inspection = 'Inspection',
  Leased = 'Leased',
  New = 'New',
  NewHomes = 'NewHomes',
  Sold = 'Sold',
  UnderOffer = 'UnderOffer',
  Unknown = 'Unknown',
  Updated = 'Updated'
}

/**
 * All possible PropertyType that should match Search API
 * https://github.com/domain-group/domain-search/blob/release/Source/Domain.Search.Contracts/v2/PropertyType.cs
 */
export enum SearchListingsPropertyType {
  AcreageSemiRural = 'AcreageSemiRural',
  ApartmentUnitFlat = 'ApartmentUnitFlat',
  Aquaculture = 'Aquaculture',
  BlockOfUnits = 'BlockOfUnits',
  CarSpace = 'CarSpace',
  Cropping = 'Cropping',
  DairyFarming = 'DairyFarming',
  DevelopmentSite = 'DevelopmentSite',
  Duplex = 'Duplex',
  Equine = 'Equine',
  Farm = 'Farm',
  Farmlet = 'Farmlet',
  FishingForestry = 'FishingForestry',
  Grazing = 'Grazing',
  Horticulture = 'Horticulture',
  House = 'House',
  IrrigationServices = 'IrrigationServices',
  Livestock = 'Livestock',
  MixedFarming = 'MixedFarming',
  NewApartments = 'NewApartments',
  NewHomeDesigns = 'NewHomeDesigns',
  NewHouseLand = 'NewHouseLand',
  NewLand = 'NewLand',
  Orchard = 'Orchard',
  Penthouse = 'Penthouse',
  RetirementVillage = 'RetirementVillage',
  Rural = 'Rural',
  RuralLifestyle = 'RuralLifestyle',
  SemiDetached = 'SemiDetached',
  SpecialistFarm = 'SpecialistFarm',
  Studio = 'Studio',
  Terrace = 'Terrace',
  Townhouse = 'Townhouse',
  Unknown = 'Unknown',
  VacantLand = 'VacantLand',
  Villa = 'Villa',
  Viticulture = 'Viticulture'
}

export type PropertyPerils = {
  __typename?: 'PropertyPerils';
  permittedUse?: Maybe<Scalars['String']['output']>;
  zones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zoning?: Maybe<Scalars['String']['output']>;
};

export type RentalEstimate = {
  __typename?: 'RentalEstimate';
  estimateDate?: Maybe<Scalars['String']['output']>;
  percentYieldRentEstimate?: Maybe<Scalars['Float']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  rentalFsd?: Maybe<Scalars['Float']['output']>;
  rentalFsdConfidence?: Maybe<Scalars['String']['output']>;
  weeklyRentEstimate?: Maybe<Scalars['Int']['output']>;
};

/** The suburb performance data for a suburb. */
export type SuburbPerformance = {
  __typename?: 'SuburbPerformance';
  header?: Maybe<SuburbPerformanceHeader>;
  series?: Maybe<SuburbPerformanceSeries>;
  /** The performance value calculated over the past 1 year. */
  statistics?: Maybe<SuburbPerformanceSeriesInfoValue>;
};

/** The header information for the suburb performance data. */
export type SuburbPerformanceHeader = {
  __typename?: 'SuburbPerformanceHeader';
  propertyCategory?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

/** The series of suburb performance data. */
export type SuburbPerformanceSeries = {
  __typename?: 'SuburbPerformanceSeries';
  seriesInfo?: Maybe<Array<SuburbPerformanceSeriesInfo>>;
};

/** An array of suburb performance data containing details for each period. */
export type SuburbPerformanceSeriesInfo = {
  __typename?: 'SuburbPerformanceSeriesInfo';
  month?: Maybe<Scalars['Int']['output']>;
  values: SuburbPerformanceSeriesInfoValue;
  year?: Maybe<Scalars['Int']['output']>;
};

/** The suburb performance data details. */
export type SuburbPerformanceSeriesInfoValue = {
  __typename?: 'SuburbPerformanceSeriesInfoValue';
  auctionNumberAuctioned?: Maybe<Scalars['Int']['output']>;
  auctionNumberSold?: Maybe<Scalars['Int']['output']>;
  auctionNumberWithdrawn?: Maybe<Scalars['Int']['output']>;
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  highestRentListingPrice?: Maybe<Scalars['Int']['output']>;
  highestSaleListingPrice?: Maybe<Scalars['Int']['output']>;
  highestSoldPrice?: Maybe<Scalars['Int']['output']>;
  lowestRentListingPrice?: Maybe<Scalars['Int']['output']>;
  lowestSaleListingPrice?: Maybe<Scalars['Int']['output']>;
  lowestSoldPrice?: Maybe<Scalars['Int']['output']>;
  meanRentYield?: Maybe<Scalars['Float']['output']>;
  medianRentListingPrice?: Maybe<Scalars['Int']['output']>;
  medianSaleListingPrice?: Maybe<Scalars['Int']['output']>;
  medianSoldPrice?: Maybe<Scalars['Int']['output']>;
  numberRentListing?: Maybe<Scalars['Int']['output']>;
  numberSaleListing?: Maybe<Scalars['Int']['output']>;
  numberSold?: Maybe<Scalars['Int']['output']>;
  percentileSoldPrice25th?: Maybe<Scalars['Int']['output']>;
  percentileSoldPrice5th?: Maybe<Scalars['Int']['output']>;
  percentileSoldPrice75th?: Maybe<Scalars['Int']['output']>;
  percentileSoldPrice95th?: Maybe<Scalars['Int']['output']>;
};

export type SupplyDemand = {
  __typename?: 'SupplyDemand';
  metadata?: Maybe<SupplyDemandMetadata>;
  monthlySnapshotData?: Maybe<Array<Maybe<SupplyDemandMonthlySnapshot>>>;
  timeSeriesData?: Maybe<SupplyDemandTimeSeries>;
};

export type SupplyDemandMetadata = {
  __typename?: 'SupplyDemandMetadata';
  aggregation?: Maybe<Aggregation>;
  dataArea?: Maybe<Scalars['String']['output']>;
  dataLevelOfAggregation?: Maybe<Scalars['String']['output']>;
  datasetMethodologyVersion?: Maybe<Scalars['String']['output']>;
  /** @deprecated dataState is not returned from API response. Please remove this field in your query. */
  dataState?: Maybe<Scalars['String']['output']>;
  /** @deprecated idOfCappedSet is not returned from API response. Please remove this field in your query. */
  idOfCappedSet?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodEndTimestamp?: Maybe<Scalars['String']['output']>;
  periodStartTimestamp?: Maybe<Scalars['String']['output']>;
  warningFlagFewSimilarListings?: Maybe<Scalars['Int']['output']>;
  warningFlagIncompleteTrend?: Maybe<Scalars['Int']['output']>;
  warningFlagVolatileTrend?: Maybe<Scalars['Int']['output']>;
};

export type Aggregation = {
  __typename?: 'Aggregation';
  bathrooms?: Maybe<Scalars['String']['output']>;
  bedrooms?: Maybe<Scalars['String']['output']>;
  carSpaces?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<Locations>>>;
  propertyTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Locations = {
  __typename?: 'Locations';
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type SupplyDemandMonthlySnapshot = {
  __typename?: 'SupplyDemandMonthlySnapshot';
  marketTemperature?: Maybe<Scalars['String']['output']>;
  marketTemperatureLastYear?: Maybe<Scalars['String']['output']>;
  monthYear?: Maybe<Scalars['String']['output']>;
  percentageChangeInLikelyBuyersFromLastYear?: Maybe<Scalars['Float']['output']>;
  percentageChangeInSimilarListingVolumeFromLastYear?: Maybe<Scalars['Float']['output']>;
};

export type SupplyDemandTimeSeries = {
  __typename?: 'SupplyDemandTimeSeries';
  area?: Maybe<SupplyDemandAreaDemandSeries>;
  property?: Maybe<SupplyDemandPropertyDemandSeries>;
};

export type SupplyDemandAreaDemandSeries = {
  __typename?: 'SupplyDemandAreaDemandSeries';
  marketType?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<SupplyDemandAreaDemandEntry>>>;
};

export type SupplyDemandAreaDemandEntry = {
  __typename?: 'SupplyDemandAreaDemandEntry';
  monthYear?: Maybe<Scalars['String']['output']>;
  numberOfLikelyBuyersIndex?: Maybe<Scalars['Float']['output']>;
};

export type SupplyDemandPropertyDemandSeries = {
  __typename?: 'SupplyDemandPropertyDemandSeries';
  marketType?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<SupplyDemandPropertyDemandEntry>>>;
};

export type SupplyDemandPropertyDemandEntry = {
  __typename?: 'SupplyDemandPropertyDemandEntry';
  monthYear?: Maybe<Scalars['String']['output']>;
  numberOfLikelyBuyersIndex?: Maybe<Scalars['Float']['output']>;
  numberOfSimilarListingsExisting?: Maybe<Scalars['Int']['output']>;
  numberOfSimilarListingsNew?: Maybe<Scalars['Int']['output']>;
  numberOfSimilarListingsTotal?: Maybe<Scalars['Int']['output']>;
};

export enum PropertyTimelineEventCategories {
  Rental = 'Rental',
  Sale = 'Sale'
}

export type PropertyTimelineEvent = {
  __typename?: 'PropertyTimelineEvent';
  agency?: Maybe<Agency>;
  category?: Maybe<PropertyTimelineEventCategories>;
  daysOnMarket?: Maybe<Scalars['Float']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventPrice?: Maybe<Scalars['Int']['output']>;
  isMajorEvent?: Maybe<Scalars['Boolean']['output']>;
  isPriceWarning?: Maybe<Scalars['Boolean']['output']>;
  priceDescription?: Maybe<Scalars['String']['output']>;
  saleMetadata?: Maybe<SaleMetadata>;
};

export type SaleMetadata = {
  __typename?: 'SaleMetadata';
  isSold?: Maybe<Scalars['Boolean']['output']>;
  marketSteps?: Maybe<Array<Maybe<MarketSteps>>>;
};

export type MarketSteps = {
  __typename?: 'MarketSteps';
  agency?: Maybe<Agency>;
  date?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PropertyValuation = {
  __typename?: 'PropertyValuation';
  /** The date of the valuation */
  date?: Maybe<Scalars['String']['output']>;
  /** Demotion Type */
  demotionType?: Maybe<Scalars['String']['output']>;
  /** Price guide type */
  guideType?: Maybe<Scalars['String']['output']>;
  /** The lower price valuation */
  lowerPrice?: Maybe<Scalars['Int']['output']>;
  /** The midpoint price valuation */
  midPrice?: Maybe<Scalars['Int']['output']>;
  /** The confidence of the valuation */
  priceConfidence?: Maybe<Scalars['String']['output']>;
  /** The rent per week in AUD */
  rentPerWeek?: Maybe<Scalars['Int']['output']>;
  /** Annual percentage return */
  rentYield?: Maybe<Scalars['Float']['output']>;
  /** Valuation source (e.g. APM, CoreLogic) */
  source?: Maybe<Scalars['String']['output']>;
  /** The upper price valuation */
  upperPrice?: Maybe<Scalars['Int']['output']>;
};

export type ContactRecommendations = {
  __typename?: 'ContactRecommendations';
  agenciesAllSubscribed?: Maybe<Scalars['Boolean']['output']>;
  agentProfileUrl?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  overallStarRating?: Maybe<Scalars['Float']['output']>;
  reviews?: Maybe<Array<Maybe<VendorReview>>>;
  showRMAReviews?: Maybe<Scalars['Boolean']['output']>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type VendorReview = {
  __typename?: 'VendorReview';
  agencyReviewTrackingPixelUrl?: Maybe<Scalars['String']['output']>;
  agentReviewTrackingPixelUrl?: Maybe<Scalars['String']['output']>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  carparks?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  reviewedOn?: Maybe<Scalars['String']['output']>;
  reviewerName?: Maybe<Scalars['String']['output']>;
  reviewType?: Maybe<Scalars['String']['output']>;
  reviewUrl?: Maybe<Scalars['String']['output']>;
  starRating?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContactStatistics = {
  __typename?: 'ContactStatistics';
  averageDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  averageJointDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  /** Average sold price for all listings including joint listings */
  averageJointSoldPrice?: Maybe<Scalars['Float']['output']>;
  /** Average sold price where the agent is the lead agent */
  averageSoldPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  maxSoldPrice?: Maybe<Scalars['Int']['output']>;
  minSoldPrice?: Maybe<Scalars['Int']['output']>;
  mostRecentNewListingDate?: Maybe<Scalars['String']['output']>;
  mostRecentSaleDate?: Maybe<Scalars['String']['output']>;
  totalAuctioned?: Maybe<Scalars['Int']['output']>;
  totalDaysOnMarket?: Maybe<Scalars['Int']['output']>;
  totalForRent?: Maybe<Scalars['Int']['output']>;
  totalForSale?: Maybe<Scalars['Int']['output']>;
  totalJointLeased?: Maybe<Scalars['Int']['output']>;
  totalJointSold?: Maybe<Scalars['Int']['output']>;
  totalJointSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalJointSoldPrice?: Maybe<Scalars['Int']['output']>;
  totalLeased?: Maybe<Scalars['Int']['output']>;
  totalNotWithheldSoldCount?: Maybe<Scalars['Int']['output']>;
  totalSold?: Maybe<Scalars['Int']['output']>;
  totalSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalSoldPrice?: Maybe<Scalars['Int']['output']>;
  totalSoldWithValidDaysOnMarket?: Maybe<Scalars['Int']['output']>;
};

export type SuburbSoldStatistics = {
  __typename?: 'SuburbSoldStatistics';
  averageDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  averageSoldPrice?: Maybe<Scalars['Float']['output']>;
  coWorkerContacts?: Maybe<Array<Maybe<CoWorkerContact>>>;
  coWorkerListingCount?: Maybe<Scalars['Int']['output']>;
  listingType?: Maybe<ListingTypeSoldStatistics>;
  listingTypeAverage?: Maybe<ListingTypeSoldStatistics>;
  salesType?: Maybe<SalesTypes>;
  topListing?: Maybe<TopListing>;
  total?: Maybe<Scalars['Int']['output']>;
  totalSaleAmount?: Maybe<Scalars['Float']['output']>;
};

export type CoWorkerContact = {
  __typename?: 'CoWorkerContact';
  id?: Maybe<Scalars['String']['output']>;
  isActiveProfilePage?: Maybe<Scalars['Boolean']['output']>;
  listingCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ListingTypeSoldStatistics = {
  __typename?: 'ListingTypeSoldStatistics';
  apartment?: Maybe<Scalars['Float']['output']>;
  house?: Maybe<Scalars['Float']['output']>;
  land?: Maybe<Scalars['Float']['output']>;
  rural?: Maybe<Scalars['Float']['output']>;
};

export type SalesTypes = {
  __typename?: 'SalesTypes';
  auction?: Maybe<Scalars['Int']['output']>;
  sold?: Maybe<Scalars['Int']['output']>;
};

export type TopListing = {
  __typename?: 'TopListing';
  adId?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  daysOnMarket?: Maybe<Scalars['Float']['output']>;
  displayableAddress?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  salesType?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  soldPrice?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ContactTestimonial = {
  __typename?: 'ContactTestimonial';
  address?: Maybe<Scalars['String']['output']>;
  adId?: Maybe<Scalars['Int']['output']>;
  author: Scalars['String']['output'];
  dateAuthored: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  testimonial: Scalars['String']['output'];
};

export type AgentsearchListing = {
  __typename?: 'AgentsearchListing';
  address?: Maybe<Address>;
  advertiser?: Maybe<Agency>;
  /** The AdvertiserId (for example agency) database id */
  advertiserId: Scalars['Int']['output'];
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  /** The encoded database id and graphql type */
  id: Scalars['ID']['output'];
  inspectionDetails?: Maybe<ListingInspectionDetails>;
  isRural?: Maybe<Scalars['Boolean']['output']>;
  /** The area that the property occupies. */
  landArea?: Maybe<Scalars['Float']['output']>;
  /** The Listing database id */
  listingId: Scalars['Int']['output'];
  /**
   * SEO URL slug for this listing. Format: <address-slug>-<listingId>,
   * e.g. 15-3-irving-street-phillip-act-2606-18045111.
   * Returns null when no SEO slug is available upstream.
   */
  listingSlug?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Media>>;
  parkingSpaces?: Maybe<Scalars['Float']['output']>;
  priceDetails?: Maybe<AgentsearchListingPriceDetails>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']['output']>;
  propertyTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  /** soldInfo only  available when listingStatus = SOLD */
  soldInfo?: Maybe<AgentsearchAgentsearchListingSoldInfo>;
  url?: Maybe<Scalars['String']['output']>;
};


export type AgentsearchListingLandAreaArgs = {
  unit: AreaUnits;
};


export type AgentsearchListingMediaArgs = {
  categories?: InputMaybe<Array<MediaCategory>>;
};

export type AgentsearchListingPriceDetails = {
  __typename?: 'AgentsearchListingPriceDetails';
  displayPrice?: Maybe<Scalars['String']['output']>;
};

export type AgentsearchAgentsearchListingSoldInfo = {
  __typename?: 'AgentsearchAgentsearchListingSoldInfo';
  soldDate?: Maybe<Scalars['String']['output']>;
  soldMethod?: Maybe<Scalars['String']['output']>;
  soldPrice?: Maybe<Scalars['Float']['output']>;
};

export type AgencyBranding = {
  __typename?: 'AgencyBranding';
  backgroundColour?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Image>;
  hero?: Maybe<Image>;
  id: Scalars['String']['output'];
  leaderboard?: Maybe<Image>;
  logo?: Maybe<Image>;
  logoColour?: Maybe<Scalars['String']['output']>;
  logoSmall?: Maybe<Image>;
  /** @deprecated Does not exist on API */
  primaryColour?: Maybe<Scalars['String']['output']>;
  wideBanner?: Maybe<Image>;
};

export type AgencyContactDetails = {
  __typename?: 'AgencyContactDetails';
  general?: Maybe<AgencyContactDetailsGeneral>;
};

export type AgencyContactDetailsGeneral = {
  __typename?: 'AgencyContactDetailsGeneral';
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum ContactSortBy {
  AlphabeticalByFirstName = 'alphabeticalByFirstName',
  NumberOfLeasedListings = 'numberOfLeasedListings',
  NumberOfListingsForRent = 'numberOfListingsForRent',
  NumberOfListingsForSale = 'numberOfListingsForSale',
  NumberOfSoldListings = 'numberOfSoldListings'
}

export type AgencyRecommendations = {
  __typename?: 'AgencyRecommendations';
  agencyProfileUrl?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  overallStarRating?: Maybe<Scalars['Float']['output']>;
  reviews?: Maybe<Array<Maybe<VendorReview>>>;
  showRMAReviews?: Maybe<Scalars['Boolean']['output']>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type AgencyStatistics = {
  __typename?: 'AgencyStatistics';
  /** Sold by Auction */
  auctioned?: Maybe<Scalars['Int']['output']>;
  forRent?: Maybe<Scalars['Int']['output']>;
  forRentCommercial?: Maybe<Scalars['Int']['output']>;
  forSale?: Maybe<Scalars['Int']['output']>;
  forSaleCommercial?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  leased?: Maybe<Scalars['Int']['output']>;
  leasedCommercial?: Maybe<Scalars['Int']['output']>;
  /** Sold by Private Treaty */
  sold?: Maybe<Scalars['Int']['output']>;
  /** Sold by Private Treaty + Auction */
  soldTotal?: Maybe<Scalars['Int']['output']>;
};

export enum AgencySearchSortBy {
  AvgDayOnMarketAscending = 'avgDayOnMarketAscending',
  AvgDayOnMarketDescending = 'avgDayOnMarketDescending',
  AvgSalePriceAscending = 'avgSalePriceAscending',
  AvgSalePriceDescending = 'avgSalePriceDescending',
  Default = 'default',
  ForRentAscending = 'forRentAscending',
  ForRentDescending = 'forRentDescending',
  ForSaleAscending = 'forSaleAscending',
  ForSaleDescending = 'forSaleDescending',
  NameAscending = 'nameAscending',
  NameDescending = 'nameDescending',
  TotalLeasedDescending = 'totalLeasedDescending',
  TotalSoldAndAuctionedAscending = 'totalSoldAndAuctionedAscending',
  TotalSoldAndAuctionedDescending = 'totalSoldAndAuctionedDescending',
  TotalSoldAscending = 'totalSoldAscending',
  TotalSoldDescending = 'totalSoldDescending'
}

export type AgencySearch = {
  __typename?: 'AgencySearch';
  advertisedAgency?: Maybe<AgencySearchAdvertisedAgency>;
  pageNumber: Scalars['Int']['output'];
  /** @deprecated This field adds unnecessary processing complexity on the front end. */
  reputations?: Maybe<Array<Maybe<AgencyReputations>>>;
  results: Array<Maybe<AgencySearchAgency>>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AgencySearchAdvertisedAgency = {
  __typename?: 'AgencySearchAdvertisedAgency';
  agencyId: Scalars['Int']['output'];
  backgroundImage?: Maybe<Scalars['String']['output']>;
  brandColour?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AgencyReputations = {
  __typename?: 'AgencyReputations';
  agencyId?: Maybe<Scalars['Int']['output']>;
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  overallStarRating?: Maybe<Scalars['Float']['output']>;
  showRMAReviews?: Maybe<Scalars['Boolean']['output']>;
};

export type AgencySearchAgency = {
  __typename?: 'AgencySearchAgency';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  agentQuerySortOrder: Scalars['Int']['output'];
  agents?: Maybe<Array<Maybe<AgentSearchAgencyContact>>>;
  averageSoldDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  averageSoldPrice?: Maybe<Scalars['Float']['output']>;
  brandColour?: Maybe<Scalars['String']['output']>;
  displayAddress?: Maybe<Scalars['String']['output']>;
  displayAgentsWithoutLiveListings: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hideOfficeLocation: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logoSmall?: Maybe<Scalars['String']['output']>;
  maxSoldPrice?: Maybe<Scalars['Float']['output']>;
  minSoldPrice?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  profileTier: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  reputation?: Maybe<AgencyReputation>;
  showRecentlySold: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  telephone?: Maybe<Scalars['String']['output']>;
  totalAuctioned?: Maybe<Scalars['Int']['output']>;
  totalDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  totalForRent?: Maybe<Scalars['Int']['output']>;
  totalForSale?: Maybe<Scalars['Int']['output']>;
  totalLeased?: Maybe<Scalars['Int']['output']>;
  totalNotWithheldSoldCount?: Maybe<Scalars['Int']['output']>;
  totalSold?: Maybe<Scalars['Int']['output']>;
  totalSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalSoldPrice?: Maybe<Scalars['Float']['output']>;
  totalSoldWithValidDaysOnMarket?: Maybe<Scalars['Int']['output']>;
};

export type AgentSearchAgencyContact = {
  __typename?: 'AgentSearchAgencyContact';
  agencyId: Scalars['Int']['output'];
  agencyLogoSmall?: Maybe<Scalars['String']['output']>;
  agencyLogoUrl?: Maybe<Scalars['String']['output']>;
  agencyName: Scalars['String']['output'];
  agencyProfileUrl: Scalars['String']['output'];
  agentIdV2: Scalars['Int']['output'];
  averageSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  brandColour?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  jobCategory?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  maxSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  minSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  profileTier: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  showRecentlySold: Scalars['Boolean']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  totalAuctioned?: Maybe<Scalars['Int']['output']>;
  totalDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  totalForRent?: Maybe<Scalars['Int']['output']>;
  totalForSale?: Maybe<Scalars['Int']['output']>;
  totalJointLeased?: Maybe<Scalars['Int']['output']>;
  totalJointSold?: Maybe<Scalars['Int']['output']>;
  totalJointSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalLeased?: Maybe<Scalars['Int']['output']>;
  totalNotWithheldSoldCount?: Maybe<Scalars['Int']['output']>;
  totalSold?: Maybe<Scalars['Int']['output']>;
  totalSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalSoldPrice?: Maybe<Scalars['Float']['output']>;
  totalSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  totalSoldWithValidDaysOnMarket?: Maybe<Scalars['Int']['output']>;
};

export type AgencyReputation = {
  __typename?: 'AgencyReputation';
  agencyId?: Maybe<Scalars['Int']['output']>;
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  numberOfReviewsRecent?: Maybe<Scalars['Int']['output']>;
  overallStarRating?: Maybe<Scalars['Float']['output']>;
  overallStarRatingRecent?: Maybe<Scalars['Float']['output']>;
};

export type AgencySuburbSubscriptionResult = {
  __typename?: 'AgencySuburbSubscriptionResult';
  agencyBranding?: Maybe<AgencyBranding>;
  agencyId: Scalars['String']['output'];
  agencyName?: Maybe<Scalars['String']['output']>;
  propertyReport: PropertyReportInfo;
};

export type PropertyReportInfo = {
  __typename?: 'PropertyReportInfo';
  ctaText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  formUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AgentShowcase = {
  __typename?: 'AgentShowcase';
  levels?: Maybe<Array<Maybe<AgentShowcasePrecisionLevel>>>;
};

export type AgentShowcasePrecisionLevel = {
  __typename?: 'AgentShowcasePrecisionLevel';
  agents?: Maybe<Array<Maybe<Agent>>>;
  level?: Maybe<Scalars['Int']['output']>;
};

export type Alert = {
  __typename?: 'Alert';
  alertId: AlertId;
  data: Scalars['String']['output'];
  delivered: Scalars['Boolean']['output'];
  expires: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type AlertId = {
  __typename?: 'AlertId';
  subjectId: Scalars['String']['output'];
  typeKey: Scalars['String']['output'];
};

export type Area = {
  __typename?: 'Area';
  suburbs?: Maybe<Array<Maybe<Suburb>>>;
};

export type BybAddressInput = {
  /** Default to "Australia" */
  country?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: States;
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum BybPropertyType {
  ApartmentUnitFlat = 'APARTMENT_UNIT_FLAT',
  BlockOfUnits = 'BLOCK_OF_UNITS',
  DevelopmentSite = 'DEVELOPMENT_SITE',
  Duplex = 'DUPLEX',
  House = 'HOUSE',
  NewApartments = 'NEW_APARTMENTS',
  NewHomeDesigns = 'NEW_HOME_DESIGNS',
  NewHouseLand = 'NEW_HOUSE_LAND',
  NewLand = 'NEW_LAND',
  Penthouse = 'PENTHOUSE',
  Retirement = 'RETIREMENT',
  SemiDetached = 'SEMI_DETACHED',
  Studio = 'STUDIO',
  Terrace = 'TERRACE',
  TownHouse = 'TOWN_HOUSE',
  Unknown = 'UNKNOWN',
  VacantLand = 'VACANT_LAND',
  Villa = 'VILLA'
}

export type ChildcareSpace = {
  __typename?: 'ChildcareSpace';
  address: Scalars['String']['output'];
  bestService?: Maybe<ServiceType>;
  distance: Scalars['Float']['output'];
  featuredImageUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kindiCareRatingImage: Scalars['String']['output'];
  landingPageUrl: Scalars['String']['output'];
  location: Geolocation;
  name: Scalars['String']['output'];
  ratingLabel?: Maybe<Scalars['String']['output']>;
  services: Array<ChildcareSpaceServiceType>;
};

export type ServiceType = {
  __typename?: 'ServiceType';
  costPerDay?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  valueForMoney?: Maybe<Scalars['String']['output']>;
};

export enum ChildcareSpaceServiceType {
  AfterSchoolCare = 'AFTER_SCHOOL_CARE',
  BeforeSchoolCare = 'BEFORE_SCHOOL_CARE',
  FamilyDayCare = 'FAMILY_DAY_CARE',
  LongDayCare = 'LONG_DAY_CARE',
  OutsideSchoolHoursCare = 'OUTSIDE_SCHOOL_HOURS_CARE',
  PreSchoolKindergarten = 'PRE_SCHOOL_KINDERGARTEN',
  VacationCare = 'VACATION_CARE'
}

export enum AgentSearchContactTypes {
  All = 'all',
  Rent = 'rent',
  Sale = 'sale',
  SoldOnly = 'soldOnly'
}

export enum ContactSearchSortBy {
  AvgDayOnMarketAscending = 'avgDayOnMarketAscending',
  AvgDayOnMarketDescending = 'avgDayOnMarketDescending',
  AvgSalePriceAscending = 'avgSalePriceAscending',
  AvgSalePriceDescending = 'avgSalePriceDescending',
  Default = 'default',
  ForRentAscending = 'forRentAscending',
  ForRentDescending = 'forRentDescending',
  ForSaleAscending = 'forSaleAscending',
  ForSaleDescending = 'forSaleDescending',
  NameAscending = 'nameAscending',
  NameDescending = 'nameDescending',
  TotalLeasedDescending = 'totalLeasedDescending',
  TotalSoldAndAuctionedAscending = 'totalSoldAndAuctionedAscending',
  TotalSoldAndAuctionedDescending = 'totalSoldAndAuctionedDescending',
  TotalSoldAscending = 'totalSoldAscending',
  TotalSoldDescending = 'totalSoldDescending'
}

export type ContactSearch = {
  __typename?: 'ContactSearch';
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This field adds unnecessary processing complexity on the front end. */
  reputations?: Maybe<Array<Maybe<AgentReputations>>>;
  results?: Maybe<Array<Maybe<ContactSearchContact>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type AgentReputations = {
  __typename?: 'AgentReputations';
  agentId?: Maybe<Scalars['Int']['output']>;
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  overallStarRating?: Maybe<Scalars['Float']['output']>;
  showRMAReviews?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactSearchContact = {
  __typename?: 'ContactSearchContact';
  agencyId: Scalars['Int']['output'];
  agencyLogoSmall?: Maybe<Scalars['String']['output']>;
  agencyLogoUrl?: Maybe<Scalars['String']['output']>;
  agencyName: Scalars['String']['output'];
  agencyProfileUrl: Scalars['String']['output'];
  agentIdV2: Scalars['String']['output'];
  averageSoldDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  averageSoldPrice?: Maybe<Scalars['Float']['output']>;
  averageSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  brandColour?: Maybe<Scalars['String']['output']>;
  /** @deprecated The agent email address is to be obscured in the future. Use hasEmail instead. */
  email?: Maybe<Scalars['String']['output']>;
  hasEmail?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  jobCategory?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  maxSoldPrice?: Maybe<Scalars['Float']['output']>;
  maxSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  minSoldPrice?: Maybe<Scalars['Float']['output']>;
  minSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  profileTier?: Maybe<Scalars['String']['output']>;
  profileUrl: Scalars['String']['output'];
  propertyType?: Maybe<Scalars['String']['output']>;
  reputation?: Maybe<ContactReputation>;
  showRecentlySold: Scalars['Boolean']['output'];
  telephone?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  totalAuctioned?: Maybe<Scalars['Int']['output']>;
  totalDaysOnMarket?: Maybe<Scalars['Float']['output']>;
  totalForRent?: Maybe<Scalars['Int']['output']>;
  totalForSale?: Maybe<Scalars['Int']['output']>;
  totalJointLeased?: Maybe<Scalars['Int']['output']>;
  totalJointSold?: Maybe<Scalars['Int']['output']>;
  totalJointSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalLeased?: Maybe<Scalars['Int']['output']>;
  totalNotWithheldSoldCount?: Maybe<Scalars['Int']['output']>;
  totalSold?: Maybe<Scalars['Int']['output']>;
  totalSoldAndAuctioned?: Maybe<Scalars['Int']['output']>;
  totalSoldPrice?: Maybe<Scalars['Float']['output']>;
  totalSoldPriceIncWithheld?: Maybe<Scalars['Float']['output']>;
  totalSoldWithValidDaysOnMarket?: Maybe<Scalars['Int']['output']>;
};

export type ContactReputation = {
  __typename?: 'ContactReputation';
  agentId?: Maybe<Scalars['Int']['output']>;
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  numberOfReviewsRecent?: Maybe<Scalars['Int']['output']>;
  overallStarRating?: Maybe<Scalars['Float']['output']>;
  overallStarRatingRecent?: Maybe<Scalars['Float']['output']>;
};

export type ContentHomeScreen = {
  __typename?: 'ContentHomeScreen';
  articles: Array<ContentHomeScreenArticle>;
};

export type ContentHomeScreenArticle = {
  __typename?: 'ContentHomeScreenArticle';
  appConfig?: Maybe<ContentHomeScreenAppConfig>;
  articleReadTime?: Maybe<ContentHomeScreenReadTime>;
  articleUrl: Scalars['String']['output'];
  author?: Maybe<Scalars['String']['output']>;
  categories: Array<ContentHomeScreenCategory>;
  contentType: Scalars['String']['output'];
  curated?: Maybe<Scalars['Boolean']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<ContentHomeScreenImage>;
  isNative: Scalars['Boolean']['output'];
  modifiedDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceLogo?: Maybe<ContentHomeScreenSourceLogo>;
  summary: Array<Maybe<Scalars['String']['output']>>;
  summaryReadTime?: Maybe<ContentHomeScreenReadTime>;
  summaryUrl?: Maybe<Scalars['String']['output']>;
  tags: Array<ContentHomeScreenTerm>;
};

export type ContentHomeScreenAppConfig = {
  __typename?: 'ContentHomeScreenAppConfig';
  cta?: Maybe<ContentHomeScreenCta>;
  customCta?: Maybe<ContentHomeScreenCustomCta>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentHomeScreenCta = {
  __typename?: 'ContentHomeScreenCTA';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentHomeScreenCustomCta = {
  __typename?: 'ContentHomeScreenCustomCTA';
  label: Scalars['String']['output'];
  type: ContentHomeScreenCtaType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ContentHomeScreenCtaType {
  Buy = 'BUY',
  Rent = 'RENT',
  Sold = 'SOLD',
  Trackhome = 'TRACKHOME',
  Webview = 'WEBVIEW'
}

export type ContentHomeScreenReadTime = {
  __typename?: 'ContentHomeScreenReadTime';
  time: Scalars['Int']['output'];
  wordCount: Scalars['Int']['output'];
};

export type ContentHomeScreenCategory = {
  __typename?: 'ContentHomeScreenCategory';
  name: Scalars['String']['output'];
  parent?: Maybe<ContentHomeScreenTerm>;
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentHomeScreenTerm = {
  __typename?: 'ContentHomeScreenTerm';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentHomeScreenImage = {
  __typename?: 'ContentHomeScreenImage';
  altText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  thumbnail: Scalars['String']['output'];
};

export type ContentHomeScreenSourceLogo = {
  __typename?: 'ContentHomeScreenSourceLogo';
  dark: Scalars['String']['output'];
  light: Scalars['String']['output'];
};

export type DemandSaleData = {
  __typename?: 'DemandSaleData';
  metadata?: Maybe<DemandSaleMetadata>;
  periodSnapshotData?: Maybe<DemandSalePeriodSnapshot>;
  timeSeriesData?: Maybe<DemandSaleTimeSeries>;
};

export type DemandSaleMetadata = {
  __typename?: 'DemandSaleMetadata';
  aggregation?: Maybe<DemandSaleAggregation>;
  dataLevelOfAggregation?: Maybe<Scalars['String']['output']>;
  datasetMethodologyVersion?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodEndTimestamp?: Maybe<Scalars['String']['output']>;
  periodStartTimestamp?: Maybe<Scalars['String']['output']>;
};

export type DemandSaleAggregation = {
  __typename?: 'DemandSaleAggregation';
  dateAgg?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<DemandSaleLocations>>>;
};

export type DemandSaleLocations = {
  __typename?: 'DemandSaleLocations';
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type DemandSalePeriodSnapshot = {
  __typename?: 'DemandSalePeriodSnapshot';
  marketTemperature?: Maybe<Scalars['Int']['output']>;
  marketTemperatureDrivers?: Maybe<DemandSaleMarketTemperatureDrivers>;
  percentageChangeInOversupplyIndexFromLastYear?: Maybe<Scalars['Float']['output']>;
  percentageChangeInPropertySeekersIndexFromLastYear?: Maybe<Scalars['Float']['output']>;
  percentageChangeInSimilarListingVolumeSurroundingSuburbFromLastYear?: Maybe<Scalars['Float']['output']>;
  periodFirstDate?: Maybe<Scalars['String']['output']>;
  periodLastDate?: Maybe<Scalars['String']['output']>;
};

export type DemandSaleMarketTemperatureDrivers = {
  __typename?: 'DemandSaleMarketTemperatureDrivers';
  neutralOrDownwardDrivers?: Maybe<Array<Maybe<DemandSaleMarketTemperatureDriver>>>;
  upwardDrivers?: Maybe<Array<Maybe<DemandSaleMarketTemperatureDriver>>>;
};

export type DemandSaleMarketTemperatureDriver = {
  __typename?: 'DemandSaleMarketTemperatureDriver';
  marketIndicator?: Maybe<Scalars['String']['output']>;
  marketIndicatorDescription?: Maybe<Scalars['String']['output']>;
  marketIndicatorScore?: Maybe<Scalars['Int']['output']>;
};

export type DemandSaleTimeSeries = {
  __typename?: 'DemandSaleTimeSeries';
  area?: Maybe<DemandSaleAreaDemandSeries>;
  property?: Maybe<DemandSalePropertyDemandSeries>;
};

export type DemandSaleAreaDemandSeries = {
  __typename?: 'DemandSaleAreaDemandSeries';
  marketType?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<DemandSaleAreaDemandEntry>>>;
};

export type DemandSaleAreaDemandEntry = {
  __typename?: 'DemandSaleAreaDemandEntry';
  numberOfPropertySeekersIndex?: Maybe<Scalars['Float']['output']>;
  periodFirstDate?: Maybe<Scalars['String']['output']>;
  periodLastDate?: Maybe<Scalars['String']['output']>;
};

export type DemandSalePropertyDemandSeries = {
  __typename?: 'DemandSalePropertyDemandSeries';
  marketType?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<DemandSalePropertyDemandEntry>>>;
};

export type DemandSalePropertyDemandEntry = {
  __typename?: 'DemandSalePropertyDemandEntry';
  numberOfPropertySeekersIndex?: Maybe<Scalars['Float']['output']>;
  numberOfSimilarListingsSameSuburb?: Maybe<Scalars['Int']['output']>;
  numberOfSimilarListingsSurroundingSuburb?: Maybe<Scalars['Int']['output']>;
  oversupplyIndex?: Maybe<Scalars['Float']['output']>;
  periodFirstDate?: Maybe<Scalars['String']['output']>;
  periodLastDate?: Maybe<Scalars['String']['output']>;
};

/**
 * GET home loans api
 * Do refinance estimate calculation
 * Do refinance savings calculation
 */
export type DhlRefinanceSavingsCalculationOptions = {
  currentInterestRate: Scalars['Float']['input'];
  lastSoldDate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  outstandingLoanAmount: Scalars['Int']['input'];
  outstandingLoanTerm: Scalars['Int']['input'];
  propertyPrice: Scalars['Int']['input'];
  propertyUse: Scalars['String']['input'];
  repaymentType: Scalars['String']['input'];
};

export type DhlRefinanceSavingsCalculationResult = {
  __typename?: 'DhlRefinanceSavingsCalculationResult';
  lowestComparisonRate: Scalars['Float']['output'];
  lowestInterestRate: Scalars['Float']['output'];
  saving: Scalars['Int']['output'];
};

/**
 * GET home loans api
 * Do calculations
 */
export type DhlUpfrontCostsCalculationOptions = {
  firstHomeBuyer: Scalars['Boolean']['input'];
  propertyCategory: Scalars['String']['input'];
  propertyUse: Scalars['String']['input'];
  propertyValue: Scalars['Float']['input'];
  state: States;
};

export type DhlUpfrontCostsCalculationResult = {
  __typename?: 'DhlUpfrontCostsCalculationResult';
  conveyancing: Scalars['Float']['output'];
  grantAmount: Scalars['Float']['output'];
  registrationFee: Scalars['Float']['output'];
  stampDuty: Scalars['Float']['output'];
  transferFee: Scalars['Float']['output'];
};

export type DhlStampDutyCalculatorData = {
  __typename?: 'DhlStampDutyCalculatorData';
  firstHomeBuyer?: Maybe<Scalars['Boolean']['output']>;
  grantAmount?: Maybe<Scalars['String']['output']>;
  myDeposit?: Maybe<Scalars['String']['output']>;
  propertyCategory?: Maybe<Scalars['String']['output']>;
  propertyUse?: Maybe<Scalars['String']['output']>;
  propertyValue?: Maybe<Scalars['String']['output']>;
  registrationFee?: Maybe<Scalars['String']['output']>;
  /** Calculation Result */
  stampDuty?: Maybe<Scalars['String']['output']>;
  /** Calculation fields */
  state?: Maybe<Scalars['String']['output']>;
  transferFee?: Maybe<Scalars['String']['output']>;
};

export type DiscoveryContent = {
  __typename?: 'DiscoveryContent';
  benefits?: Maybe<Array<Maybe<DiscoveryContentBenefit>>>;
  cta?: Maybe<DiscoveryContentCta>;
  description: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type DiscoveryContentImageArgs = {
  fitIn?: InputMaybe<Scalars['Boolean']['input']>;
  imageFormat?: InputMaybe<ImageFormat>;
  imageSize?: InputMaybe<ImageSize>;
  resolution?: InputMaybe<Resolution>;
  trim?: InputMaybe<ImageTrim>;
};

export type DiscoveryContentBenefit = {
  __typename?: 'DiscoveryContentBenefit';
  description: Scalars['String']['output'];
  icon: DiscoveryContentIcon;
  title: Scalars['String']['output'];
};

export enum DiscoveryContentIcon {
  Default = 'default',
  Domain = 'domain',
  Houses = 'houses',
  Note = 'note'
}

export type DiscoveryContentCta = {
  __typename?: 'DiscoveryContentCTA';
  action: DiscoveryContentAction;
  bodyText: Scalars['String']['output'];
};

export enum DiscoveryContentAction {
  Login = 'login',
  Search = 'search'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  featureName: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  rules?: Maybe<Array<Maybe<FeatureRule>>>;
};

export type FeatureRule = {
  __typename?: 'FeatureRule';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enabledForUser: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
  toggleData?: Maybe<Scalars['String']['output']>;
};

export enum OnboardingValue {
  Buy = 'Buy',
  BuyFirstHome = 'BuyFirstHome',
  BuyInvestment = 'BuyInvestment',
  BuyNextHome = 'BuyNextHome',
  JustLooking = 'JustLooking',
  Rent = 'Rent',
  Sell = 'Sell',
  TrackMyProperty = 'TrackMyProperty'
}

export type ContentAdviceArticlesResult = ContentAdviceArticles | ErrorWithUserMessage;

export type ContentAdviceArticles = {
  __typename?: 'ContentAdviceArticles';
  articles: Array<Maybe<AdviceArticle>>;
  carouselTitle: Scalars['String']['output'];
};

export type AdviceArticle = {
  __typename?: 'AdviceArticle';
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  readTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GetShortlistingV2Result = ErrorWithUserMessage | ShortlistingV2ResultSuccess;

export type ShortlistingV2ResultSuccess = {
  __typename?: 'ShortlistingV2ResultSuccess';
  results?: Maybe<Array<ShortlistingV2Result>>;
  totalResults: Scalars['Int']['output'];
};

export type ShortlistingV2Result = {
  __typename?: 'ShortlistingV2Result';
  id?: Maybe<Scalars['Int']['output']>;
  timeStamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ContentArticleResult = ContentArticle | ErrorWithUserMessage;

export type ContentArticle = {
  __typename?: 'ContentArticle';
  appConfig?: Maybe<ContentArticleAppConfig>;
  articleReadTime: ContentReadTime;
  authors: Array<Maybe<ContentAuthor>>;
  categories: Array<Maybe<ContentCategory>>;
  content: Array<ContentElements>;
  createdDate: Scalars['String']['output'];
  disclaimer: Array<Scalars['String']['output']>;
  featuredImage: ContentImage;
  featuredVideo?: Maybe<ContentVideo>;
  id: Scalars['Int']['output'];
  isNative?: Maybe<Scalars['Boolean']['output']>;
  lastSearch?: Maybe<SearchQueryData>;
  modifiedDate: Scalars['String']['output'];
  permalink: Scalars['String']['output'];
  publishedDate: Scalars['String']['output'];
  summary: Array<Maybe<Scalars['String']['output']>>;
  summaryReadTime?: Maybe<ContentReadTime>;
  summaryUrl?: Maybe<Scalars['String']['output']>;
  tags: Array<Maybe<ContentTag>>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ContentArticleAppConfig = {
  __typename?: 'ContentArticleAppConfig';
  ctaLabel: Scalars['String']['output'];
  ctaName: Scalars['String']['output'];
  customCtaLabel: Scalars['String']['output'];
  customCtaType: ContentHomeScreenCtaType;
  customCtaUrl?: Maybe<Scalars['String']['output']>;
  ready: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type ContentReadTime = {
  __typename?: 'ContentReadTime';
  time: Scalars['Int']['output'];
  wordCount: Scalars['Int']['output'];
};

export type ContentAuthor = {
  __typename?: 'ContentAuthor';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
};

export type ContentCategory = {
  __typename?: 'ContentCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ContentCategoryParent>;
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentCategoryParent = {
  __typename?: 'ContentCategoryParent';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentElements = ContentElementHeading | ContentElementImage | ContentElementList | ContentElementMessage | ContentElementParagraph | ContentElementPropertyDriver | ContentElementQuote | ContentElementTable;

export type ContentElementHeading = ContentElement & {
  __typename?: 'ContentElementHeading';
  element: ContentElementType;
  headingData: ContentElementHeadingData;
  headingType: ContentElementHeadingType;
};

export type ContentElement = {
  element: ContentElementType;
};

export enum ContentElementType {
  Heading = 'HEADING',
  Image = 'IMAGE',
  List = 'LIST',
  Message = 'MESSAGE',
  Paragraph = 'PARAGRAPH',
  Propertydriver = 'PROPERTYDRIVER',
  Quote = 'QUOTE',
  Table = 'TABLE',
  Text = 'TEXT'
}

export type ContentElementHeadingData = {
  __typename?: 'ContentElementHeadingData';
  text: Scalars['String']['output'];
};

export enum ContentElementHeadingType {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6'
}

export type ContentElementImage = ContentElement & {
  __typename?: 'ContentElementImage';
  element: ContentElementType;
  imageData: ContentImage;
};

export type ContentImage = {
  __typename?: 'ContentImage';
  altText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orientation: ContentElementImageOrientation;
  sizes: ContentImageVariations;
  source?: Maybe<Scalars['String']['output']>;
};

export enum ContentElementImageOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

export type ContentImageVariations = {
  __typename?: 'ContentImageVariations';
  full: ContentImageVariation;
  landscape: ContentImageVariation;
  landscape16x9?: Maybe<ContentImageVariation>;
  portrait: ContentImageVariation;
  portrait2x3?: Maybe<ContentImageVariation>;
  square1x1: ContentImageVariation;
  thumbnail: ContentImageVariation;
};

export type ContentImageVariation = {
  __typename?: 'ContentImageVariation';
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ContentElementList = ContentElement & {
  __typename?: 'ContentElementList';
  element: ContentElementType;
  listData: ContentElementListData;
  listType: ContentElementListType;
};

export type ContentElementListData = {
  __typename?: 'ContentElementListData';
  items: Array<Maybe<ContentElementListItem>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentElementListItem = {
  __typename?: 'ContentElementListItem';
  data: ContentElementListItemData;
  element: ContentElementType;
};

export type ContentElementListItemData = {
  __typename?: 'ContentElementListItemData';
  sublist?: Maybe<ContentElementList>;
  text: Scalars['String']['output'];
};

export enum ContentElementListType {
  Ordered = 'ORDERED',
  Unordered = 'UNORDERED'
}

export type ContentElementMessage = ContentElement & {
  __typename?: 'ContentElementMessage';
  element: ContentElementType;
  messageData: ContentElementMessageData;
  messageType: ContentElementMessageType;
};

export type ContentElementMessageData = {
  __typename?: 'ContentElementMessageData';
  text: Scalars['String']['output'];
};

export enum ContentElementMessageType {
  Note = 'NOTE',
  Takeaway = 'TAKEAWAY',
  Warning = 'WARNING'
}

export type ContentElementParagraph = ContentElement & {
  __typename?: 'ContentElementParagraph';
  element: ContentElementType;
  paragraphData: ContentElementParagraphData;
};

export type ContentElementParagraphData = {
  __typename?: 'ContentElementParagraphData';
  text: Scalars['String']['output'];
};

export type ContentElementPropertyDriver = ContentElement & {
  __typename?: 'ContentElementPropertyDriver';
  element: ContentElementType;
  propertyDriverData: ContentElementPropertyDriverData;
};

export type ContentElementPropertyDriverData = {
  __typename?: 'ContentElementPropertyDriverData';
  address?: Maybe<Scalars['String']['output']>;
  auctionCTAText?: Maybe<Scalars['String']['output']>;
  auctionDate?: Maybe<Scalars['String']['output']>;
  auctionUrl?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buildingArea?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  featureImg: Scalars['String']['output'];
  features: Array<Maybe<ContentElementPropertyDriverFeature>>;
  headline?: Maybe<Scalars['String']['output']>;
  highlights: Array<Maybe<Scalars['String']['output']>>;
  imageIndex?: Maybe<Scalars['String']['output']>;
  isCTAMode: Scalars['Boolean']['output'];
  isPremium: Scalars['Boolean']['output'];
  landArea?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  propertyId: Scalars['String']['output'];
  propertyTypes: Array<Maybe<Scalars['String']['output']>>;
  propertyUrl: Scalars['String']['output'];
  publication?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentElementPropertyDriverFeature = {
  __typename?: 'ContentElementPropertyDriverFeature';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContentElementQuote = ContentElement & {
  __typename?: 'ContentElementQuote';
  element: ContentElementType;
  quoteData: ContentElementQuoteData;
};

export type ContentElementQuoteData = {
  __typename?: 'ContentElementQuoteData';
  author?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type ContentElementTable = ContentElement & {
  __typename?: 'ContentElementTable';
  element: ContentElementType;
  tableData: ContentElementTableData;
};

export type ContentElementTableData = {
  __typename?: 'ContentElementTableData';
  footer: Scalars['String']['output'];
  rows: Array<Maybe<Array<Maybe<ContentElementTableCell>>>>;
  title: Scalars['String']['output'];
};

export type ContentElementTableCell = {
  __typename?: 'ContentElementTableCell';
  column?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ContentVideo = {
  __typename?: 'ContentVideo';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
};

export type SearchQueryData = {
  __typename?: 'SearchQueryData';
  isSavedSearch: Scalars['Boolean']['output'];
  searchCriteria?: Maybe<SearchListingsParameters>;
};

export type SearchListingsParameters = {
  __typename?: 'SearchListingsParameters';
  /** Filter based on Ad Ids (Include in search result if AdID is in this list) */
  adIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Return listings only created by these agencies. */
  advertiserIds?: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * Aggregated results
   * Could be the following values:
   * bedrooms, bathrooms, carspaces, propertytypes, features, suburb, tags, isrural
   */
  aggregations?: Maybe<Array<SearchResultsAggregations>>;
  /**
   * Filter listings with auction time on or from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  auctionFrom?: Maybe<Scalars['String']['output']>;
  /**
   * Filter listings with auction time date range.
   * GQL converts this into inspectionFrom and inspectionTo for Search API
   */
  auctionSchedule?: Maybe<SearchListingsScheduleDateRange>;
  /**
   * Filter listings with auction on or before from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  auctionTo?: Maybe<Scalars['String']['output']>;
  /**
   * Defines a sort order comprised of 0 or more elements specifying sort field and direction.
   * Cannot be specified simultaneously with {Sort}.
   */
  customSort?: Maybe<SearchListingsCustomSort>;
  /**
   * Return only those listings whose DateAvailable is null, or is at or after the specified time.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  dateAvailableFrom?: Maybe<Scalars['String']['output']>;
  /**
   * Return only those listings whose DateAvailable is null, or is at or before the specified time.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  dateAvailableTo?: Maybe<Scalars['String']['output']>;
  /** Filter out listings with Ad Ids (Exclude listings from search result if AdID is in this list) */
  excludeAdIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** If true, exclude listings (rental) has deposit taken */
  excludeDepositTaken?: Maybe<Scalars['Boolean']['output']>;
  /** If true, exclude listings whose price has been withheld. */
  excludePriceWithheld?: Maybe<Scalars['Boolean']['output']>;
  /** Filter by geo shapes. Shapes are mutually exclusive. */
  geoWindow?: Maybe<SearchListingsGeoWindow>;
  /** Filter by one or more high level types of properties */
  highLevelPropertyTypes?: Maybe<Array<SearchListingsHighLevelPropertyTypes>>;
  /**
   * Filter listings with inspection time on or from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  inspectionFrom?: Maybe<Scalars['String']['output']>;
  /**
   * Filter listings with inspection time date range.
   * GQL converts this into inspectionFrom and inspectionTo for Search API
   */
  inspectionSchedule?: Maybe<SearchListingsScheduleDateRange>;
  /**
   * Filter listings with inspection time on or before date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  inspectionTo?: Maybe<Scalars['String']['output']>;
  /** Filter by one or more keywords that a listing should contain */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Unit of measurement for the Land area.
   * If landAreaUnit isn't specified, land area would be treated as SQUARE_METERS.
   * Since search listings api accepts the value only in SQUARE_METERS, based on the value of landAreaUnit the maxLandArea and minLandArea would be converted to SQUARE_METERS.
   */
  landAreaUnit?: Maybe<AreaUnits>;
  /**
   * Only return listings that have been listed since the specified date inclusively. Local timezone.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  listedSince?: Maybe<Scalars['String']['output']>;
  /** Limit the results to listing with specific attributes */
  listingAttributes?: Maybe<Array<SearchListingsAttribute>>;
  /** The listing type to search for */
  listingType?: Maybe<SearchListingsType>;
  /**
   * Filter by the locations either suburb, area, region or state
   * Can also be used to search suburb and some area around it if radius is provided.
   * Invalid locations will return no results.
   * If {Domain.Search.Web.Api.v2.Models.SearchLocation.IncludeSurroundingSuburbs} is set to true, surrounding suburbs will also be searched for.
   */
  locations?: Maybe<Array<SearchListingsLocation>>;
  /** Filter by location terms. This can be used in conjunction with Locations */
  locationTerms?: Maybe<Scalars['String']['output']>;
  /**
   * Filter listing by maximum number of bathrooms
   * 0.5 means no shower
   */
  maxBathrooms?: Maybe<Scalars['Float']['output']>;
  /** Filter listing by maximum number of bedrooms */
  maxBedrooms?: Maybe<Scalars['Float']['output']>;
  /** Filter listing by maximum number of car spaces */
  maxCarspaces?: Maybe<Scalars['Int']['output']>;
  /** Max Land Area in square meters */
  maxLandArea?: Maybe<Scalars['Int']['output']>;
  /** Filter listing at or below a maximum price */
  maxPrice?: Maybe<Scalars['Int']['output']>;
  /** Filter listing by minimum number of bathrooms */
  minBathrooms?: Maybe<Scalars['Float']['output']>;
  /** Filter listing by minimum number of bedrooms */
  minBedrooms?: Maybe<Scalars['Float']['output']>;
  /** Filter listing by minimum number of car spaces */
  minCarspaces?: Maybe<Scalars['Int']['output']>;
  /** Min Land Area in square meters */
  minLandArea?: Maybe<Scalars['Int']['output']>;
  /** Filter listing at or above a minimum price */
  minPrice?: Maybe<Scalars['Int']['output']>;
  /** If true, return only listings for new properties (i.e. ones that are on the market for the first time). */
  newDevOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The specific result page to return */
  page?: Maybe<Scalars['Int']['output']>;
  /** Specify the number of result items in a page */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /**
   * Filter listings based on their whether or not they are classified as a new development
   * Any returns all properties
   * New returns only listings classified as new developments
   * Existing returns only listings that aren't classified as new developments
   */
  propertyEstablishedType?: Maybe<SearchListingsPropertyEstablishedType>;
  /** Filter by one or more property features such as Gas or AC */
  propertyFeatures?: Maybe<Array<SearchListingsPropertyFeature>>;
  /** Filter by one or more types of properties */
  propertyTypes?: Maybe<Array<SearchListingsPropertyType>>;
  /** if true, the response will include only listings flagged with IsRural */
  ruralOnly?: Maybe<Scalars['Boolean']['output']>;
  /** one or more school identifiers to find the listings in their catchment area */
  schoolCatchments?: Maybe<Array<SearchListingsSchoolCatchment>>;
  /** Filter by date range. Only used by search sold listings */
  soldDateRange?: Maybe<SearchListingsSoldDateRange>;
  sort?: Maybe<SearchListingsSort>;
  /**
   * Filter listing by tags (Include/Exclude)
   * ref: swagger for search api: https://search-api.domain.com.au/swagger/ui/index#/
   */
  tags?: Maybe<Array<SearchListingsTag>>;
  /** Search by topspot keywords */
  topspotKeywords?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Only return listings that have been updated since the specified date inclusively. Local timezone.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  updatedSince?: Maybe<Scalars['String']['output']>;
};

export enum SearchResultsAggregations {
  Bathrooms = 'BATHROOMS',
  Bedrooms = 'BEDROOMS',
  Carspaces = 'CARSPACES',
  Features = 'FEATURES',
  Isrural = 'ISRURAL',
  Propertytypes = 'PROPERTYTYPES',
  Suburb = 'SUBURB',
  Tags = 'TAGS'
}

export enum SearchListingsScheduleDateRange {
  Next_7Days = 'NEXT_7_DAYS',
  NextWeekend = 'NEXT_WEEKEND',
  ThisWeekend = 'THIS_WEEKEND',
  Today = 'TODAY'
}

/**
 * Defines a sort order comprised of 0 or more elements specifying sort field and direction.
 * Cannot be specified simultaneously with {Sort}.
 * ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/CustomSort.cs
 */
export type SearchListingsCustomSort = {
  __typename?: 'SearchListingsCustomSort';
  boostPrimarySuburbs?: Maybe<Scalars['Boolean']['output']>;
  elements?: Maybe<Array<SearchListingsCustomSortElement>>;
};

/** ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/CustomSortElement.cs */
export type SearchListingsCustomSortElement = {
  __typename?: 'SearchListingsCustomSortElement';
  direction?: Maybe<SearchListingsSortDirection>;
  field: SearchListingsCustomSortField;
};

/**
 * Sort direction from search api
 * ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search/Model/SortDirection.cs
 */
export enum SearchListingsSortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

/**
 * Custom  Sort field from search api
 * ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/CustomSortField.cs
 */
export enum SearchListingsCustomSortField {
  AdId = 'AdId',
  DateAvailable = 'DateAvailable',
  DateListed = 'DateListed',
  DateUpdated = 'DateUpdated',
  EarliestAuctionTime = 'EarliestAuctionTime',
  EarliestInspectionOpenTime = 'EarliestInspectionOpenTime',
  FreshnessLevel = 'FreshnessLevel',
  Price = 'Price',
  PriceDisplayOption = 'PriceDisplayOption',
  ProductBoost = 'ProductBoost',
  PromoLevelScore = 'PromoLevelScore',
  SoldDate = 'SoldDate',
  SuburbName = 'SuburbName'
}

/**
 * Filter by geo shapes. Shapes are mutually exclusive.
 * ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/GeoWindow.cs
 */
export type SearchListingsGeoWindow = {
  __typename?: 'SearchListingsGeoWindow';
  /** Define a geo boundary box to get listings within the box area */
  box?: Maybe<SearchListingsGeoWindowBox>;
  /** Define a geo polygon shape to get listings within the polygon area */
  polygon?: Maybe<SearchListingsGeoWindowPolygon>;
};

/** Define a geo boundary box to get listings within the box area */
export type SearchListingsGeoWindowBox = {
  __typename?: 'SearchListingsGeoWindowBox';
  bottomRight: SearchListingsGeoPoint;
  topLeft: SearchListingsGeoPoint;
};

/** ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/GeoPoint.cs */
export type SearchListingsGeoPoint = {
  __typename?: 'SearchListingsGeoPoint';
  /** Latitude coordinate */
  latitude: Scalars['Float']['output'];
  /** Longitude coordinate */
  longitude: Scalars['Float']['output'];
};

/** Define a geo polygon shape to get listings within the polygon area */
export type SearchListingsGeoWindowPolygon = {
  __typename?: 'SearchListingsGeoWindowPolygon';
  /** You must provide at least three points to form a polygon */
  points: Array<SearchListingsGeoPoint>;
};

/**
 * All possible high level PropertyType for apps from bondi-api
 * https://domain.atlassian.net/wiki/spaces/BD/pages/2508193997/Spike+What+property+types+are+currently+supported+in+iOS+and+android
 */
export enum SearchListingsHighLevelPropertyTypes {
  Apartment = 'Apartment',
  House = 'House',
  Land = 'Land',
  NewApartments = 'NewApartments',
  NewHomeDesigns = 'NewHomeDesigns',
  NewHouseLand = 'NewHouseLand',
  Rural = 'Rural',
  Townhouse = 'Townhouse'
}

/**
 * ListingAttribute from search api
 * https://github.com/domain-group/domain-search/blob/release/Source/Domain.Search/Model/ListingAttribute.cs
 */
export enum SearchListingsAttribute {
  HasMatterport = 'HasMatterport',
  HasPhotos = 'HasPhotos',
  HasPrice = 'HasPrice',
  MarkedAsNew = 'MarkedAsNew',
  NotUnderContract = 'NotUnderContract',
  NotUpForAuction = 'NotUpForAuction'
}

export type SearchListingsLocation = {
  __typename?: 'SearchListingsLocation';
  /** See http://location-api.domain.com.au/locations/areas */
  area?: Maybe<Scalars['String']['output']>;
  /** If true, this instance has a postcode and nothing more. */
  definesPostcodeOnly?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Return listing in surrounding suburbs
   * This work only if a location is a complete suburb match (State, Suburb, Area)
   */
  includeSurroundingSuburbs?: Maybe<Scalars['Boolean']['output']>;
  /** The post code for the suburb i.e 2000 */
  postcode?: Maybe<Scalars['String']['output']>;
  /** See http://location-api.domain.com.au/locations/regions */
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<States>;
  /** The name of the suburb i.e Sydney */
  suburb?: Maybe<Scalars['String']['output']>;
  /**
   * RadiusInMeters to add to the search area
   * It will be used to construct a circular search area based on suburb mid point.
   * This area will be searched in additional to the provided suburb (i.e. the results will belong to either suburb Or Circular area)
   * Radius Search works only for Suburb and will limit the results on selected suburb's state. i.e. If calculated circular area  overlapes with a different state, overlapping area will be ignored.
   * Minimum Value: 1
   * Maximum Value: 200000
   */
  surroundingRadiusInMeters?: Maybe<Scalars['Int']['output']>;
};

/**
 * PropertyEstablishedType from search api
 * ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/PropertyEstablishedType.cs
 */
export enum SearchListingsPropertyEstablishedType {
  Any = 'Any',
  Established = 'Established',
  New = 'New'
}

/**
 * PropertyFeature from search api
 * https://github.com/domain-group/domain-search/blob/release/Source/Domain.Search.Contracts/v2/PropertyFeature.cs
 */
export enum SearchListingsPropertyFeature {
  AirConditioning = 'AirConditioning',
  AlarmSystem = 'AlarmSystem',
  BalconyDeck = 'BalconyDeck',
  Bath = 'Bath',
  BroadbandInternetAccess = 'BroadbandInternetAccess',
  BuiltInWardrobes = 'BuiltInWardrobes',
  CableOrSatellite = 'CableOrSatellite',
  CityViews = 'CityViews',
  Dishwasher = 'Dishwasher',
  DoubleGlazedWindows = 'DoubleGlazedWindows',
  EnergyEfficientAppliances = 'EnergyEfficientAppliances',
  Ensuite = 'Ensuite',
  Fireplace = 'Fireplace',
  Floorboards = 'Floorboards',
  FullyFenced = 'FullyFenced',
  Furnished = 'Furnished',
  GardenCourtyard = 'GardenCourtyard',
  Gas = 'Gas',
  GreywaterSystem = 'GreywaterSystem',
  GroundFloor = 'GroundFloor',
  Gym = 'Gym',
  Heating = 'Heating',
  IndoorSpa = 'IndoorSpa',
  Intercom = 'Intercom',
  InternalLaundry = 'InternalLaundry',
  NorthFacing = 'NorthFacing',
  OutdoorSpa = 'OutdoorSpa',
  PetsAllowed = 'PetsAllowed',
  RainwaterStorageTank = 'RainwaterStorageTank',
  SecureParking = 'SecureParking',
  SeparateDiningRoom = 'SeparateDiningRoom',
  Shed = 'Shed',
  SolarHotWater = 'SolarHotWater',
  SolarPanels = 'SolarPanels',
  Study = 'Study',
  SwimmingPool = 'SwimmingPool',
  TennisCourt = 'TennisCourt',
  WallCeilingInsulation = 'WallCeilingInsulation',
  WaterEfficientAppliances = 'WaterEfficientAppliances',
  WaterEfficientFixtures = 'WaterEfficientFixtures',
  WaterViews = 'WaterViews'
}

export type SearchListingsSchoolCatchment = {
  __typename?: 'SearchListingsSchoolCatchment';
  /**
   * Used by apps to run school search from recent search
   * https://github.com/domain-group/domain-mobile-saved-search/blob/staging/mobile_saved_search/models/search_request.py#L118
   */
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum SearchListingsSoldDateRange {
  All = 'ALL',
  LastFortnight = 'LAST_FORTNIGHT',
  LastMonth = 'LAST_MONTH',
  LastSixMonths = 'LAST_SIX_MONTHS',
  LastThreeMonths = 'LAST_THREE_MONTHS',
  LastTwoYears = 'LAST_TWO_YEARS',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR'
}

/**
 * Specify how to sort results, using a range of predefined sorting configurations (see {SearchListingsSortKey}).
 * Cannot be specified simultaneously with {CustomSort}.
 */
export type SearchListingsSort = {
  __typename?: 'SearchListingsSort';
  /** Define the direction of sort */
  direction?: Maybe<SearchListingsSortDirection>;
  /** Define what concept to sort on */
  sortKey?: Maybe<SearchListingsSortKey>;
};

/**
 * Sort Key from search api
 * ref: https://github.com/domain-group/domain-search/blob/8d97ad809be9170b45c7043aa648499eca0e45a5/Source/Domain.Search.Web.Api/v2/Models/SortKey.cs
 */
export enum SearchListingsSortKey {
  AuctionTime = 'AuctionTime',
  DateAvailable = 'DateAvailable',
  DateListed = 'DateListed',
  DateUpdated = 'DateUpdated',
  Default = 'Default',
  DefaultThenDateUpdated = 'DefaultThenDateUpdated',
  InspectionTime = 'InspectionTime',
  Price = 'Price',
  SoldDate = 'SoldDate',
  Suburb = 'Suburb'
}

/**
 * Used to indicate whether listings with a given {tag} should be included
 * or excluded, based on the {criteria}.
 * https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/TagQuery.cs
 */
export type SearchListingsTag = {
  __typename?: 'SearchListingsTag';
  /** The inclusion/exclusion criteria. */
  criteria?: Maybe<SearchListingsTagCriteria>;
  /** The tag value. */
  tag: Scalars['String']['output'];
};

export enum SearchListingsTagCriteria {
  Exclude = 'Exclude',
  Include = 'Include'
}

export type ContentTag = {
  __typename?: 'ContentTag';
  id: Scalars['Int']['output'];
  invisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentArticleListResult = ContentArticleList | ErrorWithUserMessage;

export type ContentArticleList = {
  __typename?: 'ContentArticleList';
  articles: Array<Maybe<ContentArticleListItem>>;
  count: Scalars['Int']['output'];
};

export type ContentArticleListItem = {
  __typename?: 'ContentArticleListItem';
  articleReadTime: ContentReadTime;
  authors: Array<Maybe<ContentAuthor>>;
  categories: Array<Maybe<ContentCategory>>;
  contentType: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  excerpt: Scalars['String']['output'];
  featuredImage: ContentImage;
  id: Scalars['Int']['output'];
  indexImage?: Maybe<ContentImage>;
  isNative: Scalars['Boolean']['output'];
  modifiedDate: Scalars['String']['output'];
  permalink: Scalars['String']['output'];
  publishedDate: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceLogo?: Maybe<ContentSourceLogo>;
  summaryReadTime?: Maybe<ContentReadTime>;
  tags: Array<Maybe<ContentTag>>;
  title: Scalars['String']['output'];
};

export type ContentSourceLogo = {
  __typename?: 'ContentSourceLogo';
  dark: Scalars['String']['output'];
  light: Scalars['String']['output'];
};

export type LastSearchForArticleResult = ErrorWithUserMessage | LastSearchForArticle;

export type LastSearchForArticle = {
  __typename?: 'LastSearchForArticle';
  isSavedSearch?: Maybe<Scalars['Boolean']['output']>;
  searchCriteria?: Maybe<SearchListingsParameters>;
};

export type SchoolWithDistanceConnection = {
  __typename?: 'SchoolWithDistanceConnection';
  edges?: Maybe<Array<Maybe<SchoolWithDistanceEdge>>>;
  pageInfo: PageInfo;
};

export type SchoolWithDistanceEdge = {
  __typename?: 'SchoolWithDistanceEdge';
  cursor: Scalars['String']['output'];
  node: SchoolWithDistance;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type GetShortlistedListingsV2Result = ErrorWithUserMessage | GetShortlistedListingsV2ResultSuccess;

export type GetShortlistedListingsV2ResultSuccess = {
  __typename?: 'GetShortlistedListingsV2ResultSuccess';
  ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type HomeLoanRates = {
  __typename?: 'HomeLoanRates';
  comparisonRate?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  rbaRate?: Maybe<Scalars['Float']['output']>;
};

export type ListingDetailsV2 = ErrorWithUserMessage | ListingDetails;

/** Define a geo boundary box to get listings within the box area */
export type SearchListingsGeoWindowBoxInput = {
  bottomRight: SearchListingsGeoPointInput;
  topLeft: SearchListingsGeoPointInput;
};

/** ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/GeoPoint.cs */
export type SearchListingsGeoPointInput = {
  /** Latitude coordinate */
  latitude: Scalars['Float']['input'];
  /** Longitude coordinate */
  longitude: Scalars['Float']['input'];
};

export type MarketInsights = {
  __typename?: 'MarketInsights';
  /** Base market insights tracking */
  metadata?: Maybe<MarketInsightsMetadata>;
  suburbInsights?: Maybe<Array<Maybe<SuburbInsightsInfo>>>;
};

export type MarketInsightsMetadata = {
  __typename?: 'MarketInsightsMetadata';
  trackingMetadata?: Maybe<Scalars['String']['output']>;
};

export type SuburbInsightsInfo = {
  __typename?: 'SuburbInsightsInfo';
  area?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Tracking metadata for the suburb insight, based on given criteria */
  metadata?: Maybe<MarketInsightsMetadata>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** Detailed insights of the suburb, based on given criteria */
  profile?: Maybe<MarketInsightsProfile>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburbName?: Maybe<Scalars['String']['output']>;
  suburbShape?: Maybe<SuburbShape>;
  suburbSlug: Scalars['String']['output'];
};


export type SuburbInsightsInfoMetadataArgs = {
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  propertyType?: InputMaybe<MarketInsightsPropertyType>;
};


export type SuburbInsightsInfoProfileArgs = {
  bedrooms: Scalars['Int']['input'];
  propertyType: MarketInsightsPropertyType;
  timeSpan?: InputMaybe<MarketInsightsTimeSpan>;
};


export type SuburbInsightsInfoSuburbShapeArgs = {
  geometryPrecision?: InputMaybe<SuburbShapeGeometryPrecision>;
};

export enum MarketInsightsPropertyType {
  House = 'House',
  Unit = 'Unit'
}

export enum MarketInsightsTimeSpan {
  FiveYears = 'FIVE_YEARS',
  OneYear = 'ONE_YEAR',
  ThreeYears = 'THREE_YEARS'
}

export type MarketInsightsProfile = {
  __typename?: 'MarketInsightsProfile';
  /** Annual growth for given time period */
  annualGrowth?: Maybe<Scalars['Float']['output']>;
  /** Yearly sale statistics */
  annualStats?: Maybe<Array<Maybe<MarketInsightsAnnualStatistics>>>;
  /** Average days on market for given time period */
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  /** Median sold price for given time period */
  medianSoldPrice?: Maybe<Scalars['Int']['output']>;
  /**
   * Top of the recent sales price range.
   * Maps from Location Profiles propertyCategories.luxuryLevelPrice.
   * Equivalent to Bondi market_insights.recent_sales_price_high.
   */
  recentSalesPriceHigh?: Maybe<Scalars['Int']['output']>;
  /**
   * Bottom of the recent sales price range.
   * Maps from Location Profiles propertyCategories.entryLevelPrice.
   * Equivalent to Bondi market_insights.recent_sales_price_low.
   */
  recentSalesPriceLow?: Maybe<Scalars['Int']['output']>;
  /** Stats of similar properties */
  relatedProfiles?: Maybe<Array<RelatedProfile>>;
};

export type MarketInsightsAnnualStatistics = {
  __typename?: 'MarketInsightsAnnualStatistics';
  /** Annual growth for the year */
  annualGrowth?: Maybe<Scalars['Float']['output']>;
  /** Average days on market for the year */
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  /** Median sold price for the year */
  medianSoldPrice?: Maybe<Scalars['Int']['output']>;
  /** Number of sold properties for the year */
  numberSold?: Maybe<Scalars['Int']['output']>;
  /** Year of sales statistics */
  year?: Maybe<Scalars['Int']['output']>;
};

export type RelatedProfile = {
  __typename?: 'RelatedProfile';
  bedrooms: Scalars['Int']['output'];
  profile?: Maybe<MarketInsightsProfile>;
  propertyType: MarketInsightsPropertyType;
};

export type MarketInsightsResult = ErrorWithUserMessage | MarketInsights;

export type MatchingSavedSearchInput = {
  searchListingsParameters: SearchListingsParametersInput;
};

export type SearchListingsParametersInput = {
  /** Filter based on Ad Ids (Include in search result if AdID is in this list) */
  adIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Return listings only created by these agencies. */
  advertiserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Aggregated results
   * Could be the following values:
   * bedrooms, bathrooms, carspaces, propertytypes, features, suburb, tags, isrural
   */
  aggregations?: InputMaybe<Array<SearchResultsAggregations>>;
  /**
   * Filter listings with auction time on or from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  auctionFrom?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter listings with auction time date range.
   * GQL converts this into inspectionFrom and inspectionTo for Search API
   */
  auctionSchedule?: InputMaybe<SearchListingsScheduleDateRange>;
  /**
   * Filter listings with auction on or before from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  auctionTo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines a sort order comprised of 0 or more elements specifying sort field and direction.
   * Cannot be specified simultaneously with {Sort}.
   */
  customSort?: InputMaybe<SearchListingsCustomSortInput>;
  /**
   * Return only those listings whose DateAvailable is null, or is at or after the specified time.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  dateAvailableFrom?: InputMaybe<Scalars['String']['input']>;
  /**
   * Return only those listings whose DateAvailable is null, or is at or before the specified time.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  dateAvailableTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter out listings with Ad Ids (Exclude listings from search result if AdID is in this list) */
  excludeAdIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, exclude listings (rental) has deposit taken */
  excludeDepositTaken?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, exclude listings whose price has been withheld. */
  excludePriceWithheld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by geo shapes. Shapes are mutually exclusive. */
  geoWindow?: InputMaybe<SearchListingsGeoWindowInput>;
  /** Filter by one or more high level types of properties */
  highLevelPropertyTypes?: InputMaybe<Array<SearchListingsHighLevelPropertyTypes>>;
  /**
   * Filter listings with inspection time on or from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  inspectionFrom?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter listings with inspection time date range.
   * GQL converts this into inspectionFrom and inspectionTo for Search API
   */
  inspectionSchedule?: InputMaybe<SearchListingsScheduleDateRange>;
  /**
   * Filter listings with inspection time on or before date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  inspectionTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by one or more keywords that a listing should contain */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Unit of measurement for the Land area.
   * If landAreaUnit isn't specified, land area would be treated as SQUARE_METERS.
   * Since search listings api accepts the value only in SQUARE_METERS, based on the value of landAreaUnit the maxLandArea and minLandArea would be converted to SQUARE_METERS.
   */
  landAreaUnit?: InputMaybe<AreaUnits>;
  /**
   * Only return listings that have been listed since the specified date inclusively. Local timezone.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  listedSince?: InputMaybe<Scalars['String']['input']>;
  /** Limit the results to listing with specific attributes */
  listingAttributes?: InputMaybe<Array<SearchListingsAttribute>>;
  /** The listing type to search for */
  listingType?: InputMaybe<SearchListingsType>;
  /**
   * Filter by the locations either suburb, area, region or state
   * Can also be used to search suburb and some area around it if radius is provided.
   * Invalid locations will return no results.
   * If {Domain.Search.Web.Api.v2.Models.SearchLocation.IncludeSurroundingSuburbs} is set to true, surrounding suburbs will also be searched for.
   */
  locations?: InputMaybe<Array<SearchListingsLocationInput>>;
  /** Filter by location terms. This can be used in conjunction with Locations */
  locationTerms?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter listing by maximum number of bathrooms
   * 0.5 means no shower
   */
  maxBathrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by maximum number of bedrooms */
  maxBedrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by maximum number of car spaces */
  maxCarspaces?: InputMaybe<Scalars['Int']['input']>;
  /** Max Land Area in square meters */
  maxLandArea?: InputMaybe<Scalars['Int']['input']>;
  /** Filter listing at or below a maximum price */
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  /** Filter listing by minimum number of bathrooms */
  minBathrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by minimum number of bedrooms */
  minBedrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by minimum number of car spaces */
  minCarspaces?: InputMaybe<Scalars['Int']['input']>;
  /** Min Land Area in square meters */
  minLandArea?: InputMaybe<Scalars['Int']['input']>;
  /** Filter listing at or above a minimum price */
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  /** If true, return only listings for new properties (i.e. ones that are on the market for the first time). */
  newDevOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The specific result page to return */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Specify the number of result items in a page */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter listings based on their whether or not they are classified as a new development
   * Any returns all properties
   * New returns only listings classified as new developments
   * Existing returns only listings that aren't classified as new developments
   */
  propertyEstablishedType?: InputMaybe<SearchListingsPropertyEstablishedType>;
  /** Filter by one or more property features such as Gas or AC */
  propertyFeatures?: InputMaybe<Array<SearchListingsPropertyFeature>>;
  /** Filter by one or more types of properties */
  propertyTypes?: InputMaybe<Array<SearchListingsPropertyType>>;
  /** if true, the response will include only listings flagged with IsRural */
  ruralOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** one or more school identifiers to find the listings in their catchment area */
  schoolCatchments?: InputMaybe<Array<SearchListingsSchoolCatchmentInput>>;
  /** Filter by date range. Only used by search sold listings */
  soldDateRange?: InputMaybe<SearchListingsSoldDateRange>;
  sort?: InputMaybe<SearchListingsSortInput>;
  /**
   * Filter listing by tags (Include/Exclude)
   * ref: swagger for search api: https://search-api.domain.com.au/swagger/ui/index#/
   */
  tags?: InputMaybe<Array<SearchListingsTagInput>>;
  /** Search by topspot keywords */
  topspotKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Only return listings that have been updated since the specified date inclusively. Local timezone.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  updatedSince?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Defines a sort order comprised of 0 or more elements specifying sort field and direction.
 * Cannot be specified simultaneously with {Sort}.
 * ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/CustomSort.cs
 */
export type SearchListingsCustomSortInput = {
  boostPrimarySuburbs?: InputMaybe<Scalars['Boolean']['input']>;
  elements?: InputMaybe<Array<SearchListingsCustomSortElementInput>>;
};

/** ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/CustomSortElement.cs */
export type SearchListingsCustomSortElementInput = {
  direction?: InputMaybe<SearchListingsSortDirection>;
  field: SearchListingsCustomSortField;
};

/**
 * Filter by geo shapes. Shapes are mutually exclusive.
 * ref: https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/GeoWindow.cs
 */
export type SearchListingsGeoWindowInput = {
  /** Define a geo boundary box to get listings within the box area */
  box?: InputMaybe<SearchListingsGeoWindowBoxInput>;
  /** Define a geo polygon shape to get listings within the polygon area */
  polygon?: InputMaybe<SearchListingsGeoWindowPolygonInput>;
};

/** Define a geo polygon shape to get listings within the polygon area */
export type SearchListingsGeoWindowPolygonInput = {
  /** You must provide at least three points to form a polygon */
  points: Array<SearchListingsGeoPointInput>;
};

export type SearchListingsLocationInput = {
  /** See http://location-api.domain.com.au/locations/areas */
  area?: InputMaybe<Scalars['String']['input']>;
  /** If true, this instance has a postcode and nothing more. */
  definesPostcodeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Return listing in surrounding suburbs
   * This work only if a location is a complete suburb match (State, Suburb, Area)
   */
  includeSurroundingSuburbs?: InputMaybe<Scalars['Boolean']['input']>;
  /** The post code for the suburb i.e 2000 */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** See http://location-api.domain.com.au/locations/regions */
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<States>;
  /** The name of the suburb i.e Sydney */
  suburb?: InputMaybe<Scalars['String']['input']>;
  /**
   * RadiusInMeters to add to the search area
   * It will be used to construct a circular search area based on suburb mid point.
   * This area will be searched in additional to the provided suburb (i.e. the results will belong to either suburb Or Circular area)
   * Radius Search works only for Suburb and will limit the results on selected suburb's state. i.e. If calculated circular area  overlapes with a different state, overlapping area will be ignored.
   * Minimum Value: 1
   * Maximum Value: 200000
   */
  surroundingRadiusInMeters?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingsSchoolCatchmentInput = {
  /**
   * Used by apps to run school search from recent search
   * https://github.com/domain-group/domain-mobile-saved-search/blob/staging/mobile_saved_search/models/search_request.py#L118
   */
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Specify how to sort results, using a range of predefined sorting configurations (see {SearchListingsSortKey}).
 * Cannot be specified simultaneously with {CustomSort}.
 */
export type SearchListingsSortInput = {
  /** Define the direction of sort */
  direction?: InputMaybe<SearchListingsSortDirection>;
  /** Define what concept to sort on */
  sortKey?: InputMaybe<SearchListingsSortKey>;
};

/**
 * Used to indicate whether listings with a given {tag} should be included
 * or excluded, based on the {criteria}.
 * https://github.com/domain-group/domain-search/blob/94023f2faf98b74aa5ec952ae04d07daf2046351/Source/Domain.Search.Web.Api/v2/Models/TagQuery.cs
 */
export type SearchListingsTagInput = {
  /** The inclusion/exclusion criteria. */
  criteria?: InputMaybe<SearchListingsTagCriteria>;
  /** The tag value. */
  tag: Scalars['String']['input'];
};

export type MatchingSavedSearchResult = ErrorWithUserMessage | MatchingSavedSearchResultSuccess;

export type MatchingSavedSearchResultSuccess = {
  __typename?: 'MatchingSavedSearchResultSuccess';
  savedSearch?: Maybe<SavedSearchResult>;
};

export type SavedSearchResult = {
  __typename?: 'SavedSearchResult';
  /** Experiment: Denotes whether or not this search is in immediate notifications area */
  allowsImmediatePropertyAlert?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<DateTime>;
  lastRunDate?: Maybe<DateTime>;
  /** Notification preferences */
  preferences?: Maybe<Array<SavedSearchPreference>>;
  /** Name generated from the locations in the search */
  savedSearchName?: Maybe<Scalars['String']['output']>;
  /**
   * id as number for logged in user's saved search (User API)
   * uuid for anonymous user's saved search (Mobile Saved Search API)
   * uuid for recent search (Mobile Saved Search API)
   */
  searchId: Scalars['ID']['output'];
  searchRequest?: Maybe<SearchListingsParameters>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type SavedSearchPreference = {
  __typename?: 'SavedSearchPreference';
  /** PUSH, EMAIL */
  deliveryType?: Maybe<SavedSearchDeliveryType>;
  /** How often to send an alert */
  frequency?: Maybe<SavedSearchDeliveryFrequency>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Type of listing to receive an alert */
  preferenceType?: Maybe<SavedSearchPreferenceType>;
};

export enum SavedSearchDeliveryType {
  Email = 'EMAIL',
  Push = 'PUSH'
}

export enum SavedSearchDeliveryFrequency {
  Daily = 'DAILY',
  Immediate = 'IMMEDIATE',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export enum SavedSearchPreferenceType {
  Ebrochure = 'EBROCHURE',
  HomeAlerts = 'HOME_ALERTS',
  PremarketListings = 'PREMARKET_LISTINGS'
}

export type MatterportSearchLocation = {
  area?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<States>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type MatterportExhibitionResult = ErrorWithUserMessage | MatterportExhibition;

export type MatterportExhibition = {
  __typename?: 'MatterportExhibition';
  results: Array<MatterportExhibitionData>;
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type MatterportExhibitionData = SearchListingsResultListing | SearchListingsResultProject;

export type SearchListingsResultProject = {
  __typename?: 'SearchListingsResultProject';
  /** Agency details */
  agency?: Maybe<SearchListingsAgency>;
  /** Agency branding */
  branding?: Maybe<SearchListingsAgencyBranding>;
  /** The first child property address */
  childDisplayableAddress?: Maybe<Address>;
  childListings?: Maybe<Array<SearchListingsResultListing>>;
  /** The display address for whole project */
  displayableAddress?: Maybe<Address>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  /** Inspection details */
  inspectionDetails?: Maybe<InspectionDetails>;
  keywords: Array<Scalars['String']['output']>;
  /** Property labels obtained from the Search API and used on the web */
  labels?: Maybe<Array<Scalars['String']['output']>>;
  /** The media associated with the property provided by the advertiser */
  media?: Maybe<Array<Media>>;
  /** Name of the project */
  name?: Maybe<Scalars['String']['output']>;
  priceFrom?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['Int']['output'];
  projectUrl?: Maybe<Scalars['String']['output']>;
  promoLevel?: Maybe<PromoLevel>;
  /** Property labels adjusted from labels for mobile apps */
  propertyLabels?: Maybe<Array<SearchListingsResultsPropertyLabel>>;
};

export type User = Person & {
  __typename?: 'User';
  address?: Maybe<Address>;
  claimById?: Maybe<Claim>;
  claimBySlug?: Maybe<Claim>;
  claims?: Maybe<Array<Maybe<Claim>>>;
  /** @deprecated Domain Home Loans joint venture exited */
  dhlMembership?: Maybe<DhlMembership>;
  digitalDataUser?: Maybe<DigitalDataUser>;
  email: Scalars['String']['output'];
  emailSubscriptions?: Maybe<Array<Maybe<EmailSubscription>>>;
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hagridId: Scalars['Int']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<OnboardingData>;
  pendingVerificationEmail?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Image>;
  /** POST user-api/v1/shortlists/listings/list */
  shortlist?: Maybe<Array<Listing>>;
  subscriptions?: Maybe<Array<UserSubscription>>;
};


export type UserClaimByIdArgs = {
  propertyId: Scalars['String']['input'];
};


export type UserClaimBySlugArgs = {
  propertySlug: Scalars['String']['input'];
};


export type UserShortlistArgs = {
  input?: InputMaybe<ShortlistInput>;
};

export type Claim = {
  __typename?: 'Claim';
  address: Scalars['String']['output'];
  claimant: Scalars['String']['output'];
  created: Scalars['String']['output'];
  displayLabel?: Maybe<ClaimLabel>;
  id: Scalars['ID']['output'];
  /** @deprecated legacy says it all */
  legacyPropertyId: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  propertyDetails?: Maybe<ClaimedPropertyDetails>;
  propertyId: Scalars['String']['output'];
  suggestions?: Maybe<ClaimSuggestions>;
  updated: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
  vendorEnquiries?: Maybe<Array<Maybe<VendorEnquiry>>>;
};

export type ClaimLabel = {
  __typename?: 'ClaimLabel';
  colour?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ClaimedPropertyDetails = {
  __typename?: 'ClaimedPropertyDetails';
  /** @deprecated available directly on Claim */
  property?: Maybe<Property>;
  valuation?: Maybe<PropertyValuation>;
};

export type ClaimSuggestions = {
  __typename?: 'ClaimSuggestions';
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  parking?: Maybe<Scalars['Int']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
};

export type VendorEnquiry = {
  __typename?: 'VendorEnquiry';
  additionalComments?: Maybe<Scalars['String']['output']>;
  /** @deprecated old agents deprecated use contacts */
  agents?: Maybe<Array<Maybe<Agent>>>;
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  contactPreference?: Maybe<VendorEnquiryContactPreference>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  contactTimeframe?: Maybe<VendorEnquiryContactTimeframe>;
  createdAt: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  enquiryId: Scalars['String']['output'];
  estimates?: Maybe<Array<Maybe<VendorEnquiryEstimate>>>;
  features?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  parking?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  propertyType?: Maybe<VendorEnquiryPropertyType>;
  renovationTimeframe?: Maybe<VendorEnquiryRenovationTimeframe>;
  requestedInformation: Array<Maybe<VendorEnquiryRequestedInformation>>;
  timeframe?: Maybe<VendorEnquiryTimeframe>;
  type?: Maybe<VendorEnquiryType>;
  updatedAt: Scalars['String']['output'];
  usage?: Maybe<VendorEnquiryUsage>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum VendorEnquiryContactPreference {
  Any = 'ANY',
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export enum VendorEnquiryContactTimeframe {
  AnyTime = 'ANY_TIME',
  MondayToFridayAfterFivePm = 'MONDAY_TO_FRIDAY_AFTER_FIVE_PM',
  SaturdayOrSunday = 'SATURDAY_OR_SUNDAY'
}

export type VendorEnquiryEstimate = {
  __typename?: 'VendorEnquiryEstimate';
  /**
   * WARNING: Will be deprecated in favour of "contact"
   * This type is actually a "Contact".
   * It is an agent within a certain agency (e.g. rawilson@raywhite.com.au).
   * @deprecated Old agent type deprecated use contact
   */
  agent?: Maybe<Agent>;
  contact?: Maybe<Contact>;
  createdAt: Scalars['String']['output'];
  estimatePrice?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  opinionOnEstimate?: Maybe<VendorEnquiryOpinionOnEstimate>;
  response?: Maybe<VendorEnquiryResponseToEstimate>;
  updatedAt: Scalars['String']['output'];
};

export enum VendorEnquiryOpinionOnEstimate {
  JustAlright = 'JUST_ALRIGHT',
  NotReliable = 'NOT_RELIABLE',
  ReallyReliable = 'REALLY_RELIABLE'
}

export enum VendorEnquiryResponseToEstimate {
  GotAppraisalNotGo = 'GOT_APPRAISAL_NOT_GO',
  GotAppraisalPickedThisAgent = 'GOT_APPRAISAL_PICKED_THIS_AGENT',
  NoResponse = 'NO_RESPONSE',
  NotGoAfterInitialChat = 'NOT_GO_AFTER_INITIAL_CHAT'
}

export enum VendorEnquiryPropertyType {
  House = 'HOUSE',
  Other = 'OTHER',
  Studio = 'STUDIO',
  TownHouse = 'TOWN_HOUSE',
  Unit = 'UNIT'
}

export enum VendorEnquiryRenovationTimeframe {
  LastFiveToTenYears = 'LAST_FIVE_TO_TEN_YEARS',
  LastFiveYears = 'LAST_FIVE_YEARS',
  Never = 'NEVER'
}

export enum VendorEnquiryRequestedInformation {
  Appraisal = 'APPRAISAL',
  ComparativeMarketAnalysis = 'COMPARATIVE_MARKET_ANALYSIS',
  Estimate = 'ESTIMATE'
}

export enum VendorEnquiryTimeframe {
  JustResearching = 'JUST_RESEARCHING',
  OneToThreeMonths = 'ONE_TO_THREE_MONTHS',
  OverSixMonths = 'OVER_SIX_MONTHS',
  ThreeToSixMonths = 'THREE_TO_SIX_MONTHS',
  WithinMonth = 'WITHIN_MONTH'
}

export enum VendorEnquiryType {
  Appraisal = 'APPRAISAL'
}

export enum VendorEnquiryUsage {
  Investment = 'INVESTMENT',
  PrimaryResidence = 'PRIMARY_RESIDENCE'
}

export type DhlMembership = {
  __typename?: 'DhlMembership';
  /** Populated if a DHL user contains a loan application (via an evaluation funnel completion) */
  latestLoanApplication?: Maybe<DhlLoanApplication>;
  lendiUserId: Scalars['String']['output'];
};

export type DhlLoanApplication = {
  __typename?: 'DhlLoanApplication';
  maximumBorrowingPower?: Maybe<Scalars['Int']['output']>;
};

export type DigitalDataUser = {
  __typename?: 'DigitalDataUser';
  user?: Maybe<DigitalDataUserUser>;
};

export type DigitalDataUserUser = {
  __typename?: 'DigitalDataUserUser';
  /** @deprecated Domain Home Loans joint venture exited */
  dhlMembership?: Maybe<Scalars['String']['output']>;
  emailHash?: Maybe<Scalars['String']['output']>;
  emailHash256?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  membershipState?: Maybe<Scalars['String']['output']>;
  membershipType?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<DigitalDataUserUserProfile>;
  sessionToken?: Maybe<Scalars['String']['output']>;
};

export type DigitalDataUserUserProfile = {
  __typename?: 'DigitalDataUserUserProfile';
  profileInfo?: Maybe<DigitalDataUserUserProfileInfo>;
};

export type DigitalDataUserUserProfileInfo = {
  __typename?: 'DigitalDataUserUserProfileInfo';
  domainUserId?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
};

/** Email subscription for a user */
export type EmailSubscription = {
  __typename?: 'EmailSubscription';
  frequency?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OnboardingData = {
  __typename?: 'OnboardingData';
  domainUserId: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  process: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  value: Array<OnboardingValue>;
};

/** See the details on the user-api-v1 Swagger for POST user-api/v1/shortlists/listings */
export type ShortlistInput = {
  idsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shortlistId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  deliveryType: Scalars['String']['output'];
  frequency: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type SavedSearchResultsV2 = ErrorWithUserMessage | SavedSearchResultsSuccess;

export type SavedSearchResultsSuccess = {
  __typename?: 'SavedSearchResultsSuccess';
  recentSearches?: Maybe<Array<SearchResult>>;
  savedSearches?: Maybe<Array<SavedSearchResult>>;
};

export type SearchResult = RecentSearchResult | SavedSearchResult;

export type RecentSearchResult = {
  __typename?: 'RecentSearchResult';
  /** Experiment: Denotes whether or not this search is in immediate notifications area */
  allowsImmediatePropertyAlert?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<DateTime>;
  lastRunDate?: Maybe<DateTime>;
  /** Name generated from the locations in the search */
  savedSearchName?: Maybe<Scalars['String']['output']>;
  /**
   * id as number for logged in user's saved search (User API)
   * uuid for anonymous user's saved search (Mobile Saved Search API)
   * uuid for recent search (Mobile Saved Search API)
   */
  searchId: Scalars['ID']['output'];
  searchRequest?: Maybe<SearchListingsParameters>;
};

export type SoldListingsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type SoldListingsResults = ErrorWithUserMessage | SoldListingsResultsSuccess;

export type SoldListingsResultsSuccess = {
  __typename?: 'SoldListingsResultsSuccess';
  /** Saved or recent search ID used for searching sold listings */
  savedSearchId: Scalars['String']['output'];
  /** Type of saved search: SAVED_SEARCH or RECENT_SEARCH */
  savedSearchType: SavedSearchType;
  soldListingsResults?: Maybe<SearchListingsResultsSuccess>;
};

export enum SavedSearchType {
  RecentSearch = 'RECENT_SEARCH',
  SavedSearch = 'SAVED_SEARCH'
}

export type SearchListingsResultsSuccess = {
  __typename?: 'SearchListingsResultsSuccess';
  /** Will be true if the full result set returned by the Elasticsearch backend has been limited due to it exceeding the maximum allowed results size. */
  actualTotalResultsExceedsMaximum: Scalars['Boolean']['output'];
  /**
   * Experimental feature to show the affordability of supply data
   * for a given search
   */
  affordabilityOrSupply?: Maybe<AffordabilityOrSupplyResult>;
  allowsImmediatePropertyAlert: Scalars['Boolean']['output'];
  metadata: SearchListingsResultsMetadata;
  /** The returned page number */
  page: Scalars['Int']['output'];
  /** @deprecated Use searchResults instead */
  results?: Maybe<Array<SearchListingsResult>>;
  /** searchId string to map when mobile apps requested seach listing multiple saved searches */
  searchId?: Maybe<Scalars['String']['output']>;
  /**
   * Name of search based on criteria
   * Location searches will return list of locations
   * Map searches will return nearest suburb / area / region if applicable (Default: Map Area)
   * School searches will return name of school
   * Finger searches will return Drawn area name (Apps only)
   */
  searchName?: Maybe<Scalars['String']['output']>;
  searchResults?: Maybe<Array<CombinedSearchResult>>;
  suburbDetails?: Maybe<Array<Maybe<SuburbDetails>>>;
  /** The total number of available pages for this search. */
  totalPages: Scalars['Int']['output'];
  /** The total number of available listings for this search. This only counts searchrow and newdevsearchrow */
  totalResults: Scalars['Int']['output'];
};


export type SearchListingsResultsSuccessSearchResultsArgs = {
  includeTopspot?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfListingsRequired?: InputMaybe<Scalars['Int']['input']>;
};

export type AffordabilityOrSupplyResult = AffordabilityResult | ErrorWithUserMessage | SupplyResult;

export type AffordabilityResult = {
  __typename?: 'AffordabilityResult';
  ctaText?: Maybe<Scalars['String']['output']>;
  insightsMessage: Scalars['String']['output'];
  insightsTitle: Scalars['String']['output'];
  layout: AffordabilitySupplyLayout;
  listingsOverPriceTitle?: Maybe<Scalars['String']['output']>;
  listingsUnderPriceTitle?: Maybe<Scalars['String']['output']>;
  listingsWithPriceTitle?: Maybe<Scalars['String']['output']>;
  mapButtonText: Scalars['String']['output'];
  message: Scalars['String']['output'];
  percentageOfSoldProperties: Scalars['Float']['output'];
  priceWithheldDisclaimer?: Maybe<Scalars['String']['output']>;
  propertiesSoldWithDisplayPrice: Scalars['Int']['output'];
  propertiesSoldWithMatchingCritieria: Scalars['Int']['output'];
  tier: AvailabilityTier;
  title: Scalars['String']['output'];
  totalNumberOfAvailableProperties: Scalars['Int']['output'];
  totalNumberOfPropertiesSold: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export enum AffordabilitySupplyLayout {
  Graph = 'GRAPH',
  Illustration = 'ILLUSTRATION'
}

export enum AvailabilityTier {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SupplyResult = {
  __typename?: 'SupplyResult';
  ctaText?: Maybe<Scalars['String']['output']>;
  insightsMessage: Scalars['String']['output'];
  insightsTitle: Scalars['String']['output'];
  layout: AffordabilitySupplyLayout;
  listingsOverPriceTitle?: Maybe<Scalars['String']['output']>;
  listingsUnderPriceTitle?: Maybe<Scalars['String']['output']>;
  listingsWithPriceTitle?: Maybe<Scalars['String']['output']>;
  mapButtonText: Scalars['String']['output'];
  message: Scalars['String']['output'];
  percentageOfSoldProperties: Scalars['Float']['output'];
  priceWithheldDisclaimer?: Maybe<Scalars['String']['output']>;
  propertiesSoldWithDisplayPrice: Scalars['Int']['output'];
  propertiesSoldWithMatchingCritieria: Scalars['Int']['output'];
  tier: AvailabilityTier;
  title: Scalars['String']['output'];
  totalNumberOfAvailableProperties: Scalars['Int']['output'];
  totalNumberOfPropertiesSold: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type SearchListingsResultsMetadata = {
  __typename?: 'SearchListingsResultsMetadata';
  /** Aggregation buckets */
  aggregations?: Maybe<SearchListingsResultsMetadataAggregations>;
  medianPrice?: Maybe<Scalars['Int']['output']>;
  parameters?: Maybe<SearchListingsParameters>;
  /** Total number of listings not counting the children in projects */
  totalListingsExcludingChildren?: Maybe<Scalars['Int']['output']>;
  trackingMetadata?: Maybe<Scalars['String']['output']>;
};

/** Aggregations in JSON format */
export type SearchListingsResultsMetadataAggregations = {
  __typename?: 'SearchListingsResultsMetadataAggregations';
  bathrooms?: Maybe<Scalars['String']['output']>;
  bedrooms?: Maybe<Scalars['String']['output']>;
  carspaces?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Scalars['String']['output']>;
  propertytypes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use propertytypes */
  propertyTypes?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
};

export type SearchListingsResult = SearchListingsResultListing | SearchListingsResultProject;

export type CombinedSearchResult = FeaturedAgency | SearchListingsResultListing | SearchListingsResultProject | TopSpotAgency;

export type FeaturedAgency = {
  __typename?: 'FeaturedAgency';
  /** Agency details */
  agency?: Maybe<SearchListingsAgency>;
};

export type TopSpotAgency = {
  __typename?: 'TopSpotAgency';
  hasMoreListings?: Maybe<Scalars['Boolean']['output']>;
  topSpotListings?: Maybe<Array<SearchListingsResultListing>>;
};

export type SuburbDetails = {
  __typename?: 'SuburbDetails';
  /** Count of listing returned in the searched suburb */
  numberOfListings?: Maybe<Scalars['Int']['output']>;
  suburbInsight?: Maybe<SuburbInsightsInfo>;
};

export type SuburbInsightInput = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SuburbInsightResults = ErrorWithUserMessage | SuburbInsights;

export type SuburbInsights = {
  __typename?: 'SuburbInsights';
  suburbInsights?: Maybe<Array<Maybe<SuburbInsightItem>>>;
};

export type SuburbInsightItem = {
  __typename?: 'SuburbInsightItem';
  bedrooms: Scalars['Int']['output'];
  propertyType: MarketInsightsPropertyType;
  suburbInsight: SuburbInsight;
};

export type SuburbInsight = {
  __typename?: 'SuburbInsight';
  area?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<MarketInsightsProfile>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburbName?: Maybe<Scalars['String']['output']>;
  suburbShape?: Maybe<SuburbShape>;
  suburbSlug: Scalars['String']['output'];
};


export type SuburbInsightSuburbShapeArgs = {
  geometryPrecision?: InputMaybe<SuburbShapeGeometryPrecision>;
};

export type PostInspectionMode = {
  __typename?: 'PostInspectionMode';
  inPostInspectionMode?: Maybe<Scalars['Boolean']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type PremarketListing = ErrorWithUserMessage | PremarketListingDetail;

export type PremarketListingDetail = {
  __typename?: 'PremarketListingDetail';
  address?: Maybe<Address>;
  agency?: Maybe<Agency>;
  agents?: Maybe<Array<Agent>>;
  authority?: Maybe<PremarketListingAuthority>;
  /** Total number of bathrooms in the property */
  bathrooms: Scalars['Float']['output'];
  /** Total number of bedrooms in the property; Studio apartments have a value of "0" */
  bedrooms: Scalars['Float']['output'];
  /** Total number of car spaces in the property. */
  carspaces: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  dates?: Maybe<ListingDates>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedSalesPrice?: Maybe<PriceDetails>;
  exclusivity?: Maybe<PremarketListingExclusivity>;
  floorPlan?: Maybe<Image>;
  /** Brief one line text */
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listingId?: Maybe<Scalars['Int']['output']>;
  listingStatus: PremarketListingStatus;
  liveListing?: Maybe<ListingDetails>;
  mapCertainty?: Maybe<Scalars['Int']['output']>;
  /** The media associated with the property provided by the advertiser */
  media?: Maybe<Array<Media>>;
  metadata?: Maybe<PremarketListingMetadata>;
  property?: Maybe<Property>;
  propertyTypes?: Maybe<Array<ListingPropertyType>>;
  provider?: Maybe<ProviderDetails>;
  reservePrice?: Maybe<PriceDetails>;
  soldDetails?: Maybe<SoldDetails>;
  statementOfInformation?: Maybe<StatementOfInformation>;
  suburbProfile?: Maybe<LocationProfile>;
};

export type PremarketListingAuthority = {
  __typename?: 'PremarketListingAuthority';
  executedDate?: Maybe<DateTime>;
  type?: Maybe<AuthorityType>;
};

export enum AuthorityType {
  Auction = 'AUCTION',
  ExpressionOfInterest = 'EXPRESSION_OF_INTEREST',
  PrivateSale = 'PRIVATE_SALE'
}

export type ListingDates = {
  __typename?: 'ListingDates';
  created?: Maybe<DateTime>;
  drafted?: Maybe<DateTime>;
  listed?: Maybe<DateTime>;
  premarket?: Maybe<DateTime>;
  sold?: Maybe<DateTime>;
  updated?: Maybe<DateTime>;
  withdrawn?: Maybe<DateTime>;
};

export type PremarketListingExclusivity = {
  __typename?: 'PremarketListingExclusivity';
  extendedPeriodDays?: Maybe<Scalars['Int']['output']>;
  periodDays?: Maybe<Scalars['Int']['output']>;
  periodStartDate?: Maybe<DateTime>;
};

export enum PremarketListingStatus {
  Draft = 'DRAFT',
  Listed = 'LISTED',
  PreMarket = 'PRE_MARKET',
  Sold = 'SOLD',
  Withdrawn = 'WITHDRAWN'
}

export type PremarketListingMetadata = {
  __typename?: 'PremarketListingMetadata';
  additionalData?: Maybe<Array<AdditionalData>>;
  trackingMetadata?: Maybe<Scalars['String']['output']>;
};

export type AdditionalData = {
  __typename?: 'AdditionalData';
  propertyName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProjectV2 = ErrorWithUserMessage | Project;

export type PropertySupplyDemand = {
  __typename?: 'PropertySupplyDemand';
  daysOnMarketAverage?: Maybe<DaysOnMarketAverage>;
  keywordsInArea?: Maybe<KeywordsInArea>;
  outOfLocationEnquiries?: Maybe<OutOfLocationEnquiries>;
  productPerformance?: Maybe<ProductPerformance>;
  supplyDemand?: Maybe<SupplyDemand>;
};

export type DaysOnMarketAverage = {
  __typename?: 'DaysOnMarketAverage';
  auction?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Metadata>;
  privateTreaty?: Maybe<Scalars['Int']['output']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  aggregation?: Maybe<Aggregation>;
  dataLevelOfAggregation?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodEndTimestamp?: Maybe<Scalars['String']['output']>;
  periodStartTimestamp?: Maybe<Scalars['String']['output']>;
};

export type KeywordsInArea = {
  __typename?: 'KeywordsInArea';
  areaName?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Maybe<Keyword>>>;
  metadata?: Maybe<Metadata>;
};

export type Keyword = {
  __typename?: 'Keyword';
  keyword?: Maybe<Scalars['String']['output']>;
  searchCount?: Maybe<Scalars['Int']['output']>;
};

export type OutOfLocationEnquiries = {
  __typename?: 'OutOfLocationEnquiries';
  metadata?: Maybe<Metadata>;
  outOfPostcodePercentage?: Maybe<Scalars['Float']['output']>;
  outOfPostcodePercentagePerPostcode?: Maybe<Array<Maybe<OutOfPostcodePercentagePerPostcode>>>;
  outOfStatePercentage?: Maybe<Scalars['Float']['output']>;
  outOfStatePercentagePerState?: Maybe<Array<Maybe<OutOfStatePercentagePerState>>>;
};

export type OutOfPostcodePercentagePerPostcode = {
  __typename?: 'OutOfPostcodePercentagePerPostcode';
  percentage?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
};

export type OutOfStatePercentagePerState = {
  __typename?: 'OutOfStatePercentagePerState';
  percentage?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ProductPerformance = {
  __typename?: 'ProductPerformance';
  metadata?: Maybe<Metadata>;
  nonPlatinum?: Maybe<Metrics>;
  platinum?: Maybe<Metrics>;
};

export type Metrics = {
  __typename?: 'Metrics';
  daysInMarket?: Maybe<Scalars['Float']['output']>;
  numberOfEnquiries?: Maybe<Scalars['Float']['output']>;
  numberOfLeads?: Maybe<Scalars['Float']['output']>;
  numberOfViews?: Maybe<Scalars['Float']['output']>;
};

export type RecentlySoldListingsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RecentlySoldListingsResults = ErrorWithUserMessage | RecentlySoldListingsResultsSuccess;

export type RecentlySoldListingsResultsSuccess = {
  __typename?: 'RecentlySoldListingsResultsSuccess';
  ctaDriverCardDetails?: Maybe<Array<Maybe<CtaDriverCardDetails>>>;
  showCta: Scalars['Boolean']['output'];
  soldListingsResults?: Maybe<SearchListingsResultsSuccess>;
};

export type CtaDriverCardDetails = {
  __typename?: 'CtaDriverCardDetails';
  remainingListingsCount?: Maybe<Scalars['Int']['output']>;
  searchCriteria?: Maybe<SearchListingsParameters>;
  searchName: Scalars['String']['output'];
};

export type SavedSearchResults = {
  __typename?: 'SavedSearchResults';
  error?: Maybe<ErrorWithUserMessage>;
  recentSearches?: Maybe<Array<SearchResult>>;
  savedSearches?: Maybe<Array<SavedSearchResult>>;
};

export type SearchListingsResults = {
  __typename?: 'SearchListingsResults';
  /** Will be true if the full result set returned by the Elasticsearch backend has been limited due to it exceeding the maximum allowed results size. */
  actualTotalResultsExceedsMaximum: Scalars['Boolean']['output'];
  /**
   * Experimental feature to show the affordability of supply data
   * for a given search
   */
  affordabilityOrSupply?: Maybe<AffordabilityOrSupplyResult>;
  allowsImmediatePropertyAlert: Scalars['Boolean']['output'];
  error?: Maybe<ErrorWithUserMessage>;
  metadata: SearchListingsResultsMetadata;
  /** The returned page number */
  page: Scalars['Int']['output'];
  /** @deprecated Use searchResults instead */
  results?: Maybe<Array<SearchListingsResult>>;
  /**
   * Name of search based on search type
   * Location searches will return list of locations
   * Map searches will return nearest suburb / area / region if applicable (Default: Map Area)
   * School searches will return name of school
   * Finger searches will return Drawn area name (Apps only)
   */
  searchName?: Maybe<Scalars['String']['output']>;
  searchResults?: Maybe<Array<CombinedSearchResult>>;
  suburbDetails?: Maybe<Array<Maybe<SuburbDetails>>>;
  /** The total number of available pages for this search. */
  totalPages: Scalars['Int']['output'];
  /** The total number of available listings for this search. This only counts searchrow and newdevsearchrow */
  totalResults: Scalars['Int']['output'];
};


export type SearchListingsResultsSearchResultsArgs = {
  includeTopspot?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfListingsRequired?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListingsBySavedSearchParametersInput = {
  /**
   * Only return results that have been newly listed since this timestamp
   * Should be in this format: "2015-07-13T10:09:44"
   */
  listedSince?: InputMaybe<Scalars['String']['input']>;
  /** override saved search listings parameters */
  overrideParameters?: InputMaybe<OverrideSearchListingsParametersInput>;
  /**
   * id as number for logged in user's saved search (User API)
   * uuid for anonymous user's saved search (Mobile Saved Search API)
   * uuid for recent search (Mobile Saved Search API)
   */
  searchId: Scalars['ID']['input'];
  /** Show listedSince by lastRunDate first, then show the rest of all results */
  showNewListingsFirst?: InputMaybe<Scalars['Boolean']['input']>;
  type: SavedSearchType;
  /**
   * Only return results that have been updated since this timestamp (price or address changes only)
   * Should be in this format: "2015-07-13T10:09:44"
   */
  updatedSince?: InputMaybe<Scalars['String']['input']>;
  /** update last run date in saved search to current date time */
  updateLastRunDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use lastRunDate as a updatedSince field for search query */
  useLastRunDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OverrideSearchListingsParametersInput = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SearchListingsSortInput>;
};

export type SearchListingsResultsByMultipleSavedSearchesWithErrorV2 = ErrorWithUserMessage | SearchListingsResultsByMultipleSavedSearchesV2;

export type SearchListingsResultsByMultipleSavedSearchesV2 = {
  __typename?: 'SearchListingsResultsByMultipleSavedSearchesV2';
  searchListingsResults: Array<SearchListingsResultsSuccess>;
};

export type SearchListingsResultsV2 = ErrorWithUserMessage | SearchListingsResultsSuccess;

export type SearchListingsBySavedSearchResult = ErrorWithUserMessage | SearchListingsBySavedSearchResultSuccess;

export type SearchListingsBySavedSearchResultSuccess = {
  __typename?: 'SearchListingsBySavedSearchResultSuccess';
  savedSearch: SearchResult;
  searchResults: SearchListingsResultsSuccess;
};

export type SearchListingsByUrlInput = {
  aggregations?: InputMaybe<Array<SearchResultsAggregations>>;
  url: Scalars['String']['input'];
};

export type TopSpotSearchParametersInput = {
  /** Filter based on Ad Ids (Include in search result if AdID is in this list) */
  adIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Return listings only created by these agencies. */
  advertiserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Aggregated results
   * Could be the following values:
   * bedrooms, bathrooms, carspaces, propertytypes, features, suburb, tags, isrural
   */
  aggregations?: InputMaybe<Array<SearchResultsAggregations>>;
  /**
   * Filter listings with auction time on or from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  auctionFrom?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter listings with auction time date range.
   * GQL converts this into inspectionFrom and inspectionTo for Search API
   */
  auctionSchedule?: InputMaybe<SearchListingsScheduleDateRange>;
  /**
   * Filter listings with auction on or before from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  auctionTo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines a sort order comprised of 0 or more elements specifying sort field and direction.
   * Cannot be specified simultaneously with {Sort}.
   */
  customSort?: InputMaybe<SearchListingsCustomSortInput>;
  /**
   * Return only those listings whose DateAvailable is null, or is at or after the specified time.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  dateAvailableFrom?: InputMaybe<Scalars['String']['input']>;
  /**
   * Return only those listings whose DateAvailable is null, or is at or before the specified time.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  dateAvailableTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter out listings with Ad Ids (Exclude listings from search result if AdID is in this list) */
  excludeAdIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, exclude listings (rental) has deposit taken */
  excludeDepositTaken?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, exclude listings whose price has been withheld. */
  excludePriceWithheld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by geo shapes. Shapes are mutually exclusive. */
  geoWindow?: InputMaybe<SearchListingsGeoWindowInput>;
  /** Filter by one or more high level types of properties */
  highLevelPropertyTypes?: InputMaybe<Array<SearchListingsHighLevelPropertyTypes>>;
  /**
   * Filter listings with inspection time on or from the date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  inspectionFrom?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter listings with inspection time date range.
   * GQL converts this into inspectionFrom and inspectionTo for Search API
   */
  inspectionSchedule?: InputMaybe<SearchListingsScheduleDateRange>;
  /**
   * Filter listings with inspection time on or before date specified.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  inspectionTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by one or more keywords that a listing should contain */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Unit of measurement for the Land area.
   * If landAreaUnit isn't specified, land area would be treated as SQUARE_METERS.
   * Since search listings api accepts the value only in SQUARE_METERS, based on the value of landAreaUnit the maxLandArea and minLandArea would be converted to SQUARE_METERS.
   */
  landAreaUnit?: InputMaybe<AreaUnits>;
  /**
   * Only return listings that have been listed since the specified date inclusively. Local timezone.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  listedSince?: InputMaybe<Scalars['String']['input']>;
  /** Limit the results to listing with specific attributes */
  listingAttributes?: InputMaybe<Array<SearchListingsAttribute>>;
  /** The listing type to search for */
  listingType?: InputMaybe<SearchListingsType>;
  /**
   * Filter by the locations either suburb, area, region or state
   * Can also be used to search suburb and some area around it if radius is provided.
   * Invalid locations will return no results.
   * If {Domain.Search.Web.Api.v2.Models.SearchLocation.IncludeSurroundingSuburbs} is set to true, surrounding suburbs will also be searched for.
   */
  locations?: InputMaybe<Array<SearchListingsLocationInput>>;
  /** Filter by location terms. This can be used in conjunction with Locations */
  locationTerms?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter listing by maximum number of bathrooms
   * 0.5 means no shower
   */
  maxBathrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by maximum number of bedrooms */
  maxBedrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by maximum number of car spaces */
  maxCarspaces?: InputMaybe<Scalars['Int']['input']>;
  /** Max Land Area in square meters */
  maxLandArea?: InputMaybe<Scalars['Int']['input']>;
  /** Filter listing at or below a maximum price */
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  /** Filter listing by minimum number of bathrooms */
  minBathrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by minimum number of bedrooms */
  minBedrooms?: InputMaybe<Scalars['Float']['input']>;
  /** Filter listing by minimum number of car spaces */
  minCarspaces?: InputMaybe<Scalars['Int']['input']>;
  /** Min Land Area in square meters */
  minLandArea?: InputMaybe<Scalars['Int']['input']>;
  /** Filter listing at or above a minimum price */
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  /** If true, return only listings for new properties (i.e. ones that are on the market for the first time). */
  newDevOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The number of listings matching the top spot criteria per agency.
   * The total result page size will vary based on the number of agencies in the search result.
   * Defaults to 3.
   */
  numberOfListingsPerAgency?: InputMaybe<Scalars['Int']['input']>;
  /** The specific result page to return */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Specify the number of result items in a page */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter listings based on their whether or not they are classified as a new development
   * Any returns all properties
   * New returns only listings classified as new developments
   * Existing returns only listings that aren't classified as new developments
   */
  propertyEstablishedType?: InputMaybe<SearchListingsPropertyEstablishedType>;
  /** Filter by one or more property features such as Gas or AC */
  propertyFeatures?: InputMaybe<Array<SearchListingsPropertyFeature>>;
  /** Filter by one or more types of properties */
  propertyTypes?: InputMaybe<Array<SearchListingsPropertyType>>;
  /** if true, the response will include only listings flagged with IsRural */
  ruralOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** one or more school identifiers to find the listings in their catchment area */
  schoolCatchments?: InputMaybe<Array<SearchListingsSchoolCatchmentInput>>;
  /** Filter by date range. Only used by search sold listings */
  soldDateRange?: InputMaybe<SearchListingsSoldDateRange>;
  sort?: InputMaybe<SearchListingsSortInput>;
  /**
   * Filter listing by tags (Include/Exclude)
   * ref: swagger for search api: https://search-api.domain.com.au/swagger/ui/index#/
   */
  tags?: InputMaybe<Array<SearchListingsTagInput>>;
  /** Search by topspot keywords */
  topspotKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Only return listings that have been updated since the specified date inclusively. Local timezone.
   * Strings of the format: yyyy-MM-dd are acceptable.
   */
  updatedSince?: InputMaybe<Scalars['String']['input']>;
};

export type UserShortlistsResult = ErrorWithUserMessage | UserShortlists;

export type UserShortlists = {
  __typename?: 'UserShortlists';
  listingIds?: Maybe<Array<Scalars['Int']['output']>>;
  listings?: Maybe<Array<ShortListedListingDetails>>;
  sharedShortlistId?: Maybe<Scalars['String']['output']>;
  sharedUser?: Maybe<ShortListUser>;
  user?: Maybe<ShortListUser>;
};


export type UserShortlistsListingsArgs = {
  limitNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type ShortListedListingDetails = {
  __typename?: 'ShortListedListingDetails';
  listing: ListingDetails;
  listingType: ListingMode;
  shortlistedBy: ShortListUser;
};

export type ShortListUser = {
  __typename?: 'ShortListUser';
  emailId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Image>;
  userId: Scalars['Int']['output'];
};

export type SuburbInsightsResult = ErrorWithUserMessage | SuburbInsightsInfo;

/** The period size for the suburb performance query. Default to QUARTERS. */
export enum SuburbPerformancePeriodSizeInput {
  HalfYears = 'HALF_YEARS',
  Quarters = 'QUARTERS',
  Years = 'YEARS'
}

/** The type of property for the suburb performance query. Default to HOUSE. */
export enum SuburbPerformancePropertyCategoryInput {
  House = 'HOUSE',
  Unit = 'UNIT'
}

export type SuggestedAgency = {
  __typename?: 'SuggestedAgency';
  agencyName?: Maybe<Scalars['String']['output']>;
  backgroundColour?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Image>;
  postcode?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type SuggestedBuilding = {
  __typename?: 'SuggestedBuilding';
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export type SuggestedContact = {
  __typename?: 'SuggestedContact';
  agencyId?: Maybe<Scalars['Int']['output']>;
  agencyName?: Maybe<Scalars['String']['output']>;
  agentIdV2?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mugShot?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export enum LocationTypeaheadChannel {
  All = 'ALL',
  Commercial = 'COMMERCIAL',
  Residential = 'RESIDENTIAL'
}

export type SuggestedProperty = {
  __typename?: 'SuggestedProperty';
  address?: Maybe<Scalars['String']['output']>;
  aliasId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legacyPropertyId?: Maybe<Scalars['Int']['output']>;
  pdsId?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['String']['output']>;
  relativeScore?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  streetType?: Maybe<Scalars['String']['output']>;
  streetTypeLong?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export type SuggestedStreet = {
  __typename?: 'SuggestedStreet';
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export enum SuggestedSuburbMode {
  Rent = 'RENT',
  Sale = 'SALE'
}

export type Suggestions = {
  __typename?: 'Suggestions';
  /** A list of suggested suburbs. */
  suggestions: Array<SuggestedSuburb>;
};

export type SuggestedSuburb = {
  __typename?: 'SuggestedSuburb';
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum LocationSuggestionType {
  Area = 'AREA',
  Postcode = 'POSTCODE',
  Project = 'PROJECT',
  Region = 'REGION',
  School = 'SCHOOL',
  Suburb = 'SUBURB'
}

export type LocationSuggestion = AreaSuggestion | PostcodeSuggestion | ProjectSuggestion | RegionSuggestion | SchoolSuggestion | SuburbSuggestion;

export type AreaSuggestion = LocationSuggestionInterface & {
  __typename?: 'AreaSuggestion';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameSlug: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type LocationSuggestionInterface = {
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameSlug: Scalars['String']['output'];
};

export type PostcodeSuggestion = LocationSuggestionInterface & {
  __typename?: 'PostcodeSuggestion';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameSlug: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
};

export type ProjectSuggestion = LocationSuggestionInterface & {
  __typename?: 'ProjectSuggestion';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameSlug: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type RegionSuggestion = LocationSuggestionInterface & {
  __typename?: 'RegionSuggestion';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameSlug: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type SchoolSuggestion = LocationSuggestionInterface & {
  __typename?: 'SchoolSuggestion';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameSlug: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type SuburbSuggestion = LocationSuggestionInterface & {
  __typename?: 'SuburbSuggestion';
  area?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameSlug: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

export type UserRecommendations = ErrorWithUserMessage | UserRecommendationsSuccess;

export type UserRecommendationsSuccess = {
  __typename?: 'UserRecommendationsSuccess';
  recommendedListings: Array<ListingDetails>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addUserToSharedShortlist?: Maybe<AddUserToSharedShortlistResult>;
  alertDelivered: Scalars['String']['output'];
  createEnquiry?: Maybe<Enquiry>;
  createOrUpdateVendorEnquiryEstimate?: Maybe<VendorEnquiryEstimate>;
  createPropertyEnquiry?: Maybe<EnquiryResponse>;
  createRecentSearch?: Maybe<CreateRecentSearchResult>;
  /** @deprecated use createSavedSearchV2 */
  createSavedSearch?: Maybe<CreateSavedSearchResult>;
  createSavedSearchV2?: Maybe<CreateSavedSearchResultV2>;
  createSharedShortlist?: Maybe<CreateSharedShortlistResult>;
  /** Send user feedback for reporting a listing */
  createUserFeedback: Scalars['ID']['output'];
  createVendorEnquiry?: Maybe<VendorEnquiry>;
  /** @deprecated use deleteAllSavedSearchesV2 */
  deleteAllSavedSearches?: Maybe<DeleteSavedSearchResult>;
  deleteAllSavedSearchesV2?: Maybe<DeleteSavedSearchResultV2>;
  /** Delete user notes for a listing. Requires authentication. */
  deleteListingNote?: Maybe<ListingNotesMutationResultV2>;
  deletePropertyClaim: Scalars['Boolean']['output'];
  /** @deprecated use deleteSavedSearchV2 */
  deleteSavedSearch?: Maybe<DeleteSavedSearchResult>;
  deleteSavedSearchV2?: Maybe<DeleteSavedSearchResultV2>;
  deleteSharedShortlist?: Maybe<DeleteSharedShortlistResult>;
  deleteUser: Scalars['Boolean']['output'];
  modifyConnections: ModifyConnectionsPayload;
  postStat: Scalars['String']['output'];
  /** DELETE user-api/v1/shortlists/listings */
  removeShortlistListing?: Maybe<Scalars['Boolean']['output']>;
  /** DELETE user-api/v1/shortlists/listings */
  removeShortlistListingV2?: Maybe<RemoveShortlistListingResult>;
  /** POST user-api/v1/shortlists/listings */
  saveShortlistListing?: Maybe<Scalars['Boolean']['output']>;
  /** POST user-api/v1/shortlists/listings */
  saveShortlistListingV2?: Maybe<SaveShortlistListingResult>;
  saveUserOnboardingData?: Maybe<OnboardingDataUpdateSuccessResponse>;
  /** Send app feedback via email */
  sendUserFeedback: UserFeedbackEmailResponse;
  /**
   * PUT /transactions-users-ingress-api/v1/dlf
   * Persist Domain homeloan calculator data through transaction ingress Api
   * @deprecated Domain Home Loans joint venture exited
   */
  updateDhlCalculatorData?: Maybe<Scalars['String']['output']>;
  updateEmailSubscriptions: UpdateEmailSubscriptionResponse;
  updateRecentSearch?: Maybe<UpdateRecentSearchResult>;
  updateSavedSearch: UpdateSavedSearchResult;
  /** @deprecated use updateSavedSearch */
  updateSavedSearchV2: UpdateSavedSearchResultV2;
  updateSubscriptions: UpdateUserResponse;
  updateUser: UpdateUserResponse;
  updateUserFeedback: Scalars['ID']['output'];
  /** Create or update user notes for a listing. Requires authentication. */
  upsertListingNote?: Maybe<ListingNotesMutationResultV2>;
  upsertPropertyClaim?: Maybe<Claim>;
  verifyChangeUserMobile: UpdateUserResponse;
  verifyDeleteUserMobile: UpdateUserResponse;
};


export type MutationAddUserToSharedShortlistArgs = {
  sharedShortlistId: Scalars['String']['input'];
};


export type MutationAlertDeliveredArgs = {
  subjectId: Scalars['String']['input'];
  typeKey: Scalars['String']['input'];
};


export type MutationCreateEnquiryArgs = {
  input: EnquiryInput;
};


export type MutationCreateOrUpdateVendorEnquiryEstimateArgs = {
  input?: InputMaybe<VendorEnquiryEstimateInput>;
};


export type MutationCreatePropertyEnquiryArgs = {
  input: PropertyEnquiryInput;
};


export type MutationCreateRecentSearchArgs = {
  input: CreateRecentSearchParams;
};


export type MutationCreateSavedSearchArgs = {
  searchParams: CreateSavedSearchParams;
};


export type MutationCreateSavedSearchV2Args = {
  searchParams: CreateSavedSearchParams;
};


export type MutationCreateUserFeedbackArgs = {
  input: UserFeedbackInput;
};


export type MutationCreateVendorEnquiryArgs = {
  input?: InputMaybe<VendorEnquiryInput>;
};


export type MutationDeleteAllSavedSearchesArgs = {
  input: DeleteAllSavedSearchesParams;
};


export type MutationDeleteAllSavedSearchesV2Args = {
  input: DeleteAllSavedSearchesParams;
};


export type MutationDeleteListingNoteArgs = {
  listingId: Scalars['ID']['input'];
};


export type MutationDeletePropertyClaimArgs = {
  input: UnclaimPropertyInput;
};


export type MutationDeleteSavedSearchArgs = {
  input: DeleteSavedSearchParams;
};


export type MutationDeleteSavedSearchV2Args = {
  input: DeleteSavedSearchParams;
};


export type MutationDeleteSharedShortlistArgs = {
  sharedShortlistId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationModifyConnectionsArgs = {
  input?: InputMaybe<ModifyConnectionsInput>;
};


export type MutationPostStatArgs = {
  groupStats: GroupStatsStat;
};


export type MutationRemoveShortlistListingArgs = {
  adIds: Array<Scalars['Int']['input']>;
};


export type MutationRemoveShortlistListingV2Args = {
  adIds: Array<Scalars['Int']['input']>;
};


export type MutationSaveShortlistListingArgs = {
  adIds: Array<Scalars['Int']['input']>;
};


export type MutationSaveShortlistListingV2Args = {
  adIds: Array<Scalars['Int']['input']>;
};


export type MutationSaveUserOnboardingDataArgs = {
  input: OnboardingDataInput;
};


export type MutationSendUserFeedbackArgs = {
  input: UserFeedbackEmailInput;
};


export type MutationUpdateDhlCalculatorDataArgs = {
  affordabilityCalculatorMessage?: InputMaybe<DhlAffordabilityCalculatorMessageInput>;
  disableGroupStatsTracking?: InputMaybe<Scalars['Boolean']['input']>;
  equityCalculatorMessage?: InputMaybe<DhlEquityCalculatorMessageInput>;
  refinanceCalculatorMessage?: InputMaybe<DhlRefinanceCalculatorMessageInput>;
  repaymentsCalculatorMessage?: InputMaybe<DhlRepaymentsCalculatorMessageInput>;
  stampDutyCalculatorMessage?: InputMaybe<DhlStampDutyCalculatorMessageInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEmailSubscriptionsArgs = {
  input: UpdateEmailSubscriptionInput;
};


export type MutationUpdateRecentSearchArgs = {
  input: UpdateRecentSearchParams;
};


export type MutationUpdateSavedSearchArgs = {
  input: UpdateSavedSearchParams;
};


export type MutationUpdateSavedSearchV2Args = {
  input: UpdateSavedSearchParams;
};


export type MutationUpdateSubscriptionsArgs = {
  input: UpdateSubscriptionsInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserFeedbackArgs = {
  id: Scalars['ID']['input'];
  input: UserFeedbackInput;
};


export type MutationUpsertListingNoteArgs = {
  listingId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationUpsertPropertyClaimArgs = {
  input: ClaimPropertyInput;
};


export type MutationVerifyChangeUserMobileArgs = {
  input: VerifyChangeUserMobileInput;
};


export type MutationVerifyDeleteUserMobileArgs = {
  code: Scalars['String']['input'];
};

export type AddUserToSharedShortlistResult = AddUserToSharedShortlistResponse | ErrorWithUserMessage;

export type AddUserToSharedShortlistResponse = {
  __typename?: 'AddUserToSharedShortlistResponse';
  sharedShortlistId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Enquiry service input */
export type EnquiryInput = {
  deliveryMethod?: InputMaybe<DeliveryMethodEnum>;
  email: Scalars['String']['input'];
  enquiryType?: InputMaybe<EnquiryTypeEnum>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Array<InputMaybe<MetaDataType>>>;
  notificationMobileNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['Int']['input'];
  /** The reference ID of the listing or agent */
  referenceId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<SourceEnum>;
  subject: Scalars['String']['input'];
};

export enum DeliveryMethodEnum {
  Email = 'email',
  SMs = 'sMS'
}

export enum EnquiryTypeEnum {
  AgencyProfile = 'agencyProfile',
  AgentProfile = 'agentProfile',
  ContractRequest = 'contractRequest',
  DevProject = 'devProject',
  Listing = 'listing',
  NewDevLanding = 'newDevLanding',
  VendorEnquiry = 'vendorEnquiry'
}

export type MetaDataType = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum SourceEnum {
  Android = 'android',
  Default = 'default',
  IPhone = 'iPhone',
  NotDefined = 'notDefined',
  Website = 'website'
}

export type Enquiry = {
  __typename?: 'Enquiry';
  enquiryReceiptTimestamp?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VendorEnquiryEstimateInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  enquiryId: Scalars['String']['input'];
  estimatePrice?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  opinionOnEstimate?: InputMaybe<VendorEnquiryOpinionOnEstimate>;
  response?: InputMaybe<VendorEnquiryResponseToEstimate>;
};

/** Property enquiry input */
export type PropertyEnquiryInput = {
  checkedEnquiries?: InputMaybe<Array<CustomerEnquiries>>;
  deliveryMethod?: InputMaybe<EnquiryV2DeliveryMethodEnum>;
  email: Scalars['String']['input'];
  /** Sender first name */
  firstName: Scalars['String']['input'];
  /** Sender lastname/surname */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The listing ID of the property */
  listingId: Scalars['ID']['input'];
  listingMode?: InputMaybe<ListingMode>;
  listingType: ListingType;
  /** Detail enquiry message */
  message?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Array<MetaDataType>>;
  /** Sender phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<SourceEnum>;
  /**
   * Enquiry subject
   * Normally the property address, GraphQL will add the prefix 'Enquiry for' to it.
   */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerEnquiries {
  /** For Project */
  CompletionDate = 'COMPLETION_DATE',
  /** For Project */
  DevelopmentSize = 'DEVELOPMENT_SIZE',
  /** For Buy / Project */
  FloorPlan = 'FLOOR_PLAN',
  /** For Sold */
  FurtherInformation = 'FURTHER_INFORMATION',
  /** For Buy / Rent / Project */
  InspectionTimes = 'INSPECTION_TIMES',
  /** For Rent */
  LeasePeriod = 'LEASE_PERIOD',
  /** For Project */
  MasterPlan = 'MASTER_PLAN',
  /** For Rent */
  Parking = 'PARKING',
  /** For Rent */
  PetsAllowed = 'PETS_ALLOWED',
  /** For Buy / Project */
  PriceGuide = 'PRICE_GUIDE',
  /** For Buy */
  PropertySize = 'PROPERTY_SIZE',
  /** For Project */
  RemainingUnits = 'REMAINING_UNITS',
  /** For Sold */
  RequestAppraisal = 'REQUEST_APPRAISAL',
  /** For Sold */
  SimilarProperties = 'SIMILAR_PROPERTIES',
  /** For Sold */
  SoldPrice = 'SOLD_PRICE',
  /** For Buy */
  StrataFeesLeviesRates = 'STRATA_FEES_LEVIES_RATES'
}

export enum EnquiryV2DeliveryMethodEnum {
  Email = 'email',
  Sms = 'sms'
}

export type EnquiryResponse = Enquiry | ErrorWithUserMessage;

export type CreateRecentSearchParams = {
  /**
   * Recent search name. If provided, this name will be used for the recent search.
   * Otherwise, a generated name based on the location of the search is used.
   */
  recentSearchName?: InputMaybe<Scalars['String']['input']>;
  /** Common saved search parameter */
  searchListingsParametersInput: SearchListingsParametersInput;
};

export type CreateRecentSearchResult = CreateRecentSearchResultSuccess | ErrorWithUserMessage;

export type CreateRecentSearchResultSuccess = {
  __typename?: 'CreateRecentSearchResultSuccess';
  recentSearchId: Scalars['ID']['output'];
  recentSearchName?: Maybe<Scalars['String']['output']>;
};

export type CreateSavedSearchParams = {
  /** Web saved search parameter */
  noEBrochures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Common saved search parameter */
  platform: Platform;
  /** Common saved search parameter */
  preferences?: InputMaybe<Array<SavedSearchPreferenceInput>>;
  /** Common saved search parameter */
  searchListingsParametersInput: SearchListingsParametersInput;
  /** Mobile saved search parameter - If not provided default search name will be generated */
  searchName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile saved search parameter */
  type?: InputMaybe<SavedSearchType>;
};

export enum Platform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type SavedSearchPreferenceInput = {
  deliveryType: SavedSearchDeliveryType;
  frequency: SavedSearchDeliveryFrequency;
  isActive: Scalars['Boolean']['input'];
  preferenceType: SavedSearchPreferenceType;
};

export type CreateSavedSearchResult = {
  __typename?: 'CreateSavedSearchResult';
  error?: Maybe<ErrorWithUserMessage>;
  /** @deprecated use error */
  errorMessage?: Maybe<Scalars['String']['output']>;
  searchId?: Maybe<Scalars['ID']['output']>;
};

export type CreateSavedSearchResultV2 = CreateSavedSearchResultSuccess | ErrorWithUserMessage;

export type CreateSavedSearchResultSuccess = {
  __typename?: 'CreateSavedSearchResultSuccess';
  savedSearchName?: Maybe<Scalars['String']['output']>;
  searchId: Scalars['ID']['output'];
};

export type CreateSharedShortlistResult = CreateSharedShortlistResponse | ErrorWithUserMessage;

export type CreateSharedShortlistResponse = {
  __typename?: 'CreateSharedShortlistResponse';
  sharedShortlistBranchUrl?: Maybe<Scalars['String']['output']>;
  sharedShortlistId: Scalars['String']['output'];
  sharedShortlistUrl: Scalars['String']['output'];
};

export type UserFeedbackInput = {
  /**
   * For non-web devices such as iOS and Android to provide details about
   * the screen location and the device.
   */
  deviceDetails?: InputMaybe<UserFeedbackDeviceDetailsInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  topic: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
  webDetails?: InputMaybe<UserFeedbackWebDetailsInput>;
};

export type UserFeedbackDeviceDetailsInput = {
  appBuildVersion?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserFeedbackWebDetailsInput = {
  url: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type VendorEnquiryInput = {
  /** Max length 2000 characters. */
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  /** AgentIds V1, aka ContactIds */
  agentIds: Array<InputMaybe<Scalars['String']['input']>>;
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  contactPreference?: InputMaybe<VendorEnquiryContactPreference>;
  contactTimeframe?: InputMaybe<VendorEnquiryContactTimeframe>;
  features?: InputMaybe<Scalars['String']['input']>;
  parking?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  /** Property ID in the format "TT-3678-KW" */
  propertyId: Scalars['String']['input'];
  propertyType?: InputMaybe<VendorEnquiryPropertyType>;
  renovationTimeframe?: InputMaybe<VendorEnquiryRenovationTimeframe>;
  requestedInformation: Array<InputMaybe<VendorEnquiryRequestedInformation>>;
  sendEnquiryEmails?: InputMaybe<Scalars['Boolean']['input']>;
  timeframe: VendorEnquiryTimeframe;
  type: VendorEnquiryType;
  usage?: InputMaybe<VendorEnquiryUsage>;
  userInfo: VendorEnquiryUserInfoInput;
};

export type VendorEnquiryUserInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type DeleteAllSavedSearchesParams = {
  platform?: InputMaybe<Platform>;
};

export type DeleteSavedSearchResult = {
  __typename?: 'DeleteSavedSearchResult';
  error?: Maybe<ErrorWithUserMessage>;
  /** @deprecated use error */
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteSavedSearchResultV2 = DeleteSavedSearchResultSuccess | ErrorWithUserMessage;

export type DeleteSavedSearchResultSuccess = {
  __typename?: 'DeleteSavedSearchResultSuccess';
  associatedRecentSearchUUID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ListingNotesMutationResultV2 = ErrorWithUserMessage | ListingNotesMutationResult;

/** Result of a listing notes mutation */
export type ListingNotesMutationResult = {
  __typename?: 'ListingNotesMutationResult';
  /** Indicates whether the mutation was successful */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnclaimPropertyInput = {
  propertyId: Scalars['String']['input'];
};

export type DeleteSavedSearchParams = {
  platform?: InputMaybe<Platform>;
  searchId: Scalars['ID']['input'];
};

export type DeleteSharedShortlistResult = DeleteSharedShortlistResponse | ErrorWithUserMessage;

export type DeleteSharedShortlistResponse = {
  __typename?: 'DeleteSharedShortlistResponse';
  sharedShortlistId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteUserInput = {
  reason: AccountDeletionReason;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export enum AccountDeletionReason {
  AnotherAccount = 'AnotherAccount',
  GoalAchieved = 'GoalAchieved',
  Other = 'Other',
  PrivacyConcern = 'PrivacyConcern',
  TooManyEmails = 'TooManyEmails'
}

/** ModifyConnections Input */
export type ModifyConnectionsInput = {
  add: Scalars['Boolean']['input'];
  clientMutationId: Scalars['String']['input'];
};

export type ModifyConnectionsPayload = {
  __typename?: 'ModifyConnectionsPayload';
  clientMutationId: Scalars['String']['output'];
  user: User;
};

/**
 * Posts a stat to group stats (not legacy group stats). You can send IDs as relay IDs
 * or as logical database IDs, we'll handle the conversion to logical IDs if required. https://bit.ly/2HgkAtC
 */
export type GroupStatsStat = {
  /** This is an optional stringified javascript object that allows you to add additional metadata. */
  additionalMetadata?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<GroupStatsClient>;
  eventBrand?: InputMaybe<Scalars['String']['input']>;
  eventCategory: Scalars['String']['input'];
  /** Domain auth client-id of the system that is the earliest origin of the events. (Defaults to emerging-tech-graphql) */
  eventProvider?: InputMaybe<Scalars['String']['input']>;
  eventSource?: InputMaybe<Scalars['String']['input']>;
  eventSourceDetails?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  eventVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * GA cookie value See MetaData.GAClientId on
   * https://domain.atlassian.net/wiki/spaces/DOM/pages/103579681/Group+Stats+Event+Schema
   */
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  nuid?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<GroupStatsPlatform>;
  /** Place any count values here so they can easily be extracted and aggregated. */
  reportingValue?: InputMaybe<Scalars['Int']['input']>;
  sourceEntityId?: InputMaybe<Scalars['StringOrInt']['input']>;
  sourceEntityType?: InputMaybe<Scalars['String']['input']>;
  targetEntityId?: InputMaybe<Scalars['StringOrInt']['input']>;
  targetEntityType?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['StringOrInt']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export enum GroupStatsClient {
  AgentAdmin = 'AGENT_ADMIN',
  Android = 'ANDROID',
  Ipad = 'IPAD',
  Iphone = 'IPHONE',
  Unknown = 'UNKNOWN',
  Website = 'WEBSITE',
  WebsiteDesktop = 'WEBSITE_DESKTOP',
  WebsiteMobile = 'WEBSITE_MOBILE',
  WebsiteTablet = 'WEBSITE_TABLET'
}

export enum GroupStatsPlatform {
  Admin = 'Admin',
  Agent = 'Agent',
  Android = 'Android',
  IPad = 'iPad',
  IPhone = 'iPhone',
  Website = 'Website'
}

export type RemoveShortlistListingResult = ErrorWithUserMessage | RemoveShortlistListingResultSuccess;

export type RemoveShortlistListingResultSuccess = {
  __typename?: 'RemoveShortlistListingResultSuccess';
  success: Scalars['Boolean']['output'];
};

export type SaveShortlistListingResult = ErrorWithUserMessage | SaveShortlistListingResultSuccess;

export type SaveShortlistListingResultSuccess = {
  __typename?: 'SaveShortlistListingResultSuccess';
  success: Scalars['Boolean']['output'];
};

export type OnboardingDataInput = {
  domainUserId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  process: Scalars['String']['input'];
  value: Array<OnboardingValue>;
};

export type OnboardingDataUpdateSuccessResponse = {
  __typename?: 'OnboardingDataUpdateSuccessResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input type for user feedback via email */
export type UserFeedbackEmailInput = {
  /** The mobile app version (e.g., "4.7.8") */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Name of the person sending feedback */
  author: Scalars['String']['input'];
  /** Reply-to email address from the user */
  email: Scalars['String']['input'];
  /** The feedback message text */
  message: Scalars['String']['input'];
  /** Category/tag for the feedback (e.g., "Account") */
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type UserFeedbackEmailResponse = {
  __typename?: 'UserFeedbackEmailResponse';
  emailId?: Maybe<Scalars['String']['output']>;
};

export type DhlAffordabilityCalculatorMessageInput = {
  /** Calculation result */
  aditionalSavingsRequired: Scalars['String']['input'];
  /** Calculation fields */
  affordableRepayment: Scalars['String']['input'];
  borrowingPower: Scalars['String']['input'];
  depositRate: Scalars['String']['input'];
  /** Tracking ONLY */
  deviceType: Scalars['String']['input'];
  firstHomeBuyer: Scalars['Boolean']['input'];
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  grantAmount: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  myDeposit: Scalars['String']['input'];
  nuid?: InputMaybe<Scalars['String']['input']>;
  pageCategory: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  paymentFrequency: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
  propertyCategory: Scalars['String']['input'];
  propertyUse: Scalars['String']['input'];
  propertyValue: Scalars['String']['input'];
  registrationFee: Scalars['String']['input'];
  stampDuty: Scalars['String']['input'];
  state: Scalars['String']['input'];
  subpageCategory: Scalars['String']['input'];
  /** Base fields */
  tool: Scalars['String']['input'];
  transferFee: Scalars['String']['input'];
};

export type DhlEquityCalculatorMessageInput = {
  currentEstimate: Scalars['String']['input'];
  /** Tracking ONLY */
  deviceType: Scalars['String']['input'];
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  lastSoldDate: Scalars['String']['input'];
  lastSoldPrice: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  loanTerm: Scalars['String']['input'];
  nuid?: InputMaybe<Scalars['String']['input']>;
  outstandingLoanAmount: Scalars['String']['input'];
  pageCategory: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
  subpageCategory: Scalars['String']['input'];
  /** Base fields */
  tool: Scalars['String']['input'];
};

export type DhlRefinanceCalculatorMessageInput = {
  /** Calculation fields */
  currentInterestRate: Scalars['String']['input'];
  currentLender: Scalars['String']['input'];
  /** Tracking ONLY */
  deviceType: Scalars['String']['input'];
  /** Calculation result */
  estimatedMonthlySavings: Scalars['String']['input'];
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['String']['input'];
  loanTerm: Scalars['String']['input'];
  nuid?: InputMaybe<Scalars['String']['input']>;
  outstandingLoanAmount: Scalars['String']['input'];
  pageCategory: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
  propertyUse: Scalars['String']['input'];
  propertyValue: Scalars['String']['input'];
  repaymentType: Scalars['String']['input'];
  subpageCategory: Scalars['String']['input'];
  /** Base fields */
  tool: Scalars['String']['input'];
};

export type DhlRepaymentsCalculatorMessageInput = {
  /** Tracking ONLY */
  deviceType: Scalars['String']['input'];
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  interestRate: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  loanTerm: Scalars['String']['input'];
  myDeposit: Scalars['String']['input'];
  nuid?: InputMaybe<Scalars['String']['input']>;
  pageCategory: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** Calculation fields */
  propertyValue: Scalars['String']['input'];
  /** Calculation result */
  repayment: Scalars['String']['input'];
  repaymentType: Scalars['String']['input'];
  subpageCategory: Scalars['String']['input'];
  /** Base fields */
  tool: Scalars['String']['input'];
};

/**
 * GET/POST user transactions/ingress api
 * Read/save DHL(Domain Home Loans) calculators' options and results of logged-in/anonymous users
 */
export type DhlStampDutyCalculatorMessageInput = {
  /** Tracking ONLY */
  deviceType: Scalars['String']['input'];
  firstHomeBuyer: Scalars['Boolean']['input'];
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  grantAmount: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  myDeposit: Scalars['String']['input'];
  nuid?: InputMaybe<Scalars['String']['input']>;
  pageCategory: Scalars['String']['input'];
  pageName: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
  propertyCategory: Scalars['String']['input'];
  propertyUse: Scalars['String']['input'];
  propertyValue: Scalars['String']['input'];
  registrationFee: Scalars['String']['input'];
  /** Calculation result */
  stampDuty: Scalars['String']['input'];
  /** Calculation options */
  state: Scalars['String']['input'];
  subpageCategory: Scalars['String']['input'];
  /** Base fields */
  tool: Scalars['String']['input'];
  transferFee: Scalars['String']['input'];
};

export type UpdateEmailSubscriptionInput = {
  channelId: EmailChannelIds;
  emailSubscriptions: Array<UserEmailSubscriptionInput>;
};

export enum EmailChannelIds {
  Residential = 'RESIDENTIAL'
}

export type UserEmailSubscriptionInput = {
  isActive: Scalars['Boolean']['input'];
  type: EmailSubscriptionType;
};

export enum EmailSubscriptionType {
  AdditionalServices = 'AdditionalServices',
  AuctionAlertAdelaide = 'AuctionAlertAdelaide',
  AuctionAlertBrisbane = 'AuctionAlertBrisbane',
  AuctionAlertCanberra = 'AuctionAlertCanberra',
  AuctionAlertMelbourne = 'AuctionAlertMelbourne',
  AuctionAlertSydney = 'AuctionAlertSydney',
  DomainAnnouncements = 'DomainAnnouncements',
  EBrochures = 'EBrochures',
  HomeAlerts = 'HomeAlerts',
  Newsletter = 'Newsletter',
  PartnerAnnouncements = 'PartnerAnnouncements',
  Predictive = 'Predictive',
  PremarketListings = 'PremarketListings',
  Shortlist = 'Shortlist',
  TrackMyHome = 'TrackMyHome',
  UserResearch = 'UserResearch'
}

/** Email subscription update response */
export type UpdateEmailSubscriptionResponse = {
  __typename?: 'UpdateEmailSubscriptionResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRecentSearchParams = {
  /** Recent search id to update */
  recentSearchId: Scalars['ID']['input'];
  /**
   * Recent search name. If provided, this name will be used for the recent search.
   * Otherwise, a generated name based on the location of the search is used.
   */
  recentSearchName?: InputMaybe<Scalars['String']['input']>;
  /** Common saved search parameter */
  searchListingsParametersInput: SearchListingsParametersInput;
};

export type UpdateRecentSearchResult = ErrorWithUserMessage | RecentSearchResult;

export type UpdateSavedSearchParams = {
  /** Used for web saved search preference only */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Platform from which the request is generated */
  platform: Platform;
  /** Common saved search preferences - If provided searchListingsParametersInput will be ignored */
  savedSearchPreferences?: InputMaybe<Array<SavedSearchPreferenceInput>>;
  /** Search id to update */
  searchId: Scalars['String']['input'];
  /** Common saved search parameters */
  searchListingsParametersInput?: InputMaybe<SearchListingsParametersInput>;
  /** Mobile saved search parameter - If not provided default search name will be generated */
  searchName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavedSearchResult = ErrorWithUserMessage | UpdateSavedSearchResultSuccess;

export type UpdateSavedSearchResultSuccess = {
  __typename?: 'UpdateSavedSearchResultSuccess';
  savedSearchName?: Maybe<Scalars['String']['output']>;
  searchId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateSavedSearchResultV2 = ErrorWithUserMessage | UpdateSavedSearchResultSuccess;

export type UpdateSubscriptionsInput = {
  channelId?: InputMaybe<EmailChannelIds>;
  subscriptions: Array<SubscriptionInput>;
};

export type SubscriptionInput = {
  deliveryType?: InputMaybe<SubscriptionDeliveryType>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  type: SubscriptionType;
};

export enum SubscriptionDeliveryType {
  Email = 'EMAIL',
  Push = 'PUSH'
}

export enum SubscriptionType {
  AdditionalServices = 'AdditionalServices',
  AuctionAlertAdelaide = 'AuctionAlertAdelaide',
  AuctionAlertBrisbane = 'AuctionAlertBrisbane',
  AuctionAlertCanberra = 'AuctionAlertCanberra',
  AuctionAlertMelbourne = 'AuctionAlertMelbourne',
  AuctionAlertSydney = 'AuctionAlertSydney',
  DomainAnnouncements = 'DomainAnnouncements',
  EBrochures = 'EBrochures',
  HomeAlerts = 'HomeAlerts',
  Newsletter = 'Newsletter',
  PartnerAnnouncements = 'PartnerAnnouncements',
  Predictive = 'Predictive',
  PremarketListings = 'PremarketListings',
  PropertyMarketingUpdates = 'PropertyMarketingUpdates',
  Shortlist = 'Shortlist',
  TrackMyHome = 'TrackMyHome',
  UserResearch = 'UserResearch'
}

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimPropertyInput = {
  claimant: Scalars['String']['input'];
  displayLabel?: InputMaybe<ClaimPropertyDisplayLabel>;
  notes?: InputMaybe<Scalars['String']['input']>;
  propertyId: Scalars['String']['input'];
  suggestions?: InputMaybe<ClaimSuggestion>;
};

export type ClaimPropertyDisplayLabel = {
  colour?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimSuggestion = {
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  parking?: InputMaybe<Scalars['Int']['input']>;
  propertyType: Scalars['String']['input'];
};

export type VerifyChangeUserMobileInput = {
  code: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  mobilePhoneNumber: Scalars['String']['input'];
};

export type AgentInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export enum AgentStatisticsSort {
  Avgdayonmarketascending = 'AVGDAYONMARKETASCENDING',
  Avgdayonmarketdescending = 'AVGDAYONMARKETDESCENDING',
  Avgsalepriceascending = 'AVGSALEPRICEASCENDING',
  Avgsalepricedescending = 'AVGSALEPRICEDESCENDING',
  /**
   * Agency api sortBy model
   * https://github.com/domain-group/domain-agency/blob/release/Source/Domain.Agency.Common/Data/Enums/AgentSearchSortBy.cs
   */
  Default = 'DEFAULT',
  Forrentascending = 'FORRENTASCENDING',
  Forrentdescending = 'FORRENTDESCENDING',
  Forsaleascending = 'FORSALEASCENDING',
  Forsaledescending = 'FORSALEDESCENDING',
  Nameascending = 'NAMEASCENDING',
  Namedescending = 'NAMEDESCENDING',
  Random = 'RANDOM',
  Totalleaseddescending = 'TOTALLEASEDDESCENDING',
  Totalsoldandauctionedascending = 'TOTALSOLDANDAUCTIONEDASCENDING',
  Totalsoldandauctioneddescending = 'TOTALSOLDANDAUCTIONEDDESCENDING',
  Totalsoldascending = 'TOTALSOLDASCENDING',
  Totalsolddescending = 'TOTALSOLDDESCENDING'
}

export enum AgentStatisticsType {
  All = 'ALL',
  Default = 'DEFAULT',
  Rent = 'RENT',
  SoldOnly = 'SOLD_ONLY'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ContentArticleListAuthor = {
  __typename?: 'ContentArticleListAuthor';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
};

export type ContentArticleListCategory = {
  __typename?: 'ContentArticleListCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ContentArticleListCategoryParent>;
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentArticleListCategoryParent = {
  __typename?: 'ContentArticleListCategoryParent';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ContentArticleListImage = {
  __typename?: 'ContentArticleListImage';
  altText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  credit?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  sizes: ContentArticleListImageVariations;
  source?: Maybe<Scalars['String']['output']>;
};

export type ContentArticleListImageVariations = {
  __typename?: 'ContentArticleListImageVariations';
  full: ContentArticleListImageVariation;
  landscape16x9: ContentArticleListImageVariation;
  portrait2x3: ContentArticleListImageVariation;
  square1x1: ContentArticleListImageVariation;
  thumbnail: ContentArticleListImageVariation;
};

export type ContentArticleListImageVariation = {
  __typename?: 'ContentArticleListImageVariation';
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ContentArticleListTag = {
  __typename?: 'ContentArticleListTag';
  id: Scalars['Int']['output'];
  invisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

/** Deprecated: Use "MediaCategory". */
export enum MediaTypes {
  Image = 'IMAGE',
  OtherMedia = 'OTHER_MEDIA',
  Video = 'VIDEO'
}

export type SuburbPropertyStatistics = {
  __typename?: 'SuburbPropertyStatistics';
  /** The percentage clearance rate of auctions in this suburb. */
  auctionClearanceRate?: Maybe<Scalars['Float']['output']>;
  averageDaysOnMarket?: Maybe<Scalars['Int']['output']>;
  bedrooms: Scalars['Int']['output'];
  /** The number of properties currently available for rent in this suburb. */
  currentPropertiesForRent?: Maybe<Scalars['Int']['output']>;
  /** The number of properties currently available for sale in this suburb. */
  currentPropertiesForSale?: Maybe<Scalars['Int']['output']>;
  /** The bottom of the price range for this property type in this suburb. */
  entryLevelPrice?: Maybe<Scalars['Int']['output']>;
  /** The estimated monthly repayments on this property in this suburb with a 20% deposit. */
  estimatedMonthlyRepayments?: Maybe<Scalars['Int']['output']>;
  /** The top of the price range for this property type in this suburb. */
  luxuryLevelPrice?: Maybe<Scalars['Int']['output']>;
  medianRentPrice?: Maybe<Scalars['Int']['output']>;
  medianSoldPrice?: Maybe<Scalars['Int']['output']>;
  /** Although this returns an enum, it will likely only ever be "House" or "Unit" */
  propertyType: Scalars['String']['output'];
  /** Total number of properties sold in the last twelve months */
  totalSold?: Maybe<Scalars['Int']['output']>;
};

export enum TemporalUnit {
  Months = 'MONTHS',
  Years = 'YEARS'
}

export type AgencyAboutSectionFragment = { __typename: 'Agency', id: string, name?: string | null, description?: string | null, hasReinswBadge?: boolean | null, profileTier?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', suburbId: string, name: string } | null } | null, statistics?: { __typename?: 'AgencyStatistics', id: string, forSale?: number | null, soldTotal?: number | null, forRent?: number | null, leased?: number | null } | null };

export type AgencyAboutSectionQueryVariables = Exact<{
  agencyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AgencyAboutSectionQuery = { __typename?: 'Query', agency?: { __typename: 'Agency', id: string, name?: string | null, description?: string | null, hasReinswBadge?: boolean | null, profileTier?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', suburbId: string, name: string } | null } | null, statistics?: { __typename?: 'AgencyStatistics', id: string, forSale?: number | null, soldTotal?: number | null, forRent?: number | null, leased?: number | null } | null } | null };

export type ContactAboutSectionFragment = { __typename: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, profileText?: string | null, profileTier?: string | null, hasReinsw?: boolean | null, agencyName?: string | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, address?: { __typename?: 'Address', displayAddress?: string | null } | null } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalSold?: number | null, totalLeased?: number | null, totalAuctioned?: number | null, totalForSale?: number | null } | null, nextInspectionByContact?: { __typename?: 'NextInspection', listingByAdId?: { __typename?: 'Listing', id: string, listingId: number, promoLevel?: string | null, seoUrl?: string | null, isRural?: boolean | null, parkingSpaces?: number | null, bedrooms?: number | null, bathrooms?: number | null, landArea?: number | null, propertyTypes: Array<string>, priceDetails?: { __typename?: 'ListingPriceDetails', displayPrice?: string | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, street?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null, inspectionDetails?: { __typename?: 'ListingInspectionDetails', inspections?: Array<{ __typename?: 'ListingInspections', openingDateTime?: string | null, closingDateTime?: string | null } | null> | null } | null, media?: Array<{ __typename: 'Image', type?: string | null, url: string } | { __typename: 'OtherMedia' } | { __typename: 'Video' }> | null } | null } | null };

export type ContactAboutSectionQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
  quality?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactAboutSectionQuery = { __typename?: 'Query', contactByContactId?: { __typename: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, profileText?: string | null, profileTier?: string | null, hasReinsw?: boolean | null, agencyName?: string | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, address?: { __typename?: 'Address', displayAddress?: string | null } | null } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalSold?: number | null, totalLeased?: number | null, totalAuctioned?: number | null, totalForSale?: number | null } | null, nextInspectionByContact?: { __typename?: 'NextInspection', listingByAdId?: { __typename?: 'Listing', id: string, listingId: number, promoLevel?: string | null, seoUrl?: string | null, isRural?: boolean | null, parkingSpaces?: number | null, bedrooms?: number | null, bathrooms?: number | null, landArea?: number | null, propertyTypes: Array<string>, priceDetails?: { __typename?: 'ListingPriceDetails', displayPrice?: string | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, street?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null, inspectionDetails?: { __typename?: 'ListingInspectionDetails', inspections?: Array<{ __typename?: 'ListingInspections', openingDateTime?: string | null, closingDateTime?: string | null } | null> | null } | null, media?: Array<{ __typename: 'Image', type?: string | null, url: string } | { __typename: 'OtherMedia' } | { __typename: 'Video' }> | null } | null } | null } | null };

export type AgencyEnquiryFormSectionFragment = { __typename: 'Agency', id: string, agencyId: number, name?: string | null, contactDetails?: { __typename?: 'AgencyContactDetails', general?: { __typename?: 'AgencyContactDetailsGeneral', email?: string | null } | null } | null };

export type AgencyEnquiryFormUserDetailsPrefillFragment = { __typename: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string };

export type AgencyEnquiryFormQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type AgencyEnquiryFormQuery = { __typename?: 'Query', agency?: { __typename: 'Agency', id: string, agencyId: number, name?: string | null, contactDetails?: { __typename?: 'AgencyContactDetails', general?: { __typename?: 'AgencyContactDetailsGeneral', email?: string | null } | null } | null } | null };

export type AgencyEnquiryFormUserPrefillQueryVariables = Exact<{ [key: string]: never; }>;


export type AgencyEnquiryFormUserPrefillQuery = { __typename?: 'Query', me?: { __typename: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null };

export type GetAgencyProfileRatingQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type GetAgencyProfileRatingQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, depthTier?: string | null, recommendations?: { __typename?: 'AgencyRecommendations', overallStarRating?: number | null, numberOfReviews?: number | null } | null } | null };

export type AgencySearchProfileCardFragment = { __typename?: 'AgencySearchAgency', id: number, name: string, displayAddress?: string | null, profileTier: string, brandColour?: string | null, logoSmall?: string | null, profileUrl: string, mobile?: string | null, telephone?: string | null, email?: string | null, hideOfficeLocation: boolean, totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalLeased?: number | null, totalForRent?: number | null, agents?: Array<{ __typename?: 'AgentSearchAgencyContact', name: string, profileUrl: string, profilePhoto?: string | null } | null> | null, reputation?: { __typename?: 'AgencyReputation', numberOfReviews?: number | null, overallStarRating?: number | null, overallStarRatingRecent?: number | null, numberOfReviewsRecent?: number | null } | null };

export type AgencyProfileMapFragmentFragment = { __typename: 'Agency', id: string, name?: string | null, address?: { __typename: 'Address', displayAddress?: string | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null, branding?: { __typename?: 'AgencyBranding', id: string, logoColour?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null };

export type AgencyRecommendationPaginationByAgencyIdQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AgencyRecommendationPaginationByAgencyIdQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', recommendations?: { __typename?: 'AgencyRecommendations', agencyProfileUrl?: string | null, reviews?: Array<{ __typename?: 'VendorReview', title?: string | null, description?: string | null, reviewedOn?: string | null, reviewType?: string | null, starRating?: number | null, agentReviewTrackingPixelUrl?: string | null, agencyReviewTrackingPixelUrl?: string | null, reviewUrl?: string | null, bedrooms?: number | null, bathrooms?: number | null, carparks?: number | null, streetAddress?: string | null, suburb?: string | null, state?: string | null, postCode?: string | null } | null> | null } | null } | null };

export type AgencyRecommendationsFragment = { __typename?: 'Agency', id: string, name?: string | null, agencyId: number, recommendations?: { __typename?: 'AgencyRecommendations', subscribed?: boolean | null, showRMAReviews?: boolean | null, numberOfReviews?: number | null, overallStarRating?: number | null, agencyProfileUrl?: string | null, lastUpdated?: string | null, reviews?: Array<{ __typename?: 'VendorReview', title?: string | null, description?: string | null, reviewedOn?: string | null, reviewerName?: string | null, reviewType?: string | null, starRating?: number | null, isRecommended?: boolean | null, agentReviewTrackingPixelUrl?: string | null, agencyReviewTrackingPixelUrl?: string | null, reviewUrl?: string | null, propertyType?: string | null, bedrooms?: number | null, bathrooms?: number | null, carparks?: number | null, streetAddress?: string | null, suburb?: string | null, state?: string | null, postCode?: string | null } | null> | null } | null };

export type AgencyByAgencyIdQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type AgencyByAgencyIdQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, name?: string | null, agencyId: number, recommendations?: { __typename?: 'AgencyRecommendations', subscribed?: boolean | null, showRMAReviews?: boolean | null, numberOfReviews?: number | null, overallStarRating?: number | null, agencyProfileUrl?: string | null, lastUpdated?: string | null, reviews?: Array<{ __typename?: 'VendorReview', title?: string | null, description?: string | null, reviewedOn?: string | null, reviewerName?: string | null, reviewType?: string | null, starRating?: number | null, isRecommended?: boolean | null, agentReviewTrackingPixelUrl?: string | null, agencyReviewTrackingPixelUrl?: string | null, reviewUrl?: string | null, propertyType?: string | null, bedrooms?: number | null, bathrooms?: number | null, carparks?: number | null, streetAddress?: string | null, suburb?: string | null, state?: string | null, postCode?: string | null } | null> | null } | null } | null };

export type AgencyTeamFragment = { __typename?: 'Agency', id: string, agencyId: number, contacts?: Array<{ __typename: 'Contact', contactId?: number | null, agentIdV2: string, id: string, agencyId: number, name?: string | null, jobTitle?: string | null, hasEmail?: boolean | null, telephone?: string | null, mobile?: string | null, profileTier?: string | null, profileUrl?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, averageSoldPrice?: number | null, averageDaysOnMarket?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, name?: string | null, branding?: { __typename?: 'AgencyBranding', id: string, logoColour?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null } | null, recommendations?: { __typename?: 'ContactRecommendations', overallStarRating?: number | null, numberOfReviews?: number | null } | null } | null> | null };

export type GetAgencyTeamQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetAgencyTeamQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, agencyId: number, contacts?: Array<{ __typename: 'Contact', contactId?: number | null, agentIdV2: string, id: string, agencyId: number, name?: string | null, jobTitle?: string | null, hasEmail?: boolean | null, telephone?: string | null, mobile?: string | null, profileTier?: string | null, profileUrl?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, averageSoldPrice?: number | null, averageDaysOnMarket?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, name?: string | null, branding?: { __typename?: 'AgencyBranding', id: string, logoColour?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null } | null, recommendations?: { __typename?: 'ContactRecommendations', overallStarRating?: number | null, numberOfReviews?: number | null } | null } | null> | null } | null };

export type GetAgentProfile2026QueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type GetAgentProfile2026Query = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, agencyUrlPath?: string | null, jobCategory?: string | null, jobTitle?: string | null, hasReinsw?: boolean | null, profileUrl?: string | null, recommendations?: { __typename?: 'ContactRecommendations', numberOfReviews?: number | null, overallStarRating?: number | null } | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, name?: string | null, profileUrl?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', id: string, suburbId: string, name: string } | null } | null, branding?: { __typename?: 'AgencyBranding', id: string, backgroundColour?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', id: string, suburbId: string, name: string, slug?: string | null } | null } | null, statistics?: { __typename?: 'ContactStatistics', totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, averageDaysOnMarket?: number | null, averageSoldPrice?: number | null } | null } | null };

export type GetContactIdAppraisalCtaQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetContactIdAppraisalCtaQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agencyId: number, agentIdV2: string, name?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null } | null };

export type AppraisalCtaFragment = { __typename?: 'Contact', id: string, agencyId: number, agentIdV2: string, name?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null };

export type GetContactAppraisalCtaQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetContactAppraisalCtaQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, agencyId: number, agentIdV2: string, name?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null } | null };

export type CreateEnquiryMutationVariables = Exact<{
  input: EnquiryInput;
}>;


export type CreateEnquiryMutation = { __typename?: 'Mutation', createEnquiry?: { __typename?: 'Enquiry', s3Key?: string | null } | null };

export type ContactEnquiryFormFragment = { __typename: 'Contact', id: string, name?: string | null, hasEmail?: boolean | null, profilePhoto?: { __typename?: 'Image', url: string } | null };

export type ContactSearchProfileCardFragment = { __typename?: 'ContactSearchContact', id: number, agentIdV2: string, agencyId: number, name: string, jobTitle?: string | null, jobCategory?: string | null, hasEmail?: boolean | null, telephone?: string | null, mobile?: string | null, profileTier?: string | null, profileUrl: string, profilePhoto?: string | null, totalForSale?: number | null, averageSoldPrice?: number | null, averageSoldDaysOnMarket?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null, agencyName: string, agencyLogoUrl?: string | null, brandColour?: string | null, reputation?: { __typename?: 'ContactReputation', numberOfReviews?: number | null, overallStarRating?: number | null, overallStarRatingRecent?: number | null, numberOfReviewsRecent?: number | null } | null };

export type GetContactProfileRatingQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type GetContactProfileRatingQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, depthTier?: string | null, recommendations?: { __typename?: 'ContactRecommendations', overallStarRating?: number | null, numberOfReviews?: number | null } | null } | null };

export type ContactByAgencyIdAndAgentIdPaginationQueryVariables = Exact<{
  agentIdV2: Scalars['String']['input'];
  agencyId: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactByAgencyIdAndAgentIdPaginationQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', recommendations?: { __typename?: 'ContactRecommendations', agentProfileUrl?: string | null, reviews?: Array<{ __typename?: 'VendorReview', title?: string | null, description?: string | null, reviewedOn?: string | null, reviewType?: string | null, starRating?: number | null, isRecommended?: boolean | null, agentReviewTrackingPixelUrl?: string | null, agencyReviewTrackingPixelUrl?: string | null, bedrooms?: number | null, bathrooms?: number | null, carparks?: number | null, streetAddress?: string | null, suburb?: string | null, state?: string | null, postCode?: string | null } | null> | null } | null } | null };

export type ContactRecommendationsFragment = { __typename?: 'Contact', id: string, firstName?: string | null, agentIdV2: string, agencyId: number, recommendations?: { __typename?: 'ContactRecommendations', subscribed?: boolean | null, showRMAReviews?: boolean | null, numberOfReviews?: number | null, overallStarRating?: number | null, lastUpdated?: string | null, agentProfileUrl?: string | null, agenciesAllSubscribed?: boolean | null, reviews?: Array<{ __typename?: 'VendorReview', title?: string | null, description?: string | null, reviewedOn?: string | null, reviewerName?: string | null, reviewType?: string | null, starRating?: number | null, isRecommended?: boolean | null, agentReviewTrackingPixelUrl?: string | null, agencyReviewTrackingPixelUrl?: string | null, reviewUrl?: string | null, propertyType?: string | null, bedrooms?: number | null, bathrooms?: number | null, carparks?: number | null, streetAddress?: string | null, suburb?: string | null, state?: string | null, postCode?: string | null } | null> | null } | null };

export type ContactByContactIdQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type ContactByContactIdQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, firstName?: string | null, agentIdV2: string, agencyId: number, recommendations?: { __typename?: 'ContactRecommendations', subscribed?: boolean | null, showRMAReviews?: boolean | null, numberOfReviews?: number | null, overallStarRating?: number | null, lastUpdated?: string | null, agentProfileUrl?: string | null, agenciesAllSubscribed?: boolean | null, reviews?: Array<{ __typename?: 'VendorReview', title?: string | null, description?: string | null, reviewedOn?: string | null, reviewerName?: string | null, reviewType?: string | null, starRating?: number | null, isRecommended?: boolean | null, agentReviewTrackingPixelUrl?: string | null, agencyReviewTrackingPixelUrl?: string | null, reviewUrl?: string | null, propertyType?: string | null, bedrooms?: number | null, bathrooms?: number | null, carparks?: number | null, streetAddress?: string | null, suburb?: string | null, state?: string | null, postCode?: string | null } | null> | null } | null } | null };

export type AgencyListingsStoryFragment = { __typename?: 'Agency', id: string, name?: string | null, hideOfficeLocation?: boolean | null, address?: { __typename?: 'Address', displayAddress?: string | null } | null, statistics?: { __typename?: 'AgencyStatistics', id: string, forSale?: number | null, sold?: number | null, forRent?: number | null, leased?: number | null, auctioned?: number | null } | null };

export type GetAgencyListingsStoryQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type GetAgencyListingsStoryQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, name?: string | null, hideOfficeLocation?: boolean | null, address?: { __typename?: 'Address', displayAddress?: string | null } | null, statistics?: { __typename?: 'AgencyStatistics', id: string, forSale?: number | null, sold?: number | null, forRent?: number | null, leased?: number | null, auctioned?: number | null } | null } | null };

export type ContactListingsStoryFragment = { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, hideOfficeLocation?: boolean | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, address?: { __typename?: 'Address', displayAddress?: string | null } | null } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalAuctioned?: number | null, totalSold?: number | null } | null };

export type GetContactListingsStoryQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type GetContactListingsStoryQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, hideOfficeLocation?: boolean | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, address?: { __typename?: 'Address', displayAddress?: string | null } | null } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalAuctioned?: number | null, totalSold?: number | null } | null } | null };

export type AgencyCurrentListingsQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  suburbId?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<AgencyApiPropertyType>;
  sortBy?: InputMaybe<AgentsearchListingsSortBy>;
  bedrooms?: InputMaybe<AgentsearchListingBedrooms>;
  imageFormat?: InputMaybe<ImageFormat>;
  quality?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AgencyCurrentListingsQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, agentsearchListingsByAgencyId?: { __typename?: 'AgentsearchListingCategories', soldListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null, saleListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null, leaseListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null, leasedListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null } | null } | null };

export type AgentListingsTabFragment = { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null };

export type ContactCurrentListingsQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  suburbId?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<AgencyApiPropertyType>;
  sortBy?: InputMaybe<AgentsearchListingsSortBy>;
  bedrooms?: InputMaybe<AgentsearchListingBedrooms>;
  imageFormat?: InputMaybe<ImageFormat>;
  quality?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactCurrentListingsQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentsearchListingsByAgentIdV2AndAgencyId?: { __typename?: 'AgentsearchListingCategories', soldListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null, saleListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null, leaseListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null, leasedListings?: { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null } | null } | null } | null };

export type ContactListingsTabFragment = { __typename?: 'AgentsearchListingResults', total?: number | null, totalPages: number, results?: Array<{ __typename?: 'AgentsearchListingResult', saleType?: string | null, listing?: { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null } | null } | null> | null };

export type CurrentListingCardFragment = { __typename?: 'AgentsearchListing', id: string, listingId: number, bedrooms?: number | null, bathrooms?: number | null, parkingSpaces?: number | null, isRural?: boolean | null, url?: string | null, seoUrl?: string | null, listingSlug?: string | null, propertyId?: string | null, soldInfo?: { __typename?: 'AgentsearchAgentsearchListingSoldInfo', soldDate?: string | null, soldPrice?: number | null, soldMethod?: string | null } | null, priceDetails?: { __typename?: 'AgentsearchListingPriceDetails', displayPrice?: string | null } | null, media?: Array<{ __typename?: 'Image', url: string } | { __typename?: 'OtherMedia' } | { __typename?: 'Video' }> | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null };

export type AgencyCurrentListingsFilterQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type AgencyCurrentListingsFilterQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, agentsearchListingsFiltersByAgencyId?: { __typename?: 'ListingFilters', listingSummary?: Array<{ __typename?: 'ListingFilterListingType', listingType?: ListingFilterStatus | null, bedrooms?: Array<string> | null, propertyTypes?: Array<AgencyApiPropertyType | null> | null, suburbSummaries?: Array<{ __typename?: 'ListingFilterSuburbSummary', suburbSlug?: string | null, suburbName: string, listingCount: number } | null> | null } | null> | null } | null } | null };

export type ContactCurrentListingsFilterQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type ContactCurrentListingsFilterQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentsearchListingsFiltersByAgentIdV2AndAgencyId?: { __typename?: 'ListingFilters', listingSummary?: Array<{ __typename?: 'ListingFilterListingType', listingType?: ListingFilterStatus | null, bedrooms?: Array<string> | null, propertyTypes?: Array<AgencyApiPropertyType | null> | null, suburbSummaries?: Array<{ __typename?: 'ListingFilterSuburbSummary', suburbSlug?: string | null, suburbName: string, listingCount: number } | null> | null } | null> | null } | null } | null };

export type AgencyFooterFragment = { __typename?: 'Agency', id: string, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', suburbId: string, name: string, slug?: string | null } | null } | null };

export type ContactFooterFragment = { __typename?: 'Contact', id: string, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', suburbId: string, name: string, slug?: string | null } | null } | null };

export type SearchResultsFooterFragment = { __typename?: 'LocationProfile', id?: string | null, suburbName?: string | null, urlSlug?: string | null, surroundingSuburbs?: Array<{ __typename?: 'SurroundingSuburb', name?: string | null, urlSlug?: string | null } | null> | null, data: { __typename?: 'LocationDetails', apartmentsAndUnitsForSale?: number | null, blockOfUnitsForSale?: number | null, duplexesForSale?: number | null, housesForSale?: number | null, penthousesForSale?: number | null, semiDetachedHousesForSale?: number | null, studiosForSale?: number | null, terracedHousesForSale?: number | null, townhousesForSale?: number | null, villasForSale?: number | null, apartmentsAndUnitsForRent?: number | null, duplexesForRent?: number | null, housesForRent?: number | null, penthousesForRent?: number | null, semiDetachedHousesForRent?: number | null, studiosForRent?: number | null, terracedHousesForRent?: number | null, townhousesForRent?: number | null, villasForRent?: number | null } };

export type SearchResultsFooterQueryVariables = Exact<{
  singleSuburbSlug: Scalars['String']['input'];
}>;


export type SearchResultsFooterQuery = { __typename?: 'Query', locationProfile?: { __typename?: 'LocationProfile', id?: string | null, suburbName?: string | null, urlSlug?: string | null, surroundingSuburbs?: Array<{ __typename?: 'SurroundingSuburb', name?: string | null, urlSlug?: string | null } | null> | null, data: { __typename?: 'LocationDetails', apartmentsAndUnitsForSale?: number | null, blockOfUnitsForSale?: number | null, duplexesForSale?: number | null, housesForSale?: number | null, penthousesForSale?: number | null, semiDetachedHousesForSale?: number | null, studiosForSale?: number | null, terracedHousesForSale?: number | null, townhousesForSale?: number | null, villasForSale?: number | null, apartmentsAndUnitsForRent?: number | null, duplexesForRent?: number | null, housesForRent?: number | null, penthousesForRent?: number | null, semiDetachedHousesForRent?: number | null, studiosForRent?: number | null, terracedHousesForRent?: number | null, townhousesForRent?: number | null, villasForRent?: number | null } } | null };

export type AgencyDigitalDataFragment = { __typename?: 'Agency', agencyId: number, name?: string | null, profileUrl?: string | null, profileTier?: string | null, depthTier?: string | null, branding?: { __typename?: 'AgencyBranding', id: string, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', name: string, postcode: string, state: States, suburbId: string } | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null } | null> | null };

export type DigitalDataForAgencyQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type DigitalDataForAgencyQuery = { __typename?: 'Query', agency?: { __typename: 'Agency', id: string, agencyId: number, name?: string | null, profileUrl?: string | null, profileTier?: string | null, depthTier?: string | null, branding?: { __typename?: 'AgencyBranding', id: string, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', name: string, postcode: string, state: States, suburbId: string } | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null } | null> | null } | null };

export type ContactDigitalDataFragment = { __typename?: 'Contact', id: string, agencyId: number, agentIdV2: string, agencyName?: string | null, name?: string | null, profileTier?: string | null, depthTier?: string | null, profileUrl?: string | null, agencyLogo?: string | null, jobTitle?: string | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, profileUrl?: string | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null } | null> | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', name: string, postcode: string, state: States, suburbId: string } | null } | null, branding?: { __typename?: 'AgencyBranding', id: string, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', name: string, postcode: string, state: States, suburbId: string } | null } | null, profilePhoto?: { __typename?: 'Image', url: string } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalAuctioned?: number | null, totalSold?: number | null } | null };

export type DigitalDataForContactQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type DigitalDataForContactQuery = { __typename?: 'Query', contactByContactId?: { __typename: 'Contact', id: string, agencyId: number, agentIdV2: string, agencyName?: string | null, name?: string | null, profileTier?: string | null, depthTier?: string | null, profileUrl?: string | null, agencyLogo?: string | null, jobTitle?: string | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, profileUrl?: string | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null } | null> | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', name: string, postcode: string, state: States, suburbId: string } | null } | null, branding?: { __typename?: 'AgencyBranding', id: string, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', name: string, postcode: string, state: States, suburbId: string } | null } | null, profilePhoto?: { __typename?: 'Image', url: string } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalAuctioned?: number | null, totalSold?: number | null } | null } | null };

export type AgencyHeaderFragment = { __typename?: 'Agency', id: string, agencyId: number, profileTier?: string | null, profileUrl?: string | null, name?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', id: string, suburbId: string, name: string, slug?: string | null } | null } | null };

export type ContactHeaderFragment = { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, profileUrl?: string | null, profileTier?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null, suburb?: { __typename?: 'Suburb', id: string, suburbId: string, name: string, slug?: string | null } | null } | null, statistics?: { __typename?: 'ContactStatistics', totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null } | null };

export type AgencyHeroFragment = { __typename?: 'Agency', id: string, profileTier?: string | null, name?: string | null, hideOfficeLocation?: boolean | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, youtubeChannelUrl?: string | null, website?: string | null, contactDetails?: { __typename?: 'AgencyContactDetails', general?: { __typename?: 'AgencyContactDetailsGeneral', mobile?: string | null, phone?: string | null, email?: string | null } | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null } | null, branding?: { __typename?: 'AgencyBranding', backgroundColour?: string | null, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null };

export type GetAgencyHeroQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetAgencyHeroQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, profileTier?: string | null, name?: string | null, hideOfficeLocation?: boolean | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, youtubeChannelUrl?: string | null, website?: string | null, contactDetails?: { __typename?: 'AgencyContactDetails', general?: { __typename?: 'AgencyContactDetailsGeneral', mobile?: string | null, phone?: string | null, email?: string | null } | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null } | null, branding?: { __typename?: 'AgencyBranding', backgroundColour?: string | null, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null } | null };

export type ContactHeroFragment = { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, jobCategory?: string | null, telephone?: string | null, mobile?: string | null, hasEmail?: boolean | null, agencyLogo?: string | null, agencyUrlPath?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, linkedInUrl?: string | null, instagramUrl?: string | null, youTubeChannelUrl?: string | null, agentVideoUrl?: string | null, personalWebsiteUrl?: string | null, profileTier?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null } | null, profilePhoto?: { __typename?: 'Image', url: string } | null, agencyByAgencyId?: { __typename?: 'Agency', hideOfficeLocation?: boolean | null, youtubeChannelUrl?: string | null, website?: string | null, branding?: { __typename?: 'AgencyBranding', backgroundColour?: string | null, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null } | null };

export type GetContactHeroQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetContactHeroQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, jobCategory?: string | null, telephone?: string | null, mobile?: string | null, hasEmail?: boolean | null, agencyLogo?: string | null, agencyUrlPath?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, linkedInUrl?: string | null, instagramUrl?: string | null, youTubeChannelUrl?: string | null, agentVideoUrl?: string | null, personalWebsiteUrl?: string | null, profileTier?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null } | null, profilePhoto?: { __typename?: 'Image', url: string } | null, agencyByAgencyId?: { __typename?: 'Agency', hideOfficeLocation?: boolean | null, youtubeChannelUrl?: string | null, website?: string | null, branding?: { __typename?: 'AgencyBranding', backgroundColour?: string | null, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null } | null } | null };

export type GetContactIdHeroQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetContactIdHeroQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, jobCategory?: string | null, telephone?: string | null, mobile?: string | null, hasEmail?: boolean | null, agencyLogo?: string | null, agencyUrlPath?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, linkedInUrl?: string | null, instagramUrl?: string | null, youTubeChannelUrl?: string | null, agentVideoUrl?: string | null, personalWebsiteUrl?: string | null, profileTier?: string | null, address?: { __typename?: 'Address', displayAddress?: string | null } | null, profilePhoto?: { __typename?: 'Image', url: string } | null, agencyByAgencyId?: { __typename?: 'Agency', hideOfficeLocation?: boolean | null, youtubeChannelUrl?: string | null, website?: string | null, branding?: { __typename?: 'AgencyBranding', backgroundColour?: string | null, logo?: { __typename?: 'Image', url: string } | null, hero?: { __typename?: 'Image', url: string } | null } | null } | null } | null };

export type ListingCardFragment = { __typename?: 'Listing', id: string, listingId: number, promoLevel?: string | null, seoUrl?: string | null, isRural?: boolean | null, parkingSpaces?: number | null, bedrooms?: number | null, bathrooms?: number | null, landArea?: number | null, propertyTypes: Array<string>, priceDetails?: { __typename?: 'ListingPriceDetails', displayPrice?: string | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, street?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null, inspectionDetails?: { __typename?: 'ListingInspectionDetails', inspections?: Array<{ __typename?: 'ListingInspections', openingDateTime?: string | null, closingDateTime?: string | null } | null> | null } | null, media?: Array<{ __typename: 'Image', type?: string | null, url: string } | { __typename: 'OtherMedia' } | { __typename: 'Video' }> | null };

export type ListingCardQueryVariables = Exact<{
  adId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
  quality?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListingCardQuery = { __typename?: 'Query', listing?: { __typename?: 'Listing', id: string, listingId: number, promoLevel?: string | null, seoUrl?: string | null, isRural?: boolean | null, parkingSpaces?: number | null, bedrooms?: number | null, bathrooms?: number | null, landArea?: number | null, propertyTypes: Array<string>, priceDetails?: { __typename?: 'ListingPriceDetails', displayPrice?: string | null } | null, address?: { __typename?: 'Address', displayAddress?: string | null, street?: string | null, state?: States | null, postcode?: string | null, suburb?: { __typename?: 'Suburb', name: string, suburbId: string } | null, geolocation?: { __typename?: 'Geolocation', latitude: number, longitude: number } | null } | null, inspectionDetails?: { __typename?: 'ListingInspectionDetails', inspections?: Array<{ __typename?: 'ListingInspections', openingDateTime?: string | null, closingDateTime?: string | null } | null> | null } | null, media?: Array<{ __typename: 'Image', type?: string | null, url: string } | { __typename: 'OtherMedia' } | { __typename: 'Video' }> | null } | null };

export type AgencySalesStatisticsStoryFragment = { __typename?: 'Agency', id: string, name?: string | null, profileUrl?: string | null, showTabSoldLastYear?: boolean | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, topListing?: { __typename?: 'TopListing', soldPrice?: number | null, daysOnMarket?: number | null, soldDate?: string | null, displayableAddress?: string | null, bedrooms?: number | null, listingType?: string | null, salesType?: string | null, state?: string | null, postcode?: string | null, adId?: number | null } | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, salesType?: string | null, listingCount?: number | null, suburbSlug?: string | null } | null> | null };

export type GetAgencySalesStatisticsStoryQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type GetAgencySalesStatisticsStoryQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, name?: string | null, profileUrl?: string | null, showTabSoldLastYear?: boolean | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, topListing?: { __typename?: 'TopListing', soldPrice?: number | null, daysOnMarket?: number | null, soldDate?: string | null, displayableAddress?: string | null, bedrooms?: number | null, listingType?: string | null, salesType?: string | null, state?: string | null, postcode?: string | null, adId?: number | null } | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, salesType?: string | null, listingCount?: number | null, suburbSlug?: string | null } | null> | null } | null };

export type GetContactIdSalesStatisticsStoryQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type GetContactIdSalesStatisticsStoryQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, agencyUrlPath?: string | null, isHideSoldLeasedListings?: boolean | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, coWorkerListingCount?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, topListing?: { __typename?: 'TopListing', soldPrice?: number | null, daysOnMarket?: number | null, soldDate?: string | null, displayableAddress?: string | null, bedrooms?: number | null, listingType?: string | null, salesType?: string | null, state?: string | null, postcode?: string | null, adId?: number | null } | null, coWorkerContacts?: Array<{ __typename?: 'CoWorkerContact', id?: string | null, isActiveProfilePage?: boolean | null } | null> | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, showTabSoldLastYear?: boolean | null, contacts?: Array<{ __typename?: 'Contact', name?: string | null, agentIdV2: string, profileUrl?: string | null } | null> | null } | null } | null };

export type ContactSalesStatisticsStoryFragment = { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, agencyUrlPath?: string | null, isHideSoldLeasedListings?: boolean | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, coWorkerListingCount?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, topListing?: { __typename?: 'TopListing', soldPrice?: number | null, daysOnMarket?: number | null, soldDate?: string | null, displayableAddress?: string | null, bedrooms?: number | null, listingType?: string | null, salesType?: string | null, state?: string | null, postcode?: string | null, adId?: number | null } | null, coWorkerContacts?: Array<{ __typename?: 'CoWorkerContact', id?: string | null, isActiveProfilePage?: boolean | null } | null> | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, showTabSoldLastYear?: boolean | null, contacts?: Array<{ __typename?: 'Contact', name?: string | null, agentIdV2: string, profileUrl?: string | null } | null> | null } | null };

export type GetContactSalesStatisticsStoryQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
}>;


export type GetContactSalesStatisticsStoryQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, name?: string | null, agencyName?: string | null, agencyUrlPath?: string | null, isHideSoldLeasedListings?: boolean | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, coWorkerListingCount?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, topListing?: { __typename?: 'TopListing', soldPrice?: number | null, daysOnMarket?: number | null, soldDate?: string | null, displayableAddress?: string | null, bedrooms?: number | null, listingType?: string | null, salesType?: string | null, state?: string | null, postcode?: string | null, adId?: number | null } | null, coWorkerContacts?: Array<{ __typename?: 'CoWorkerContact', id?: string | null, isActiveProfilePage?: boolean | null } | null> | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, showTabSoldLastYear?: boolean | null, contacts?: Array<{ __typename?: 'Contact', name?: string | null, agentIdV2: string, profileUrl?: string | null } | null> | null } | null } | null };

export type AgencyProfileSalesStatisticsFragment = { __typename?: 'Agency', id: string, showTabSoldLastYear?: boolean | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null } | null };

export type GetAgencySalesStatisticsQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type GetAgencySalesStatisticsQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, showTabSoldLastYear?: boolean | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null } | null } | null };

export type GetAgencySalesStatisticsDataQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  suburbSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAgencySalesStatisticsDataQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, suburbStatisticsData?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null } | null } | null };

export type GetContactSalesStatisticsDataQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
  suburbSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContactSalesStatisticsDataQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, suburbStatisticsData?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null } | null } | null };

export type GetContactIdSalesStatisticsQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type GetContactIdSalesStatisticsQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agencyId: number, agentIdV2: string, isHideSoldLeasedListings?: boolean | null, agencyByAgencyId?: { __typename?: 'Agency', showTabSoldLastYear?: boolean | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null } | null } | null };

export type ContactProfileSalesStatisticsFragment = { __typename?: 'Contact', id: string, agencyId: number, agentIdV2: string, isHideSoldLeasedListings?: boolean | null, agencyByAgencyId?: { __typename?: 'Agency', showTabSoldLastYear?: boolean | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null } | null };

export type ContactByAgencyIdAndAgentIdQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
}>;


export type ContactByAgencyIdAndAgentIdQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, agencyId: number, agentIdV2: string, isHideSoldLeasedListings?: boolean | null, agencyByAgencyId?: { __typename?: 'Agency', showTabSoldLastYear?: boolean | null } | null, activeSuburbs?: Array<{ __typename?: 'ActiveSuburbDetails', suburbName?: string | null, suburbSlug?: string | null, listingCount?: number | null } | null> | null, suburbStatistics?: { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null } | null } | null };

export type SuburbStatisticsFragment = { __typename?: 'SuburbSoldStatistics', averageDaysOnMarket?: number | null, averageSoldPrice?: number | null, totalSaleAmount?: number | null, total?: number | null, salesType?: { __typename?: 'SalesTypes', sold?: number | null, auction?: number | null } | null, listingType?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null, listingTypeAverage?: { __typename?: 'ListingTypeSoldStatistics', apartment?: number | null, house?: number | null, land?: number | null, rural?: number | null } | null };

export type FindAndAgentAutocompleteQueryVariables = Exact<{
  input: Scalars['String']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  locationTypes?: InputMaybe<Array<InputMaybe<LocationSuggestionType>> | InputMaybe<LocationSuggestionType>>;
  imageFormat?: InputMaybe<ImageFormat>;
  fitIn?: InputMaybe<Scalars['Boolean']['input']>;
  trim?: InputMaybe<ImageTrim>;
}>;


export type FindAndAgentAutocompleteQuery = { __typename?: 'Query', suggestLocations?: Array<{ __typename?: 'AreaSuggestion' } | { __typename?: 'PostcodeSuggestion' } | { __typename?: 'ProjectSuggestion' } | { __typename?: 'RegionSuggestion' } | { __typename?: 'SchoolSuggestion' } | { __typename?: 'SuburbSuggestion', displayName: string, nameSlug: string, name: string, state: string, postcode: string }> | null, suggestedAgencies?: Array<{ __typename?: 'SuggestedAgency', agencyName?: string | null, profileUrl?: string | null, backgroundColour?: string | null, suburb?: string | null, state?: string | null, postcode?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null> | null, suggestedContacts?: Array<{ __typename?: 'SuggestedContact', id?: string | null, contactId?: number | null, name?: string | null, thumbnail?: string | null, profileUrl?: string | null, agencyId?: number | null, agencyName?: string | null, suburb?: string | null, state?: string | null } | null> | null };

export type AgencySearchQueryVariables = Exact<{
  suburbSlugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  agencySortBy?: InputMaybe<AgencySearchSortBy>;
  contactSortBy?: InputMaybe<ContactSearchSortBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  agentFilter?: InputMaybe<AgentSearchContactTypes>;
  keywordName?: InputMaybe<Scalars['String']['input']>;
  includeAgents?: InputMaybe<Scalars['Boolean']['input']>;
  isAgencyView: Scalars['Boolean']['input'];
}>;


export type AgencySearchQuery = { __typename?: 'Query', contactSearchBySuburbs?: { __typename?: 'ContactSearch', total?: number | null, totalPages?: number | null, pageNumber?: number | null, results?: Array<{ __typename?: 'ContactSearchContact', id: number, agentIdV2: string, agencyId: number, name: string, jobTitle?: string | null, jobCategory?: string | null, hasEmail?: boolean | null, telephone?: string | null, mobile?: string | null, profileTier?: string | null, profileUrl: string, profilePhoto?: string | null, totalForSale?: number | null, averageSoldPrice?: number | null, averageSoldDaysOnMarket?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null, agencyName: string, agencyLogoUrl?: string | null, brandColour?: string | null, reputation?: { __typename?: 'ContactReputation', numberOfReviews?: number | null, overallStarRating?: number | null, overallStarRatingRecent?: number | null, numberOfReviewsRecent?: number | null } | null } | null> | null } | null, agencySearchBySuburbs?: { __typename?: 'AgencySearch', total: number, totalPages: number, pageNumber: number, results?: Array<{ __typename?: 'AgencySearchAgency', id: number, name: string, displayAddress?: string | null, profileTier: string, brandColour?: string | null, logoSmall?: string | null, profileUrl: string, mobile?: string | null, telephone?: string | null, email?: string | null, hideOfficeLocation: boolean, totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalLeased?: number | null, totalForRent?: number | null, agents?: Array<{ __typename?: 'AgentSearchAgencyContact', name: string, profileUrl: string, profilePhoto?: string | null } | null> | null, reputation?: { __typename?: 'AgencyReputation', numberOfReviews?: number | null, overallStarRating?: number | null, overallStarRatingRecent?: number | null, numberOfReviewsRecent?: number | null } | null } | null> } | null, locationProfiles?: Array<{ __typename?: 'LocationProfile', id?: string | null, suburbName?: string | null, state?: string | null, postcode?: string | null, urlSlug?: string | null, surroundingSuburbs?: Array<{ __typename?: 'SurroundingSuburb', name?: string | null, urlSlug?: string | null } | null> | null, data: { __typename?: 'LocationDetails', apartmentsAndUnitsForSale?: number | null, blockOfUnitsForSale?: number | null, duplexesForSale?: number | null, housesForSale?: number | null, penthousesForSale?: number | null, semiDetachedHousesForSale?: number | null, studiosForSale?: number | null, terracedHousesForSale?: number | null, townhousesForSale?: number | null, villasForSale?: number | null, apartmentsAndUnitsForRent?: number | null, duplexesForRent?: number | null, housesForRent?: number | null, penthousesForRent?: number | null, semiDetachedHousesForRent?: number | null, studiosForRent?: number | null, terracedHousesForRent?: number | null, townhousesForRent?: number | null, villasForRent?: number | null } } | null> | null };

export type GetContactIdProfileCardQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetContactIdProfileCardQuery = { __typename?: 'Query', contactByContactId?: { __typename: 'Contact', contactId?: number | null, id: string, agentIdV2: string, agencyId: number, name?: string | null, jobTitle?: string | null, hasEmail?: boolean | null, telephone?: string | null, mobile?: string | null, profileTier?: string | null, profileUrl?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, averageSoldPrice?: number | null, averageDaysOnMarket?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, name?: string | null, branding?: { __typename?: 'AgencyBranding', id: string, logoColour?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null } | null, recommendations?: { __typename?: 'ContactRecommendations', overallStarRating?: number | null, numberOfReviews?: number | null } | null } | null };

export type ContactProfileCardFragment = { __typename: 'Contact', contactId?: number | null, id: string, agentIdV2: string, agencyId: number, name?: string | null, jobTitle?: string | null, hasEmail?: boolean | null, telephone?: string | null, mobile?: string | null, profileTier?: string | null, profileUrl?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, averageSoldPrice?: number | null, averageDaysOnMarket?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, name?: string | null, branding?: { __typename?: 'AgencyBranding', id: string, logoColour?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null } | null, recommendations?: { __typename?: 'ContactRecommendations', overallStarRating?: number | null, numberOfReviews?: number | null } | null };

export type GetContactProfileCardQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
  imageFormat?: InputMaybe<ImageFormat>;
}>;


export type GetContactProfileCardQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename: 'Contact', contactId?: number | null, id: string, agentIdV2: string, agencyId: number, name?: string | null, jobTitle?: string | null, hasEmail?: boolean | null, telephone?: string | null, mobile?: string | null, profileTier?: string | null, profileUrl?: string | null, profilePhoto?: { __typename?: 'Image', url: string } | null, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, averageSoldPrice?: number | null, averageDaysOnMarket?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null, agencyByAgencyId?: { __typename?: 'Agency', id: string, agencyId: number, name?: string | null, branding?: { __typename?: 'AgencyBranding', id: string, logoColour?: string | null, logo?: { __typename?: 'Image', url: string } | null } | null } | null, recommendations?: { __typename?: 'ContactRecommendations', overallStarRating?: number | null, numberOfReviews?: number | null } | null } | null };

export type TestimonialsFragment = { __typename?: 'Contact', id: string, testimonials?: Array<{ __typename?: 'ContactTestimonial', testimonial: string, author: string, dateAuthored: string } | null> | null };

export type GetContactTestimonialsQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
}>;


export type GetContactTestimonialsQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, testimonials?: Array<{ __typename?: 'ContactTestimonial', testimonial: string, author: string, dateAuthored: string } | null> | null } | null };

export type AgencyTopSummaryFragment = { __typename?: 'Agency', id: string, statistics?: { __typename?: 'AgencyStatistics', id: string, forSale?: number | null, soldTotal?: number | null, forRent?: number | null, leased?: number | null } | null };

export type GetAgencyTopSummaryQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type GetAgencyTopSummaryQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, statistics?: { __typename?: 'AgencyStatistics', id: string, forSale?: number | null, soldTotal?: number | null, forRent?: number | null, leased?: number | null } | null } | null };

export type GetContactIdTopSummaryQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type GetContactIdTopSummaryQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null } | null };

export type ContactTopSummaryFragment = { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null };

export type GetContactTopSummaryQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
}>;


export type GetContactTopSummaryQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, statistics?: { __typename?: 'ContactStatistics', id: string, totalForSale?: number | null, totalSoldAndAuctioned?: number | null, totalJointSoldAndAuctioned?: number | null, totalForRent?: number | null, totalLeased?: number | null, totalJointLeased?: number | null } | null } | null };

export type AgencyVideoFragment = { __typename: 'Agency', id: string, agencyVideoUrl?: string | null };

export type GetAgencyVideoQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
}>;


export type GetAgencyVideoQuery = { __typename?: 'Query', agency?: { __typename: 'Agency', id: string, agencyVideoUrl?: string | null } | null };

export type GetContactIdVideoQueryVariables = Exact<{
  contactId: Scalars['Int']['input'];
}>;


export type GetContactIdVideoQuery = { __typename?: 'Query', contactByContactId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, agentVideoUrl?: string | null } | null };

export type ContactVideoFragment = { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, agentVideoUrl?: string | null };

export type GetContactVideoQueryVariables = Exact<{
  agencyId: Scalars['Int']['input'];
  agentIdV2: Scalars['String']['input'];
}>;


export type GetContactVideoQuery = { __typename?: 'Query', contactByAgencyIdAndAgentId?: { __typename?: 'Contact', id: string, agentIdV2: string, agencyId: number, agentVideoUrl?: string | null } | null };

export type ShortlistQueryVariables = Exact<{ [key: string]: never; }>;


export type ShortlistQuery = { __typename?: 'Query', me?: { __typename?: 'User', shortlist?: Array<{ __typename?: 'Listing', id: string, listingId: number }> | null } | null };

export type SaveToShortlistMutationVariables = Exact<{
  adIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SaveToShortlistMutation = { __typename?: 'Mutation', saveShortlistListing?: boolean | null };

export type RemoveFromShortlistMutationVariables = Exact<{
  adIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RemoveFromShortlistMutation = { __typename?: 'Mutation', removeShortlistListing?: boolean | null };

export type PushToGroupStatsMutationMutationVariables = Exact<{
  groupStats: GroupStatsStat;
}>;


export type PushToGroupStatsMutationMutation = { __typename?: 'Mutation', postStat: string };

export const AgencyAboutSectionFragmentDoc = gql`
    fragment AgencyAboutSection on Agency {
  __typename
  id
  name
  description
  hasReinswBadge
  profileTier
  address {
    displayAddress
    suburb {
      suburbId
      name
    }
  }
  statistics {
    id
    forSale
    soldTotal
    forRent
    leased
  }
}
    `;
export const ListingCardFragmentDoc = gql`
    fragment ListingCard on Listing {
  id
  listingId
  promoLevel
  seoUrl
  isRural
  priceDetails {
    displayPrice
  }
  address {
    displayAddress
    street
    suburb {
      name
      suburbId
    }
    state
    postcode
    geolocation {
      latitude
      longitude
    }
  }
  inspectionDetails {
    inspections {
      openingDateTime
      closingDateTime
    }
  }
  parkingSpaces
  bedrooms
  bathrooms
  landArea(unit: SQUARE_METERS)
  propertyTypes
  media {
    __typename
    ... on Image {
      type
      url(resolution: {width: 660, height: 440}, imageFormat: $imageFormat, quality: $quality)
    }
  }
}
    `;
export const ContactAboutSectionFragmentDoc = gql`
    fragment ContactAboutSection on Contact {
  __typename
  id
  agentIdV2
  agencyId
  name
  profileText
  profileTier
  hasReinsw
  agencyName
  agencyByAgencyId {
    id
    agencyId
    address {
      displayAddress
    }
  }
  statistics {
    id
    totalSold
    totalLeased
    totalAuctioned
    totalForSale
  }
  nextInspectionByContact {
    listingByAdId {
      ...ListingCard
    }
  }
}
    ${ListingCardFragmentDoc}`;
export const AgencyEnquiryFormSectionFragmentDoc = gql`
    fragment AgencyEnquiryFormSection on Agency {
  __typename
  id
  agencyId
  name
  contactDetails {
    general {
      email
    }
  }
}
    `;
export const AgencyEnquiryFormUserDetailsPrefillFragmentDoc = gql`
    fragment AgencyEnquiryFormUserDetailsPrefill on User {
  __typename
  id
  firstName
  lastName
  email
}
    `;
export const AgencySearchProfileCardFragmentDoc = gql`
    fragment AgencySearchProfileCard on AgencySearchAgency {
  id
  name
  displayAddress
  profileTier
  brandColour
  logoSmall
  profileUrl
  mobile
  telephone
  email
  hideOfficeLocation
  totalForSale
  totalSoldAndAuctioned
  totalLeased
  totalForRent
  agents {
    name
    profileUrl
    profilePhoto
  }
  reputation {
    numberOfReviews
    overallStarRating
    overallStarRatingRecent
    numberOfReviewsRecent
  }
}
    `;
export const AgencyProfileMapFragmentFragmentDoc = gql`
    fragment AgencyProfileMapFragment on Agency {
  __typename
  id
  name
  address {
    __typename
    displayAddress
    geolocation {
      latitude
      longitude
    }
  }
  branding {
    id
    logoColour
    logo {
      url(imageFormat: $imageFormat)
    }
  }
}
    `;
export const AgencyRecommendationsFragmentDoc = gql`
    fragment AgencyRecommendations on Agency {
  id
  name
  agencyId
  recommendations {
    subscribed
    showRMAReviews
    numberOfReviews
    overallStarRating
    agencyProfileUrl
    lastUpdated
    reviews {
      title
      description
      reviewedOn
      reviewerName
      reviewType
      starRating
      isRecommended
      agentReviewTrackingPixelUrl
      agencyReviewTrackingPixelUrl
      reviewUrl
      propertyType
      bedrooms
      bathrooms
      carparks
      streetAddress
      suburb
      state
      postCode
    }
  }
}
    `;
export const ContactEnquiryFormFragmentDoc = gql`
    fragment ContactEnquiryForm on Contact {
  __typename
  id
  name
  hasEmail
  profilePhoto {
    url(imageFormat: $imageFormat)
  }
}
    `;
export const ContactProfileCardFragmentDoc = gql`
    fragment ContactProfileCard on Contact {
  contactId
  id
  agentIdV2
  agencyId
  name
  jobTitle
  hasEmail
  telephone
  mobile
  profileTier
  profileUrl
  profilePhoto {
    url(imageFormat: $imageFormat)
  }
  statistics {
    id
    totalForSale
    averageSoldPrice
    averageDaysOnMarket
    totalSoldAndAuctioned
    totalJointSoldAndAuctioned
    totalForRent
    totalLeased
    totalJointLeased
  }
  agencyByAgencyId {
    id
    agencyId
    name
    branding {
      id
      logo {
        url(imageFormat: $imageFormat)
      }
      logoColour
    }
  }
  recommendations {
    overallStarRating
    numberOfReviews
  }
  ...ContactEnquiryForm
}
    ${ContactEnquiryFormFragmentDoc}`;
export const AgencyTeamFragmentDoc = gql`
    fragment AgencyTeam on Agency {
  id
  agencyId
  contacts(page: 1, pageSize: 500) {
    contactId
    agentIdV2
    ...ContactProfileCard
  }
}
    ${ContactProfileCardFragmentDoc}`;
export const AppraisalCtaFragmentDoc = gql`
    fragment AppraisalCTA on Contact {
  id
  agencyId
  agentIdV2
  name
  profilePhoto {
    url(imageFormat: $imageFormat)
  }
}
    `;
export const ContactSearchProfileCardFragmentDoc = gql`
    fragment ContactSearchProfileCard on ContactSearchContact {
  id
  agentIdV2
  agencyId
  name
  jobTitle
  jobCategory
  hasEmail
  telephone
  mobile
  profileTier
  profileUrl
  profilePhoto
  totalForSale
  averageSoldPrice
  averageSoldDaysOnMarket
  totalSoldAndAuctioned
  totalJointSoldAndAuctioned
  totalForRent
  totalLeased
  totalJointLeased
  agencyName
  agencyLogoUrl
  brandColour
  reputation {
    numberOfReviews
    overallStarRating
    overallStarRatingRecent
    numberOfReviewsRecent
  }
}
    `;
export const ContactRecommendationsFragmentDoc = gql`
    fragment ContactRecommendations on Contact {
  id
  firstName
  agentIdV2
  agencyId
  recommendations {
    subscribed
    showRMAReviews
    numberOfReviews
    overallStarRating
    reviews {
      title
      description
      reviewedOn
      reviewerName
      reviewType
      starRating
      isRecommended
      agentReviewTrackingPixelUrl
      agencyReviewTrackingPixelUrl
      reviewUrl
      propertyType
      bedrooms
      bathrooms
      carparks
      streetAddress
      suburb
      state
      postCode
    }
    lastUpdated
    agentProfileUrl
    agenciesAllSubscribed
  }
}
    `;
export const AgencyListingsStoryFragmentDoc = gql`
    fragment AgencyListingsStory on Agency {
  id
  name
  hideOfficeLocation
  address {
    displayAddress
  }
  statistics {
    id
    forSale
    sold
    forRent
    leased
    auctioned
  }
}
    `;
export const ContactListingsStoryFragmentDoc = gql`
    fragment ContactListingsStory on Contact {
  id
  agentIdV2
  agencyId
  name
  agencyName
  hideOfficeLocation
  agencyByAgencyId {
    id
    agencyId
    address {
      displayAddress
    }
  }
  statistics {
    id
    totalForSale
    totalForRent
    totalLeased
    totalAuctioned
    totalSold
  }
}
    `;
export const CurrentListingCardFragmentDoc = gql`
    fragment CurrentListingCard on AgentsearchListing {
  id
  listingId
  soldInfo {
    soldDate
    soldPrice
    soldMethod
  }
  priceDetails {
    displayPrice
  }
  media {
    ... on Image {
      url(resolution: {width: 395, height: 225}, imageFormat: $imageFormat, quality: $quality)
    }
  }
  bedrooms
  bathrooms
  parkingSpaces
  isRural
  url
  seoUrl
  listingSlug
  propertyId
  address {
    displayAddress
    suburb {
      name
      suburbId
    }
    state
    postcode
    geolocation {
      latitude
      longitude
    }
  }
}
    `;
export const AgentListingsTabFragmentDoc = gql`
    fragment AgentListingsTab on AgentsearchListingResults {
  total
  totalPages
  results {
    saleType
    listing {
      ...CurrentListingCard
    }
  }
}
    ${CurrentListingCardFragmentDoc}`;
export const ContactListingsTabFragmentDoc = gql`
    fragment ContactListingsTab on AgentsearchListingResults {
  total
  totalPages
  results {
    saleType
    listing {
      ...CurrentListingCard
    }
  }
}
    ${CurrentListingCardFragmentDoc}`;
export const AgencyFooterFragmentDoc = gql`
    fragment AgencyFooter on Agency {
  id
  address {
    displayAddress
    suburb {
      suburbId
      name
      slug
    }
  }
}
    `;
export const ContactFooterFragmentDoc = gql`
    fragment ContactFooter on Contact {
  id
  address {
    displayAddress
    suburb {
      suburbId
      name
      slug
    }
  }
}
    `;
export const SearchResultsFooterFragmentDoc = gql`
    fragment SearchResultsFooter on LocationProfile {
  id
  suburbName
  urlSlug
  surroundingSuburbs {
    name
    urlSlug
  }
  data {
    apartmentsAndUnitsForSale
    blockOfUnitsForSale
    duplexesForSale
    housesForSale
    penthousesForSale
    semiDetachedHousesForSale
    studiosForSale
    terracedHousesForSale
    townhousesForSale
    villasForSale
    apartmentsAndUnitsForRent
    duplexesForRent
    housesForRent
    penthousesForRent
    semiDetachedHousesForRent
    studiosForRent
    terracedHousesForRent
    townhousesForRent
    villasForRent
  }
}
    `;
export const AgencyDigitalDataFragmentDoc = gql`
    fragment AgencyDigitalData on Agency {
  agencyId
  name
  profileUrl
  branding {
    id
    logo {
      url(imageFormat: $imageFormat)
    }
    hero {
      url(imageFormat: $imageFormat)
    }
  }
  address {
    suburb {
      name
      postcode
      state
      suburbId
    }
    displayAddress
  }
  activeSuburbs {
    suburbName
  }
  profileTier
  depthTier
}
    `;
export const ContactDigitalDataFragmentDoc = gql`
    fragment ContactDigitalData on Contact {
  id
  agencyId
  agentIdV2
  agencyName
  agencyByAgencyId {
    id
    agencyId
    activeSuburbs {
      suburbName
    }
    address {
      suburb {
        name
        postcode
        state
        suburbId
      }
      displayAddress
    }
    branding {
      id
      logo {
        url(imageFormat: $imageFormat)
      }
      hero {
        url(imageFormat: $imageFormat)
      }
    }
    profileUrl
  }
  name
  address {
    suburb {
      name
      postcode
      state
      suburbId
    }
    displayAddress
  }
  profileTier
  depthTier
  profilePhoto {
    url(imageFormat: $imageFormat)
  }
  profileUrl
  agencyLogo
  jobTitle
  statistics {
    id
    totalForSale
    totalSoldAndAuctioned
    totalForRent
    totalLeased
    totalAuctioned
    totalSold
  }
}
    `;
export const AgencyHeaderFragmentDoc = gql`
    fragment AgencyHeader on Agency {
  id
  agencyId
  profileTier
  profileUrl
  name
  address {
    displayAddress
    state
    suburb {
      id
      suburbId
      name
      slug
    }
    postcode
  }
}
    `;
export const ContactHeaderFragmentDoc = gql`
    fragment ContactHeader on Contact {
  id
  agentIdV2
  agencyId
  name
  profileUrl
  profileTier
  address {
    displayAddress
    suburb {
      id
      suburbId
      name
      slug
    }
  }
  statistics {
    totalForSale
    totalSoldAndAuctioned
    totalForRent
    totalLeased
  }
}
    `;
export const AgencyHeroFragmentDoc = gql`
    fragment AgencyHero on Agency {
  id
  profileTier
  name
  contactDetails {
    general {
      mobile
      phone
      email
    }
  }
  address {
    displayAddress
  }
  hideOfficeLocation
  facebookUrl
  twitterUrl
  instagramUrl
  linkedInUrl
  youtubeChannelUrl
  website
  branding {
    backgroundColour
    logo {
      url(imageFormat: $imageFormat)
    }
    hero {
      url(imageFormat: $imageFormat)
    }
  }
}
    `;
export const ContactHeroFragmentDoc = gql`
    fragment ContactHero on Contact {
  id
  agentIdV2
  agencyId
  name
  agencyName
  jobCategory
  telephone
  mobile
  hasEmail
  address {
    displayAddress
  }
  profilePhoto {
    url(imageFormat: $imageFormat)
  }
  agencyLogo
  agencyUrlPath
  agencyByAgencyId {
    hideOfficeLocation
    branding {
      backgroundColour
      logo {
        url(imageFormat: $imageFormat)
      }
      hero {
        url(imageFormat: $imageFormat)
      }
    }
    youtubeChannelUrl
    website
  }
  facebookUrl
  twitterUrl
  linkedInUrl
  instagramUrl
  youTubeChannelUrl
  agentVideoUrl
  personalWebsiteUrl
  profileTier
}
    `;
export const AgencySalesStatisticsStoryFragmentDoc = gql`
    fragment AgencySalesStatisticsStory on Agency {
  id
  name
  profileUrl
  showTabSoldLastYear
  suburbStatistics {
    averageDaysOnMarket
    averageSoldPrice
    totalSaleAmount
    total
    salesType {
      sold
      auction
    }
    listingType {
      apartment
      house
      land
      rural
    }
    topListing {
      soldPrice
      daysOnMarket
      soldDate
      displayableAddress
      bedrooms
      listingType
      salesType
      state
      postcode
      adId
    }
  }
  activeSuburbs {
    suburbName
    salesType
    listingCount
    suburbSlug
  }
}
    `;
export const ContactSalesStatisticsStoryFragmentDoc = gql`
    fragment ContactSalesStatisticsStory on Contact {
  id
  agentIdV2
  agencyId
  name
  agencyName
  agencyUrlPath
  isHideSoldLeasedListings
  suburbStatistics {
    averageDaysOnMarket
    averageSoldPrice
    totalSaleAmount
    total
    salesType {
      sold
      auction
    }
    listingType {
      apartment
      house
      land
      rural
    }
    topListing {
      soldPrice
      daysOnMarket
      soldDate
      displayableAddress
      bedrooms
      listingType
      salesType
      state
      postcode
      adId
    }
    coWorkerContacts {
      id
      isActiveProfilePage
    }
    coWorkerListingCount
  }
  activeSuburbs {
    suburbName
    suburbSlug
    listingCount
  }
  agencyByAgencyId {
    id
    agencyId
    showTabSoldLastYear
    contacts {
      name
      agentIdV2
      profileUrl
    }
  }
}
    `;
export const SuburbStatisticsFragmentDoc = gql`
    fragment SuburbStatistics on SuburbSoldStatistics {
  averageDaysOnMarket
  averageSoldPrice
  totalSaleAmount
  total
  salesType {
    sold
    auction
  }
  listingType {
    apartment
    house
    land
    rural
  }
  listingTypeAverage {
    apartment
    house
    land
    rural
  }
}
    `;
export const AgencyProfileSalesStatisticsFragmentDoc = gql`
    fragment AgencyProfileSalesStatistics on Agency {
  id
  showTabSoldLastYear
  activeSuburbs {
    suburbName
    suburbSlug
    listingCount
  }
  suburbStatistics {
    ...SuburbStatistics
  }
}
    ${SuburbStatisticsFragmentDoc}`;
export const ContactProfileSalesStatisticsFragmentDoc = gql`
    fragment ContactProfileSalesStatistics on Contact {
  id
  agencyId
  agentIdV2
  isHideSoldLeasedListings
  agencyByAgencyId {
    showTabSoldLastYear
  }
  activeSuburbs {
    suburbName
    suburbSlug
    listingCount
  }
  suburbStatistics {
    ...SuburbStatistics
  }
}
    ${SuburbStatisticsFragmentDoc}`;
export const TestimonialsFragmentDoc = gql`
    fragment Testimonials on Contact {
  id
  testimonials {
    testimonial
    author
    dateAuthored
  }
}
    `;
export const AgencyTopSummaryFragmentDoc = gql`
    fragment AgencyTopSummary on Agency {
  id
  statistics {
    id
    forSale
    soldTotal
    forRent
    leased
  }
}
    `;
export const ContactTopSummaryFragmentDoc = gql`
    fragment ContactTopSummary on Contact {
  id
  agentIdV2
  agencyId
  statistics {
    id
    totalForSale
    totalSoldAndAuctioned
    totalJointSoldAndAuctioned
    totalForRent
    totalLeased
    totalJointLeased
  }
}
    `;
export const AgencyVideoFragmentDoc = gql`
    fragment AgencyVideo on Agency {
  __typename
  id
  agencyVideoUrl
}
    `;
export const ContactVideoFragmentDoc = gql`
    fragment ContactVideo on Contact {
  id
  agentIdV2
  agencyId
  agentVideoUrl
}
    `;
export const AgencyAboutSectionDocument = gql`
    query agencyAboutSection($agencyId: Int) {
  agency(agencyId: $agencyId) {
    ...AgencyAboutSection
  }
}
    ${AgencyAboutSectionFragmentDoc}`;

/**
 * __useAgencyAboutSectionQuery__
 *
 * To run a query within a React component, call `useAgencyAboutSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyAboutSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyAboutSectionQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencyAboutSectionQuery(baseOptions?: Apollo.QueryHookOptions<AgencyAboutSectionQuery, AgencyAboutSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyAboutSectionQuery, AgencyAboutSectionQueryVariables>(AgencyAboutSectionDocument, options);
      }
export function useAgencyAboutSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyAboutSectionQuery, AgencyAboutSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyAboutSectionQuery, AgencyAboutSectionQueryVariables>(AgencyAboutSectionDocument, options);
        }
export function useAgencyAboutSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencyAboutSectionQuery, AgencyAboutSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencyAboutSectionQuery, AgencyAboutSectionQueryVariables>(AgencyAboutSectionDocument, options);
        }
export type AgencyAboutSectionQueryHookResult = ReturnType<typeof useAgencyAboutSectionQuery>;
export type AgencyAboutSectionLazyQueryHookResult = ReturnType<typeof useAgencyAboutSectionLazyQuery>;
export type AgencyAboutSectionSuspenseQueryHookResult = ReturnType<typeof useAgencyAboutSectionSuspenseQuery>;
export type AgencyAboutSectionQueryResult = Apollo.QueryResult<AgencyAboutSectionQuery, AgencyAboutSectionQueryVariables>;
export const ContactAboutSectionDocument = gql`
    query contactAboutSection($contactId: Int!, $imageFormat: ImageFormat, $quality: Int) {
  contactByContactId(contactId: $contactId) {
    ...ContactAboutSection
  }
}
    ${ContactAboutSectionFragmentDoc}`;

/**
 * __useContactAboutSectionQuery__
 *
 * To run a query within a React component, call `useContactAboutSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAboutSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAboutSectionQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      imageFormat: // value for 'imageFormat'
 *      quality: // value for 'quality'
 *   },
 * });
 */
export function useContactAboutSectionQuery(baseOptions: Apollo.QueryHookOptions<ContactAboutSectionQuery, ContactAboutSectionQueryVariables> & ({ variables: ContactAboutSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAboutSectionQuery, ContactAboutSectionQueryVariables>(ContactAboutSectionDocument, options);
      }
export function useContactAboutSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAboutSectionQuery, ContactAboutSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAboutSectionQuery, ContactAboutSectionQueryVariables>(ContactAboutSectionDocument, options);
        }
export function useContactAboutSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAboutSectionQuery, ContactAboutSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAboutSectionQuery, ContactAboutSectionQueryVariables>(ContactAboutSectionDocument, options);
        }
export type ContactAboutSectionQueryHookResult = ReturnType<typeof useContactAboutSectionQuery>;
export type ContactAboutSectionLazyQueryHookResult = ReturnType<typeof useContactAboutSectionLazyQuery>;
export type ContactAboutSectionSuspenseQueryHookResult = ReturnType<typeof useContactAboutSectionSuspenseQuery>;
export type ContactAboutSectionQueryResult = Apollo.QueryResult<ContactAboutSectionQuery, ContactAboutSectionQueryVariables>;
export const AgencyEnquiryFormDocument = gql`
    query agencyEnquiryForm($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    ...AgencyEnquiryFormSection
  }
}
    ${AgencyEnquiryFormSectionFragmentDoc}`;

/**
 * __useAgencyEnquiryFormQuery__
 *
 * To run a query within a React component, call `useAgencyEnquiryFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyEnquiryFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyEnquiryFormQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencyEnquiryFormQuery(baseOptions: Apollo.QueryHookOptions<AgencyEnquiryFormQuery, AgencyEnquiryFormQueryVariables> & ({ variables: AgencyEnquiryFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyEnquiryFormQuery, AgencyEnquiryFormQueryVariables>(AgencyEnquiryFormDocument, options);
      }
export function useAgencyEnquiryFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyEnquiryFormQuery, AgencyEnquiryFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyEnquiryFormQuery, AgencyEnquiryFormQueryVariables>(AgencyEnquiryFormDocument, options);
        }
export function useAgencyEnquiryFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencyEnquiryFormQuery, AgencyEnquiryFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencyEnquiryFormQuery, AgencyEnquiryFormQueryVariables>(AgencyEnquiryFormDocument, options);
        }
export type AgencyEnquiryFormQueryHookResult = ReturnType<typeof useAgencyEnquiryFormQuery>;
export type AgencyEnquiryFormLazyQueryHookResult = ReturnType<typeof useAgencyEnquiryFormLazyQuery>;
export type AgencyEnquiryFormSuspenseQueryHookResult = ReturnType<typeof useAgencyEnquiryFormSuspenseQuery>;
export type AgencyEnquiryFormQueryResult = Apollo.QueryResult<AgencyEnquiryFormQuery, AgencyEnquiryFormQueryVariables>;
export const AgencyEnquiryFormUserPrefillDocument = gql`
    query agencyEnquiryFormUserPrefill {
  me {
    ...AgencyEnquiryFormUserDetailsPrefill
  }
}
    ${AgencyEnquiryFormUserDetailsPrefillFragmentDoc}`;

/**
 * __useAgencyEnquiryFormUserPrefillQuery__
 *
 * To run a query within a React component, call `useAgencyEnquiryFormUserPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyEnquiryFormUserPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyEnquiryFormUserPrefillQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgencyEnquiryFormUserPrefillQuery(baseOptions?: Apollo.QueryHookOptions<AgencyEnquiryFormUserPrefillQuery, AgencyEnquiryFormUserPrefillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyEnquiryFormUserPrefillQuery, AgencyEnquiryFormUserPrefillQueryVariables>(AgencyEnquiryFormUserPrefillDocument, options);
      }
export function useAgencyEnquiryFormUserPrefillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyEnquiryFormUserPrefillQuery, AgencyEnquiryFormUserPrefillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyEnquiryFormUserPrefillQuery, AgencyEnquiryFormUserPrefillQueryVariables>(AgencyEnquiryFormUserPrefillDocument, options);
        }
export function useAgencyEnquiryFormUserPrefillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencyEnquiryFormUserPrefillQuery, AgencyEnquiryFormUserPrefillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencyEnquiryFormUserPrefillQuery, AgencyEnquiryFormUserPrefillQueryVariables>(AgencyEnquiryFormUserPrefillDocument, options);
        }
export type AgencyEnquiryFormUserPrefillQueryHookResult = ReturnType<typeof useAgencyEnquiryFormUserPrefillQuery>;
export type AgencyEnquiryFormUserPrefillLazyQueryHookResult = ReturnType<typeof useAgencyEnquiryFormUserPrefillLazyQuery>;
export type AgencyEnquiryFormUserPrefillSuspenseQueryHookResult = ReturnType<typeof useAgencyEnquiryFormUserPrefillSuspenseQuery>;
export type AgencyEnquiryFormUserPrefillQueryResult = Apollo.QueryResult<AgencyEnquiryFormUserPrefillQuery, AgencyEnquiryFormUserPrefillQueryVariables>;
export const GetAgencyProfileRatingDocument = gql`
    query GetAgencyProfileRating($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    id
    depthTier
    recommendations {
      overallStarRating
      numberOfReviews
    }
  }
}
    `;

/**
 * __useGetAgencyProfileRatingQuery__
 *
 * To run a query within a React component, call `useGetAgencyProfileRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyProfileRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyProfileRatingQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetAgencyProfileRatingQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyProfileRatingQuery, GetAgencyProfileRatingQueryVariables> & ({ variables: GetAgencyProfileRatingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyProfileRatingQuery, GetAgencyProfileRatingQueryVariables>(GetAgencyProfileRatingDocument, options);
      }
export function useGetAgencyProfileRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyProfileRatingQuery, GetAgencyProfileRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyProfileRatingQuery, GetAgencyProfileRatingQueryVariables>(GetAgencyProfileRatingDocument, options);
        }
export function useGetAgencyProfileRatingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileRatingQuery, GetAgencyProfileRatingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyProfileRatingQuery, GetAgencyProfileRatingQueryVariables>(GetAgencyProfileRatingDocument, options);
        }
export type GetAgencyProfileRatingQueryHookResult = ReturnType<typeof useGetAgencyProfileRatingQuery>;
export type GetAgencyProfileRatingLazyQueryHookResult = ReturnType<typeof useGetAgencyProfileRatingLazyQuery>;
export type GetAgencyProfileRatingSuspenseQueryHookResult = ReturnType<typeof useGetAgencyProfileRatingSuspenseQuery>;
export type GetAgencyProfileRatingQueryResult = Apollo.QueryResult<GetAgencyProfileRatingQuery, GetAgencyProfileRatingQueryVariables>;
export const AgencyRecommendationPaginationByAgencyIdDocument = gql`
    query agencyRecommendationPaginationByAgencyId($agencyId: Int!, $pageSize: Int, $pageNumber: Int) {
  agency(agencyId: $agencyId) {
    recommendations(pageSize: $pageSize, pageNumber: $pageNumber) {
      agencyProfileUrl
      reviews {
        title
        description
        reviewedOn
        reviewType
        starRating
        agentReviewTrackingPixelUrl
        agencyReviewTrackingPixelUrl
        reviewUrl
        bedrooms
        bathrooms
        carparks
        streetAddress
        suburb
        state
        postCode
      }
    }
  }
}
    `;

/**
 * __useAgencyRecommendationPaginationByAgencyIdQuery__
 *
 * To run a query within a React component, call `useAgencyRecommendationPaginationByAgencyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyRecommendationPaginationByAgencyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyRecommendationPaginationByAgencyIdQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useAgencyRecommendationPaginationByAgencyIdQuery(baseOptions: Apollo.QueryHookOptions<AgencyRecommendationPaginationByAgencyIdQuery, AgencyRecommendationPaginationByAgencyIdQueryVariables> & ({ variables: AgencyRecommendationPaginationByAgencyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyRecommendationPaginationByAgencyIdQuery, AgencyRecommendationPaginationByAgencyIdQueryVariables>(AgencyRecommendationPaginationByAgencyIdDocument, options);
      }
export function useAgencyRecommendationPaginationByAgencyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyRecommendationPaginationByAgencyIdQuery, AgencyRecommendationPaginationByAgencyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyRecommendationPaginationByAgencyIdQuery, AgencyRecommendationPaginationByAgencyIdQueryVariables>(AgencyRecommendationPaginationByAgencyIdDocument, options);
        }
export function useAgencyRecommendationPaginationByAgencyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencyRecommendationPaginationByAgencyIdQuery, AgencyRecommendationPaginationByAgencyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencyRecommendationPaginationByAgencyIdQuery, AgencyRecommendationPaginationByAgencyIdQueryVariables>(AgencyRecommendationPaginationByAgencyIdDocument, options);
        }
export type AgencyRecommendationPaginationByAgencyIdQueryHookResult = ReturnType<typeof useAgencyRecommendationPaginationByAgencyIdQuery>;
export type AgencyRecommendationPaginationByAgencyIdLazyQueryHookResult = ReturnType<typeof useAgencyRecommendationPaginationByAgencyIdLazyQuery>;
export type AgencyRecommendationPaginationByAgencyIdSuspenseQueryHookResult = ReturnType<typeof useAgencyRecommendationPaginationByAgencyIdSuspenseQuery>;
export type AgencyRecommendationPaginationByAgencyIdQueryResult = Apollo.QueryResult<AgencyRecommendationPaginationByAgencyIdQuery, AgencyRecommendationPaginationByAgencyIdQueryVariables>;
export const AgencyByAgencyIdDocument = gql`
    query agencyByAgencyId($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    id
    ...AgencyRecommendations
  }
}
    ${AgencyRecommendationsFragmentDoc}`;

/**
 * __useAgencyByAgencyIdQuery__
 *
 * To run a query within a React component, call `useAgencyByAgencyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyByAgencyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyByAgencyIdQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencyByAgencyIdQuery(baseOptions: Apollo.QueryHookOptions<AgencyByAgencyIdQuery, AgencyByAgencyIdQueryVariables> & ({ variables: AgencyByAgencyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyByAgencyIdQuery, AgencyByAgencyIdQueryVariables>(AgencyByAgencyIdDocument, options);
      }
export function useAgencyByAgencyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyByAgencyIdQuery, AgencyByAgencyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyByAgencyIdQuery, AgencyByAgencyIdQueryVariables>(AgencyByAgencyIdDocument, options);
        }
export function useAgencyByAgencyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencyByAgencyIdQuery, AgencyByAgencyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencyByAgencyIdQuery, AgencyByAgencyIdQueryVariables>(AgencyByAgencyIdDocument, options);
        }
export type AgencyByAgencyIdQueryHookResult = ReturnType<typeof useAgencyByAgencyIdQuery>;
export type AgencyByAgencyIdLazyQueryHookResult = ReturnType<typeof useAgencyByAgencyIdLazyQuery>;
export type AgencyByAgencyIdSuspenseQueryHookResult = ReturnType<typeof useAgencyByAgencyIdSuspenseQuery>;
export type AgencyByAgencyIdQueryResult = Apollo.QueryResult<AgencyByAgencyIdQuery, AgencyByAgencyIdQueryVariables>;
export const GetAgencyTeamDocument = gql`
    query getAgencyTeam($agencyId: Int!, $imageFormat: ImageFormat) {
  agency(agencyId: $agencyId) {
    ...AgencyTeam
  }
}
    ${AgencyTeamFragmentDoc}`;

/**
 * __useGetAgencyTeamQuery__
 *
 * To run a query within a React component, call `useGetAgencyTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyTeamQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetAgencyTeamQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyTeamQuery, GetAgencyTeamQueryVariables> & ({ variables: GetAgencyTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>(GetAgencyTeamDocument, options);
      }
export function useGetAgencyTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>(GetAgencyTeamDocument, options);
        }
export function useGetAgencyTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>(GetAgencyTeamDocument, options);
        }
export type GetAgencyTeamQueryHookResult = ReturnType<typeof useGetAgencyTeamQuery>;
export type GetAgencyTeamLazyQueryHookResult = ReturnType<typeof useGetAgencyTeamLazyQuery>;
export type GetAgencyTeamSuspenseQueryHookResult = ReturnType<typeof useGetAgencyTeamSuspenseQuery>;
export type GetAgencyTeamQueryResult = Apollo.QueryResult<GetAgencyTeamQuery, GetAgencyTeamQueryVariables>;
export const GetAgentProfile2026Document = gql`
    query getAgentProfile2026($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    id
    agentIdV2
    agencyId
    name
    agencyName
    agencyUrlPath
    jobCategory
    jobTitle
    hasReinsw
    profileUrl
    recommendations {
      numberOfReviews
      overallStarRating
    }
    agencyByAgencyId {
      id
      name
      profileUrl
      address {
        displayAddress
        suburb {
          id
          suburbId
          name
        }
      }
      branding {
        id
        backgroundColour
        logo {
          url
        }
      }
    }
    address {
      displayAddress
      suburb {
        id
        suburbId
        name
        slug
      }
    }
    statistics {
      totalForSale
      totalSoldAndAuctioned
      totalForRent
      totalLeased
      averageDaysOnMarket
      averageSoldPrice
    }
  }
}
    `;

/**
 * __useGetAgentProfile2026Query__
 *
 * To run a query within a React component, call `useGetAgentProfile2026Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentProfile2026Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentProfile2026Query({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetAgentProfile2026Query(baseOptions: Apollo.QueryHookOptions<GetAgentProfile2026Query, GetAgentProfile2026QueryVariables> & ({ variables: GetAgentProfile2026QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentProfile2026Query, GetAgentProfile2026QueryVariables>(GetAgentProfile2026Document, options);
      }
export function useGetAgentProfile2026LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentProfile2026Query, GetAgentProfile2026QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentProfile2026Query, GetAgentProfile2026QueryVariables>(GetAgentProfile2026Document, options);
        }
export function useGetAgentProfile2026SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentProfile2026Query, GetAgentProfile2026QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentProfile2026Query, GetAgentProfile2026QueryVariables>(GetAgentProfile2026Document, options);
        }
export type GetAgentProfile2026QueryHookResult = ReturnType<typeof useGetAgentProfile2026Query>;
export type GetAgentProfile2026LazyQueryHookResult = ReturnType<typeof useGetAgentProfile2026LazyQuery>;
export type GetAgentProfile2026SuspenseQueryHookResult = ReturnType<typeof useGetAgentProfile2026SuspenseQuery>;
export type GetAgentProfile2026QueryResult = Apollo.QueryResult<GetAgentProfile2026Query, GetAgentProfile2026QueryVariables>;
export const GetContactIdAppraisalCtaDocument = gql`
    query getContactIdAppraisalCTA($contactId: Int!, $imageFormat: ImageFormat) {
  contactByContactId(contactId: $contactId) {
    ...AppraisalCTA
  }
}
    ${AppraisalCtaFragmentDoc}`;

/**
 * __useGetContactIdAppraisalCtaQuery__
 *
 * To run a query within a React component, call `useGetContactIdAppraisalCtaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdAppraisalCtaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdAppraisalCtaQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetContactIdAppraisalCtaQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdAppraisalCtaQuery, GetContactIdAppraisalCtaQueryVariables> & ({ variables: GetContactIdAppraisalCtaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdAppraisalCtaQuery, GetContactIdAppraisalCtaQueryVariables>(GetContactIdAppraisalCtaDocument, options);
      }
export function useGetContactIdAppraisalCtaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdAppraisalCtaQuery, GetContactIdAppraisalCtaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdAppraisalCtaQuery, GetContactIdAppraisalCtaQueryVariables>(GetContactIdAppraisalCtaDocument, options);
        }
export function useGetContactIdAppraisalCtaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdAppraisalCtaQuery, GetContactIdAppraisalCtaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdAppraisalCtaQuery, GetContactIdAppraisalCtaQueryVariables>(GetContactIdAppraisalCtaDocument, options);
        }
export type GetContactIdAppraisalCtaQueryHookResult = ReturnType<typeof useGetContactIdAppraisalCtaQuery>;
export type GetContactIdAppraisalCtaLazyQueryHookResult = ReturnType<typeof useGetContactIdAppraisalCtaLazyQuery>;
export type GetContactIdAppraisalCtaSuspenseQueryHookResult = ReturnType<typeof useGetContactIdAppraisalCtaSuspenseQuery>;
export type GetContactIdAppraisalCtaQueryResult = Apollo.QueryResult<GetContactIdAppraisalCtaQuery, GetContactIdAppraisalCtaQueryVariables>;
export const GetContactAppraisalCtaDocument = gql`
    query getContactAppraisalCTA($agencyId: Int!, $agentIdV2: String!, $imageFormat: ImageFormat) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...AppraisalCTA
  }
}
    ${AppraisalCtaFragmentDoc}`;

/**
 * __useGetContactAppraisalCtaQuery__
 *
 * To run a query within a React component, call `useGetContactAppraisalCtaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactAppraisalCtaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactAppraisalCtaQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetContactAppraisalCtaQuery(baseOptions: Apollo.QueryHookOptions<GetContactAppraisalCtaQuery, GetContactAppraisalCtaQueryVariables> & ({ variables: GetContactAppraisalCtaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactAppraisalCtaQuery, GetContactAppraisalCtaQueryVariables>(GetContactAppraisalCtaDocument, options);
      }
export function useGetContactAppraisalCtaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactAppraisalCtaQuery, GetContactAppraisalCtaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactAppraisalCtaQuery, GetContactAppraisalCtaQueryVariables>(GetContactAppraisalCtaDocument, options);
        }
export function useGetContactAppraisalCtaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactAppraisalCtaQuery, GetContactAppraisalCtaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactAppraisalCtaQuery, GetContactAppraisalCtaQueryVariables>(GetContactAppraisalCtaDocument, options);
        }
export type GetContactAppraisalCtaQueryHookResult = ReturnType<typeof useGetContactAppraisalCtaQuery>;
export type GetContactAppraisalCtaLazyQueryHookResult = ReturnType<typeof useGetContactAppraisalCtaLazyQuery>;
export type GetContactAppraisalCtaSuspenseQueryHookResult = ReturnType<typeof useGetContactAppraisalCtaSuspenseQuery>;
export type GetContactAppraisalCtaQueryResult = Apollo.QueryResult<GetContactAppraisalCtaQuery, GetContactAppraisalCtaQueryVariables>;
export const CreateEnquiryDocument = gql`
    mutation CreateEnquiry($input: EnquiryInput!) {
  createEnquiry(input: $input) {
    s3Key
  }
}
    `;
export type CreateEnquiryMutationFn = Apollo.MutationFunction<CreateEnquiryMutation, CreateEnquiryMutationVariables>;

/**
 * __useCreateEnquiryMutation__
 *
 * To run a mutation, you first call `useCreateEnquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnquiryMutation, { data, loading, error }] = useCreateEnquiryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnquiryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnquiryMutation, CreateEnquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnquiryMutation, CreateEnquiryMutationVariables>(CreateEnquiryDocument, options);
      }
export type CreateEnquiryMutationHookResult = ReturnType<typeof useCreateEnquiryMutation>;
export type CreateEnquiryMutationResult = Apollo.MutationResult<CreateEnquiryMutation>;
export type CreateEnquiryMutationOptions = Apollo.BaseMutationOptions<CreateEnquiryMutation, CreateEnquiryMutationVariables>;
export const GetContactProfileRatingDocument = gql`
    query GetContactProfileRating($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    id
    depthTier
    recommendations {
      overallStarRating
      numberOfReviews
    }
  }
}
    `;

/**
 * __useGetContactProfileRatingQuery__
 *
 * To run a query within a React component, call `useGetContactProfileRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactProfileRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactProfileRatingQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactProfileRatingQuery(baseOptions: Apollo.QueryHookOptions<GetContactProfileRatingQuery, GetContactProfileRatingQueryVariables> & ({ variables: GetContactProfileRatingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactProfileRatingQuery, GetContactProfileRatingQueryVariables>(GetContactProfileRatingDocument, options);
      }
export function useGetContactProfileRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactProfileRatingQuery, GetContactProfileRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactProfileRatingQuery, GetContactProfileRatingQueryVariables>(GetContactProfileRatingDocument, options);
        }
export function useGetContactProfileRatingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactProfileRatingQuery, GetContactProfileRatingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactProfileRatingQuery, GetContactProfileRatingQueryVariables>(GetContactProfileRatingDocument, options);
        }
export type GetContactProfileRatingQueryHookResult = ReturnType<typeof useGetContactProfileRatingQuery>;
export type GetContactProfileRatingLazyQueryHookResult = ReturnType<typeof useGetContactProfileRatingLazyQuery>;
export type GetContactProfileRatingSuspenseQueryHookResult = ReturnType<typeof useGetContactProfileRatingSuspenseQuery>;
export type GetContactProfileRatingQueryResult = Apollo.QueryResult<GetContactProfileRatingQuery, GetContactProfileRatingQueryVariables>;
export const ContactByAgencyIdAndAgentIdPaginationDocument = gql`
    query contactByAgencyIdAndAgentIdPagination($agentIdV2: String!, $agencyId: Int!, $pageSize: Int, $pageNumber: Int) {
  contactByAgencyIdAndAgentId(agentIdV2: $agentIdV2, agencyId: $agencyId) {
    recommendations(pageSize: $pageSize, pageNumber: $pageNumber) {
      agentProfileUrl
      reviews {
        title
        description
        reviewedOn
        reviewType
        starRating
        isRecommended
        agentReviewTrackingPixelUrl
        agencyReviewTrackingPixelUrl
        bedrooms
        bathrooms
        carparks
        streetAddress
        suburb
        state
        postCode
      }
    }
  }
}
    `;

/**
 * __useContactByAgencyIdAndAgentIdPaginationQuery__
 *
 * To run a query within a React component, call `useContactByAgencyIdAndAgentIdPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactByAgencyIdAndAgentIdPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactByAgencyIdAndAgentIdPaginationQuery({
 *   variables: {
 *      agentIdV2: // value for 'agentIdV2'
 *      agencyId: // value for 'agencyId'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useContactByAgencyIdAndAgentIdPaginationQuery(baseOptions: Apollo.QueryHookOptions<ContactByAgencyIdAndAgentIdPaginationQuery, ContactByAgencyIdAndAgentIdPaginationQueryVariables> & ({ variables: ContactByAgencyIdAndAgentIdPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactByAgencyIdAndAgentIdPaginationQuery, ContactByAgencyIdAndAgentIdPaginationQueryVariables>(ContactByAgencyIdAndAgentIdPaginationDocument, options);
      }
export function useContactByAgencyIdAndAgentIdPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactByAgencyIdAndAgentIdPaginationQuery, ContactByAgencyIdAndAgentIdPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactByAgencyIdAndAgentIdPaginationQuery, ContactByAgencyIdAndAgentIdPaginationQueryVariables>(ContactByAgencyIdAndAgentIdPaginationDocument, options);
        }
export function useContactByAgencyIdAndAgentIdPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactByAgencyIdAndAgentIdPaginationQuery, ContactByAgencyIdAndAgentIdPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactByAgencyIdAndAgentIdPaginationQuery, ContactByAgencyIdAndAgentIdPaginationQueryVariables>(ContactByAgencyIdAndAgentIdPaginationDocument, options);
        }
export type ContactByAgencyIdAndAgentIdPaginationQueryHookResult = ReturnType<typeof useContactByAgencyIdAndAgentIdPaginationQuery>;
export type ContactByAgencyIdAndAgentIdPaginationLazyQueryHookResult = ReturnType<typeof useContactByAgencyIdAndAgentIdPaginationLazyQuery>;
export type ContactByAgencyIdAndAgentIdPaginationSuspenseQueryHookResult = ReturnType<typeof useContactByAgencyIdAndAgentIdPaginationSuspenseQuery>;
export type ContactByAgencyIdAndAgentIdPaginationQueryResult = Apollo.QueryResult<ContactByAgencyIdAndAgentIdPaginationQuery, ContactByAgencyIdAndAgentIdPaginationQueryVariables>;
export const ContactByContactIdDocument = gql`
    query contactByContactId($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    id
    ...ContactRecommendations
  }
}
    ${ContactRecommendationsFragmentDoc}`;

/**
 * __useContactByContactIdQuery__
 *
 * To run a query within a React component, call `useContactByContactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactByContactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactByContactIdQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactByContactIdQuery(baseOptions: Apollo.QueryHookOptions<ContactByContactIdQuery, ContactByContactIdQueryVariables> & ({ variables: ContactByContactIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactByContactIdQuery, ContactByContactIdQueryVariables>(ContactByContactIdDocument, options);
      }
export function useContactByContactIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactByContactIdQuery, ContactByContactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactByContactIdQuery, ContactByContactIdQueryVariables>(ContactByContactIdDocument, options);
        }
export function useContactByContactIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactByContactIdQuery, ContactByContactIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactByContactIdQuery, ContactByContactIdQueryVariables>(ContactByContactIdDocument, options);
        }
export type ContactByContactIdQueryHookResult = ReturnType<typeof useContactByContactIdQuery>;
export type ContactByContactIdLazyQueryHookResult = ReturnType<typeof useContactByContactIdLazyQuery>;
export type ContactByContactIdSuspenseQueryHookResult = ReturnType<typeof useContactByContactIdSuspenseQuery>;
export type ContactByContactIdQueryResult = Apollo.QueryResult<ContactByContactIdQuery, ContactByContactIdQueryVariables>;
export const GetAgencyListingsStoryDocument = gql`
    query getAgencyListingsStory($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    ...AgencyListingsStory
  }
}
    ${AgencyListingsStoryFragmentDoc}`;

/**
 * __useGetAgencyListingsStoryQuery__
 *
 * To run a query within a React component, call `useGetAgencyListingsStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyListingsStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyListingsStoryQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetAgencyListingsStoryQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyListingsStoryQuery, GetAgencyListingsStoryQueryVariables> & ({ variables: GetAgencyListingsStoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyListingsStoryQuery, GetAgencyListingsStoryQueryVariables>(GetAgencyListingsStoryDocument, options);
      }
export function useGetAgencyListingsStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyListingsStoryQuery, GetAgencyListingsStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyListingsStoryQuery, GetAgencyListingsStoryQueryVariables>(GetAgencyListingsStoryDocument, options);
        }
export function useGetAgencyListingsStorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyListingsStoryQuery, GetAgencyListingsStoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyListingsStoryQuery, GetAgencyListingsStoryQueryVariables>(GetAgencyListingsStoryDocument, options);
        }
export type GetAgencyListingsStoryQueryHookResult = ReturnType<typeof useGetAgencyListingsStoryQuery>;
export type GetAgencyListingsStoryLazyQueryHookResult = ReturnType<typeof useGetAgencyListingsStoryLazyQuery>;
export type GetAgencyListingsStorySuspenseQueryHookResult = ReturnType<typeof useGetAgencyListingsStorySuspenseQuery>;
export type GetAgencyListingsStoryQueryResult = Apollo.QueryResult<GetAgencyListingsStoryQuery, GetAgencyListingsStoryQueryVariables>;
export const GetContactListingsStoryDocument = gql`
    query getContactListingsStory($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    ...ContactListingsStory
  }
}
    ${ContactListingsStoryFragmentDoc}`;

/**
 * __useGetContactListingsStoryQuery__
 *
 * To run a query within a React component, call `useGetContactListingsStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactListingsStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactListingsStoryQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactListingsStoryQuery(baseOptions: Apollo.QueryHookOptions<GetContactListingsStoryQuery, GetContactListingsStoryQueryVariables> & ({ variables: GetContactListingsStoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactListingsStoryQuery, GetContactListingsStoryQueryVariables>(GetContactListingsStoryDocument, options);
      }
export function useGetContactListingsStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactListingsStoryQuery, GetContactListingsStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactListingsStoryQuery, GetContactListingsStoryQueryVariables>(GetContactListingsStoryDocument, options);
        }
export function useGetContactListingsStorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactListingsStoryQuery, GetContactListingsStoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactListingsStoryQuery, GetContactListingsStoryQueryVariables>(GetContactListingsStoryDocument, options);
        }
export type GetContactListingsStoryQueryHookResult = ReturnType<typeof useGetContactListingsStoryQuery>;
export type GetContactListingsStoryLazyQueryHookResult = ReturnType<typeof useGetContactListingsStoryLazyQuery>;
export type GetContactListingsStorySuspenseQueryHookResult = ReturnType<typeof useGetContactListingsStorySuspenseQuery>;
export type GetContactListingsStoryQueryResult = Apollo.QueryResult<GetContactListingsStoryQuery, GetContactListingsStoryQueryVariables>;
export const AgencyCurrentListingsDocument = gql`
    query agencyCurrentListings($agencyId: Int!, $page: Int!, $suburbId: String, $propertyType: AgencyApiPropertyType, $sortBy: AgentsearchListingsSortBy, $bedrooms: AgentsearchListingBedrooms, $imageFormat: ImageFormat, $quality: Int) {
  agency(agencyId: $agencyId) {
    id
    agentsearchListingsByAgencyId(page: $page, pageSize: 6, listingStatuses: [SOLD, SALE, LEASE, LEASED], propertyType: $propertyType, sortBy: $sortBy, suburbId: $suburbId, bedrooms: $bedrooms) {
      soldListings {
        ...AgentListingsTab
      }
      saleListings {
        ...AgentListingsTab
      }
      leaseListings {
        ...AgentListingsTab
      }
      leasedListings {
        ...AgentListingsTab
      }
    }
  }
}
    ${AgentListingsTabFragmentDoc}`;

/**
 * __useAgencyCurrentListingsQuery__
 *
 * To run a query within a React component, call `useAgencyCurrentListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyCurrentListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyCurrentListingsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      page: // value for 'page'
 *      suburbId: // value for 'suburbId'
 *      propertyType: // value for 'propertyType'
 *      sortBy: // value for 'sortBy'
 *      bedrooms: // value for 'bedrooms'
 *      imageFormat: // value for 'imageFormat'
 *      quality: // value for 'quality'
 *   },
 * });
 */
export function useAgencyCurrentListingsQuery(baseOptions: Apollo.QueryHookOptions<AgencyCurrentListingsQuery, AgencyCurrentListingsQueryVariables> & ({ variables: AgencyCurrentListingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyCurrentListingsQuery, AgencyCurrentListingsQueryVariables>(AgencyCurrentListingsDocument, options);
      }
export function useAgencyCurrentListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyCurrentListingsQuery, AgencyCurrentListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyCurrentListingsQuery, AgencyCurrentListingsQueryVariables>(AgencyCurrentListingsDocument, options);
        }
export function useAgencyCurrentListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencyCurrentListingsQuery, AgencyCurrentListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencyCurrentListingsQuery, AgencyCurrentListingsQueryVariables>(AgencyCurrentListingsDocument, options);
        }
export type AgencyCurrentListingsQueryHookResult = ReturnType<typeof useAgencyCurrentListingsQuery>;
export type AgencyCurrentListingsLazyQueryHookResult = ReturnType<typeof useAgencyCurrentListingsLazyQuery>;
export type AgencyCurrentListingsSuspenseQueryHookResult = ReturnType<typeof useAgencyCurrentListingsSuspenseQuery>;
export type AgencyCurrentListingsQueryResult = Apollo.QueryResult<AgencyCurrentListingsQuery, AgencyCurrentListingsQueryVariables>;
export const ContactCurrentListingsDocument = gql`
    query contactCurrentListings($contactId: Int!, $page: Int!, $suburbId: String, $propertyType: AgencyApiPropertyType, $sortBy: AgentsearchListingsSortBy, $bedrooms: AgentsearchListingBedrooms, $imageFormat: ImageFormat, $quality: Int) {
  contactByContactId(contactId: $contactId) {
    id
    agentsearchListingsByAgentIdV2AndAgencyId(page: $page, pageSize: 6, listingStatuses: [SOLD, SALE, LEASE, LEASED], propertyType: $propertyType, sortBy: $sortBy, suburbId: $suburbId, bedrooms: $bedrooms) {
      soldListings {
        ...ContactListingsTab
      }
      saleListings {
        ...ContactListingsTab
      }
      leaseListings {
        ...ContactListingsTab
      }
      leasedListings {
        ...ContactListingsTab
      }
    }
  }
}
    ${ContactListingsTabFragmentDoc}`;

/**
 * __useContactCurrentListingsQuery__
 *
 * To run a query within a React component, call `useContactCurrentListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCurrentListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCurrentListingsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      page: // value for 'page'
 *      suburbId: // value for 'suburbId'
 *      propertyType: // value for 'propertyType'
 *      sortBy: // value for 'sortBy'
 *      bedrooms: // value for 'bedrooms'
 *      imageFormat: // value for 'imageFormat'
 *      quality: // value for 'quality'
 *   },
 * });
 */
export function useContactCurrentListingsQuery(baseOptions: Apollo.QueryHookOptions<ContactCurrentListingsQuery, ContactCurrentListingsQueryVariables> & ({ variables: ContactCurrentListingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCurrentListingsQuery, ContactCurrentListingsQueryVariables>(ContactCurrentListingsDocument, options);
      }
export function useContactCurrentListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCurrentListingsQuery, ContactCurrentListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCurrentListingsQuery, ContactCurrentListingsQueryVariables>(ContactCurrentListingsDocument, options);
        }
export function useContactCurrentListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactCurrentListingsQuery, ContactCurrentListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactCurrentListingsQuery, ContactCurrentListingsQueryVariables>(ContactCurrentListingsDocument, options);
        }
export type ContactCurrentListingsQueryHookResult = ReturnType<typeof useContactCurrentListingsQuery>;
export type ContactCurrentListingsLazyQueryHookResult = ReturnType<typeof useContactCurrentListingsLazyQuery>;
export type ContactCurrentListingsSuspenseQueryHookResult = ReturnType<typeof useContactCurrentListingsSuspenseQuery>;
export type ContactCurrentListingsQueryResult = Apollo.QueryResult<ContactCurrentListingsQuery, ContactCurrentListingsQueryVariables>;
export const AgencyCurrentListingsFilterDocument = gql`
    query agencyCurrentListingsFilter($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    id
    agentsearchListingsFiltersByAgencyId {
      listingSummary {
        listingType
        bedrooms
        propertyTypes
        suburbSummaries {
          suburbSlug
          suburbName
          listingCount
        }
      }
    }
  }
}
    `;

/**
 * __useAgencyCurrentListingsFilterQuery__
 *
 * To run a query within a React component, call `useAgencyCurrentListingsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyCurrentListingsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyCurrentListingsFilterQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencyCurrentListingsFilterQuery(baseOptions: Apollo.QueryHookOptions<AgencyCurrentListingsFilterQuery, AgencyCurrentListingsFilterQueryVariables> & ({ variables: AgencyCurrentListingsFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyCurrentListingsFilterQuery, AgencyCurrentListingsFilterQueryVariables>(AgencyCurrentListingsFilterDocument, options);
      }
export function useAgencyCurrentListingsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyCurrentListingsFilterQuery, AgencyCurrentListingsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyCurrentListingsFilterQuery, AgencyCurrentListingsFilterQueryVariables>(AgencyCurrentListingsFilterDocument, options);
        }
export function useAgencyCurrentListingsFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencyCurrentListingsFilterQuery, AgencyCurrentListingsFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencyCurrentListingsFilterQuery, AgencyCurrentListingsFilterQueryVariables>(AgencyCurrentListingsFilterDocument, options);
        }
export type AgencyCurrentListingsFilterQueryHookResult = ReturnType<typeof useAgencyCurrentListingsFilterQuery>;
export type AgencyCurrentListingsFilterLazyQueryHookResult = ReturnType<typeof useAgencyCurrentListingsFilterLazyQuery>;
export type AgencyCurrentListingsFilterSuspenseQueryHookResult = ReturnType<typeof useAgencyCurrentListingsFilterSuspenseQuery>;
export type AgencyCurrentListingsFilterQueryResult = Apollo.QueryResult<AgencyCurrentListingsFilterQuery, AgencyCurrentListingsFilterQueryVariables>;
export const ContactCurrentListingsFilterDocument = gql`
    query contactCurrentListingsFilter($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    id
    agentsearchListingsFiltersByAgentIdV2AndAgencyId {
      listingSummary {
        listingType
        bedrooms
        propertyTypes
        suburbSummaries {
          suburbSlug
          suburbName
          listingCount
        }
      }
    }
  }
}
    `;

/**
 * __useContactCurrentListingsFilterQuery__
 *
 * To run a query within a React component, call `useContactCurrentListingsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCurrentListingsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCurrentListingsFilterQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactCurrentListingsFilterQuery(baseOptions: Apollo.QueryHookOptions<ContactCurrentListingsFilterQuery, ContactCurrentListingsFilterQueryVariables> & ({ variables: ContactCurrentListingsFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCurrentListingsFilterQuery, ContactCurrentListingsFilterQueryVariables>(ContactCurrentListingsFilterDocument, options);
      }
export function useContactCurrentListingsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCurrentListingsFilterQuery, ContactCurrentListingsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCurrentListingsFilterQuery, ContactCurrentListingsFilterQueryVariables>(ContactCurrentListingsFilterDocument, options);
        }
export function useContactCurrentListingsFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactCurrentListingsFilterQuery, ContactCurrentListingsFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactCurrentListingsFilterQuery, ContactCurrentListingsFilterQueryVariables>(ContactCurrentListingsFilterDocument, options);
        }
export type ContactCurrentListingsFilterQueryHookResult = ReturnType<typeof useContactCurrentListingsFilterQuery>;
export type ContactCurrentListingsFilterLazyQueryHookResult = ReturnType<typeof useContactCurrentListingsFilterLazyQuery>;
export type ContactCurrentListingsFilterSuspenseQueryHookResult = ReturnType<typeof useContactCurrentListingsFilterSuspenseQuery>;
export type ContactCurrentListingsFilterQueryResult = Apollo.QueryResult<ContactCurrentListingsFilterQuery, ContactCurrentListingsFilterQueryVariables>;
export const SearchResultsFooterDocument = gql`
    query SearchResultsFooter($singleSuburbSlug: String!) {
  locationProfile(urlSlug: $singleSuburbSlug) {
    id
    ...SearchResultsFooter
  }
}
    ${SearchResultsFooterFragmentDoc}`;

/**
 * __useSearchResultsFooterQuery__
 *
 * To run a query within a React component, call `useSearchResultsFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchResultsFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchResultsFooterQuery({
 *   variables: {
 *      singleSuburbSlug: // value for 'singleSuburbSlug'
 *   },
 * });
 */
export function useSearchResultsFooterQuery(baseOptions: Apollo.QueryHookOptions<SearchResultsFooterQuery, SearchResultsFooterQueryVariables> & ({ variables: SearchResultsFooterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchResultsFooterQuery, SearchResultsFooterQueryVariables>(SearchResultsFooterDocument, options);
      }
export function useSearchResultsFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchResultsFooterQuery, SearchResultsFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchResultsFooterQuery, SearchResultsFooterQueryVariables>(SearchResultsFooterDocument, options);
        }
export function useSearchResultsFooterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchResultsFooterQuery, SearchResultsFooterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchResultsFooterQuery, SearchResultsFooterQueryVariables>(SearchResultsFooterDocument, options);
        }
export type SearchResultsFooterQueryHookResult = ReturnType<typeof useSearchResultsFooterQuery>;
export type SearchResultsFooterLazyQueryHookResult = ReturnType<typeof useSearchResultsFooterLazyQuery>;
export type SearchResultsFooterSuspenseQueryHookResult = ReturnType<typeof useSearchResultsFooterSuspenseQuery>;
export type SearchResultsFooterQueryResult = Apollo.QueryResult<SearchResultsFooterQuery, SearchResultsFooterQueryVariables>;
export const DigitalDataForAgencyDocument = gql`
    query digitalDataForAgency($agencyId: Int!, $imageFormat: ImageFormat) {
  agency(agencyId: $agencyId) {
    id
    __typename
    ...AgencyDigitalData
  }
}
    ${AgencyDigitalDataFragmentDoc}`;

/**
 * __useDigitalDataForAgencyQuery__
 *
 * To run a query within a React component, call `useDigitalDataForAgencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDigitalDataForAgencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDigitalDataForAgencyQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useDigitalDataForAgencyQuery(baseOptions: Apollo.QueryHookOptions<DigitalDataForAgencyQuery, DigitalDataForAgencyQueryVariables> & ({ variables: DigitalDataForAgencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DigitalDataForAgencyQuery, DigitalDataForAgencyQueryVariables>(DigitalDataForAgencyDocument, options);
      }
export function useDigitalDataForAgencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DigitalDataForAgencyQuery, DigitalDataForAgencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DigitalDataForAgencyQuery, DigitalDataForAgencyQueryVariables>(DigitalDataForAgencyDocument, options);
        }
export function useDigitalDataForAgencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DigitalDataForAgencyQuery, DigitalDataForAgencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DigitalDataForAgencyQuery, DigitalDataForAgencyQueryVariables>(DigitalDataForAgencyDocument, options);
        }
export type DigitalDataForAgencyQueryHookResult = ReturnType<typeof useDigitalDataForAgencyQuery>;
export type DigitalDataForAgencyLazyQueryHookResult = ReturnType<typeof useDigitalDataForAgencyLazyQuery>;
export type DigitalDataForAgencySuspenseQueryHookResult = ReturnType<typeof useDigitalDataForAgencySuspenseQuery>;
export type DigitalDataForAgencyQueryResult = Apollo.QueryResult<DigitalDataForAgencyQuery, DigitalDataForAgencyQueryVariables>;
export const DigitalDataForContactDocument = gql`
    query digitalDataForContact($contactId: Int!, $imageFormat: ImageFormat) {
  contactByContactId(contactId: $contactId) {
    __typename
    ...ContactDigitalData
  }
}
    ${ContactDigitalDataFragmentDoc}`;

/**
 * __useDigitalDataForContactQuery__
 *
 * To run a query within a React component, call `useDigitalDataForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useDigitalDataForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDigitalDataForContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useDigitalDataForContactQuery(baseOptions: Apollo.QueryHookOptions<DigitalDataForContactQuery, DigitalDataForContactQueryVariables> & ({ variables: DigitalDataForContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DigitalDataForContactQuery, DigitalDataForContactQueryVariables>(DigitalDataForContactDocument, options);
      }
export function useDigitalDataForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DigitalDataForContactQuery, DigitalDataForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DigitalDataForContactQuery, DigitalDataForContactQueryVariables>(DigitalDataForContactDocument, options);
        }
export function useDigitalDataForContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DigitalDataForContactQuery, DigitalDataForContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DigitalDataForContactQuery, DigitalDataForContactQueryVariables>(DigitalDataForContactDocument, options);
        }
export type DigitalDataForContactQueryHookResult = ReturnType<typeof useDigitalDataForContactQuery>;
export type DigitalDataForContactLazyQueryHookResult = ReturnType<typeof useDigitalDataForContactLazyQuery>;
export type DigitalDataForContactSuspenseQueryHookResult = ReturnType<typeof useDigitalDataForContactSuspenseQuery>;
export type DigitalDataForContactQueryResult = Apollo.QueryResult<DigitalDataForContactQuery, DigitalDataForContactQueryVariables>;
export const GetAgencyHeroDocument = gql`
    query getAgencyHero($agencyId: Int!, $imageFormat: ImageFormat) {
  agency(agencyId: $agencyId) {
    ...AgencyHero
  }
}
    ${AgencyHeroFragmentDoc}`;

/**
 * __useGetAgencyHeroQuery__
 *
 * To run a query within a React component, call `useGetAgencyHeroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyHeroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyHeroQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetAgencyHeroQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyHeroQuery, GetAgencyHeroQueryVariables> & ({ variables: GetAgencyHeroQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyHeroQuery, GetAgencyHeroQueryVariables>(GetAgencyHeroDocument, options);
      }
export function useGetAgencyHeroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyHeroQuery, GetAgencyHeroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyHeroQuery, GetAgencyHeroQueryVariables>(GetAgencyHeroDocument, options);
        }
export function useGetAgencyHeroSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyHeroQuery, GetAgencyHeroQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyHeroQuery, GetAgencyHeroQueryVariables>(GetAgencyHeroDocument, options);
        }
export type GetAgencyHeroQueryHookResult = ReturnType<typeof useGetAgencyHeroQuery>;
export type GetAgencyHeroLazyQueryHookResult = ReturnType<typeof useGetAgencyHeroLazyQuery>;
export type GetAgencyHeroSuspenseQueryHookResult = ReturnType<typeof useGetAgencyHeroSuspenseQuery>;
export type GetAgencyHeroQueryResult = Apollo.QueryResult<GetAgencyHeroQuery, GetAgencyHeroQueryVariables>;
export const GetContactHeroDocument = gql`
    query getContactHero($agencyId: Int!, $agentIdV2: String!, $imageFormat: ImageFormat) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...ContactHero
  }
}
    ${ContactHeroFragmentDoc}`;

/**
 * __useGetContactHeroQuery__
 *
 * To run a query within a React component, call `useGetContactHeroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactHeroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactHeroQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetContactHeroQuery(baseOptions: Apollo.QueryHookOptions<GetContactHeroQuery, GetContactHeroQueryVariables> & ({ variables: GetContactHeroQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactHeroQuery, GetContactHeroQueryVariables>(GetContactHeroDocument, options);
      }
export function useGetContactHeroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactHeroQuery, GetContactHeroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactHeroQuery, GetContactHeroQueryVariables>(GetContactHeroDocument, options);
        }
export function useGetContactHeroSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactHeroQuery, GetContactHeroQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactHeroQuery, GetContactHeroQueryVariables>(GetContactHeroDocument, options);
        }
export type GetContactHeroQueryHookResult = ReturnType<typeof useGetContactHeroQuery>;
export type GetContactHeroLazyQueryHookResult = ReturnType<typeof useGetContactHeroLazyQuery>;
export type GetContactHeroSuspenseQueryHookResult = ReturnType<typeof useGetContactHeroSuspenseQuery>;
export type GetContactHeroQueryResult = Apollo.QueryResult<GetContactHeroQuery, GetContactHeroQueryVariables>;
export const GetContactIdHeroDocument = gql`
    query getContactIdHero($contactId: Int!, $imageFormat: ImageFormat) {
  contactByContactId(contactId: $contactId) {
    ...ContactHero
  }
}
    ${ContactHeroFragmentDoc}`;

/**
 * __useGetContactIdHeroQuery__
 *
 * To run a query within a React component, call `useGetContactIdHeroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdHeroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdHeroQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetContactIdHeroQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdHeroQuery, GetContactIdHeroQueryVariables> & ({ variables: GetContactIdHeroQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdHeroQuery, GetContactIdHeroQueryVariables>(GetContactIdHeroDocument, options);
      }
export function useGetContactIdHeroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdHeroQuery, GetContactIdHeroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdHeroQuery, GetContactIdHeroQueryVariables>(GetContactIdHeroDocument, options);
        }
export function useGetContactIdHeroSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdHeroQuery, GetContactIdHeroQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdHeroQuery, GetContactIdHeroQueryVariables>(GetContactIdHeroDocument, options);
        }
export type GetContactIdHeroQueryHookResult = ReturnType<typeof useGetContactIdHeroQuery>;
export type GetContactIdHeroLazyQueryHookResult = ReturnType<typeof useGetContactIdHeroLazyQuery>;
export type GetContactIdHeroSuspenseQueryHookResult = ReturnType<typeof useGetContactIdHeroSuspenseQuery>;
export type GetContactIdHeroQueryResult = Apollo.QueryResult<GetContactIdHeroQuery, GetContactIdHeroQueryVariables>;
export const ListingCardDocument = gql`
    query listingCard($adId: Int!, $imageFormat: ImageFormat, $quality: Int) {
  listing(adId: $adId) {
    ...ListingCard
  }
}
    ${ListingCardFragmentDoc}`;

/**
 * __useListingCardQuery__
 *
 * To run a query within a React component, call `useListingCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingCardQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *      imageFormat: // value for 'imageFormat'
 *      quality: // value for 'quality'
 *   },
 * });
 */
export function useListingCardQuery(baseOptions: Apollo.QueryHookOptions<ListingCardQuery, ListingCardQueryVariables> & ({ variables: ListingCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingCardQuery, ListingCardQueryVariables>(ListingCardDocument, options);
      }
export function useListingCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingCardQuery, ListingCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingCardQuery, ListingCardQueryVariables>(ListingCardDocument, options);
        }
export function useListingCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListingCardQuery, ListingCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingCardQuery, ListingCardQueryVariables>(ListingCardDocument, options);
        }
export type ListingCardQueryHookResult = ReturnType<typeof useListingCardQuery>;
export type ListingCardLazyQueryHookResult = ReturnType<typeof useListingCardLazyQuery>;
export type ListingCardSuspenseQueryHookResult = ReturnType<typeof useListingCardSuspenseQuery>;
export type ListingCardQueryResult = Apollo.QueryResult<ListingCardQuery, ListingCardQueryVariables>;
export const GetAgencySalesStatisticsStoryDocument = gql`
    query getAgencySalesStatisticsStory($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    ...AgencySalesStatisticsStory
  }
}
    ${AgencySalesStatisticsStoryFragmentDoc}`;

/**
 * __useGetAgencySalesStatisticsStoryQuery__
 *
 * To run a query within a React component, call `useGetAgencySalesStatisticsStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencySalesStatisticsStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencySalesStatisticsStoryQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetAgencySalesStatisticsStoryQuery(baseOptions: Apollo.QueryHookOptions<GetAgencySalesStatisticsStoryQuery, GetAgencySalesStatisticsStoryQueryVariables> & ({ variables: GetAgencySalesStatisticsStoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencySalesStatisticsStoryQuery, GetAgencySalesStatisticsStoryQueryVariables>(GetAgencySalesStatisticsStoryDocument, options);
      }
export function useGetAgencySalesStatisticsStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencySalesStatisticsStoryQuery, GetAgencySalesStatisticsStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencySalesStatisticsStoryQuery, GetAgencySalesStatisticsStoryQueryVariables>(GetAgencySalesStatisticsStoryDocument, options);
        }
export function useGetAgencySalesStatisticsStorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencySalesStatisticsStoryQuery, GetAgencySalesStatisticsStoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencySalesStatisticsStoryQuery, GetAgencySalesStatisticsStoryQueryVariables>(GetAgencySalesStatisticsStoryDocument, options);
        }
export type GetAgencySalesStatisticsStoryQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsStoryQuery>;
export type GetAgencySalesStatisticsStoryLazyQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsStoryLazyQuery>;
export type GetAgencySalesStatisticsStorySuspenseQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsStorySuspenseQuery>;
export type GetAgencySalesStatisticsStoryQueryResult = Apollo.QueryResult<GetAgencySalesStatisticsStoryQuery, GetAgencySalesStatisticsStoryQueryVariables>;
export const GetContactIdSalesStatisticsStoryDocument = gql`
    query getContactIdSalesStatisticsStory($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    ...ContactSalesStatisticsStory
  }
}
    ${ContactSalesStatisticsStoryFragmentDoc}`;

/**
 * __useGetContactIdSalesStatisticsStoryQuery__
 *
 * To run a query within a React component, call `useGetContactIdSalesStatisticsStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdSalesStatisticsStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdSalesStatisticsStoryQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactIdSalesStatisticsStoryQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdSalesStatisticsStoryQuery, GetContactIdSalesStatisticsStoryQueryVariables> & ({ variables: GetContactIdSalesStatisticsStoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdSalesStatisticsStoryQuery, GetContactIdSalesStatisticsStoryQueryVariables>(GetContactIdSalesStatisticsStoryDocument, options);
      }
export function useGetContactIdSalesStatisticsStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdSalesStatisticsStoryQuery, GetContactIdSalesStatisticsStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdSalesStatisticsStoryQuery, GetContactIdSalesStatisticsStoryQueryVariables>(GetContactIdSalesStatisticsStoryDocument, options);
        }
export function useGetContactIdSalesStatisticsStorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdSalesStatisticsStoryQuery, GetContactIdSalesStatisticsStoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdSalesStatisticsStoryQuery, GetContactIdSalesStatisticsStoryQueryVariables>(GetContactIdSalesStatisticsStoryDocument, options);
        }
export type GetContactIdSalesStatisticsStoryQueryHookResult = ReturnType<typeof useGetContactIdSalesStatisticsStoryQuery>;
export type GetContactIdSalesStatisticsStoryLazyQueryHookResult = ReturnType<typeof useGetContactIdSalesStatisticsStoryLazyQuery>;
export type GetContactIdSalesStatisticsStorySuspenseQueryHookResult = ReturnType<typeof useGetContactIdSalesStatisticsStorySuspenseQuery>;
export type GetContactIdSalesStatisticsStoryQueryResult = Apollo.QueryResult<GetContactIdSalesStatisticsStoryQuery, GetContactIdSalesStatisticsStoryQueryVariables>;
export const GetContactSalesStatisticsStoryDocument = gql`
    query getContactSalesStatisticsStory($agencyId: Int!, $agentIdV2: String!) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...ContactSalesStatisticsStory
  }
}
    ${ContactSalesStatisticsStoryFragmentDoc}`;

/**
 * __useGetContactSalesStatisticsStoryQuery__
 *
 * To run a query within a React component, call `useGetContactSalesStatisticsStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactSalesStatisticsStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactSalesStatisticsStoryQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *   },
 * });
 */
export function useGetContactSalesStatisticsStoryQuery(baseOptions: Apollo.QueryHookOptions<GetContactSalesStatisticsStoryQuery, GetContactSalesStatisticsStoryQueryVariables> & ({ variables: GetContactSalesStatisticsStoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactSalesStatisticsStoryQuery, GetContactSalesStatisticsStoryQueryVariables>(GetContactSalesStatisticsStoryDocument, options);
      }
export function useGetContactSalesStatisticsStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactSalesStatisticsStoryQuery, GetContactSalesStatisticsStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactSalesStatisticsStoryQuery, GetContactSalesStatisticsStoryQueryVariables>(GetContactSalesStatisticsStoryDocument, options);
        }
export function useGetContactSalesStatisticsStorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactSalesStatisticsStoryQuery, GetContactSalesStatisticsStoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactSalesStatisticsStoryQuery, GetContactSalesStatisticsStoryQueryVariables>(GetContactSalesStatisticsStoryDocument, options);
        }
export type GetContactSalesStatisticsStoryQueryHookResult = ReturnType<typeof useGetContactSalesStatisticsStoryQuery>;
export type GetContactSalesStatisticsStoryLazyQueryHookResult = ReturnType<typeof useGetContactSalesStatisticsStoryLazyQuery>;
export type GetContactSalesStatisticsStorySuspenseQueryHookResult = ReturnType<typeof useGetContactSalesStatisticsStorySuspenseQuery>;
export type GetContactSalesStatisticsStoryQueryResult = Apollo.QueryResult<GetContactSalesStatisticsStoryQuery, GetContactSalesStatisticsStoryQueryVariables>;
export const GetAgencySalesStatisticsDocument = gql`
    query getAgencySalesStatistics($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    id
    ...AgencyProfileSalesStatistics
  }
}
    ${AgencyProfileSalesStatisticsFragmentDoc}`;

/**
 * __useGetAgencySalesStatisticsQuery__
 *
 * To run a query within a React component, call `useGetAgencySalesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencySalesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencySalesStatisticsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetAgencySalesStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetAgencySalesStatisticsQuery, GetAgencySalesStatisticsQueryVariables> & ({ variables: GetAgencySalesStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencySalesStatisticsQuery, GetAgencySalesStatisticsQueryVariables>(GetAgencySalesStatisticsDocument, options);
      }
export function useGetAgencySalesStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencySalesStatisticsQuery, GetAgencySalesStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencySalesStatisticsQuery, GetAgencySalesStatisticsQueryVariables>(GetAgencySalesStatisticsDocument, options);
        }
export function useGetAgencySalesStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencySalesStatisticsQuery, GetAgencySalesStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencySalesStatisticsQuery, GetAgencySalesStatisticsQueryVariables>(GetAgencySalesStatisticsDocument, options);
        }
export type GetAgencySalesStatisticsQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsQuery>;
export type GetAgencySalesStatisticsLazyQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsLazyQuery>;
export type GetAgencySalesStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsSuspenseQuery>;
export type GetAgencySalesStatisticsQueryResult = Apollo.QueryResult<GetAgencySalesStatisticsQuery, GetAgencySalesStatisticsQueryVariables>;
export const GetAgencySalesStatisticsDataDocument = gql`
    query getAgencySalesStatisticsData($agencyId: Int!, $suburbSlug: String) {
  agency(agencyId: $agencyId) {
    id
    suburbStatisticsData: suburbStatistics(suburbSlug: $suburbSlug) {
      ...SuburbStatistics
    }
  }
}
    ${SuburbStatisticsFragmentDoc}`;

/**
 * __useGetAgencySalesStatisticsDataQuery__
 *
 * To run a query within a React component, call `useGetAgencySalesStatisticsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencySalesStatisticsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencySalesStatisticsDataQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      suburbSlug: // value for 'suburbSlug'
 *   },
 * });
 */
export function useGetAgencySalesStatisticsDataQuery(baseOptions: Apollo.QueryHookOptions<GetAgencySalesStatisticsDataQuery, GetAgencySalesStatisticsDataQueryVariables> & ({ variables: GetAgencySalesStatisticsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencySalesStatisticsDataQuery, GetAgencySalesStatisticsDataQueryVariables>(GetAgencySalesStatisticsDataDocument, options);
      }
export function useGetAgencySalesStatisticsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencySalesStatisticsDataQuery, GetAgencySalesStatisticsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencySalesStatisticsDataQuery, GetAgencySalesStatisticsDataQueryVariables>(GetAgencySalesStatisticsDataDocument, options);
        }
export function useGetAgencySalesStatisticsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencySalesStatisticsDataQuery, GetAgencySalesStatisticsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencySalesStatisticsDataQuery, GetAgencySalesStatisticsDataQueryVariables>(GetAgencySalesStatisticsDataDocument, options);
        }
export type GetAgencySalesStatisticsDataQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsDataQuery>;
export type GetAgencySalesStatisticsDataLazyQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsDataLazyQuery>;
export type GetAgencySalesStatisticsDataSuspenseQueryHookResult = ReturnType<typeof useGetAgencySalesStatisticsDataSuspenseQuery>;
export type GetAgencySalesStatisticsDataQueryResult = Apollo.QueryResult<GetAgencySalesStatisticsDataQuery, GetAgencySalesStatisticsDataQueryVariables>;
export const GetContactSalesStatisticsDataDocument = gql`
    query getContactSalesStatisticsData($agencyId: Int!, $agentIdV2: String!, $suburbSlug: String) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    id
    suburbStatisticsData: suburbStatistics(suburbSlug: $suburbSlug) {
      ...SuburbStatistics
    }
  }
}
    ${SuburbStatisticsFragmentDoc}`;

/**
 * __useGetContactSalesStatisticsDataQuery__
 *
 * To run a query within a React component, call `useGetContactSalesStatisticsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactSalesStatisticsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactSalesStatisticsDataQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *      suburbSlug: // value for 'suburbSlug'
 *   },
 * });
 */
export function useGetContactSalesStatisticsDataQuery(baseOptions: Apollo.QueryHookOptions<GetContactSalesStatisticsDataQuery, GetContactSalesStatisticsDataQueryVariables> & ({ variables: GetContactSalesStatisticsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactSalesStatisticsDataQuery, GetContactSalesStatisticsDataQueryVariables>(GetContactSalesStatisticsDataDocument, options);
      }
export function useGetContactSalesStatisticsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactSalesStatisticsDataQuery, GetContactSalesStatisticsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactSalesStatisticsDataQuery, GetContactSalesStatisticsDataQueryVariables>(GetContactSalesStatisticsDataDocument, options);
        }
export function useGetContactSalesStatisticsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactSalesStatisticsDataQuery, GetContactSalesStatisticsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactSalesStatisticsDataQuery, GetContactSalesStatisticsDataQueryVariables>(GetContactSalesStatisticsDataDocument, options);
        }
export type GetContactSalesStatisticsDataQueryHookResult = ReturnType<typeof useGetContactSalesStatisticsDataQuery>;
export type GetContactSalesStatisticsDataLazyQueryHookResult = ReturnType<typeof useGetContactSalesStatisticsDataLazyQuery>;
export type GetContactSalesStatisticsDataSuspenseQueryHookResult = ReturnType<typeof useGetContactSalesStatisticsDataSuspenseQuery>;
export type GetContactSalesStatisticsDataQueryResult = Apollo.QueryResult<GetContactSalesStatisticsDataQuery, GetContactSalesStatisticsDataQueryVariables>;
export const GetContactIdSalesStatisticsDocument = gql`
    query getContactIdSalesStatistics($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    ...ContactProfileSalesStatistics
  }
}
    ${ContactProfileSalesStatisticsFragmentDoc}`;

/**
 * __useGetContactIdSalesStatisticsQuery__
 *
 * To run a query within a React component, call `useGetContactIdSalesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdSalesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdSalesStatisticsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactIdSalesStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdSalesStatisticsQuery, GetContactIdSalesStatisticsQueryVariables> & ({ variables: GetContactIdSalesStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdSalesStatisticsQuery, GetContactIdSalesStatisticsQueryVariables>(GetContactIdSalesStatisticsDocument, options);
      }
export function useGetContactIdSalesStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdSalesStatisticsQuery, GetContactIdSalesStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdSalesStatisticsQuery, GetContactIdSalesStatisticsQueryVariables>(GetContactIdSalesStatisticsDocument, options);
        }
export function useGetContactIdSalesStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdSalesStatisticsQuery, GetContactIdSalesStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdSalesStatisticsQuery, GetContactIdSalesStatisticsQueryVariables>(GetContactIdSalesStatisticsDocument, options);
        }
export type GetContactIdSalesStatisticsQueryHookResult = ReturnType<typeof useGetContactIdSalesStatisticsQuery>;
export type GetContactIdSalesStatisticsLazyQueryHookResult = ReturnType<typeof useGetContactIdSalesStatisticsLazyQuery>;
export type GetContactIdSalesStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetContactIdSalesStatisticsSuspenseQuery>;
export type GetContactIdSalesStatisticsQueryResult = Apollo.QueryResult<GetContactIdSalesStatisticsQuery, GetContactIdSalesStatisticsQueryVariables>;
export const ContactByAgencyIdAndAgentIdDocument = gql`
    query contactByAgencyIdAndAgentId($agencyId: Int!, $agentIdV2: String!) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...ContactProfileSalesStatistics
  }
}
    ${ContactProfileSalesStatisticsFragmentDoc}`;

/**
 * __useContactByAgencyIdAndAgentIdQuery__
 *
 * To run a query within a React component, call `useContactByAgencyIdAndAgentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactByAgencyIdAndAgentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactByAgencyIdAndAgentIdQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *   },
 * });
 */
export function useContactByAgencyIdAndAgentIdQuery(baseOptions: Apollo.QueryHookOptions<ContactByAgencyIdAndAgentIdQuery, ContactByAgencyIdAndAgentIdQueryVariables> & ({ variables: ContactByAgencyIdAndAgentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactByAgencyIdAndAgentIdQuery, ContactByAgencyIdAndAgentIdQueryVariables>(ContactByAgencyIdAndAgentIdDocument, options);
      }
export function useContactByAgencyIdAndAgentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactByAgencyIdAndAgentIdQuery, ContactByAgencyIdAndAgentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactByAgencyIdAndAgentIdQuery, ContactByAgencyIdAndAgentIdQueryVariables>(ContactByAgencyIdAndAgentIdDocument, options);
        }
export function useContactByAgencyIdAndAgentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactByAgencyIdAndAgentIdQuery, ContactByAgencyIdAndAgentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactByAgencyIdAndAgentIdQuery, ContactByAgencyIdAndAgentIdQueryVariables>(ContactByAgencyIdAndAgentIdDocument, options);
        }
export type ContactByAgencyIdAndAgentIdQueryHookResult = ReturnType<typeof useContactByAgencyIdAndAgentIdQuery>;
export type ContactByAgencyIdAndAgentIdLazyQueryHookResult = ReturnType<typeof useContactByAgencyIdAndAgentIdLazyQuery>;
export type ContactByAgencyIdAndAgentIdSuspenseQueryHookResult = ReturnType<typeof useContactByAgencyIdAndAgentIdSuspenseQuery>;
export type ContactByAgencyIdAndAgentIdQueryResult = Apollo.QueryResult<ContactByAgencyIdAndAgentIdQuery, ContactByAgencyIdAndAgentIdQueryVariables>;
export const FindAndAgentAutocompleteDocument = gql`
    query FindAndAgentAutocomplete($input: String!, $maxResults: Int, $locationTypes: [LocationSuggestionType], $imageFormat: ImageFormat, $fitIn: Boolean, $trim: ImageTrim) {
  suggestLocations(prefixText: $input, locationTypes: $locationTypes, maxResults: $maxResults) {
    ... on SuburbSuggestion {
      displayName
      nameSlug
      name
      state
      postcode
    }
  }
  suggestedAgencies(name: $input, pageSize: $maxResults) {
    agencyName
    profileUrl
    backgroundColour
    suburb
    state
    postcode
    logo {
      url(imageFormat: $imageFormat, fitIn: $fitIn, trim: $trim)
    }
  }
  suggestedContacts(name: $input, pageSize: $maxResults) {
    id
    contactId
    name
    thumbnail
    profileUrl
    agencyId
    agencyName
    suburb
    state
  }
}
    `;

/**
 * __useFindAndAgentAutocompleteQuery__
 *
 * To run a query within a React component, call `useFindAndAgentAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAndAgentAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAndAgentAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *      maxResults: // value for 'maxResults'
 *      locationTypes: // value for 'locationTypes'
 *      imageFormat: // value for 'imageFormat'
 *      fitIn: // value for 'fitIn'
 *      trim: // value for 'trim'
 *   },
 * });
 */
export function useFindAndAgentAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<FindAndAgentAutocompleteQuery, FindAndAgentAutocompleteQueryVariables> & ({ variables: FindAndAgentAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAndAgentAutocompleteQuery, FindAndAgentAutocompleteQueryVariables>(FindAndAgentAutocompleteDocument, options);
      }
export function useFindAndAgentAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAndAgentAutocompleteQuery, FindAndAgentAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAndAgentAutocompleteQuery, FindAndAgentAutocompleteQueryVariables>(FindAndAgentAutocompleteDocument, options);
        }
export function useFindAndAgentAutocompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAndAgentAutocompleteQuery, FindAndAgentAutocompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAndAgentAutocompleteQuery, FindAndAgentAutocompleteQueryVariables>(FindAndAgentAutocompleteDocument, options);
        }
export type FindAndAgentAutocompleteQueryHookResult = ReturnType<typeof useFindAndAgentAutocompleteQuery>;
export type FindAndAgentAutocompleteLazyQueryHookResult = ReturnType<typeof useFindAndAgentAutocompleteLazyQuery>;
export type FindAndAgentAutocompleteSuspenseQueryHookResult = ReturnType<typeof useFindAndAgentAutocompleteSuspenseQuery>;
export type FindAndAgentAutocompleteQueryResult = Apollo.QueryResult<FindAndAgentAutocompleteQuery, FindAndAgentAutocompleteQueryVariables>;
export const AgencySearchDocument = gql`
    query AgencySearch($suburbSlugs: [String!]!, $agencySortBy: AgencySearchSortBy, $contactSortBy: ContactSearchSortBy, $page: Int, $pageSize: Int, $agentFilter: AgentSearchContactTypes, $keywordName: String, $includeAgents: Boolean, $isAgencyView: Boolean!) {
  contactSearchBySuburbs(suburbSlugs: $suburbSlugs, sortBy: $contactSortBy, page: $page, pageSize: $pageSize, agentType: $agentFilter, agentNameKeyword: $keywordName) {
    total
    totalPages
    pageNumber
    results @skip(if: $isAgencyView) {
      id
      ...ContactSearchProfileCard
    }
  }
  agencySearchBySuburbs(suburbSlugs: $suburbSlugs, sortBy: $agencySortBy, page: $page, pageSize: $pageSize, agencyNameKeyword: $keywordName, includeAgents: $includeAgents) {
    total
    totalPages
    pageNumber
    results @include(if: $isAgencyView) {
      id
      ...AgencySearchProfileCard
    }
  }
  locationProfiles(urlSlugs: $suburbSlugs) {
    id
    suburbName
    state
    postcode
    urlSlug
    ...SearchResultsFooter @include(if: $isAgencyView)
  }
}
    ${ContactSearchProfileCardFragmentDoc}
${AgencySearchProfileCardFragmentDoc}
${SearchResultsFooterFragmentDoc}`;

/**
 * __useAgencySearchQuery__
 *
 * To run a query within a React component, call `useAgencySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencySearchQuery({
 *   variables: {
 *      suburbSlugs: // value for 'suburbSlugs'
 *      agencySortBy: // value for 'agencySortBy'
 *      contactSortBy: // value for 'contactSortBy'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      agentFilter: // value for 'agentFilter'
 *      keywordName: // value for 'keywordName'
 *      includeAgents: // value for 'includeAgents'
 *      isAgencyView: // value for 'isAgencyView'
 *   },
 * });
 */
export function useAgencySearchQuery(baseOptions: Apollo.QueryHookOptions<AgencySearchQuery, AgencySearchQueryVariables> & ({ variables: AgencySearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencySearchQuery, AgencySearchQueryVariables>(AgencySearchDocument, options);
      }
export function useAgencySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencySearchQuery, AgencySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencySearchQuery, AgencySearchQueryVariables>(AgencySearchDocument, options);
        }
export function useAgencySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgencySearchQuery, AgencySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgencySearchQuery, AgencySearchQueryVariables>(AgencySearchDocument, options);
        }
export type AgencySearchQueryHookResult = ReturnType<typeof useAgencySearchQuery>;
export type AgencySearchLazyQueryHookResult = ReturnType<typeof useAgencySearchLazyQuery>;
export type AgencySearchSuspenseQueryHookResult = ReturnType<typeof useAgencySearchSuspenseQuery>;
export type AgencySearchQueryResult = Apollo.QueryResult<AgencySearchQuery, AgencySearchQueryVariables>;
export const GetContactIdProfileCardDocument = gql`
    query getContactIdProfileCard($contactId: Int!, $imageFormat: ImageFormat) {
  contactByContactId(contactId: $contactId) {
    ...ContactProfileCard
  }
}
    ${ContactProfileCardFragmentDoc}`;

/**
 * __useGetContactIdProfileCardQuery__
 *
 * To run a query within a React component, call `useGetContactIdProfileCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdProfileCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdProfileCardQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetContactIdProfileCardQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdProfileCardQuery, GetContactIdProfileCardQueryVariables> & ({ variables: GetContactIdProfileCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdProfileCardQuery, GetContactIdProfileCardQueryVariables>(GetContactIdProfileCardDocument, options);
      }
export function useGetContactIdProfileCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdProfileCardQuery, GetContactIdProfileCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdProfileCardQuery, GetContactIdProfileCardQueryVariables>(GetContactIdProfileCardDocument, options);
        }
export function useGetContactIdProfileCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdProfileCardQuery, GetContactIdProfileCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdProfileCardQuery, GetContactIdProfileCardQueryVariables>(GetContactIdProfileCardDocument, options);
        }
export type GetContactIdProfileCardQueryHookResult = ReturnType<typeof useGetContactIdProfileCardQuery>;
export type GetContactIdProfileCardLazyQueryHookResult = ReturnType<typeof useGetContactIdProfileCardLazyQuery>;
export type GetContactIdProfileCardSuspenseQueryHookResult = ReturnType<typeof useGetContactIdProfileCardSuspenseQuery>;
export type GetContactIdProfileCardQueryResult = Apollo.QueryResult<GetContactIdProfileCardQuery, GetContactIdProfileCardQueryVariables>;
export const GetContactProfileCardDocument = gql`
    query getContactProfileCard($agencyId: Int!, $agentIdV2: String!, $imageFormat: ImageFormat) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...ContactProfileCard
  }
}
    ${ContactProfileCardFragmentDoc}`;

/**
 * __useGetContactProfileCardQuery__
 *
 * To run a query within a React component, call `useGetContactProfileCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactProfileCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactProfileCardQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetContactProfileCardQuery(baseOptions: Apollo.QueryHookOptions<GetContactProfileCardQuery, GetContactProfileCardQueryVariables> & ({ variables: GetContactProfileCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactProfileCardQuery, GetContactProfileCardQueryVariables>(GetContactProfileCardDocument, options);
      }
export function useGetContactProfileCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactProfileCardQuery, GetContactProfileCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactProfileCardQuery, GetContactProfileCardQueryVariables>(GetContactProfileCardDocument, options);
        }
export function useGetContactProfileCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactProfileCardQuery, GetContactProfileCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactProfileCardQuery, GetContactProfileCardQueryVariables>(GetContactProfileCardDocument, options);
        }
export type GetContactProfileCardQueryHookResult = ReturnType<typeof useGetContactProfileCardQuery>;
export type GetContactProfileCardLazyQueryHookResult = ReturnType<typeof useGetContactProfileCardLazyQuery>;
export type GetContactProfileCardSuspenseQueryHookResult = ReturnType<typeof useGetContactProfileCardSuspenseQuery>;
export type GetContactProfileCardQueryResult = Apollo.QueryResult<GetContactProfileCardQuery, GetContactProfileCardQueryVariables>;
export const GetContactTestimonialsDocument = gql`
    query GetContactTestimonials($agencyId: Int!, $agentIdV2: String!) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...Testimonials
  }
}
    ${TestimonialsFragmentDoc}`;

/**
 * __useGetContactTestimonialsQuery__
 *
 * To run a query within a React component, call `useGetContactTestimonialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactTestimonialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactTestimonialsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *   },
 * });
 */
export function useGetContactTestimonialsQuery(baseOptions: Apollo.QueryHookOptions<GetContactTestimonialsQuery, GetContactTestimonialsQueryVariables> & ({ variables: GetContactTestimonialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactTestimonialsQuery, GetContactTestimonialsQueryVariables>(GetContactTestimonialsDocument, options);
      }
export function useGetContactTestimonialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactTestimonialsQuery, GetContactTestimonialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactTestimonialsQuery, GetContactTestimonialsQueryVariables>(GetContactTestimonialsDocument, options);
        }
export function useGetContactTestimonialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactTestimonialsQuery, GetContactTestimonialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactTestimonialsQuery, GetContactTestimonialsQueryVariables>(GetContactTestimonialsDocument, options);
        }
export type GetContactTestimonialsQueryHookResult = ReturnType<typeof useGetContactTestimonialsQuery>;
export type GetContactTestimonialsLazyQueryHookResult = ReturnType<typeof useGetContactTestimonialsLazyQuery>;
export type GetContactTestimonialsSuspenseQueryHookResult = ReturnType<typeof useGetContactTestimonialsSuspenseQuery>;
export type GetContactTestimonialsQueryResult = Apollo.QueryResult<GetContactTestimonialsQuery, GetContactTestimonialsQueryVariables>;
export const GetAgencyTopSummaryDocument = gql`
    query getAgencyTopSummary($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    ...AgencyTopSummary
  }
}
    ${AgencyTopSummaryFragmentDoc}`;

/**
 * __useGetAgencyTopSummaryQuery__
 *
 * To run a query within a React component, call `useGetAgencyTopSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyTopSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyTopSummaryQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetAgencyTopSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyTopSummaryQuery, GetAgencyTopSummaryQueryVariables> & ({ variables: GetAgencyTopSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyTopSummaryQuery, GetAgencyTopSummaryQueryVariables>(GetAgencyTopSummaryDocument, options);
      }
export function useGetAgencyTopSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyTopSummaryQuery, GetAgencyTopSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyTopSummaryQuery, GetAgencyTopSummaryQueryVariables>(GetAgencyTopSummaryDocument, options);
        }
export function useGetAgencyTopSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyTopSummaryQuery, GetAgencyTopSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyTopSummaryQuery, GetAgencyTopSummaryQueryVariables>(GetAgencyTopSummaryDocument, options);
        }
export type GetAgencyTopSummaryQueryHookResult = ReturnType<typeof useGetAgencyTopSummaryQuery>;
export type GetAgencyTopSummaryLazyQueryHookResult = ReturnType<typeof useGetAgencyTopSummaryLazyQuery>;
export type GetAgencyTopSummarySuspenseQueryHookResult = ReturnType<typeof useGetAgencyTopSummarySuspenseQuery>;
export type GetAgencyTopSummaryQueryResult = Apollo.QueryResult<GetAgencyTopSummaryQuery, GetAgencyTopSummaryQueryVariables>;
export const GetContactIdTopSummaryDocument = gql`
    query getContactIdTopSummary($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    ...ContactTopSummary
  }
}
    ${ContactTopSummaryFragmentDoc}`;

/**
 * __useGetContactIdTopSummaryQuery__
 *
 * To run a query within a React component, call `useGetContactIdTopSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdTopSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdTopSummaryQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactIdTopSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdTopSummaryQuery, GetContactIdTopSummaryQueryVariables> & ({ variables: GetContactIdTopSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdTopSummaryQuery, GetContactIdTopSummaryQueryVariables>(GetContactIdTopSummaryDocument, options);
      }
export function useGetContactIdTopSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdTopSummaryQuery, GetContactIdTopSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdTopSummaryQuery, GetContactIdTopSummaryQueryVariables>(GetContactIdTopSummaryDocument, options);
        }
export function useGetContactIdTopSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdTopSummaryQuery, GetContactIdTopSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdTopSummaryQuery, GetContactIdTopSummaryQueryVariables>(GetContactIdTopSummaryDocument, options);
        }
export type GetContactIdTopSummaryQueryHookResult = ReturnType<typeof useGetContactIdTopSummaryQuery>;
export type GetContactIdTopSummaryLazyQueryHookResult = ReturnType<typeof useGetContactIdTopSummaryLazyQuery>;
export type GetContactIdTopSummarySuspenseQueryHookResult = ReturnType<typeof useGetContactIdTopSummarySuspenseQuery>;
export type GetContactIdTopSummaryQueryResult = Apollo.QueryResult<GetContactIdTopSummaryQuery, GetContactIdTopSummaryQueryVariables>;
export const GetContactTopSummaryDocument = gql`
    query getContactTopSummary($agencyId: Int!, $agentIdV2: String!) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...ContactTopSummary
  }
}
    ${ContactTopSummaryFragmentDoc}`;

/**
 * __useGetContactTopSummaryQuery__
 *
 * To run a query within a React component, call `useGetContactTopSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactTopSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactTopSummaryQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *   },
 * });
 */
export function useGetContactTopSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetContactTopSummaryQuery, GetContactTopSummaryQueryVariables> & ({ variables: GetContactTopSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactTopSummaryQuery, GetContactTopSummaryQueryVariables>(GetContactTopSummaryDocument, options);
      }
export function useGetContactTopSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactTopSummaryQuery, GetContactTopSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactTopSummaryQuery, GetContactTopSummaryQueryVariables>(GetContactTopSummaryDocument, options);
        }
export function useGetContactTopSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactTopSummaryQuery, GetContactTopSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactTopSummaryQuery, GetContactTopSummaryQueryVariables>(GetContactTopSummaryDocument, options);
        }
export type GetContactTopSummaryQueryHookResult = ReturnType<typeof useGetContactTopSummaryQuery>;
export type GetContactTopSummaryLazyQueryHookResult = ReturnType<typeof useGetContactTopSummaryLazyQuery>;
export type GetContactTopSummarySuspenseQueryHookResult = ReturnType<typeof useGetContactTopSummarySuspenseQuery>;
export type GetContactTopSummaryQueryResult = Apollo.QueryResult<GetContactTopSummaryQuery, GetContactTopSummaryQueryVariables>;
export const GetAgencyVideoDocument = gql`
    query getAgencyVideo($agencyId: Int!) {
  agency(agencyId: $agencyId) {
    ...AgencyVideo
  }
}
    ${AgencyVideoFragmentDoc}`;

/**
 * __useGetAgencyVideoQuery__
 *
 * To run a query within a React component, call `useGetAgencyVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyVideoQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetAgencyVideoQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyVideoQuery, GetAgencyVideoQueryVariables> & ({ variables: GetAgencyVideoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyVideoQuery, GetAgencyVideoQueryVariables>(GetAgencyVideoDocument, options);
      }
export function useGetAgencyVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyVideoQuery, GetAgencyVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyVideoQuery, GetAgencyVideoQueryVariables>(GetAgencyVideoDocument, options);
        }
export function useGetAgencyVideoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyVideoQuery, GetAgencyVideoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyVideoQuery, GetAgencyVideoQueryVariables>(GetAgencyVideoDocument, options);
        }
export type GetAgencyVideoQueryHookResult = ReturnType<typeof useGetAgencyVideoQuery>;
export type GetAgencyVideoLazyQueryHookResult = ReturnType<typeof useGetAgencyVideoLazyQuery>;
export type GetAgencyVideoSuspenseQueryHookResult = ReturnType<typeof useGetAgencyVideoSuspenseQuery>;
export type GetAgencyVideoQueryResult = Apollo.QueryResult<GetAgencyVideoQuery, GetAgencyVideoQueryVariables>;
export const GetContactIdVideoDocument = gql`
    query getContactIdVideo($contactId: Int!) {
  contactByContactId(contactId: $contactId) {
    ...ContactVideo
  }
}
    ${ContactVideoFragmentDoc}`;

/**
 * __useGetContactIdVideoQuery__
 *
 * To run a query within a React component, call `useGetContactIdVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactIdVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactIdVideoQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactIdVideoQuery(baseOptions: Apollo.QueryHookOptions<GetContactIdVideoQuery, GetContactIdVideoQueryVariables> & ({ variables: GetContactIdVideoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactIdVideoQuery, GetContactIdVideoQueryVariables>(GetContactIdVideoDocument, options);
      }
export function useGetContactIdVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactIdVideoQuery, GetContactIdVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactIdVideoQuery, GetContactIdVideoQueryVariables>(GetContactIdVideoDocument, options);
        }
export function useGetContactIdVideoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactIdVideoQuery, GetContactIdVideoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactIdVideoQuery, GetContactIdVideoQueryVariables>(GetContactIdVideoDocument, options);
        }
export type GetContactIdVideoQueryHookResult = ReturnType<typeof useGetContactIdVideoQuery>;
export type GetContactIdVideoLazyQueryHookResult = ReturnType<typeof useGetContactIdVideoLazyQuery>;
export type GetContactIdVideoSuspenseQueryHookResult = ReturnType<typeof useGetContactIdVideoSuspenseQuery>;
export type GetContactIdVideoQueryResult = Apollo.QueryResult<GetContactIdVideoQuery, GetContactIdVideoQueryVariables>;
export const GetContactVideoDocument = gql`
    query getContactVideo($agencyId: Int!, $agentIdV2: String!) {
  contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
    ...ContactVideo
  }
}
    ${ContactVideoFragmentDoc}`;

/**
 * __useGetContactVideoQuery__
 *
 * To run a query within a React component, call `useGetContactVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactVideoQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agentIdV2: // value for 'agentIdV2'
 *   },
 * });
 */
export function useGetContactVideoQuery(baseOptions: Apollo.QueryHookOptions<GetContactVideoQuery, GetContactVideoQueryVariables> & ({ variables: GetContactVideoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactVideoQuery, GetContactVideoQueryVariables>(GetContactVideoDocument, options);
      }
export function useGetContactVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactVideoQuery, GetContactVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactVideoQuery, GetContactVideoQueryVariables>(GetContactVideoDocument, options);
        }
export function useGetContactVideoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactVideoQuery, GetContactVideoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactVideoQuery, GetContactVideoQueryVariables>(GetContactVideoDocument, options);
        }
export type GetContactVideoQueryHookResult = ReturnType<typeof useGetContactVideoQuery>;
export type GetContactVideoLazyQueryHookResult = ReturnType<typeof useGetContactVideoLazyQuery>;
export type GetContactVideoSuspenseQueryHookResult = ReturnType<typeof useGetContactVideoSuspenseQuery>;
export type GetContactVideoQueryResult = Apollo.QueryResult<GetContactVideoQuery, GetContactVideoQueryVariables>;
export const ShortlistDocument = gql`
    query Shortlist {
  me {
    shortlist {
      id
      listingId
    }
  }
}
    `;

/**
 * __useShortlistQuery__
 *
 * To run a query within a React component, call `useShortlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortlistQuery({
 *   variables: {
 *   },
 * });
 */
export function useShortlistQuery(baseOptions?: Apollo.QueryHookOptions<ShortlistQuery, ShortlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortlistQuery, ShortlistQueryVariables>(ShortlistDocument, options);
      }
export function useShortlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortlistQuery, ShortlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortlistQuery, ShortlistQueryVariables>(ShortlistDocument, options);
        }
export function useShortlistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShortlistQuery, ShortlistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShortlistQuery, ShortlistQueryVariables>(ShortlistDocument, options);
        }
export type ShortlistQueryHookResult = ReturnType<typeof useShortlistQuery>;
export type ShortlistLazyQueryHookResult = ReturnType<typeof useShortlistLazyQuery>;
export type ShortlistSuspenseQueryHookResult = ReturnType<typeof useShortlistSuspenseQuery>;
export type ShortlistQueryResult = Apollo.QueryResult<ShortlistQuery, ShortlistQueryVariables>;
export const SaveToShortlistDocument = gql`
    mutation saveToShortlist($adIds: [Int!]!) {
  saveShortlistListing(adIds: $adIds)
}
    `;
export type SaveToShortlistMutationFn = Apollo.MutationFunction<SaveToShortlistMutation, SaveToShortlistMutationVariables>;

/**
 * __useSaveToShortlistMutation__
 *
 * To run a mutation, you first call `useSaveToShortlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveToShortlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveToShortlistMutation, { data, loading, error }] = useSaveToShortlistMutation({
 *   variables: {
 *      adIds: // value for 'adIds'
 *   },
 * });
 */
export function useSaveToShortlistMutation(baseOptions?: Apollo.MutationHookOptions<SaveToShortlistMutation, SaveToShortlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveToShortlistMutation, SaveToShortlistMutationVariables>(SaveToShortlistDocument, options);
      }
export type SaveToShortlistMutationHookResult = ReturnType<typeof useSaveToShortlistMutation>;
export type SaveToShortlistMutationResult = Apollo.MutationResult<SaveToShortlistMutation>;
export type SaveToShortlistMutationOptions = Apollo.BaseMutationOptions<SaveToShortlistMutation, SaveToShortlistMutationVariables>;
export const RemoveFromShortlistDocument = gql`
    mutation removeFromShortlist($adIds: [Int!]!) {
  removeShortlistListing(adIds: $adIds)
}
    `;
export type RemoveFromShortlistMutationFn = Apollo.MutationFunction<RemoveFromShortlistMutation, RemoveFromShortlistMutationVariables>;

/**
 * __useRemoveFromShortlistMutation__
 *
 * To run a mutation, you first call `useRemoveFromShortlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromShortlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromShortlistMutation, { data, loading, error }] = useRemoveFromShortlistMutation({
 *   variables: {
 *      adIds: // value for 'adIds'
 *   },
 * });
 */
export function useRemoveFromShortlistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromShortlistMutation, RemoveFromShortlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromShortlistMutation, RemoveFromShortlistMutationVariables>(RemoveFromShortlistDocument, options);
      }
export type RemoveFromShortlistMutationHookResult = ReturnType<typeof useRemoveFromShortlistMutation>;
export type RemoveFromShortlistMutationResult = Apollo.MutationResult<RemoveFromShortlistMutation>;
export type RemoveFromShortlistMutationOptions = Apollo.BaseMutationOptions<RemoveFromShortlistMutation, RemoveFromShortlistMutationVariables>;
export const PushToGroupStatsMutationDocument = gql`
    mutation pushToGroupStatsMutation($groupStats: GroupStatsStat!) {
  postStat(groupStats: $groupStats)
}
    `;
export type PushToGroupStatsMutationMutationFn = Apollo.MutationFunction<PushToGroupStatsMutationMutation, PushToGroupStatsMutationMutationVariables>;

/**
 * __usePushToGroupStatsMutationMutation__
 *
 * To run a mutation, you first call `usePushToGroupStatsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToGroupStatsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToGroupStatsMutationMutation, { data, loading, error }] = usePushToGroupStatsMutationMutation({
 *   variables: {
 *      groupStats: // value for 'groupStats'
 *   },
 * });
 */
export function usePushToGroupStatsMutationMutation(baseOptions?: Apollo.MutationHookOptions<PushToGroupStatsMutationMutation, PushToGroupStatsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushToGroupStatsMutationMutation, PushToGroupStatsMutationMutationVariables>(PushToGroupStatsMutationDocument, options);
      }
export type PushToGroupStatsMutationMutationHookResult = ReturnType<typeof usePushToGroupStatsMutationMutation>;
export type PushToGroupStatsMutationMutationResult = Apollo.MutationResult<PushToGroupStatsMutationMutation>;
export type PushToGroupStatsMutationMutationOptions = Apollo.BaseMutationOptions<PushToGroupStatsMutationMutation, PushToGroupStatsMutationMutationVariables>;